(function () {
  Window.data = Window.data || {};
  Window.data.json = Window.data.json || {};

  Window.data.json.estados = {
    type: "Topology",
    arcs: [
      [
        [72067, 37424],
        [15, 92],
        [32, 32],
        [-14, 35],
        [24, 41],
        [30, 13],
        [23, 58],
        [-29, 79],
        [36, 14],
        [8, 22],
        [-14, 55],
        [64, -14],
        [24, 49],
        [20, 16],
        [0, 44],
        [21, 75],
        [-133, 85],
        [6, 229],
        [262, -2],
        [391, -3],
        [94, 15],
        [25, 50],
        [59, 6],
        [83, 19],
        [15, 49],
        [22, 19],
        [5, 44],
        [-47, 22],
        [26, 69],
        [68, 10],
        [86, 26],
        [204, 32],
        [44, -16],
        [88, 120],
        [-17, 18],
        [191, -1],
        [1, 148],
        [41, 110],
        [1, 81],
        [63, 13],
        [39, -197],
        [87, -39],
        [32, -64],
        [62, -58],
        [-13, -63],
        [115, 1],
        [23, -17],
        [52, 7],
        [0, -51],
        [105, 0],
        [54, 0],
        [-16, -59],
        [86, -9],
        [57, -7],
        [-16, -280],
        [133, -17],
        [82, -9],
        [5, -22],
        [66, 50],
        [7, -9],
        [64, 84],
        [87, -31],
        [-8, -30],
        [33, -13],
        [64, 38],
        [34, -66],
        [3, -81],
        [33, -123],
        [-1, -13],
        [91, -1],
        [13, -39],
        [1, -69],
        [-7, -254],
        [-131, 3],
        [-69, -75],
        [126, 3],
        [-41, -120],
        [83, -30],
        [101, -15],
        [85, -48],
        [76, -55],
        [322, -226],
        [76, -62],
        [12, -63],
      ],
      [
        [75892, 37049],
        [5, -59],
        [-5, -90],
        [-10, -43],
        [-125, -66],
        [-18, 39],
        [-23, 10],
        [18, -91],
        [-7, -49],
        [34, -36],
        [21, -91],
        [28, 56],
        [34, 13],
        [39, -2],
        [32, -15],
        [53, 5],
        [46, -11],
        [-13, -171],
        [-194, 14],
        [-280, -102],
        [-362, -134],
        [-4, -55],
        [-81, 10],
        [-1, -87],
        [-14, -62],
        [-62, -34],
        [6, -15],
        [-19, -56],
        [-30, -27],
        [-34, -68],
        [-52, 22],
        [-53, -46],
        [28, -53],
        [-60, -27],
        [-14, -49],
        [-22, -11],
        [-31, -64],
        [-22, 0],
        [-20, -52],
        [-51, -27],
        [-25, -75],
        [-25, 2],
        [-35, -29],
        [-54, 13],
        [-21, 22],
        [-31, -94],
        [-166, 34],
        [0, -41],
        [-59, -146],
        [-49, -25],
        [-62, 16],
        [-110, -5],
        [-20, 51],
        [-113, 11],
        [6, -60],
        [34, -7],
        [-69, -131],
        [-50, 16],
        [-21, -38],
        [-66, 32],
        [-123, 69],
        [-13, 40],
        [-68, 6],
        [-12, 10],
        [-95, 28],
        [14, 30],
        [-68, 18],
        [-25, 13],
        [-77, 8],
        [-36, 38],
        [-14, -14],
        [-40, 3],
        [41, 42],
        [-22, 52],
        [-53, -1],
        [-33, -15],
        [-4, 36],
        [-35, 14],
        [-268, 137],
        [-59, 53],
        [-57, 6],
        [-28, -11],
        [-44, 7],
        [-60, 1],
        [-3, 54],
        [-43, -19],
        [-54, 22],
        [-71, 58],
        [-47, -27],
        [-34, 18],
        [-39, -15],
        [-30, 11],
        [-24, -10],
        [-34, -47],
        [-54, -4],
        [-32, -53],
        [5, -63],
        [-81, 6],
        [-17, 15],
        [-24, -69],
        [-58, -17],
        [-46, 22],
      ],
      [
        [71828, 35523],
        [-123, 88],
        [-120, 104],
        [-36, 24],
        [-49, 13],
        [-20, 35],
        [5, 24],
        [-33, 43],
        [-23, 54],
        [-32, -6],
        [-56, 15],
        [19, 111],
        [0, 55],
        [-50, -1],
        [-30, 51],
        [-29, 13],
        [-15, 33],
        [26, 38],
        [24, 15],
        [12, 82],
        [24, 22],
        [59, 210],
        [25, 66],
        [21, 10],
        [51, 81],
        [5, 26],
        [69, 159],
        [64, 97],
        [34, 5],
        [11, 58],
        [25, 11],
        [29, 56],
        [33, 10],
        [35, 59],
        [10, 35],
        [-12, 51],
        [63, 42],
        [79, 40],
        [29, 3],
        [42, 30],
        [73, 39],
      ],
      [
        [6809, 86762],
        [2, 17],
        [-10, 150],
        [-15, 63],
        [-26, 49],
        [-4, 40],
        [-54, 76],
        [-10, 78],
        [-18, 29],
        [3, 39],
        [-12, 60],
        [-31, 81],
        [-32, 48],
        [-33, 34],
        [-93, 46],
        [-73, 23],
        [-138, 37],
        [-33, 20],
        [-73, 9],
        [-24, 47],
        [-32, 19],
        [-9, 51],
        [-50, 143],
        [-75, 153],
        [-49, 117],
        [-57, 95],
        [-27, 94],
        [-25, 112],
        [-42, 55],
        [-43, 105],
        [-5, 51],
        [-12, 19],
        [6, 55],
        [-8, 68],
        [6, 122],
        [396, 37],
        [288, 25],
        [458, 44],
        [41, 2],
        [583, 51],
        [662, 61],
        [830, 73],
        [828, 71],
        [664, 58],
        [968, 79],
        [454, 38],
        [1212, 98],
        [609, 49],
        [994, 74],
        [1319, 97],
        [745, 53],
        [-43, -66],
        [-28, -73],
        [-50, -72],
        [-19, -70],
        [-59, -56],
        [-25, -52],
        [-60, -37],
        [-19, -49],
        [-32, -5],
        [-22, 16],
        [-40, -3],
        [-13, -35],
        [7, -70],
        [19, -20],
        [9, -52],
        [-51, -128],
        [31, -15],
        [62, 3],
        [-14, -39],
        [-43, -39],
        [6, -70],
        [-30, -32],
        [9, -66],
        [-24, -37],
        [-2, -43],
      ],
      [
        [16333, 88767],
        [-12, -54],
        [-42, -15],
        [-29, 8],
        [-32, -29],
        [-49, -12],
        [-91, 47],
        [-21, 32],
        [-61, 12],
        [-62, -40],
        [-32, -8],
        [-73, 4],
        [-21, 9],
        [-34, -14],
        [-20, -37],
        [15, -104],
        [21, -61],
        [-38, -39],
        [-28, -54],
        [-69, -56],
        [3, -46],
        [30, -23],
        [-26, -25],
        [-42, -6],
        [25, -68],
        [-7, -53],
        [12, -70],
        [-21, -66],
        [-65, -46],
        [-53, -57],
        [-7, -30],
        [-65, -31],
        [-47, -53],
        [-34, -24],
        [-77, -93],
        [2, -48],
        [-36, -41],
        [-16, -39],
        [27, -10],
        [26, -54],
        [227, -192],
        [-4, -7],
        [80, -69],
        [-66, -156],
        [152, -533],
        [-48, -206],
        [10, -387],
        [84, -34],
        [17, -25],
        [19, -71],
        [112, -49],
        [18, -28],
        [-6, -32],
        [25, -14],
        [36, 19],
        [55, 2],
        [54, -30],
        [35, -5],
        [74, 8],
        [51, -30],
        [33, -82],
        [35, -73],
        [31, -38],
        [55, -21],
      ],
      [
        [16363, 85420],
        [-6, -102],
        [-8, -56],
        [-33, -106],
        [-5, -88],
        [7, -83],
        [21, -62],
        [35, -77],
        [40, -52],
        [30, -88],
        [26, -181],
        [-11, -53],
        [-20, -41],
        [-48, -37],
        [-50, 13],
        [-21, -10],
        [0, -33],
        [-27, -93],
        [-48, -29],
        [-10, -54],
        [-35, -73],
        [-72, -255],
        [6, -26],
        [-6, -61],
        [14, -20],
        [-1, -136],
        [-19, -112],
        [-48, -32],
        [-1, -52],
        [-12, -65],
        [-35, -31],
        [16, -36],
        [-8, -15],
        [2, -94],
        [-14, -73],
        [7, -65],
        [-11, -166],
        [13, -34],
        [-42, -52],
        [7, -36],
        [-21, -67],
        [29, -22],
        [15, -41],
        [3, -84],
        [-20, -99],
        [8, -23],
        [-31, -204],
        [0, -88],
        [11, -39],
        [13, -100],
        [48, -108],
        [33, -50],
        [90, -86],
        [73, -31],
        [44, -63],
        [39, -7],
        [10, -33],
        [-18, -20],
        [-37, -9],
        [-35, -72],
        [-15, -76],
        [5, -42],
        [55, -75],
        [62, -44],
        [125, -66],
        [122, -48],
        [91, -45],
        [66, -40],
        [48, -154],
        [-5, -70],
        [27, -66],
        [5, -75],
        [-24, -67],
        [3, -45],
        [18, -22],
        [14, -73],
        [27, -19],
        [-15, -103],
        [-4, -119],
        [8, -60],
        [17, -18],
        [13, -62],
        [-60, -124],
        [3, -75],
        [17, -20],
        [29, -111],
        [2, -32],
        [-14, -71],
        [-10, -101],
        [16, -65],
        [21, -27],
        [65, -150],
        [51, -43],
        [29, -64],
        [32, -41],
        [3, -60],
        [13, -34],
        [0, -53],
        [68, -130],
        [15, -61],
        [-8, -69],
        [-28, -79],
        [5, -101],
        [21, -43],
        [8, -48],
        [-27, -95],
        [7, -25],
        [-28, -51],
        [-7, -72],
        [36, -33],
        [-7, -31],
        [9, -38],
        [-32, -6],
        [10, -43],
        [-20, -13],
        [-1, -111],
        [-16, -56],
        [-23, -39],
        [3, -31],
        [-19, -23],
        [0, -31],
        [64, -57],
        [11, -32],
        [-56, -94],
        [7, -81],
        [-25, -51],
        [-40, -40],
        [-20, -42],
        [25, -68],
        [54, -53],
        [8, -38],
        [42, -63],
        [9, -43],
        [17, -11],
        [8, -75],
        [38, -46],
        [74, -29],
        [24, -21],
        [30, -94],
        [52, -59],
        [15, -42],
        [-4, -82],
        [26, -36],
        [9, -59],
        [47, -31],
        [-5, -23],
        [12, -58],
        [54, -35],
        [33, -69],
        [32, -31],
        [-10, -20],
        [29, -52],
        [123, -56],
        [62, -19],
        [53, -48],
        [46, -141],
        [44, -24],
        [110, -10],
        [22, 7],
        [43, -38],
        [9, -22],
        [47, -31],
        [17, -59],
        [-6, -55],
        [-21, -51],
        [9, -47],
        [43, -56],
        [10, -25],
        [96, -52],
        [10, -35],
        [-34, -20],
        [-37, -2],
        [-11, -73],
        [17, -50],
        [30, -36],
        [75, -37],
        [28, 12],
        [42, -17],
        [39, -47],
        [15, -62],
        [28, -13],
        [77, -14],
        [88, -1],
        [30, 8],
        [51, 65],
        [-32, 5],
        [-1, 38],
        [29, 24],
        [59, 14],
        [29, -21],
        [29, -39],
        [70, 14],
        [63, -60],
        [62, -31],
        [29, 2],
        [27, -25],
        [17, -60],
        [46, -38],
        [41, -58],
        [66, -34],
        [36, -51],
        [27, 13],
        [48, -17],
        [5, -27],
        [40, -39],
        [4, -24],
        [62, -43],
        [36, -49],
        [45, -16],
        [49, -40],
        [85, -33],
        [40, -33],
        [22, -68],
        [59, -94],
        [67, -10],
        [39, -62],
        [63, -23],
        [63, 7],
        [70, -57],
        [28, -52],
        [112, -111],
        [42, -53],
        [46, -14],
        [11, -36],
        [55, -36],
        [89, -103],
        [73, -34],
        [75, -58],
        [11, -19],
        [36, 2],
        [45, -26],
        [40, -9],
        [21, -37],
        [-2, -61],
        [34, -32],
        [87, -16],
        [35, -41],
        [40, -2],
        [12, -17],
        [58, -17],
        [21, -44],
        [34, -50],
        [148, -121],
        [34, -21],
        [26, -68],
        [28, -15],
        [72, -106],
        [49, -26],
        [80, -77],
        [40, -7],
        [9, -26],
        [46, -26],
        [40, -40],
        [21, -44],
        [5, -48],
        [31, -59],
        [-44, -39],
        [-41, -63],
        [-44, -41],
        [-16, -48],
        [11, -43],
        [41, -14],
        [27, -22],
        [-15, -70],
        [29, -24],
        [17, -41],
        [29, 18],
        [16, -63],
        [68, -23],
        [20, -66],
        [51, -67],
        [42, -15],
        [29, -41],
        [26, -10],
        [21, -43],
        [-1, -68],
        [22, -45],
        [25, -17],
        [41, -81],
        [24, -8],
        [21, -30],
        [4, -104],
        [-31, 18],
        [-38, -22],
        [-36, -61],
        [-13, -62],
        [13, -59],
        [45, -41],
        [14, -29],
        [11, -106],
        [-52, -47],
        [-6, -28],
        [47, -72],
        [11, -53],
        [25, -27],
        [20, -53],
        [40, -34],
        [6, -36],
        [57, -16],
        [76, 1],
        [62, 16],
        [49, 118],
        [-51, 19],
        [-19, 38],
        [31, 14],
        [-3, 52],
        [51, 38],
        [46, -28],
        [34, 28],
        [94, 11],
        [36, -10],
        [-7, -52],
        [-13, -19],
        [26, -35],
        [38, -24],
        [52, 15],
        [-6, 25],
        [37, 27],
        [46, 15],
        [18, -20],
        [-29, -26],
        [-22, -52],
        [8, -36],
        [81, -20],
        [29, -25],
        [-51, -16],
        [1, -47],
        [33, -24],
        [19, -41],
        [30, -7],
        [-41, -75],
        [7, -55],
        [-7, -68],
        [33, -72],
        [47, -21],
        [-19, -26],
        [12, -39],
        [35, -24],
        [104, 3],
        [67, 21],
        [11, 18],
        [58, 28],
        [0, 21],
        [42, 8],
        [-1, 24],
        [40, 30],
        [29, 1],
        [49, 42],
        [65, 0],
        [19, -26],
        [38, 7],
        [13, -35],
        [47, -17],
        [22, -29],
        [23, -86],
        [52, -25],
        [14, -21],
        [-10, -50],
        [22, -40],
        [8, -43],
        [-9, -102],
        [36, -78],
        [23, -73],
        [28, -8],
        [-5, -41],
        [32, -59],
        [2, -39],
        [46, -120],
        [36, -40],
        [79, -50],
        [28, -64],
        [-15, -90],
        [4, -56],
        [13, -51],
        [33, -60],
        [2, -45],
        [26, -49],
        [8, -78],
        [-6, -76],
        [42, -102],
        [73, -51],
        [43, -13],
        [18, -39],
        [68, -22],
        [14, -13],
        [74, -9],
        [25, -45],
        [94, -49],
        [62, -14],
        [85, 2],
        [118, 21],
        [95, 25],
        [153, 52],
        [33, -11],
        [17, -27],
        [36, -20],
        [-13, -31],
        [46, -24],
        [2, -25],
        [-24, -42],
        [11, -19],
        [49, -12],
        [42, 13],
        [5, 26],
        [46, 11],
        [16, -13],
        [-7, -46],
        [16, -35],
        [-30, -14],
        [-44, -79],
        [28, -44],
        [3, -41],
        [20, -25],
        [-24, -41],
        [4, -27],
        [-72, -156],
        [-29, -130],
        [16, -76],
        [-7, -63],
        [38, -61],
        [41, -40],
        [36, -20],
        [41, -40],
        [26, -50],
        [49, -58],
        [80, -80],
        [21, -41],
        [63, -26],
        [-30, -39],
        [-15, -39],
        [-5, -51],
        [-28, -35],
        [-26, -85],
        [-8, -60],
        [-2, -98],
        [30, -75],
        [11, -79],
        [61, -51],
        [7, -35],
        [-47, -58],
        [-19, -51],
        [-8, -82],
        [9, -44],
        [31, -45],
        [64, -42],
        [63, 1],
        [16, -12],
      ],
      [
        [25752, 66557],
        [-6621, 0],
      ],
      [
        [19131, 66557],
        [109, 140],
        [25, 23],
        [73, 113],
        [92, 125],
        [43, 24],
        [84, 161],
        [-4, 22],
        [94, 140],
        [48, 80],
        [53, 112],
        [46, 120],
        [-29, 30],
        [-22, 82],
        [-30, 34],
        [-58, 16],
        [-14, -24],
        [-48, -17],
        [-78, 79],
        [-6, 27],
        [99, 204],
        [92, 212],
        [95, 254],
        [33, 108],
        [25, 103],
        [13, 100],
        [-18, 65],
        [-43, 30],
        [-49, 52],
        [4, 107],
        [-5, 25],
        [-51, 35],
        [-28, 3],
        [-20, 74],
        [-27, 43],
        [-92, 62],
        [-97, 20],
        [-53, -17],
        [-57, 53],
        [25, 74],
        [9, 61],
        [-3, 85],
        [-41, 127],
        [-48, 51],
        [-44, 30],
        [-66, 18],
        [-34, -1],
        [-88, 28],
        [-56, 5],
        [-48, -31],
        [8, -38],
        [-72, 44],
        [-41, -10],
        [2, 146],
        [-28, 17],
        [-37, 64],
        [-55, -10],
        [-23, 18],
        [-30, 62],
        [-40, 34],
        [-90, 23],
        [-49, -6],
        [0, 45],
        [15, 13],
        [2, 65],
        [-26, 16],
        [-6, 76],
        [-46, 32],
        [2, 50],
        [-10, 37],
        [-50, 68],
        [-30, 13],
        [-34, -39],
        [-35, 33],
        [-26, 42],
        [9, 54],
        [-24, 24],
        [0, 51],
        [-14, 77],
        [-29, 53],
        [-33, 35],
        [-35, 14],
        [-48, -16],
        [-41, 110],
        [-28, 30],
        [-44, 10],
        [-73, 72],
        [-48, 35],
        [-38, -3],
        [-57, 15],
        [-16, -17],
        [-64, 2],
        [-18, -50],
        [-68, 60],
        [7, 42],
        [-29, 84],
        [-57, 58],
        [-51, 23],
        [-35, -7],
        [-29, -39],
        [-21, 34],
        [-25, 12],
        [-19, 51],
        [11, 62],
        [-4, 44],
        [-21, 70],
        [3, 21],
        [-12, 122],
        [-9, 40],
        [-22, 25],
        [-22, -7],
        [-9, 60],
        [-33, 75],
        [-43, 40],
        [-83, -1],
        [-21, 27],
        [-57, 42],
        [-30, 8],
        [-24, -21],
        [-63, 5],
        [-30, -44],
        [-33, 51],
        [-23, 5],
        [-35, 97],
        [-16, 24],
        [-38, -3],
        [-1, 109],
        [-14, 65],
        [-33, 56],
        [-57, 4],
        [-34, 49],
        [-26, 19],
        [-33, -16],
        [-36, 13],
        [-53, 71],
        [-36, -11],
        [-36, 25],
        [-4, 30],
        [-44, 79],
        [-44, 26],
        [-12, -18],
        [-48, 38],
        [-24, 78],
        [-32, 18],
        [-26, 53],
        [-45, 44],
        [-28, 4],
        [-37, 62],
        [-63, 45],
        [-12, 23],
        [-32, 13],
        [-42, 63],
        [-76, 75],
        [-65, 94],
        [-85, 75],
        [-57, 27],
        [-84, 3],
        [-55, 14],
        [-86, 63],
        [-63, 17],
        [-57, 26],
        [-49, 35],
        [-61, 21],
        [-68, -7],
        [-55, 23],
        [-32, -9],
        [-53, 5],
        [-22, -13],
        [-48, 24],
        [-59, -11],
        [-59, 37],
        [-51, 15],
        [-51, -17],
        [-11, 10],
        [-22, 79],
        [-28, 60],
        [-57, 91],
        [-68, 52],
        [-33, 69],
        [-55, 61],
        [-38, 25],
        [-42, 4],
        [-112, 72],
        [-35, 32],
        [-54, 7],
        [-59, 19],
        [-85, 52],
        [-58, 5],
        [-77, 18],
        [-39, -11],
        [-29, 24],
        [-37, 55],
        [-64, 19],
        [-38, 71],
        [-58, 40],
        [-31, 43],
        [-39, 38],
        [-66, 39],
        [-98, 10],
        [-67, -50],
        [-58, 2],
        [-33, 25],
        [-18, 34],
        [-34, 31],
        [-75, 42],
        [-40, 54],
        [-44, 40],
        [-22, 3],
        [-60, 104],
        [-64, 54],
        [-53, 14],
        [-82, -15],
        [-86, 83],
        [-67, 48],
        [-38, 44],
        [-22, 9],
        [-59, 57],
        [-44, 14],
        [-44, 49],
        [3, 43],
        [54, 235],
        [5, 67],
        [-4, 66],
        [-34, 123],
        [-20, 110],
        [-18, 58],
        [-29, 32],
        [-27, 50],
        [-19, 16],
        [-27, 48],
        [-85, 94],
        [-213, 60],
        [-73, -6],
        [-27, 18],
        [24, 61],
        [37, 166],
        [40, 195],
        [31, 215],
        [-40, 107],
        [4, 19],
        [-30, 57],
        [-25, 26],
        [3, 39],
        [-11, 54],
        [12, 37],
        [22, 138],
        [3, 130],
        [-2, 121],
        [-7, 68],
        [-28, 138],
        [-61, 141],
        [-43, 46],
        [-40, 107],
        [-71, 91],
        [-71, 61],
        [-97, 58],
        [-57, 50],
        [-45, 27],
        [-103, 33],
        [-94, -3],
        [-121, -43],
        [-66, -63],
        [14, -42],
        [29, -22],
        [-11, -57],
        [-90, 28],
        [-13, 55],
        [11, 11],
        [-1, 77],
        [-11, 54],
        [-26, 91],
        [-26, 51],
        [-56, 23],
        [-19, 105],
        [-56, 62],
        [4, 45],
        [-9, 63],
        [23, 45],
        [18, 116],
        [2, 38],
        [30, 159],
        [12, 134],
        [14, 217],
        [-3, 153],
        [-27, 167],
        [-61, 90],
        [4, 56],
        [-11, 74],
        [-3, 80],
        [-14, 97],
        [-26, 74],
        [-34, 61],
        [-29, 32],
        [-76, 36],
        [-41, -13],
        [-45, 22],
        [-159, 152],
        [-47, 31],
        [-45, 15],
        [-36, -16],
        [-34, 12],
        [-68, 76],
        [-45, 20],
        [-32, 54],
        [-10, 58],
        [-25, 45],
        [-28, 19],
        [-31, 46],
        [-43, 34],
        [-31, -7],
        [-39, 49],
        [-68, 110],
        [-16, 14],
        [-64, 10],
        [-76, -47],
        [-84, -22],
        [-39, 13],
        [-44, 67],
        [-3, 67],
        [16, 41],
        [10, 58],
        [17, 47],
        [28, 146],
        [22, 137],
        [33, 177],
        [9, 132],
        [0, 78],
        [-49, 104],
        [-68, 94],
        [-27, 89],
        [-46, 21],
        [-21, 95],
        [-48, 87],
        [-49, 58],
        [-39, 27],
        [-32, 78],
        [-43, 16],
        [-26, 29],
        [-43, 12],
        [-5, 42],
        [-41, 36],
        [-32, 12],
        [-16, 45],
        [-43, 10],
        [-34, 38],
        [-8, 68],
        [-60, 33],
        [-5, 44],
        [-24, 1],
        [-60, 45],
        [8, 25],
        [-25, 70],
        [-34, 67],
        [-11, 39],
        [-51, 25],
        [-1, 17],
        [-58, 88],
        [-93, 51],
        [-120, 88],
        [-54, 7],
        [-59, -24],
        [-35, 12],
        [0, 62],
        [-17, 41],
        [-9, 62],
        [-52, 32],
        [-11, 31],
        [-68, 41],
        [-35, -15],
        [-64, 64],
        [-8, 38],
        [-29, 25],
        [11, 28],
        [-20, 29],
        [-42, 11],
        [-42, -16],
        [-19, 96],
        [46, 1],
        [26, 32],
        [44, 9],
        [42, -5],
        [24, 16],
        [4, 32],
        [-61, 58],
        [-15, 46],
        [-2, 42],
        [45, 73],
        [37, 129],
        [0, 29],
        [-135, 153],
        [2, 21],
        [-59, 27],
        [-23, 54],
        [-32, 1],
        [-25, -23],
        [-70, 54],
        [-80, 126],
        [40, 9],
        [49, -15],
        [25, -23],
        [52, -17],
        [35, -31],
        [70, -17],
        [50, -51],
        [41, -1],
        [63, 44],
        [31, 37],
        [37, 73],
        [40, 111],
        [31, 13],
        [-4, 39],
        [29, 67],
        [19, 126],
        [-15, 92],
        [-34, 53],
        [-8, 33],
        [-21, 13],
        [-31, -25],
        [-32, 24],
        [-48, 0],
        [-92, 27],
        [-33, 21],
        [-43, 67],
        [-57, 57],
        [-29, -5],
        [-75, 43],
        [-41, -11],
        [-68, 7],
        [-48, 57],
        [3, 120],
        [-7, 51],
        [-33, 90],
        [-23, 24],
        [-61, 37],
        [-37, -8],
        [-44, 27],
        [-61, -16],
        [-78, -2],
        [-49, 38],
        [-38, 5],
        [-39, 35],
        [-39, 58],
        [-65, 61],
        [-7, 34],
        [-23, 45],
        [11, 40],
        [-13, 31],
        [26, 49],
        [-3, 104],
        [-10, 41],
      ],
      [
        [16641, 85346],
        [12, -63],
        [20, -59],
        [61, -84],
        [57, -56],
        [127, -86],
        [80, -62],
        [69, -115],
        [19, -66],
        [-22, -21],
        [-63, -8],
        [-7, 33],
        [-27, -3],
        [-57, 22],
        [-23, -38],
        [-33, 5],
        [-9, 32],
        [-45, -26],
        [-26, -1],
        [-36, 34],
        [-21, 36],
        [-49, -1],
        [-107, 52],
        [-58, 49],
        [-71, 77],
        [-18, 42],
        [-21, 115],
        [5, 98],
        [-11, 104],
        [7, 44],
        [65, 30],
        [92, -14],
        [32, -17],
        [58, -53],
      ],
      [
        [5147, 88371],
        [30, -91],
        [-24, 0],
        [-6, 91],
      ],
      [
        [14622, 67037],
        [-9, -63],
        [26, -75],
        [-32, -44],
        [2, -50],
        [32, -46],
        [-20, -41],
        [-72, 36],
        [-56, -3],
        [-46, -22],
        [-20, -23],
        [-35, 27],
        [-58, -2],
        [-39, 74],
        [-29, 90],
        [-53, 74],
        [-74, 50],
        [-67, 10],
        [-62, -22],
        [-26, -18],
        [-52, -7],
        [-40, -28],
        [3, -25],
        [-51, 7],
        [-13, 35],
        [23, 17],
        [3, 42],
        [-11, 47],
        [11, 49],
        [76, 38],
        [72, 59],
        [49, 50],
        [123, 146],
        [34, 56],
        [20, 13],
        [36, 51],
        [45, 42],
        [46, 72],
        [-6, 24],
        [30, 28],
        [-18, 42],
        [-52, 85],
        [-4, 57],
        [-19, 25],
        [14, 66],
        [-34, 45],
        [36, 64],
        [23, 9],
        [11, 53],
        [-13, 86],
        [45, 14],
        [-9, 66],
        [35, 29],
        [24, 3],
        [4, 48],
        [53, 27],
        [15, -23],
        [32, -5],
        [-1, -28],
        [39, -8],
        [18, -52],
        [0, -54],
        [-10, -38],
        [28, -72],
        [20, -34],
        [31, -11],
        [23, -28],
        [-9, -39],
        [9, -47],
        [40, -95],
        [8, -43],
        [-31, -88],
        [-16, -115],
        [5, -51],
        [20, -42],
        [40, -43],
        [16, -63],
        [-1, -66],
        [-18, -79],
        [12, -28],
        [-6, -33],
        [-24, -34],
        [-49, -37],
        [-9, -27],
        [-44, -63],
        [6, -41],
      ],
      [
        [7216, 85370],
        [37, -9],
        [0, -52],
        [-37, 38],
        [0, 23],
      ],
      [
        [18155, 76254],
        [-27, 32],
        [35, 33],
        [-1, 29],
        [43, 20],
        [33, -30],
        [14, -62],
        [18, -18],
        [-59, -24],
        [-56, 20],
      ],
      [
        [17543, 76906],
        [43, -12],
        [-15, -28],
        [-28, 40],
      ],
      [
        [16649, 84013],
        [-66, -18],
        [-62, 22],
        [-11, 29],
        [33, 39],
        [-18, 59],
        [78, -32],
        [34, -51],
        [12, -48],
      ],
      [
        [27888, 68470],
        [18, -28],
        [-15, -41],
        [-84, 30],
        [15, 39],
        [33, 13],
        [33, -13],
      ],
      [
        [12966, 68097],
        [39, -56],
        [-47, -20],
        [-11, 32],
        [19, 44],
      ],
      [
        [12756, 68119],
        [28, -44],
        [30, -19],
        [-2, -28],
        [-48, -9],
        [-33, 6],
        [-41, 27],
        [18, 18],
        [0, 49],
        [48, 0],
      ],
      [
        [25167, 69909],
        [68, -13],
        [45, -21],
        [55, -1],
        [26, -38],
        [49, -15],
        [88, -75],
        [79, -46],
        [25, -41],
        [61, -43],
        [20, -42],
        [64, -34],
        [33, -47],
        [3, -40],
        [-65, -44],
        [-48, 20],
        [-29, 31],
        [-12, 58],
        [-33, 57],
        [-44, 25],
        [-7, 18],
        [-92, 40],
        [-58, 61],
        [-58, 22],
        [-58, 0],
        [10, 28],
        [-30, 27],
        [-23, 47],
        [-66, 49],
        [-3, 17],
      ],
      [
        [24987, 70064],
        [49, -48],
        [26, 2],
        [68, -21],
        [11, -71],
        [-77, 48],
        [-57, 18],
        [-35, 30],
        [15, 42],
      ],
      [
        [22314, 71513],
        [43, -29],
        [-36, -38],
        [-24, 24],
        [17, 43],
      ],
      [
        [22513, 71620],
        [39, -39],
        [-24, -12],
        [-15, 51],
      ],
      [
        [22259, 71973],
        [71, 2],
        [31, -35],
        [-26, -42],
        [23, -16],
        [-12, -70],
        [30, -38],
        [19, -93],
        [-55, 24],
        [2, 30],
        [-35, 28],
        [20, 41],
        [-63, 112],
        [-18, 44],
        [13, 13],
      ],
      [
        [22308, 74225],
        [5, -49],
        [87, -43],
        [69, -3],
        [12, -31],
        [29, -26],
        [39, -13],
        [37, -44],
        [33, -13],
        [68, -70],
        [28, -92],
        [38, -15],
        [0, -20],
        [49, -30],
        [51, -2],
        [15, -57],
        [30, -19],
        [7, -56],
        [40, -40],
        [42, -96],
        [21, -30],
        [-5, -25],
        [50, -37],
        [1, -22],
        [-38, -33],
        [-32, -77],
        [-38, -33],
        [-5, -40],
        [17, -48],
        [12, -62],
        [-3, -56],
        [18, -21],
        [88, -57],
        [32, -9],
        [129, -21],
        [38, 4],
        [38, -47],
        [35, 5],
        [29, 30],
        [40, -20],
        [29, 19],
        [54, -28],
        [73, 28],
        [95, -2],
        [54, -17],
        [109, 24],
        [71, -50],
        [-44, -82],
        [-5, -69],
        [9, -88],
        [17, -21],
        [-7, -61],
        [13, -29],
        [-4, -58],
        [24, -37],
        [-24, -57],
        [-9, -105],
        [6, -48],
        [-7, -79],
        [11, -45],
        [34, -47],
        [8, -33],
        [33, -30],
        [10, -29],
        [-10, -66],
        [13, -42],
        [23, -28],
        [65, -21],
        [44, -4],
        [5, -23],
        [99, -5],
        [-61, -132],
        [6, -81],
        [-14, -43],
        [6, -75],
        [-34, 6],
        [-87, 72],
        [-36, 9],
        [-23, 44],
        [-51, 19],
        [-80, 47],
        [-25, 1],
        [-57, 97],
        [-53, 18],
        [-50, 39],
        [-28, -1],
        [-66, 38],
        [-23, 28],
        [-4, 53],
        [-25, 16],
        [-32, 49],
        [-16, 48],
        [-38, 31],
        [-16, 30],
        [-74, 69],
        [-28, 54],
        [-72, 29],
        [-20, 38],
        [-40, 20],
        [-23, -6],
        [-94, 53],
        [-32, 64],
        [-42, 38],
        [-114, 52],
        [-45, 37],
        [-48, 82],
        [-17, 6],
        [-18, 42],
        [-36, 35],
        [14, 40],
        [-8, 33],
        [-30, 14],
        [-34, 75],
        [-31, 23],
        [-45, -7],
        [-24, 12],
        [-43, -17],
        [-24, 17],
        [-35, -3],
        [-35, 17],
        [-42, 75],
        [3, 27],
        [-17, 87],
        [-67, 55],
        [-20, 7],
        [-27, 83],
        [-36, 25],
        [-4, 27],
        [-26, 46],
        [-55, 37],
        [1, 36],
        [-51, 46],
        [-6, 23],
        [-84, 43],
        [-19, 43],
        [19, 48],
        [-29, 59],
        [11, 58],
        [35, 63],
        [30, 22],
        [12, 61],
        [21, 21],
        [14, 66],
        [18, 35],
        [-2, 29],
        [-27, 20],
        [-10, 40],
        [20, 27],
        [-19, 47],
        [52, 5],
        [21, -26],
        [50, -1],
        [28, 22],
        [67, 24],
        [-2, 28],
        [51, 13],
      ],
      [
        [22072, 74287],
        [7, -56],
        [-54, -21],
        [-18, 61],
        [65, 16],
      ],
      [
        [471, 72402],
        [-22, -13],
        [-33, -75],
        [-27, -17],
        [-43, -105],
        [38, -116],
        [-5, -38],
        [27, -26],
        [103, -49],
        [78, -106],
        [43, -51],
        [5, -54],
        [19, -63],
        [-12, -28],
        [16, -93],
        [-35, -89],
        [7, -48],
        [-3, -71],
        [33, -44],
        [-15, -35],
        [3, -37],
        [-20, -93],
        [10, -16],
        [-28, -42],
        [-28, -12],
        [-34, -102],
        [-58, -35],
        [-11, -20],
        [-47, 28],
        [-75, -35],
        [21, 56],
        [3, 39],
        [-18, 26],
        [-5, 43],
        [-27, 18],
        [3, 43],
        [-27, 40],
        [13, 15],
        [22, 109],
        [-15, 56],
        [-41, -1],
        [-48, 48],
        [37, 24],
        [-20, 61],
        [20, 51],
        [-40, 52],
        [-13, 89],
        [-44, 56],
        [-57, 30],
        [-22, 52],
        [-47, 31],
        [-25, 0],
        [-25, 29],
        [13, 64],
        [22, 18],
        [31, 100],
        [-19, 37],
        [4, 37],
        [-16, 36],
        [-37, 47],
        [144, 114],
        [58, 2],
        [24, 27],
        [54, -26],
        [44, 8],
        [35, 46],
        [34, -1],
        [44, 39],
        [26, 10],
        [8, -40],
      ],
      [
        [10357, 78898],
        [34, -29],
        [-11, -53],
        [-60, 15],
        [-12, 31],
        [49, 36],
      ],
      [
        [35286, 53242],
        [-54, -76],
        [-33, -110],
        [-41, -36],
        [-33, -4],
        [-39, 82],
        [-2, 29],
        [19, 47],
        [57, 53],
        [46, 16],
        [80, -1],
      ],
      [
        [34233, 52734],
        [24, -62],
        [29, -17],
        [-8, -43],
        [-3, -86],
        [19, -74],
        [65, -74],
        [58, -26],
        [50, -113],
        [26, -55],
        [7, -56],
        [69, -36],
        [9, -19],
        [69, -22],
        [27, -33],
        [-8, -53],
        [52, -63],
        [77, -25],
        [39, 31],
        [25, -12],
        [32, -41],
        [77, -50],
        [-4, -42],
        [20, -26],
        [-3, -25],
        [36, -17],
        [-5, -51],
        [11, -36],
        [-4, -45],
        [21, -19],
        [70, -101],
        [37, -35],
        [5, -40],
        [35, -35],
        [37, 11],
        [13, -21],
        [-25, -49],
        [18, -30],
        [48, -42],
        [25, -65],
        [-1, -32],
        [20, -31],
        [0, -58],
        [26, -27],
        [22, -55],
        [1, -49],
        [40, -62],
        [-1, -28],
        [34, -22],
        [-26, -68],
        [4, -47],
        [-14, -82],
        [-79, -106],
        [-28, -73],
        [-10, -69],
        [8, -18],
        [-22, -52],
        [-69, -26],
        [-45, -43],
        [-49, -95],
        [-12, -123],
        [-36, -94],
        [2, -104],
        [-5, -84],
        [29, -115],
        [-20, -43],
        [19, -134],
        [23, -64],
        [73, -88],
        [42, -66],
        [59, -65],
        [20, -37],
        [-9, -63],
        [18, -19],
        [-35, -65],
        [1, -62],
        [11, -30],
        [-14, -41],
        [45, -54],
        [9, -33],
        [-18, -34],
        [28, -51],
        [-10, -72],
        [60, -72],
        [22, -36],
        [40, -37],
        [13, -32],
        [51, -26],
        [-4, -35],
        [26, -70],
        [58, -97],
        [33, -23],
        [-2, -23],
        [45, -67],
        [80, -35],
        [36, -27],
        [27, -65],
        [54, -31],
        [18, -43],
        [122, -43],
        [207, -59],
        [150, -37],
        [139, -28],
        [125, -17],
        [96, -8],
        [126, 9],
        [59, 16],
        [60, -12],
        [99, 32],
        [4, 59],
        [13, 36],
        [-5, 74],
        [-54, 21],
        [23, 78],
        [-37, 42],
        [-54, 2],
        [-32, 57],
        [-17, 73],
        [18, 40],
        [-27, 126],
        [1, 49],
        [24, 72],
        [44, 35],
        [81, 12],
        [32, 30],
        [11, 38],
        [49, -8],
        [16, 13],
        [67, -24],
        [158, -22],
        [18, -43],
        [-20, -13],
        [-2, -76],
        [41, -29],
        [42, -15],
        [2, -29],
        [25, -23],
        [49, -4],
        [52, -45],
        [24, -42],
        [-3, -47],
        [30, -38],
        [23, -50],
        [102, -15],
        [41, -26],
        [22, -38],
        [57, -38],
        [39, -5],
        [71, -53],
        [30, 1],
        [76, -38],
        [25, -42],
        [38, -10],
        [31, -41],
        [50, -27],
        [25, -27],
        [46, -16],
        [8, -21],
        [52, -9],
        [47, -54],
        [28, -122],
        [20, -24],
        [-6, -68],
        [21, -29],
        [13, -90],
        [-1, -68],
        [16, -49],
        [-4, -27],
        [10, -80],
        [39, -30],
        [79, -17],
        [55, -2],
        [16, -20],
        [74, -19],
        [91, 19],
        [73, 24],
        [50, 2],
        [54, 21],
        [122, 57],
        [61, 39],
        [24, -5],
        [-5, -47],
        [11, -55],
        [37, -36],
        [39, -9],
        [21, -47],
        [-10, -35],
        [-27, -15],
        [-11, -60],
        [-36, -37],
        [-26, 8],
        [-35, -40],
        [0, -89],
        [-20, -85],
        [12, -85],
        [35, -81],
        [40, -39],
        [83, -49],
        [15, -35],
        [70, -52],
        [49, -24],
        [70, -81],
        [37, -33],
        [13, -31],
        [59, -32],
        [8, -36],
        [51, -51],
        [-1, -14],
        [66, -72],
        [40, -32],
        [-47, -112],
        [-7, -63],
        [2, -77],
        [-11, -36],
        [7, -63],
        [43, -66],
        [10, -71],
        [21, -36],
        [2, -50],
        [-12, -55],
        [-1, -35],
        [46, -57],
        [50, -36],
        [46, -21],
        [121, -43],
        [17, -28],
        [56, -19],
        [79, -9],
        [98, -54],
        [36, -44],
        [92, -36],
        [152, -36],
        [24, -12],
        [19, -61],
        [53, -30],
        [126, -28],
        [40, -28],
        [-3, -18],
        [-42, -68],
        [-8, -32],
        [6, -66],
        [68, -107],
        [13, -41],
        [53, -37],
        [24, -57],
        [22, -30],
        [47, -20],
        [19, -40],
        [-5, -78],
        [-27, -66],
        [0, -37],
        [19, -39],
        [33, -12],
        [34, -73],
        [-14, -32],
        [-32, 5],
        [-40, -29],
        [26, -80],
        [-9, -51],
        [18, -65],
        [-16, -75],
        [13, -67],
        [-18, -69],
        [-49, -105],
        [5, -117],
        [10, -21],
        [-14, -57],
        [-48, -60],
        [-21, -54],
        [-2, -41],
        [-18, -33],
        [-60, -52],
        [-27, -59],
        [-33, -23],
        [-46, -91],
        [-46, -25],
        [-58, -91],
        [-48, -33],
        [-13, -32],
        [-70, -50],
        [-97, -43],
        [-43, -54],
        [-46, -11],
        [-59, 3],
        [-83, -21],
        [-36, -27],
        [-200, -62],
        [-49, -51],
        [-64, -26],
        [-91, -65],
        [-23, -98],
        [21, -24],
        [-33, -22],
        [-49, -57],
        [-44, -16],
        [-85, -15],
        [-39, -41],
        [-51, -14],
        [-50, -27],
        [-42, -35],
        [-39, -57],
        [0, -59],
        [-67, -62],
        [-93, -80],
        [-12, -34],
        [-54, -15],
        [-106, -3],
        [-78, -23],
        [-57, -54],
        [-4, 16],
        [1, 1],
        [-5, -3],
        [0, -1],
        [1, -17],
        [-1, -2],
        [0, -1],
        [-1, -1],
        [4, -8],
        [7, 4],
        [42, -7],
        [1, -21],
        [-119, -13],
        [-151, 10],
        [-27, -9],
        [-82, 37],
        [-41, 27],
        [-127, 102],
        [-196, 229],
        [-44, 95],
        [-69, 100],
        [-13, 67],
        [-30, 64],
        [-14, 3],
        [-42, 174],
        [-1, 59],
        [-37, 180],
        [-24, 59],
        [-30, 106],
        [-15, 17],
        [-16, 119],
        [-46, 151],
        [-15, 89],
        [-30, 89],
        [-4, 134],
        [-21, 37],
        [5, 30],
        [-7, 80],
        [-21, 101],
        [-52, 106],
        [-19, 4],
        [-29, 47],
        [-37, 89],
        [-65, 80],
        [-22, 84],
        [-81, 67],
        [-6, 71],
        [-14, 45],
        [-36, 77],
        [-33, 45],
        [-61, 117],
        [-34, 47],
        [-29, 21],
        [-50, 100],
        [-45, 74],
        [-75, 103],
        [-60, 65],
        [-102, 87],
        [-107, 80],
        [-65, 39],
        [-181, 96],
        [-183, 83],
        [-263, 102],
        [-134, 67],
        [-101, 61],
        [-178, 126],
        [-219, 192],
        [-108, 107],
        [-164, 190],
        [-150, 167],
        [-51, 64],
        [-121, 139],
        [-63, 65],
        [-95, 108],
        [-130, 127],
        [-59, 46],
        [-48, 19],
        [-24, 50],
        [-32, 40],
        [-79, 70],
        [-41, 50],
        [-94, 95],
        [-96, 87],
        [-91, 69],
        [-84, 72],
        [-66, 37],
        [-2, 35],
        [-67, 75],
        [-140, 103],
        [-116, 81],
        [-99, 60],
        [-95, 65],
        [-247, 129],
        [-52, 43],
        [-172, 110],
        [-78, 53],
        [-582, 330],
        [-171, 88],
        [-171, 79],
        [-44, 13],
        [-103, 42],
        [-158, 72],
        [-113, 42],
        [-82, 20],
        [-161, 28],
        [-81, 0],
        [-108, -25],
        [-72, -25],
        [-107, -20],
        [-23, 9],
        [-117, -26],
        [-5, -31],
        [-40, -97],
        [-60, -38],
        [-68, 75],
        [-51, 68],
        [-36, 29],
        [-164, 112],
        [-103, 78],
        [-231, 197],
        [-79, 61],
        [-53, 23],
        [-128, 75],
        [-23, 38],
        [-30, -6],
        [-61, 76],
        [-60, 36],
        [-44, 11],
        [-92, 42],
        [-17, 16],
        [-46, 9],
        [-43, 39],
        [-263, 132],
        [-24, -5],
        [-96, 49],
        [-57, 40],
        [13, 21],
        [-21, 92],
        [-32, 47],
        [-27, 57],
        [-94, 85],
        [-46, 9],
        [-2, 21],
        [-47, 65],
        [-1, 25],
        [-64, 22],
        [-14, 22],
        [30, 36],
        [18, 57],
        [42, -6],
        [19, -22],
        [41, 25],
        [27, 65],
        [2, 110],
        [-27, 117],
        [-39, 60],
        [-56, 59],
        [-88, 77],
        [-86, 53],
        [-109, 40],
        [-65, 3],
        [-86, -30],
        [-22, -24],
        [13, -66],
        [0, -72],
        [-50, 41],
        [-16, 63],
        [-81, 78],
        [-55, 20],
        [-8, 24],
        [19, 42],
        [54, 45],
        [63, 129],
        [64, 174],
        [111, 281],
        [81, 239],
        [17, 38],
        [77, 227],
        [14, 58],
        [142, 504],
        [19, 87],
        [31, 107],
        [41, 183],
        [22, 149],
        [13, 40],
        [41, 25],
        [17, 70],
        [-22, 36],
        [-29, 19],
        [-3, 41],
        [42, 66],
        [24, 78],
        [31, 159],
        [24, 167],
        [18, 166],
        [13, 60],
        [9, 119],
        [-21, 41],
        [18, 67],
        [21, 2],
        [-7, 65],
        [-17, 61],
        [2, 61],
        [15, 168],
        [7, 180],
        [-1, 385],
        [15, 49],
        [-18, 33],
        [-4, 174],
        [-11, 148],
        [-26, 129],
        [-25, 66],
        [-76, 98],
        [-2, 30],
        [-37, 146],
        [-19, 47],
        [-49, 89],
        [-39, 88],
        [-26, 80],
        [-30, 136],
        [-19, 60],
        [-40, 94],
        [-28, 81],
        [-44, 61],
        [-22, 14],
        [-82, 113],
        [-45, 53],
        [-49, 24],
        [-71, 62],
        [-102, 37],
        [-33, -30],
        [-27, 13],
        [-22, 37],
        [-36, 33],
        [-2, 86],
        [-10, 49],
        [-34, 118],
        [-43, 114],
        [-75, 151],
        [-61, 82],
        [-54, 48],
        [-83, 114],
        [-94, 89],
        [-52, 28],
        [-50, 14],
        [-72, 37],
        [-71, 10],
        [-67, -25],
        [-26, -105],
        [-78, -22],
        [-64, 38],
        [-55, 39],
        [-79, 71],
        [-106, 66],
        [-59, 20],
        [-45, 55],
        [-29, 21],
        [-47, 17],
        [-67, 38],
        [-33, 49],
        [-82, 41],
        [-55, 6],
        [-31, -26],
        [-48, 1],
        [-35, -18],
        [-19, 50],
        [-126, 150],
        [-68, 58],
        [-84, 56],
        [-175, 110],
        [-24, 20],
        [-103, 73],
        [-173, 150],
        [-112, 103],
        [-83, 67],
        [-110, 74],
        [-68, 40],
        [-151, 80],
        [-8, 18],
        [-70, 26],
        [-125, 102],
        [-105, 71],
        [-51, 58],
        [-103, 82],
        [-21, 47],
        [-79, 60],
        [-64, 38],
        [-131, 55],
        [-1, 29],
        [-58, 81],
        [-45, 12],
        [-84, 68],
        [-55, 31],
        [-97, 38],
        [-208, 41],
        [-87, 10],
        [-43, 31],
        [14, 30],
        [-55, 163],
        [-6, 37],
        [-36, 19],
        [-64, 52],
        [-127, 80],
        [-68, 35],
        [-70, 27],
        [-87, 24],
        [-129, 24],
        [-146, 9],
        [-66, -10],
        [-22, 18],
        [-42, -29],
        [-61, -9],
        [-121, -50],
        [-39, -95],
        [-4, -64],
        [-23, -41],
        [-54, -19],
        [-49, -28],
        [-17, -23],
        [18, -42],
        [-8, -40],
        [-58, -11],
        [-50, -19],
        [-28, -47],
        [-15, 9],
        [-135, 40],
        [-132, 75],
        [-89, 131],
        [-72, 61],
        [-31, 39],
        [-52, 39],
        [-73, 25],
        [-40, 5],
        [-13, 25],
        [-34, 27],
        [-34, -7],
        [-16, 27],
        [-3, 46],
        [-17, 63],
        [-47, 120],
        [-25, 47],
        [-24, 75],
        [-78, 158],
        [-45, 68],
        [-57, 64],
        [-138, 112],
        [-98, 64],
        [-88, 46],
        [-169, 62],
        [-114, 27],
        [-62, 8],
        [-82, -6],
        [-56, -30],
        [-8, -47],
        [-22, -45],
        [-84, -7],
        [-71, 58],
        [-52, 84],
        [-52, 60],
        [-35, 15],
        [-24, 29],
        [1, 44],
        [-20, 63],
        [-28, 51],
        [-81, 87],
        [-49, 78],
        [-48, 42],
        [-126, 92],
        [-61, 38],
        [-151, 71],
        [-112, 36],
        [-202, 37],
        [-74, 3],
        [-70, -10],
        [-51, -18],
        [-39, -31],
        [-16, -62],
        [-76, 79],
        [-60, 34],
        [-28, 34],
        [-31, 12],
        [-105, 23],
        [-54, 55],
        [-72, 35],
        [-28, -1],
        [-10, -29],
        [-81, -34],
        [-20, 21],
        [-64, 18],
        [9, 31],
        [25, 26],
        [0, 30],
        [-27, 64],
        [-71, 50],
        [-36, 14],
        [-51, -5],
        [-48, -17],
        [-19, 38],
        [-27, 23],
        [12, 31],
        [-14, 59],
        [18, 65],
        [-17, 99],
        [13, 15],
        [1, 77],
        [-6, 142],
        [-18, 163],
        [-21, 85],
        [-31, 98],
        [-25, 58],
        [-30, 40],
        [-62, 60],
        [-101, 63],
        [-53, 23],
        [-18, 21],
        [-43, -1],
        [-60, 59],
        [-48, 69],
        [-36, 18],
        [-58, 11],
        [-50, 19],
        [-71, 48],
        [-69, 26],
        [-33, 20],
        [-98, 19],
        [-56, 35],
        [-56, 24],
        [-52, 8],
        [-29, -7],
        [-40, 17],
        [-8, 40],
        [-21, 10],
        [-32, 53],
        [-29, 11],
        [-23, 46],
        [7, 32],
        [-36, 100],
        [-38, 75],
        [-87, 88],
        [-68, 48],
        [-91, 23],
        [-59, -15],
        [-40, -23],
        [-40, 16],
        [-8, 55],
        [-42, 21],
        [2, 38],
        [-195, 104],
        [-36, 2],
        [-53, 36],
        [-7, 72],
        [-30, 66],
        [-26, 27],
        [-77, 44],
        [-105, 38],
        [-53, -20],
        [-10, -38],
        [-34, 13],
        [-9, 36],
        [-40, 66],
        [-22, -3],
        [-49, 141],
        [9, 12],
        [-20, 63],
        [-31, 43],
        [-27, 60],
        [-16, 77],
        [-55, 52],
        [-14, 25],
        [-66, 57],
        [23, 30],
        [60, 31],
        [39, 6],
        [38, -21],
        [22, 3],
        [71, -51],
        [46, -71],
        [32, -16],
        [114, -16],
        [72, 0],
        [144, 22],
        [63, 21],
        [136, -11],
        [61, -20],
        [71, 11],
        [58, -18],
        [11, -34],
        [56, -47],
        [86, -3],
        [105, 16],
        [45, 14],
        [77, -20],
        [17, -22],
        [105, -11],
        [30, 18],
        [84, -25],
        [10, -44],
        [56, -28],
        [101, -11],
        [66, 9],
        [37, -35],
        [28, -6],
        [56, 8],
        [13, -23],
        [54, -7],
        [76, 1],
        [27, -12],
        [99, 24],
        [65, 24],
        [91, -6],
        [75, 21],
        [56, -34],
        [28, -5],
        [56, -30],
        [70, 13],
        [206, 105],
        [174, 108],
        [70, 19],
        [12, 34],
        [117, 110],
        [127, 91],
        [76, 21],
        [63, -10],
        [43, -38],
        [133, 121],
        [-39, 45],
        [-2, 101],
        [43, 120],
        [29, 35],
        [54, 39],
        [64, 65],
        [20, 37],
        [111, 109],
      ],
      [
        [25752, 66557],
        [13, -18],
        [0, -51],
        [21, -58],
        [2, -57],
        [-19, -27],
        [-28, -102],
        [11, -12],
        [14, -107],
        [-19, -40],
        [21, -37],
        [-29, -34],
        [-3, -58],
        [-15, -21],
        [1, -60],
        [61, -77],
        [72, -41],
        [26, -49],
        [74, -45],
        [33, -70],
        [-15, -29],
        [7, -70],
        [43, -42],
        [-7, -58],
        [29, -64],
        [81, -85],
        [36, -63],
        [31, -28],
        [26, -3],
        [12, -30],
        [32, -6],
        [52, 9],
        [98, -163],
        [90, -38],
        [18, -22],
        [-10, -41],
        [22, -30],
        [105, -39],
        [57, 10],
        [81, -31],
        [56, -2],
        [44, -35],
        [76, -16],
        [17, -20],
        [58, -12],
        [61, -39],
        [1, -31],
        [32, -36],
        [40, -12],
        [39, 7],
        [39, -33],
        [26, -9],
        [62, 9],
        [58, -47],
        [34, -2],
        [51, -57],
        [91, -37],
        [70, -76],
        [2, -51],
        [15, -28],
        [99, -81],
        [16, -68],
        [17, -17],
        [-5, -75],
        [5, -60],
        [20, -45],
        [-11, -68],
        [21, -51],
        [6, -59],
        [49, -33],
        [35, -88],
        [-27, -28],
        [11, -61],
        [30, -23],
        [37, -70],
        [79, -35],
        [5, -61],
        [31, -59],
        [63, -35],
        [30, -1],
        [20, -26],
        [29, -97],
        [0, -27],
        [64, -72],
        [15, -65],
        [38, -57],
        [28, -18],
        [-5, -67],
        [-68, -120],
        [10, -50],
        [48, -13],
        [55, -37],
        [22, -30],
        [55, -42],
        [35, -39],
        [9, -36],
        [36, -15],
        [50, -1],
        [122, -52],
        [25, -21],
        [10, -33],
        [67, -35],
        [41, -10],
        [82, 12],
        [26, -33],
        [153, -31],
        [58, -2],
        [44, -17],
        [63, -86],
        [19, -14],
        [88, 8],
        [34, -15],
        [50, 8],
        [2, -60],
        [27, -26],
        [7, -40],
        [-39, -26],
        [-71, 21],
        [-78, -60],
        [-87, -119],
        [-22, -65],
        [-21, -103],
        [-3, -58],
        [7, -72],
        [20, -60],
        [41, -48],
        [34, -16],
        [18, -26],
        [66, -35],
        [25, -63],
        [27, -39],
        [32, -13],
        [0, -45],
        [38, -65],
        [46, -32],
        [62, -29],
        [45, -4],
        [15, -18],
        [2, -76],
        [45, -25],
        [226, 104],
        [33, 38],
        [61, 9],
        [48, 61],
        [23, 4],
        [36, -34],
        [62, -29],
        [16, -45],
        [69, -34],
        [20, -26],
        [34, -10],
        [43, -54],
        [35, -18],
        [61, -76],
        [52, -77],
        [12, -41],
        [80, -47],
        [33, -39],
        [89, -52],
        [47, 7],
        [1, -38],
        [35, -39],
        [17, -45],
        [31, -12],
        [2, -33],
        [74, -35],
        [25, -32],
        [32, -20],
        [42, -7],
        [15, -45],
        [48, -10],
        [10, -20],
        [45, -4],
        [68, -59],
        [40, -13],
        [-3, -72],
        [-18, -57],
        [-7, -79],
        [9, -98],
        [-6, -21],
        [19, -50],
        [-19, -71],
        [-11, -172],
        [20, -64],
        [20, -15],
        [20, -21],
        [61, -25],
        [91, -46],
        [38, -2],
        [59, -31],
        [36, -4],
        [96, 7],
        [8, 23],
        [39, -14],
        [36, -53],
        [41, -7],
        [-45, -73],
        [8, -88],
        [-30, -42],
        [-23, -5],
        [-4, -50],
        [-23, -57],
        [11, -11],
        [9, -73],
        [-7, -91],
        [2, -40],
        [33, -60],
        [63, -50],
        [36, -5],
        [40, -54],
        [46, -28],
        [-62, -23],
        [8, -37],
        [30, -41],
        [39, -28],
        [52, -4],
        [16, -23],
        [34, -7],
        [4, -24],
        [41, -71],
        [-11, -30],
        [28, -73],
        [-5, -102],
        [-38, 2],
        [-15, -21],
        [-12, -99],
        [44, -62],
        [26, -114],
        [26, -55],
        [-4, -102],
        [31, -53],
        [32, -22],
        [15, -28],
        [-1, -35],
        [14, -34],
        [-2, -40],
        [20, -79],
        [22, -25],
        [24, -65],
        [43, -36],
        [51, -21],
        [-3, -84],
        [26, -33],
        [-1, -37],
        [-43, -46],
        [-10, -68],
        [-43, -36],
        [-22, -34],
        [-4, -38],
        [27, -48],
        [7, -123],
        [-24, -41],
        [-60, -64],
        [-7, -63],
        [23, -66],
        [-15, -45],
        [17, -38],
        [41, -31],
        [30, -53],
        [-8, -54],
        [10, -58],
        [-26, -38],
        [37, -71],
        [11, -55],
        [2, -64],
        [11, -37],
        [52, -1],
        [8, 25],
        [60, -60],
        [14, -33],
        [-31, -25],
        [-21, -56],
        [2, -69],
        [32, -84],
        [52, -25],
        [66, -78],
        [65, -21],
        [57, -39],
        [55, -87],
        [23, 1],
        [21, 28],
        [29, -4],
        [16, -46],
        [38, -67],
        [-20, -37],
        [25, -60],
        [30, -118],
        [20, -20],
        [-5, -78],
        [31, -69],
        [5, -56],
        [55, -80],
        [32, -22],
        [44, -98],
        [89, -37],
        [-4, -26],
        [17, -51],
        [40, -46],
        [34, -19],
        [23, -43],
        [26, -16],
        [100, 1],
        [89, -7],
        [8, -36],
        [50, -19],
        [18, 37],
        [69, -23],
        [61, 5],
        [63, -13],
        [-1, -26],
        [-26, -37],
        [8, -56],
        [32, -58],
        [-30, -13],
        [4, -66],
        [-31, -19],
        [5, -71],
        [33, -41],
        [21, -73],
        [40, -26],
        [-1, -42],
        [18, -43],
        [1, -54],
        [30, -43],
        [-3, -21],
        [42, -41],
        [17, -39],
        [10, -83],
        [69, -58],
        [43, -6],
        [-11, -28],
        [50, -47],
        [11, -41],
        [-13, -41],
        [44, -23],
        [-8, -29],
        [19, -55],
        [-36, -10],
        [-11, -20],
        [-3, -56],
        [33, -66],
        [-11, -31],
        [19, -79],
        [29, -48],
        [31, -16],
        [15, -31],
      ],
      [
        [31864, 59844],
        [36, -23],
        [18, -47],
        [-26, -16],
        [-28, 86],
      ],
      [
        [28902, 62856],
        [64, -55],
        [44, -51],
        [39, -16],
        [-12, -36],
        [20, -27],
        [-23, -88],
        [-24, -55],
        [-40, -6],
        [-47, -27],
        [-48, 86],
        [1, 49],
        [-15, 48],
        [-40, 77],
        [-34, 32],
        [12, 54],
        [44, 51],
        [22, 1],
        [37, -37],
      ],
      [
        [29794, 63867],
        [79, -5],
        [49, -60],
        [11, -27],
        [-19, -32],
        [-38, 1],
        [-68, -16],
        [-56, 15],
        [-35, 57],
        [13, 44],
        [64, 23],
      ],
      [
        [14587, 65991],
        [47, -49],
        [98, -26],
        [12, -30],
        [-40, -59],
        [-28, -14],
        [-40, 92],
        [-61, 62],
        [-82, 21],
        [-32, 28],
        [32, 30],
        [94, -55],
      ],
      [
        [39386, 47540],
        [-22, -73],
        [-60, 29],
        [-35, -6],
        [-26, 13],
        [-84, 18],
        [-64, -2],
        [-65, 97],
        [-71, 97],
        [-29, 66],
        [-85, 235],
        [-21, 73],
        [-4, 45],
        [24, 58],
        [-8, 57],
        [-90, 149],
        [10, 128],
        [16, 56],
        [-6, 29],
        [21, 38],
        [38, -51],
        [16, -65],
        [47, -56],
        [36, -80],
        [35, -38],
        [48, -91],
        [1, -28],
        [37, -54],
        [23, -59],
        [55, -58],
        [8, -45],
        [39, -48],
        [22, -61],
        [55, -47],
        [50, -64],
        [45, -112],
        [8, -58],
        [39, -62],
        [-3, -30],
      ],
      [
        [36840, 49416],
        [35, -7],
        [58, -43],
        [37, -75],
        [35, -27],
        [46, 11],
        [27, -39],
        [-23, -26],
        [35, -57],
        [34, -4],
        [15, -22],
        [-22, -70],
        [-72, -19],
        [-18, -77],
        [25, -66],
        [-49, -27],
        [-30, -46],
        [-5, -41],
        [-61, 9],
        [-24, -15],
        [-32, 18],
        [29, 50],
        [-41, 19],
        [34, 60],
        [-38, 22],
        [-56, -5],
        [-33, 69],
        [69, 23],
        [-40, 24],
        [46, 57],
        [-83, 1],
        [-61, 52],
        [-9, 90],
        [40, 35],
        [-36, 44],
        [-7, 37],
        [42, 0],
        [75, 34],
        [28, 22],
        [30, -11],
      ],
      [
        [36669, 49706],
        [48, -35],
        [-2, -50],
        [13, -21],
        [51, -33],
        [32, -57],
        [-5, -42],
        [-38, -36],
        [-26, 0],
        [-29, 21],
        [-9, -34],
        [-45, 3],
        [21, 56],
        [57, 45],
        [-34, 20],
        [-41, -32],
        [-68, -31],
        [6, 38],
        [42, 25],
        [-26, 22],
        [3, 25],
        [-38, 37],
        [42, 31],
        [-4, 28],
        [18, 27],
        [32, -7],
      ],
      [
        [35863, 50941],
        [-6, -85],
        [-40, -13],
        [-49, 40],
        [26, 47],
        [46, 27],
        [23, -16],
      ],
      [
        [35217, 52250],
        [43, -32],
        [15, -26],
        [7, -65],
        [17, -40],
        [35, -52],
        [59, -47],
        [106, -14],
        [117, -38],
        [74, -14],
        [62, -30],
        [1, -37],
        [43, -38],
        [28, -6],
        [-7, -41],
        [29, -44],
        [16, -46],
        [1, -47],
        [-21, -112],
        [29, -56],
        [32, -82],
        [24, -22],
        [11, -55],
        [50, -85],
        [58, -74],
        [-27, -27],
        [-97, -21],
        [-62, 4],
        [-73, -30],
        [47, 64],
        [-5, 41],
        [-60, 31],
        [-59, 48],
        [-50, 20],
        [-17, 31],
        [-70, 8],
        [-46, 26],
        [20, 32],
        [-33, 66],
        [-54, 26],
        [-27, 94],
        [7, 17],
        [-31, 66],
        [-40, 53],
        [0, 69],
        [-34, 67],
        [-73, 8],
        [-34, 43],
        [-36, -3],
        [-16, 43],
        [-6, 78],
        [22, 56],
        [1, 99],
        [14, 44],
        [-9, 28],
        [19, 22],
      ],
      [
        [34913, 55251],
        [19, -89],
        [25, -15],
        [-28, -62],
        [23, -102],
        [15, -24],
        [-3, -36],
        [26, -177],
        [-5, -43],
        [-19, -31],
        [-63, 48],
        [-32, -10],
        [-33, 40],
        [-15, 80],
        [-49, 72],
        [5, 98],
        [14, 115],
        [57, 71],
        [24, 59],
        [39, 6],
      ],
      [
        [33708, 55262],
        [14, -59],
        [30, -30],
        [35, -13],
        [20, -74],
        [0, -42],
        [-53, -60],
        [-8, -32],
        [-75, 35],
        [-23, 49],
        [5, 28],
        [-11, 48],
        [-38, 64],
        [-2, 57],
        [64, -7],
        [10, 28],
        [32, 8],
      ],
      [
        [32672, 55744],
        [23, 0],
        [6, -37],
        [29, -68],
        [5, -78],
        [18, -27],
        [-15, -23],
        [-62, 92],
        [16, 68],
        [-5, 60],
        [-15, 13],
      ],
      [
        [33175, 56908],
        [17, -3],
        [68, 35],
        [-10, 34],
        [27, 29],
        [46, -41],
        [60, -14],
        [2, -18],
        [65, 32],
        [21, -12],
        [42, 23],
        [21, 33],
        [36, -15],
        [-57, -105],
        [-23, -58],
        [4, -23],
        [-12, -62],
        [5, -46],
        [19, -40],
        [38, -12],
        [-10, -53],
        [33, -66],
        [-65, 19],
        [-38, 48],
        [-26, 7],
        [-20, 44],
        [-43, 24],
        [-60, -25],
        [-10, -76],
        [-50, -89],
        [-42, -33],
        [-59, -110],
        [-79, -75],
        [-41, -76],
        [3, -33],
        [-20, -55],
        [13, -77],
        [-33, -50],
        [-26, 4],
        [-41, -49],
        [1, -135],
        [12, -53],
        [-14, -19],
        [-33, 47],
        [-76, 32],
        [-12, 38],
        [-11, 90],
        [26, 33],
        [18, 50],
        [40, 22],
        [-11, 58],
        [24, 144],
        [22, 19],
        [-8, 78],
        [25, 24],
        [21, 41],
        [8, 63],
        [42, 35],
        [4, 28],
        [33, 34],
        [35, 18],
        [20, 66],
        [-22, 58],
        [18, 53],
        [30, 20],
        [-41, 44],
        [-18, 68],
        [64, 7],
        [48, 21],
      ],
      [
        [32648, 57351],
        [16, -63],
        [-14, -38],
        [11, -39],
        [-19, -10],
        [-87, 0],
        [26, 36],
        [-35, 22],
        [10, 38],
        [53, 51],
        [39, 3],
      ],
      [
        [124332, 17449],
        [-99, 9],
        [-45, 28],
        [-38, -21],
        [-31, 5],
        [-39, -17],
        [-31, 14],
        [-14, 43],
        [-29, 24],
        [-38, -7],
        [-40, 13],
        [-32, -5],
        [-69, 19],
        [-34, 57],
        [-37, 11],
        [-102, 50],
        [-50, 42],
        [-53, -7],
        [-26, 25],
        [-9, 49],
        [-50, 1],
        [7, 121],
        [58, -2],
        [-20, 78],
        [-42, -2],
        [-19, -46],
        [-21, -3],
        [-46, -68],
        [-84, 59],
        [-15, -8],
        [-52, 13],
        [-58, -6],
        [-13, -27],
        [49, -51],
        [-70, -63],
        [-36, -24],
        [24, -46],
        [3, -33],
        [-64, -4],
        [-35, -63],
        [21, -60],
        [-11, -57],
        [-29, -18],
        [-20, -34],
        [31, -62],
        [-23, -118],
        [-8, -79],
        [10, -21],
        [6, -74],
        [-19, -63],
        [-8, -73],
        [3, -44],
        [-17, -18],
        [13, -32],
        [10, -116],
        [32, -31],
        [-94, -39],
        [18, -39],
        [-43, -114],
        [-152, 102],
        [-189, 120],
        [2, 13],
        [-58, 26],
        [-63, 47],
        [-29, 22],
        [-71, 83],
        [-9, -91],
        [-26, 46],
        [-13, -20],
        [-155, 139],
        [-287, 53],
        [-97, 114],
        [-57, 29],
        [-42, 8],
        [-118, -18],
        [-22, 12],
        [-123, 17],
        [-13, 46],
        [-41, 86],
        [-56, -20],
        [-77, 56],
        [-32, 13],
        [-38, 60],
        [-18, 55],
        [-52, 8],
        [-20, 19],
        [29, 30],
        [-5, 36],
        [-21, 16],
        [-50, -20],
        [-44, 21],
        [-27, -30],
        [-40, 10],
        [-10, -31],
        [-24, -10],
        [-37, 30],
        [-74, 9],
        [-37, 35],
        [-25, 5],
        [-26, 34],
        [-4, 57],
        [-95, 81],
        [1, 63],
        [-56, 29],
        [2, 165],
        [-18, 46],
        [71, 62],
        [-140, 288],
        [-17, 27],
        [46, 5],
        [-10, 58],
        [-23, 14],
        [40, 243],
        [-48, 183],
        [22, 0],
        [4, 195],
        [1, 211],
        [-131, -6],
        [-168, 6],
        [-309, -4],
        [-60, 50],
        [-47, -36],
        [-46, -32],
        [-33, -53],
        [-52, 14],
        [2, 56],
        [-27, 36],
        [-47, 24],
        [-58, 49],
        [-45, -1],
        [-57, 22],
        [-17, 19],
        [-55, 127],
        [11, 95],
        [-1, 84],
        [-21, 64],
        [-55, 97],
        [-29, 39],
        [-42, 91],
        [-46, 42],
        [-6, 45],
        [9, 44],
        [-17, 81],
      ],
      [
        [119086, 20355],
        [371, 76],
        [113, 16],
        [134, 11],
        [170, 7],
        [388, 22],
        [75, 14],
        [62, 3],
        [89, 15],
        [236, 13],
        [105, 11],
        [172, 12],
        [245, 27],
        [142, 1],
        [54, -6],
        [26, -15],
        [98, -137],
        [41, -79],
        [26, -37],
        [93, -77],
        [73, -40],
        [102, -27],
        [142, 87],
        [-22, 3],
        [-60, 80],
        [-41, 21],
        [53, 64],
        [213, 14],
        [150, 34],
        [89, 27],
        [109, 45],
        [86, 53],
        [6, 31],
        [61, 29],
        [108, 28],
        [51, 33],
        [10, 18],
        [49, 30],
        [410, 179],
        [56, 44],
        [28, 8],
        [12, -54],
        [28, -17],
        [111, 79],
        [0, 46],
        [138, 124],
        [73, 59],
        [111, 134],
        [23, 36],
        [104, 118],
        [77, 57],
        [130, 81],
        [132, 77],
        [175, 87],
        [171, 69],
        [124, 59],
        [186, 102],
        [22, 23],
        [97, 53],
        [200, 121],
        [19, 50],
        [74, 52],
        [62, 64],
        [217, 143],
        [187, 114],
        [63, 51],
        [189, 129],
        [131, 99],
        [53, 43],
        [2, 13],
        [141, 127],
        [147, 145],
        [52, 45],
        [109, 86],
        [110, 102],
        [83, 91],
        [99, 136],
        [40, 89],
        [25, 29],
        [3, 31],
        [-14, 64],
        [2, 124],
        [41, 93],
        [25, 86],
        [0, 35],
        [20, 73],
        [-8, 32],
        [21, 78],
        [-4, 79],
        [-26, 45],
        [4, 58],
        [-11, 35],
        [19, 48],
        [14, 75],
        [-7, 36],
        [-29, 14],
        [58, 101],
        [38, 91],
        [25, 118],
        [-6, 45],
        [-32, 54],
        [-58, 19],
        [13, 65],
        [-16, 66],
        [80, 82],
        [25, 52],
        [31, 28],
        [36, 56],
        [13, 42],
        [-16, 34],
        [20, 77],
        [23, 40],
        [40, 29],
        [84, 82],
        [46, 58],
        [46, 20],
        [70, 56],
        [90, 62],
        [118, 71],
        [88, 87],
        [48, 21],
        [76, 53],
        [33, 64],
        [34, 20],
        [47, 99],
        [26, 30],
        [33, 82],
        [34, 16],
        [20, 72],
        [24, 55],
        [25, 14],
        [-33, 27],
        [4, 47],
        [-40, -2],
        [-49, 103],
        [51, 38],
        [-7, 39],
        [-35, 69],
        [-36, 35],
        [-4, 46],
        [-25, 38],
        [-27, 62],
        [23, 39],
        [-2, 92],
        [28, 43],
        [7, 84],
        [-19, 81],
        [-26, 63],
        [-28, 70],
        [5, 35],
        [26, 32],
        [36, 16],
        [13, 55],
        [-10, 24],
        [-12, 105],
        [-31, 25],
        [6, 39],
        [-3, 135],
        [-14, 60],
        [-2, 56],
        [11, 39],
        [-3, 112],
        [-9, 23],
        [11, 87],
        [-24, 65],
        [8, 45],
        [30, 66],
        [13, 45],
        [-37, 166],
        [-5, 53],
        [-17, 64],
        [21, 48],
        [-13, 62],
        [-25, 18],
        [-11, 50],
        [11, 20],
        [44, -9],
        [24, -23],
        [30, 22],
        [-45, 34],
        [-12, 23],
        [-44, -36],
        [-7, 131],
        [36, 102],
        [0, 24],
        [41, 96],
        [15, 70],
        [44, 64],
        [18, 58],
        [19, 25],
        [10, 60],
        [40, 77],
        [7, 69],
        [19, 26],
        [12, 200],
        [16, 28],
        [-8, 67],
        [9, 9],
        [-1, 91],
        [-30, 13],
        [68, 59],
        [15, 46],
        [-4, 38],
        [36, 7],
        [59, 67],
        [18, 80],
        [-27, 2],
        [-10, 55],
        [3, 64],
        [-8, 31],
        [8, 62],
        [49, 112],
        [-4, 22],
      ],
      [
        [128579, 31207],
        [21, -8],
        [95, 16],
        [-12, -489],
        [0, -10],
        [-22, -947],
        [209, -10],
        [27, 112],
        [0, -174],
        [463, 21],
        [25, -9],
        [-15, -117],
        [40, -4],
        [-48, -240],
        [227, -47],
        [-7, -119],
        [119, 23],
        [144, -7],
        [99, -43],
        [32, -30],
        [154, -1],
        [6, 44],
        [42, -6],
        [7, 56],
        [33, 76],
        [39, 43],
        [90, 44],
        [66, 1],
        [8, 47],
        [467, -603],
        [297, -385],
        [-158, 3],
        [-11, -126],
        [-4, -45],
        [160, -10],
        [-25, -185],
        [13, -22],
        [188, -38],
        [-2, -180],
        [41, -143],
        [28, 41],
        [66, 42],
        [96, 117],
        [20, 14],
        [688, -895],
        [-27, -296],
        [40, -4],
        [-8, -81],
        [49, -4],
        [-2, -227],
        [72, -107],
        [-26, 3],
        [190, -276],
        [47, -109],
        [230, -22],
        [-15, -151],
        [-57, 9],
        [66, -155],
        [41, -54],
        [92, -9],
        [165, -241],
        [532, -485],
      ],
      [
        [133674, 24805],
        [690, -630],
        [-2, -975],
        [0, -461],
        [52, -4],
        [-53, -680],
        [-6, -582],
        [17, -383],
        [3, -216],
        [-53, -14],
        [17, -86],
        [3, -170],
        [8, -750],
        [-3, -486],
        [114, -3],
        [20, -320],
        [-78, -2],
        [26, -455],
        [-88, 1],
        [-30, -357],
        [70, 14],
        [-1, -388],
        [-262, -5],
        [-10, -303],
        [267, -5],
        [-2, -122],
        [-86, 1],
        [1, -195],
        [-200, 14],
        [-2, -237],
        [6, -94],
        [247, -3],
        [1, -66],
      ],
      [
        [134340, 16843],
        [1, -617],
        [-817, 0],
        [-752, -4],
        [-863, 5],
        [-430, 2],
        [-341, -4],
        [-375, -2],
        [-907, 9],
        [-546, -5],
        [-162, -1],
        [-367, -13],
        [-363, 10],
        [-675, 6],
        [-452, -2],
        [-594, -1],
        [-283, -2],
        [-517, 2],
      ],
      [
        [125897, 16226],
        [0, 296],
        [-37, 1],
        [1, 132],
        [36, -4],
        [-1, 302],
        [-608, 5],
        [30, 60],
        [-78, 32],
        [-12, -120],
        [-83, 24],
        [31, 61],
        [-121, 14],
        [-65, -26],
        [-35, 27],
        [-115, -15],
        [-29, 31],
        [-31, 3],
        [-58, 41],
        [-23, 71],
        [-81, 54],
        [-72, 42],
        [-69, 88],
        [-62, 30],
        [-38, 7],
        [-26, 23],
        [-19, 44],
      ],
      [
        [128276, 30094],
        [-37, -16],
        [26, 67],
        [12, 66],
        [24, 3],
        [-25, -120],
      ],
      [
        [128358, 30395],
        [5, -28],
        [-7, -91],
        [-58, 45],
        [-5, 47],
        [35, 63],
        [30, -36],
      ],
      [
        [73126, 52305],
        [45, -336],
        [32, -240],
        [-1027, 332],
      ],
      [
        [72176, 52061],
        [-359, -620],
        [-484, -837],
        [-15, -158],
        [-61, 11],
        [-20, 29],
        [-44, 15],
        [-10, 33],
        [-49, 43],
        [-52, 8],
        [-72, 61],
        [-43, -12],
        [-76, 9],
        [-66, 41],
        [-8, 30],
        [-34, -8],
        [-25, 34],
        [-48, -16],
        [-81, -14],
        [-43, 39],
        [-22, -7],
        [-62, 56],
        [-93, -5],
        [-72, 43],
        [-79, 8],
        [-45, 30],
        [-747, 683],
        [27, 25],
        [15, 45],
        [23, 22],
        [-8, 65],
        [-36, 38],
        [-56, 39],
        [-34, 43],
        [17, 56],
        [1, 38],
        [-19, 29],
        [26, 21],
        [-4, 25],
        [31, 21],
        [-68, 18],
        [-69, 49],
        [-3, 30],
        [-27, 17],
        [-61, 13],
        [-45, 46],
        [-46, 10],
        [-36, 30],
        [2, 27],
        [-30, 15],
        [-29, -17],
        [-32, 13],
        [-50, 69],
        [-32, 89],
        [-93, 110],
        [-3, 56],
        [-22, 34],
        [-72, 48],
        [0, 21],
        [-33, 26],
        [-36, -8],
        [-56, 51],
        [-20, 46],
        [4, 37],
        [-79, 58],
        [-30, 56],
        [-53, 16],
        [-33, -4],
        [-23, 16],
        [-12, 47],
        [-30, 55],
        [-23, 20],
        [4, 48],
        [53, 19],
        [10, 75],
        [13, 12],
        [38, 19],
        [27, 47],
        [-34, 28],
        [76, 76],
        [18, 31],
        [1, 33],
        [22, 61],
        [-6, 21],
        [81, 42],
        [89, 27],
        [24, 21],
        [61, 25],
        [50, -17],
        [24, 9],
        [48, -32],
        [37, -2],
        [32, 14],
        [35, -41],
        [30, -59],
        [66, -8],
        [-3, 127],
        [-17, 64],
        [-45, 1],
        [-82, 31],
        [-100, 90],
        [-37, 78],
        [-134, 123],
        [-35, 18],
        [-183, 191],
        [-83, 95],
        [1, 8],
        [112, 42],
        [65, 54],
        [15, 38],
        [-6, 48],
        [28, 30],
        [52, 6],
        [7, 33],
        [-16, 39],
        [39, 15],
        [7, 55],
        [46, 11],
        [-35, 32],
        [20, 28],
        [35, -6],
        [46, 23],
        [-27, 51],
        [4, 21],
        [36, 11],
        [56, -24],
        [32, -1],
        [-12, 61],
        [12, 22],
        [54, 43],
        [27, 39],
        [18, 71],
        [18, 14],
        [2, 41],
        [68, 28],
        [-6, 16],
        [-52, 39],
        [63, 43],
        [59, 173],
        [-2, 60],
        [17, 58],
        [3, 84],
        [17, 25],
        [-1, 43],
        [-18, 49],
        [-40, 33],
        [-26, 62],
        [-32, 40],
        [-11, 41],
        [-1, 82],
        [-18, 1311],
        [413, 704],
        [-257, 380],
        [-263, 1189],
        [-193, 72],
        [-1016, 374],
        [-32, -12],
        [-66, 145],
        [-111, 11],
        [-77, 17],
      ],
      [
        [67443, 60257],
        [-13, 28],
        [-62, 21],
        [-45, 183],
        [-118, 187],
        [-16, 97],
        [-37, 19],
        [-80, 14],
        [-48, 47],
        [-67, 47],
        [-83, 99],
        [-40, 25],
        [-50, 55],
        [-43, 23],
        [-1, 45],
        [74, 151],
        [-75, -5],
        [310, 227],
        [22, 139],
        [153, 66],
        [12, 19],
        [-7, 76],
        [-14, 52],
        [-15, 122],
        [-21, 27],
        [-89, 41],
        [-36, 4],
        [-73, 166],
        [4, 438],
        [-50, 177],
        [-49, -30],
        [-14, 72],
        [-35, 94],
        [-6, 106],
        [-207, 66],
        [61, 639],
        [24, -5],
        [18, 542],
        [-25, 107],
        [-41, 178],
        [-68, -31],
        [-62, 275],
        [64, 5],
        [-57, 81],
        [29, 195],
        [-34, 134],
        [71, -7],
        [-249, 289],
        [160, 144],
        [-199, 0],
        [-21, 21],
        [-53, 21],
        [65, 105],
        [1, 160],
        [11, 0],
        [-54, 306],
        [90, -27],
        [-30, -87],
        [226, -68],
        [70, 215],
        [-226, 68],
        [172, 440],
        [131, 241],
        [-30, 15],
        [457, 931],
        [23, -10],
        [159, 288],
        [394, 771],
        [-2, 90],
        [-21, 11],
        [27, 58],
        [22, 48],
        [58, 132],
        [109, -31],
        [42, 79],
        [-111, 37],
        [90, 203],
        [67, -52],
        [43, 58],
        [70, -146],
        [173, 284],
        [24, -17],
        [235, 452],
        [-14, 14],
        [160, 266],
        [37, 40],
        [62, 97],
        [25, -57],
        [20, -4],
        [28, 57],
        [-44, 143],
        [152, 187],
        [60, 66],
        [223, 400],
        [10, 13],
      ],
      [
        [69246, 71519],
        [21, 20],
        [31, -8],
        [44, -31],
        [19, -54],
        [-22, -61],
        [30, -4],
        [27, 28],
        [35, 71],
        [51, -35],
        [22, -41],
        [62, 5],
        [54, 41],
        [22, -31],
        [26, 19],
        [51, -2],
        [145, -32],
        [30, -32],
        [57, -12],
        [84, 58],
        [39, -8],
        [51, 12],
        [8, 25],
        [-16, 52],
        [41, 67],
        [32, 22],
        [16, 39],
        [-38, 63],
        [25, 54],
        [2, 54],
        [42, 17],
        [67, 60],
        [-16, 55],
        [45, 32],
        [29, -11],
        [44, 46],
        [44, -26],
        [52, 29],
        [7, 29],
        [-19, 36],
        [37, 5],
        [43, 53],
        [31, 12],
        [-16, 30],
        [30, 14],
        [5, 53],
        [25, 10],
        [30, 50],
        [-10, 68],
        [38, 47],
        [55, 15],
        [74, -33],
        [51, -15],
        [82, 87],
        [70, -18],
        [-6, 37],
        [20, 8],
        [9, 37],
        [-12, 50],
        [28, 13],
        [40, -41],
        [30, -16],
        [41, 10],
        [79, 61],
        [8, 19],
        [-20, 35],
        [-2, 32],
        [-47, 28],
        [-28, -2],
        [-40, 40],
        [-31, 1],
        [-16, 40],
        [33, 34],
        [-20, 44],
        [71, 73],
        [-22, 76],
        [25, 16],
        [33, 149],
        [-17, 25],
        [31, 41],
        [19, -13],
        [50, -5],
        [79, 32],
        [0, 80],
        [52, 26],
        [4, 41],
        [35, 48],
        [43, -1],
        [12, 27],
        [-53, 1],
        [-7, 26],
        [-31, 17],
        [28, 30],
        [-23, 75],
        [6, 60],
        [32, 37],
        [-8, 27],
        [33, 46],
        [17, 77],
        [63, 18],
        [-30, 40],
        [-2, 144],
        [43, 17],
        [29, 30],
        [-5, 33],
        [21, 20],
        [48, 0],
        [16, 37],
        [-14, 48],
        [20, 29],
        [-2, 33],
        [43, 1],
        [11, 30],
        [-29, 75],
        [31, 19],
        [78, -27],
        [22, 24],
        [4, 135],
        [-13, 23],
        [23, 47],
        [53, 21],
        [14, 37],
        [46, 37],
        [40, 64],
        [34, 3],
        [14, 24],
        [-28, 43],
        [4, 57],
        [44, 39],
        [-9, 82],
        [43, 32],
        [19, 64],
        [39, 24],
        [8, -35],
        [36, -18],
        [60, -8],
        [72, 1],
        [37, 10],
        [36, 52],
        [52, 20],
        [68, -7],
        [37, 28],
        [38, 13],
        [-13, 44],
        [20, 26],
        [35, -18],
        [38, -65],
        [-2, -28],
        [34, -22],
        [62, 51],
        [49, 23],
        [49, 34],
        [11, 24],
        [-39, 45],
        [12, 20],
        [81, -17],
        [51, 28],
        [19, -9],
        [17, -43],
        [29, 0],
        [32, 37],
        [43, -43],
        [57, 12],
        [26, -19],
        [26, 18],
        [49, -33],
        [87, -25],
        [26, 22],
        [24, -6],
        [17, -32],
        [22, 44],
        [-24, 51],
        [60, 41],
        [0, 55],
        [34, 94],
        [31, 57],
        [-9, 68],
        [60, 38],
        [11, 50],
        [40, 32],
        [32, -6],
        [7, -26],
        [44, 15],
        [-10, 31],
        [15, 30],
        [95, -3],
        [65, -32],
        [26, -41],
        [53, 23],
        [32, -10],
        [-1, -57],
        [42, -7],
        [18, 53],
        [30, -18],
        [-3, -57],
        [50, 1],
        [44, -38],
        [39, 15],
        [39, -2],
        [35, -33],
        [27, 13],
        [18, 46],
        [35, -15],
        [16, -45],
        [-14, -26],
        [10, -26],
        [52, 2],
        [37, -58],
        [48, -17],
        [26, -38],
        [67, -25],
        [43, 21],
        [14, -46],
        [39, -7],
        [31, 8],
        [28, -11],
        [55, 19],
        [40, -37],
        [121, -9],
        [12, 22],
        [37, 12],
        [-14, 26],
        [28, 31],
        [72, -15],
        [23, -18],
        [75, 42],
        [38, -47],
        [22, 9],
        [14, 38],
        [-1, 43],
        [39, 3],
        [37, -21],
        [18, -65],
        [26, -13],
        [40, 28],
        [43, -2],
        [19, -20],
        [0, -57],
        [21, -13],
        [30, 16],
        [44, 58],
        [104, -1],
        [33, -19],
        [39, 3],
        [49, 29],
        [36, 35],
        [25, 3],
        [53, -64],
        [60, -35],
        [34, 28],
        [-32, 56],
        [13, 30],
        [30, 5],
        [58, -39],
        [-46, -50],
        [6, -36],
        [41, -32],
        [69, -1],
        [12, 39],
        [55, 6],
        [82, -44],
        [7, -11],
        [54, 7],
        [22, -32],
        [36, -5],
        [44, 23],
        [53, -71],
        [53, 19],
        [38, 27],
        [40, -53],
        [47, 44],
        [41, 10],
        [28, -26],
        [14, -36],
        [41, -23],
        [35, 19],
        [30, 58],
        [59, 0],
        [46, 22],
        [52, -12],
        [93, -12],
        [10, 75],
        [-9, 17],
        [31, 55],
        [73, 26],
        [24, 34],
        [30, -12],
        [24, -47],
        [-17, -64],
        [5, -43],
        [-8, -85],
        [42, -10],
        [42, 31],
        [81, -5],
        [79, 54],
        [32, 43],
        [70, 31],
        [46, -17],
        [-7, -58],
        [21, -104],
        [33, -17],
        [27, 4],
        [112, 88],
        [47, 16],
        [24, -45],
        [-24, -25],
        [-57, -35],
        [11, -33],
        [62, -27],
        [19, -23],
        [-11, -89],
        [18, -22],
        [95, -44],
        [18, -44],
        [-15, -68],
        [38, -59],
        [13, -79],
        [26, -17],
        [32, 57],
        [17, 14],
        [39, -15],
        [92, 2],
        [72, -44],
        [5, -65],
        [-45, -104],
        [-10, -55],
        [10, -93],
        [20, -35],
        [43, -38],
        [35, 8],
        [50, 75],
        [6, 52],
        [-16, 91],
        [56, 59],
        [23, 3],
        [48, -20],
        [23, -47],
        [-20, -74],
        [41, -158],
        [-1, -27],
        [-27, -28],
        [-41, -80],
        [-13, -59],
        [6, -35],
        [18, -14],
        [86, 14],
        [72, -12],
        [56, 1],
        [94, -13],
        [59, -34],
        [33, -61],
        [58, -82],
        [40, -42],
        [33, -6],
        [41, 17],
        [84, -33],
        [92, 15],
        [51, -10],
        [94, -34],
        [21, -87],
        [1, -29],
        [63, -57],
        [23, -59],
        [5, -51],
        [31, -37],
        [49, -39],
        [29, -57],
        [-2, -32],
        [41, -40],
        [93, -27],
        [57, -30],
        [46, -33],
        [55, 3],
        [26, -18],
        [22, -57],
        [56, -30],
        [46, -11],
        [8, -28],
        [83, -47],
        [53, -7],
        [24, -47],
        [9, -83],
        [74, -28],
        [41, -2],
        [63, -55],
        [32, -15],
        [71, 15],
        [25, -14],
        [-17, -36],
        [39, -7],
        [48, -28],
        [15, -25],
        [-11, -59],
        [24, -22],
        [27, 11],
        [54, -86],
        [-11, -53],
        [31, -2],
        [16, -38],
        [-1, -34],
        [-41, -49],
        [10, -32],
        [44, -21],
        [-1, -20],
        [95, -36],
        [27, -24],
        [-4, -44],
        [53, -51],
        [82, -50],
        [44, -8],
        [67, -28],
        [49, -57],
        [22, -48],
        [21, -75],
        [4, -120],
        [16, -92],
        [18, -69],
        [23, -48],
        [9, -62],
        [16, -39],
        [-12, -25],
        [8, -81],
        [-19, -20],
        [16, -35],
        [-20, -55],
        [17, -17],
        [53, -73],
        [24, -7],
        [5, -32],
        [-38, -7],
        [26, -63],
        [18, -4],
        [28, 36],
        [28, -15],
        [24, -33],
        [47, 5],
        [-14, -63],
        [22, -11],
        [39, 14],
        [2, -29],
        [-39, -20],
        [9, -32],
        [30, -1],
        [-5, -41],
        [82, -73],
        [-15, -64],
        [28, -53],
        [41, 15],
        [70, -18],
        [2, -61],
        [48, -36],
        [13, -86],
        [-22, -41],
        [38, -58],
        [-17, -48],
        [19, -14],
        [37, 8],
        [31, -31],
        [-5, -36],
        [37, -18],
        [-3, -88],
        [6, -27],
        [-22, -46],
        [15, -118],
        [37, -109],
        [16, -15],
        [78, -15],
        [21, -39],
        [63, -35],
        [68, 6],
        [6, -21],
        [-15, -100],
        [5, -37],
        [65, -21],
        [23, -50],
        [129, -45],
        [14, -56],
        [-55, -94],
        [0, -60],
        [21, -42],
        [49, -40],
        [26, -60],
        [136, -40],
        [9, -12],
        [88, -16],
        [18, -24],
        [-49, -52],
        [-108, -33],
        [6, -31],
        [119, -120],
        [14, -26],
        [8, -68],
        [-28, -80],
        [-35, -51],
        [31, -81],
        [111, -134],
        [22, -71],
        [24, -34],
        [81, -93],
        [23, -61],
        [-37, -119],
        [22, -47],
        [36, -22],
        [24, -42],
        [91, -108],
        [57, -24],
        [89, 6],
        [36, -48],
        [26, -158],
        [23, -19],
        [49, -2],
        [101, -53],
        [26, -38],
        [41, -17],
        [85, 1],
        [95, -60],
        [137, -38],
        [31, -24],
        [18, -52],
        [54, -92],
        [53, -47],
        [2, -71],
        [14, -26],
        [38, -34],
        [74, -25],
        [37, -26],
        [16, -30],
        [19, -119],
        [24, -81],
        [32, -48],
        [46, -90],
        [90, -35],
        [49, -15],
        [122, -7],
        [14, -10],
        [-8, -68],
        [-29, -69],
        [10, -62],
        [44, -16],
        [6, -47],
        [38, -44],
        [78, -27],
        [32, -65],
        [-2, -32],
        [-40, -54],
        [-5, -41],
        [13, -48],
        [38, -41],
        [51, -29],
        [26, -60],
        [-10, -49],
        [18, -59],
        [-16, -71],
        [39, -35],
        [85, -2],
        [25, -64],
        [10, -55],
      ],
      [
        [85175, 65420],
        [-308, -353],
        [-5, 4],
        [-99, -123],
        [-303, -292],
        [-80, 86],
        [-793, 823],
        [-449, -337],
        [-296, -230],
        [-249, -1162],
        [-60, -275],
        [-20, -5],
        [-2, -1],
        [-1175, -285],
        [-718, -691],
        [16, -599],
        [72, -14],
        [34, -26],
        [-9, -38],
        [47, -60],
        [70, 64],
        [65, 21],
        [34, -3],
        [100, -106],
        [23, 41],
        [-44, 55],
        [-14, 103],
        [50, 17],
        [60, -34],
        [23, 7],
        [36, 46],
        [11, 50],
        [68, 56],
        [55, 7],
        [27, -22],
        [10, -102],
        [56, 1],
        [30, -22],
        [12, -32],
        [522, -139],
        [17, -109],
        [-22, -52],
        [-5, -90],
        [10, -49],
        [-24, -35],
        [18, -68],
        [-3, -83],
        [16, -47],
        [-30, -71],
        [29, -94],
        [-14, -86],
        [3, -39],
        [-49, -110],
        [15, -26],
        [12, -59],
        [4, -93],
        [14, -7],
        [0, -75],
        [-31, -45],
        [-48, -41],
        [-144, -144],
        [-51, -111],
        [-31, -130],
        [-29, -124],
        [-354, -355],
        [-22, 48],
        [-262, 552],
        [-557, -498],
        [-142, -127],
        [-362, -312],
        [-437, -377],
        [-149, -121],
        [-309, -262],
        [-51, -35],
        [-79, -73],
        [97, -121],
        [227, -247],
        [146, -168],
        [59, -84],
        [78, -225],
        [29, -49],
        [96, -95],
        [94, -50],
        [84, -29],
        [119, -71],
        [49, -58],
        [89, -136],
        [48, -47],
        [-1, -20],
        [121, -55],
        [54, -331],
        [-4, -255],
        [132, -49],
        [194, -9],
        [34, -122],
        [21, -18],
        [-67, -263],
        [-45, -29],
        [-68, -194],
        [169, -330],
        [90, -136],
        [8, -77],
        [74, -124],
        [33, -188],
        [-4, -35],
        [238, -22],
        [45, -153],
        [136, -178],
        [120, 12],
        [26, -7],
        [81, 23],
        [37, -6],
        [96, -100],
        [-1, -46],
        [73, 13],
        [51, -10],
        [116, -38],
        [99, -15],
        [41, -86],
        [-323, 27],
        [-41, -32],
        [-48, -38],
        [183, -55],
        [-25, -118],
        [109, -31],
        [139, -6],
        [25, -66],
        [37, -4],
        [-24, -73],
        [95, -7],
        [38, -10],
        [112, -45],
        [70, -42],
        [10, -25],
        [-84, -348],
        [112, -30],
        [56, -1],
        [87, -23],
        [1, 14],
        [92, -10],
        [190, 34],
        [14, 10],
        [71, 7],
        [36, 11],
        [71, -23],
        [33, -33],
        [54, -16],
        [50, -29],
        [25, -33],
        [56, -38],
        [45, 8],
        [49, -185],
        [-48, -20],
        [-39, -57],
        [128, -91],
        [-46, -32],
        [69, -56],
        [-146, -53],
        [-202, 31],
        [-93, 44],
        [-29, -177],
        [-82, 29],
        [-124, 35],
        [-69, 28],
        [-72, 19],
        [-167, 71],
        [-132, 39],
        [-121, 32],
        [-142, 13],
        [-85, 17],
        [-202, 56],
        [-142, -20],
        [-396, -72],
        [-433, -351],
        [-6, -60],
        [-79, -774],
        [136, -87],
        [3, -25],
        [172, -151],
        [122, -122],
        [-454, -414],
        [-5, -53],
        [65, -158],
        [75, -205],
        [-21, -379],
        [-14, -349],
        [-4, -36],
        [25, -197],
      ],
      [
        [80776, 49539],
        [-49, -23],
        [-57, 2],
        [-115, 18],
        [-161, 78],
        [-89, 62],
        [-148, -121],
        [-112, -84],
        [-559, 240],
        [-217, 159],
        [-93, 151],
        [-77, 137],
        [-67, 254],
        [-42, 81],
        [-61, 81],
        [-62, 46],
        [-97, 14],
        [-354, 117],
        [-134, 59],
        [-275, -125],
        [-48, -81],
        [-167, -126],
        [-59, -47],
        [-139, 35],
        [-128, 13],
        [-97, -5],
        [-263, 42],
        [-12, 2],
        [-100, 23],
        [-85, 206],
        [145, -55],
        [36, 226],
        [-253, 126],
        [-133, -103],
        [-406, 176],
        [-91, 158],
        [-177, 319],
        [-79, 224],
        [-1070, 263],
        [-717, 236],
        [-266, 34],
        [-772, -46],
      ],
      [
        [66192, 21409],
        [-56, 41],
        [-33, 7],
        [-42, 33],
        [-102, 46],
        [-166, 93],
        [-150, 95],
        [-136, 80],
        [-188, 91],
        [-180, 76],
        [-384, 152],
        [-120, 40],
        [-120, 24],
        [22, 82],
        [5, 62],
        [41, 31],
        [44, -17],
        [32, 23],
        [6, 42],
        [-12, 51],
        [-20, 38],
        [-48, 51],
        [-83, 44],
        [-31, -2],
        [-35, -60],
        [-12, 19],
        [22, 28],
        [-2, 55],
        [-49, 29],
        [-50, 9],
        [-83, -15],
        [-35, -36],
        [1, -24],
        [39, -42],
        [-26, -29],
        [-69, 73],
        [-28, 6],
        [-62, -69],
        [-45, 20],
        [-20, -42],
        [-34, 103],
        [-28, 13],
        [-49, 4],
        [-23, 22],
        [-75, 41],
        [-121, 36],
        [-217, 59],
        [-143, 22],
        [-85, 24],
        [-202, 78],
        [-90, 30],
        [-66, 7],
      ],
      [
        [62884, 22953],
        [6, 38],
        [63, 7],
        [109, -21],
        [106, -40],
        [11, 24],
        [33, 14],
        [17, -34],
        [-8, -37],
        [18, -50],
        [42, -21],
        [60, -12],
        [18, 18],
        [5, 44],
        [-46, 9],
        [1, 31],
        [-20, 43],
        [22, 25],
        [40, 6],
        [11, -34],
        [34, 8],
        [16, 72],
        [26, 27],
        [-13, 72],
        [39, 18],
        [6, 37],
        [29, 55],
        [27, 31],
        [53, 39],
        [15, 35],
        [49, 11],
        [42, -61],
        [36, -15],
        [21, 37],
        [32, 7],
        [28, -34],
        [-7, -71],
        [12, -17],
        [62, 36],
        [11, -39],
        [31, 7],
        [10, 30],
        [-20, 44],
        [53, 17],
        [-19, 27],
        [16, 30],
        [27, -6],
        [54, 20],
        [9, 48],
        [-12, 26],
        [74, 20],
        [26, -9],
        [34, 29],
        [42, 15],
        [16, -12],
        [-23, -41],
        [-4, -33],
        [76, -2],
        [58, 53],
        [36, -21],
        [38, -36],
        [60, 84],
        [18, 12],
        [42, -12],
        [41, -33],
        [38, -7],
        [20, 50],
        [51, 40],
        [25, 30],
        [51, -31],
        [15, 30],
        [37, -11],
        [44, 32],
        [65, 23],
        [61, -23],
        [51, -30],
        [88, 11],
        [67, -54],
        [1, 47],
        [74, 59],
        [20, -31],
        [24, 1],
        [45, 31],
        [43, -16],
        [21, 24],
        [50, 9],
        [30, 15],
        [-49, 162],
        [61, 31],
        [7, 57],
        [42, 48],
        [88, 57],
        [28, 80],
        [2, 33],
        [59, 97],
        [-41, -18],
        [-32, 51],
        [47, 188],
        [23, 17],
        [13, 4],
        [33, 67],
        [46, -1],
        [58, -64],
        [92, -40],
        [61, -22],
        [81, -5],
        [5, 15],
        [60, 1],
        [5, -40],
        [36, -60],
        [157, -42],
        [145, -55],
        [6, 20],
        [-48, 74],
        [51, 39],
        [29, 10],
        [36, -37],
        [18, -57],
        [17, -6],
        [55, 21],
        [42, -81],
        [93, 44],
        [29, -32],
        [27, -55],
        [6, -59],
        [47, 20],
        [82, 65],
        [116, 34],
        [77, 56],
        [75, -11],
        [85, 65],
        [1, 51],
        [35, 14],
        [19, 35],
        [48, 47],
        [14, 27],
        [62, 21],
        [58, 32],
        [54, -9],
        [160, 57],
        [55, -58],
        [-29, -59],
        [-13, -68],
        [35, -47],
        [23, -8],
        [39, -56],
        [36, -64],
        [35, -20],
        [8, -92],
        [38, -52],
        [42, 12],
        [36, -48],
        [63, -52],
        [7, -32],
        [32, -27],
        [22, -37],
        [7, -48],
        [90, -57],
        [40, -5],
        [39, -45],
        [-1, -52],
        [-41, -42],
        [26, -21],
        [-45, -34],
        [-4, -39],
        [-27, -37],
        [0, -130],
        [6, -57],
        [-19, -62],
        [16, -24],
        [-7, -54],
        [-31, -44],
        [17, -87],
        [33, -23],
        [24, -44],
        [3, -56],
        [-26, -22],
        [5, -39],
        [-32, -32],
        [-23, -93],
        [14, -25],
        [-39, -37],
        [-19, -43],
        [13, -16],
        [-4, -44],
        [18, -22],
        [-22, -35],
        [-14, -71],
        [11, -47],
        [29, -36],
        [35, -18],
        [14, -41],
        [35, -20],
        [8, -50],
        [38, -37],
        [-24, -28],
        [-13, -52],
        [26, -77],
        [-5, -43],
        [10, -31],
        [-26, -37],
        [32, -42],
      ],
      [
        [68411, 21906],
        [-9, -30],
        [-79, 25],
        [19, -39],
        [-22, -46],
        [-51, 18],
        [-3, -35],
        [25, -22],
        [-36, -53],
        [-52, -5],
        [3, -39],
        [22, -33],
        [-23, -36],
        [-28, 21],
        [-82, -13],
        [-10, -51],
        [-42, -19],
        [-1, -44],
        [-16, -57],
        [-40, 19],
        [-32, -3],
        [-43, 45],
        [-20, -15],
        [-60, 53],
        [-26, 5],
        [-49, -45],
        [-44, -83],
        [30, -40],
        [44, -33],
        [28, -35],
        [2, -30],
        [-38, -42],
        [7, -23],
        [18, -29],
        [-4, -51],
        [7, -43],
        [-79, -88],
        [-41, -9],
        [-34, -26],
        [-22, 14],
        [-50, -24],
        [-46, -6],
        [-30, -78],
        [-19, -14],
        [-36, 7],
        [-25, -37],
        [-3, -47],
        [-37, -57],
        [-33, -85],
        [-31, -14],
        [-21, -43],
        [-36, -22],
        [1, -50],
      ],
      [
        [67264, 20519],
        [-25, 44],
        [-147, 155],
        [-130, 121],
        [-139, 106],
        [-198, 143],
        [-325, 211],
        [-52, 47],
        [-56, 63],
      ],
      [
        [34783, 23735],
        [30, -7],
        [2, -52],
        [-30, -71],
        [18, -34],
        [-31, -16],
        [-17, 14],
        [-32, -12],
        [-20, 17],
        [14, 61],
        [48, 17],
        [18, 83],
      ],
      [
        [16683, 18977],
        [44, -27],
        [108, 9],
        [50, 15],
        [36, -16],
        [24, -35],
        [-88, -78],
        [-45, 25],
        [-66, -26],
        [-34, 17],
        [-6, -32],
        [-40, 8],
        [-50, -25],
        [-30, 26],
        [14, 112],
        [28, -1],
        [55, 28],
      ],
      [
        [33931, 21394],
        [50, -42],
        [27, 8],
        [55, -82],
        [31, -7],
        [26, 16],
        [33, -68],
        [0, -20],
        [36, -22],
        [-1, -22],
        [63, -75],
        [5, -103],
        [-15, -35],
        [7, -88],
        [-11, -96],
        [-31, -20],
        [-63, 8],
        [-5, -32],
        [-38, -18],
        [-36, 10],
        [-14, 74],
        [-53, 44],
        [-57, -5],
        [-21, 40],
        [-35, 5],
        [-17, 21],
        [-26, -28],
        [-41, 5],
        [-32, 80],
        [3, 26],
        [-35, 6],
        [-22, 22],
        [-9, 34],
        [-28, -18],
        [-49, 18],
        [50, 35],
        [-22, 37],
        [8, 68],
        [21, -9],
        [21, 35],
        [30, -12],
        [18, 36],
        [35, -17],
        [24, 22],
        [17, 44],
        [-2, 49],
        [49, 58],
        [54, 18],
      ],
      [
        [120746, 2964],
        [212, -287],
        [-5, -18],
        [-45, -43],
        [20, -30],
        [-18, -54],
        [-26, 3],
        [-3, -63],
        [-32, -57],
        [-56, -31],
        [-7, -24],
        [-48, 7],
        [-39, 21],
        [-58, -11],
        [-16, -40],
        [-23, -13],
        [0, -38],
        [-43, -27],
        [-10, -27],
        [28, -43],
        [-11, -27],
        [5, -51],
        [-11, -53],
        [25, -49],
        [-2, -58],
        [9, -48],
        [-15, -31],
        [39, -88],
        [-47, -113],
        [-89, -49],
        [-21, 4],
        [-26, -50],
        [-25, -18],
        [-15, -95],
        [35, -57],
        [-3, -57],
        [33, -81],
        [28, -32],
        [18, -44],
        [-6, -56],
        [-40, -19],
        [3, -65],
        [56, -42],
        [10, -28],
        [8, -27],
        [30, -37],
        [-7, -62],
        [7, -38],
        [20, -27],
        [-16, -49],
        [-1, -105],
        [-16, -25],
        [-48, -29],
        [8, -39],
        [-41, -6],
        [-58, -134],
        [12, -64],
        [-18, -48],
        [-3, -63],
        [-74, -72],
        [-30, 0],
        [-14, -23],
        [-38, -20],
        [-1, -57],
        [-22, -43],
        [-25, -14],
        [-79, 77],
        [-286, 291],
        [-62, 59],
        [-29, 31],
        [-192, 185],
        [-111, 99],
        [-82, 68],
        [3, 35],
        [-96, 93],
        [-13, 32],
        [-155, 144],
        [-198, 202],
        [-180, 205],
        [-380, 420],
        [-125, 149],
        [-81, 90],
        [-119, 131],
        [-142, 154],
        [-212, 237],
        [-155, 166],
        [-190, 199],
        [-1, 30],
        [-41, 33],
        [-79, 86],
        [-234, 239],
        [-254, 259],
        [-161, 162],
        [-127, 118],
        [-179, 179],
        [-166, 162],
        [-248, 243],
        [-114, 110],
        [-128, 113],
        [-32, 35],
        [-131, 121],
        [-286, 259],
        [-614, 527],
        [-243, 199],
        [-169, 136],
        [-155, 120],
        [-234, 178],
        [-218, 155],
        [-67, 51],
        [-129, 91],
        [-281, 182],
        [-247, 146],
        [-128, 68],
        [-176, 84],
        [-85, 26],
        [-80, -6],
        [-46, 30],
        [-20, -25],
        [-199, 91],
      ],
      [
        [112044, 7269],
        [0, 18],
        [-164, 77],
        [-17, 41],
        [-281, 536],
        [-9, 18],
        [-31, 180],
        [65, 32],
        [172, 117],
        [43, 34],
        [46, 70],
        [16, 46],
        [0, 43],
        [-38, 37],
        [48, 100],
        [-20, 68],
        [-66, 187],
        [5, 10],
        [-239, 386],
        [-165, 265],
        [-4, 3],
        [26, 70],
        [405, 1082],
        [530, 1416],
        [289, 768],
      ],
      [
        [112655, 12873],
        [-12, 48],
        [35, 24],
        [7, 60],
        [78, 24],
        [22, 21],
        [55, -2],
        [2, 84],
        [31, 30],
        [6, 33],
        [69, 112],
        [-10, 26],
        [37, 58],
        [45, -40],
        [72, 60],
        [40, -32],
        [44, 21],
        [37, 0],
        [43, 19],
        [56, -2],
        [32, 11],
        [101, -10],
        [27, 40],
        [124, 5],
        [-8, 147],
        [122, 23],
        [139, 119],
      ],
      [
        [113849, 13752],
        [46, 66],
        [201, 296],
        [197, 298],
        [-4, 19],
        [22, 70],
        [-8, 46],
        [13, 14],
        [-36, 38],
        [53, 66],
        [15, 60],
        [-3, 36],
        [20, 19],
        [7, 44],
        [53, 96],
        [32, 12],
        [31, -8],
        [47, -32],
        [34, 10],
        [2, 73],
        [13, 92],
        [18, 31],
        [76, 1],
        [25, 8],
        [26, 44],
        [32, 105],
        [59, 52],
        [53, 22],
        [1, 51],
        [105, 9],
        [27, 9],
        [-20, 84],
        [31, 79],
        [-13, 28],
        [14, 75],
        [-4, 53],
        [-45, 71],
        [-18, 2],
        [-9, 49],
        [-56, 62],
        [-38, 116],
        [45, 5],
        [24, -38],
        [109, -15],
        [13, 17],
        [27, 101],
        [-71, 4],
        [-27, -46],
        [-61, 12],
        [0, 58],
        [33, 3],
        [27, 45],
        [58, -37],
        [47, 7],
        [4, 16],
        [-38, 73],
        [10, 44],
        [35, 60],
        [-7, 36],
        [29, 20],
        [-8, 45],
        [-61, 57],
        [-2, 73],
        [26, 27],
        [15, 74],
        [23, 9],
        [-21, 93],
        [3, 45],
        [16, 18],
        [52, -43],
        [63, 20],
        [74, 47],
        [-12, 30],
        [21, 49],
        [49, 50],
        [7, 70],
        [40, -1],
        [21, -36],
        [32, -22],
        [23, -34],
        [44, -9],
        [24, -51],
        [48, -10],
        [57, 37],
        [52, 22],
        [30, -20],
        [56, -14],
        [24, -66],
        [49, -3],
        [35, -23],
        [33, 6],
        [41, -9],
        [21, -19],
        [-7, -53],
        [45, -11],
        [18, -36],
        [45, -18],
        [34, 11],
        [65, -15],
        [23, -36],
        [20, -5],
        [0, -52],
        [-105, -58],
        [-33, 6],
        [-15, -52],
        [-32, -68],
        [12, -38],
        [40, -53],
        [22, -58],
        [64, 116],
        [35, -21],
        [163, 14],
        [71, -9],
        [81, -84],
        [-6, -27],
        [25, -23],
        [9, -61],
        [35, -26],
        [-25, -41],
        [-12, -43],
        [-63, -52],
        [-41, -8],
        [-20, -99],
        [-34, -31],
        [-2, -75],
        [-12, -18],
        [17, -37],
        [42, -12],
        [7, -46],
        [23, -27],
        [-18, -56],
        [5, -85],
        [-16, -12],
        [-5, -127],
        [13, -79],
        [-7, -21],
        [16, -60],
        [54, -62],
        [64, -28],
        [24, -51],
        [25, -25],
        [-16, -73],
        [16, -31],
        [71, -23],
        [6, -51],
        [24, -34],
        [-47, -16],
        [63, -86],
        [17, 30],
        [35, -5],
        [7, -31],
        [48, -112],
        [40, -33],
        [36, 87],
        [-1, 15],
        [85, 0],
        [36, -22],
        [26, 35],
        [52, -6],
        [40, 32],
        [97, -31],
        [30, -20],
        [19, -106],
        [20, -44],
        [18, -1],
        [52, 27],
        [11, 34],
        [13, -12],
        [19, -131],
        [19, -25],
        [14, -60],
        [-29, -60],
        [-140, -24],
        [9, -38],
        [106, -59],
        [8, 46],
        [85, 12],
        [92, 19],
        [1, -48],
        [74, -63],
        [33, -44],
        [-16, -115],
        [56, -10],
        [12, -66],
        [12, -6],
        [82, 17],
        [29, 4],
        [95, 76],
        [32, 9],
        [34, 31],
        [77, 43],
        [-4, 88],
        [11, 68],
        [37, 71],
        [1, 120],
        [39, -27],
        [23, 54],
        [60, 39],
        [78, 12],
        [85, 56],
        [54, 75],
        [-26, 41],
        [31, 28],
        [4, 32],
        [-22, 37],
        [117, 144],
        [38, -20],
        [25, -27],
        [18, 12],
        [109, 37],
        [47, 109],
        [52, 10],
        [53, -9],
        [81, 14],
        [51, 10],
        [51, -19],
        [60, 4],
        [39, -19],
        [67, 35],
        [59, 17],
        [29, -13],
        [6, 39],
        [128, 90],
        [103, 67],
        [-34, 120],
        [15, 60],
        [26, 10],
        [-4, 88],
        [1, 142],
        [18, -6],
        [36, 23],
        [4, 29],
        [101, -12],
        [78, -32],
        [44, -2],
        [65, -52],
        [202, 256],
        [166, 161],
        [28, -42],
        [76, 91],
        [89, -37],
        [4, -71],
        [97, 8],
        [-25, 63],
        [42, 33],
        [-90, 132],
        [30, -13],
        [90, -68],
        [68, 83],
        [4, 73],
        [25, 35],
        [-34, 17],
        [21, 63],
        [53, -1],
        [0, 29],
        [102, -40],
        [65, -4],
        [27, 51],
        [-15, 40],
        [-34, 26],
        [-35, -6],
        [-25, 22],
        [195, 72],
        [46, -7],
        [20, 48],
        [55, -33],
        [23, 41],
        [33, 101],
        [-40, 118],
        [44, -36],
        [18, -64],
        [37, -47],
        [39, -16],
        [114, -1],
        [26, -20],
        [1, -24],
        [-81, -105],
        [-3, -40],
        [22, -32],
        [52, -10],
        [62, 36],
        [19, 58],
        [-8, 47],
        [22, 31],
        [39, 8],
        [42, -18],
        [55, -45],
        [95, 18],
        [58, -30],
        [38, -9],
        [39, 8],
        [43, 22],
        [80, 57],
        [25, -31],
        [5, -77],
        [16, -48],
        [30, -34],
        [74, -38],
        [5, -36],
        [-44, -57],
        [-10, -55],
        [20, -84],
        [21, -51],
        [7, -51],
        [-4, -45],
        [-42, -136],
        [-29, -29],
        [-55, 35],
        [-94, -68],
        [44, -29],
        [12, -22],
        [107, -23],
        [52, -28],
        [25, -47],
        [33, 13],
        [16, -34],
        [64, 11],
        [23, -25],
        [45, 53],
        [11, -51],
        [55, -43],
        [35, 4],
        [16, -18],
        [106, -29],
        [56, -60],
        [25, 61],
        [32, 1],
        [35, -44],
        [1, -37],
        [-17, -48],
        [43, -94],
        [-17, -62],
        [44, -24],
        [-25, -26],
        [-46, -19],
        [52, -72],
        [30, -20],
        [27, -72],
        [-14, -63],
        [2, -40],
        [30, -37],
        [-14, -20],
        [14, -67],
        [-37, -32],
        [-2, -44],
        [-25, 2],
        [1, -73],
        [-42, -66],
        [-46, -55],
        [-45, -18],
        [-23, -28],
        [-33, 27],
        [-12, -35],
        [44, -23],
        [82, -9],
        [-34, -85],
        [160, -71],
        [11, 33],
        [67, -24],
        [12, -27],
        [40, -3],
        [10, -43],
        [220, -80],
        [5, 106],
        [94, -12],
        [2, -60],
        [91, -46],
        [33, -29],
        [23, 35],
        [94, -56],
        [129, -62],
        [43, 36],
        [37, 7],
        [39, -32],
        [50, -18],
        [24, -74],
        [-14, -59],
        [95, -45],
        [58, -97],
        [2, -42],
        [-40, -52],
        [-97, 40],
        [-54, -26],
        [-8, -114],
        [-18, -63],
        [-39, -77],
      ],
      [
        [123820, 13436],
        [55, -169],
        [41, -38],
        [76, -22],
        [55, 9],
        [63, -7],
        [50, -43],
        [50, -28],
        [32, -59],
        [-12, -70],
        [5, -22],
        [44, -7],
        [19, 14],
        [19, 76],
        [28, 28],
        [38, 0],
        [41, -15],
        [24, 7],
        [86, -14],
        [21, 8],
        [67, -54],
        [9, -22],
        [-8, -50],
        [-33, -51],
        [-5, -26],
        [13, -119],
        [25, -44],
        [21, -14],
        [19, -9],
        [109, -6],
        [35, -33],
        [35, -85],
        [0, -50],
        [36, -70],
        [28, -34],
        [62, -48],
        [65, -93],
        [97, -56],
        [82, 10],
        [45, -5],
        [24, -18],
        [8, -47],
        [-10, -53],
        [27, -37],
        [55, -21],
        [26, -28],
        [30, -67],
        [52, -33],
        [41, -61],
        [34, -34],
        [-43, -65],
        [23, -31],
        [41, -29],
        [68, -16],
        [122, -39],
        [44, -9],
        [55, -32],
        [23, -28],
        [10, -51],
        [38, 11],
        [6, 52],
        [-28, 86],
        [34, 38],
        [59, -1],
        [41, -26],
        [14, -47],
        [-15, -43],
        [-67, -38],
        [-11, -24],
        [35, -28],
        [52, 25],
        [85, -21],
        [22, -21],
        [-8, -72],
        [39, -49],
        [25, -57],
        [80, 6],
        [31, 13],
        [50, 2],
        [60, -22],
        [54, -51],
        [17, -54],
        [67, -18],
        [92, 16],
        [77, 0],
        [15, -39],
        [-13, -45],
        [7, -26],
        [97, -42],
        [75, -20],
        [34, -23],
        [8, -43],
        [164, -108],
        [27, -5],
        [27, -30],
        [9, -34],
        [-9, -51],
        [50, -25],
        [42, -40],
        [28, -9],
        [19, -39],
        [-1, -42],
        [25, -78],
        [68, -78],
        [9, -19],
        [-23, -45],
        [10, -46],
        [19, -35],
        [2, -100],
        [-51, -12],
        [-2, -40],
        [43, -22],
        [60, 9],
        [43, 66],
        [45, -80],
        [-52, -27],
        [-44, -43],
        [-9, -90],
        [26, -47],
        [-13, -73],
        [16, -26],
        [29, -4],
        [75, 42],
        [41, -28],
        [21, -56],
        [-16, -54],
        [-42, -27],
        [-68, 2],
        [-7, -28],
        [24, -25],
        [50, -3],
        [20, 49],
        [46, -2],
        [27, 15],
        [28, -8],
        [-8, -43],
        [14, -42],
        [27, -9],
        [180, 62],
        [13, -17],
        [-22, -46],
        [11, -13],
        [94, -40],
        [6, 42],
        [44, 14],
        [57, -11],
        [13, -14],
        [6, -52],
        [32, 1],
        [20, 29],
        [41, -6],
        [-10, -46],
        [6, -40],
        [-34, -48],
        [-6, -27],
        [21, -19],
        [49, 10],
        [49, -19],
        [80, 15],
        [94, 5],
        [34, -18],
        [20, -69],
        [37, -8],
        [26, 52],
        [49, -22],
        [-5, -36],
        [-52, -24],
        [-10, -34],
        [23, -38],
        [48, -37],
        [51, -11],
        [24, -39],
        [-15, -37],
        [-29, -1],
        [-42, 63],
        [-27, 9],
        [-29, -15],
        [-48, -54],
        [50, -11],
        [17, -51],
        [65, -16],
        [7, -27],
        [-36, -21],
        [-19, 20],
        [-31, -3],
        [-16, -32],
        [-40, -36],
        [16, -42],
        [-10, -41],
        [-21, -15],
        [-80, 0],
        [-28, -34],
        [27, -38],
        [-34, -19],
        [8, -46],
        [34, -15],
        [41, -61],
        [-5, -25],
        [-31, -13],
        [-39, 33],
        [-32, 4],
        [-38, -55],
        [1, -42],
        [69, -5],
        [49, -32],
        [-3, -20],
        [-44, 7],
        [-60, -34],
        [-25, -76],
        [15, -110],
        [27, -25],
        [31, -3],
        [65, -42],
        [10, -54],
        [-62, -32],
        [-43, -8],
        [-6, -51],
        [88, -19],
        [-1, -110],
        [-28, -3],
        [-72, 36],
        [-24, -61],
        [0, -37],
        [37, -61],
        [27, 33],
        [41, 31],
        [44, -15],
        [-12, -33],
        [-30, 5],
        [-54, -66],
        [20, -44],
        [-1613, 0],
        [-780, -1],
        [-940, 1],
        [-602, 0],
        [-391, 0],
        [-797, 0],
        [-811, -1],
        [-524, -954],
        [-352, -640],
        [-313, -572],
        [-638, -1165],
        [-374, -686],
        [120, -165],
        [96, -132],
        [253, -342],
      ],
      [
        [62109, 59166],
        [-52, -2],
        [-132, 29],
        [-44, -22],
        [-44, -56],
        [-65, -32],
        [-37, -41],
        [-9, -29],
        [-26, -25],
        [-71, 25],
        [-29, -37],
        [61, -15],
        [-6, -35],
        [-46, -34],
        [-28, 20],
        [-64, -3],
        [-18, 19],
        [-41, -9],
        [-23, -29],
        [-68, -21],
        [-31, -36],
        [-48, -5],
        [-69, -30],
        [-19, -52],
        [-207, 505],
        [-749, -294],
        [-29, 25],
        [6, 62],
        [-25, 29],
        [-59, 17],
        [-26, -41],
        [-23, 7],
        [-25, -45],
        [-44, -8],
        [-18, -44],
        [-76, 34],
        [-22, 43],
        [-65, 5],
        [-20, 32],
        [44, 93],
        [0, 36],
        [-66, 91],
        [-34, 19],
        [-16, -21],
        [-39, 0],
        [-37, -28],
        [-53, -30],
        [-98, 18],
        [-63, 30],
        [-80, -3],
        [-32, 11],
        [-58, -25],
        [23, -63],
        [-16, -14],
        [-81, 49],
        [-38, 60],
        [5, 60],
        [-243, 19],
        [-217, 451],
        [-107, 226],
        [16, -76],
        [69, -263],
        [-38, -6],
        [-107, 29],
        [-39, 2],
        [-21, -17],
        [-135, 6],
        [18, 85],
        [-15, 2],
        [-39, 74],
        [-33, 33],
        [-69, -21],
        [-110, 222],
        [-28, -29],
        [-52, 108],
        [-39, -13],
        [-31, 8],
        [-38, -28],
        [-54, 1],
        [-59, -43],
        [85, -186],
        [-178, 148],
        [-234, 279],
        [-41, -43],
        [-90, 12],
        [-20, 112],
        [-40, -53],
        [-97, 63],
        [-17, -1],
        [-35, -12],
        [-260, 219],
        [-90, 60],
        [-148, 125],
        [-82, -85],
        [-59, -145],
        [-28, -59],
        [-75, -134],
        [-20, 0],
        [-44, 28],
        [-50, 71],
        [-38, -1],
        [-72, -32],
        [-39, -9],
        [-25, 19],
        [-64, -8],
        [-13, -50],
        [43, -67],
        [-41, -59],
        [14, -48],
        [115, -14],
        [64, -31],
        [26, -24],
        [5, -57],
        [-11, -24],
        [-66, 59],
        [-58, -35],
        [-35, 19],
        [-51, -34],
        [-31, 1],
        [-19, -22],
        [21, -51],
        [-56, -4],
        [-48, -28],
        [6, -49],
        [-21, -3],
        [-40, -56],
        [-27, -104],
        [10, -37],
        [-33, -57],
        [-27, -92],
        [-1, -49],
        [28, -65],
        [-41, -60],
        [-8, -86],
        [-178, -64],
        [47, -24],
        [-50, -77],
        [42, -22],
        [81, 0],
        [-7, -40],
        [36, -84],
        [-16, -17],
        [41, -58],
        [-107, -211],
        [5, -89],
        [-153, -48],
        [-21, -161],
        [123, 17],
        [-53, -160],
        [-58, 10],
        [-59, 58],
        [-95, -143],
        [-53, -49],
        [-365, -470],
        [-40, -54],
        [78, -318],
        [-198, -135],
        [-13, -30],
        [32, -54],
        [-77, -171],
        [28, -43],
        [47, -34],
        [7, -85],
        [-49, -49],
        [-15, 1],
        [-14, -62],
        [118, -2],
        [-51, -161],
        [-165, -22],
        [-44, -66],
        [-150, -45],
        [-61, 33],
        [-59, -196],
        [19, -1092],
        [134, 107],
        [288, 141],
        [2, -63],
        [-107, -67],
        [-97, -37],
        [-60, -65],
        [-34, -21],
        [-32, -68],
        [-54, -30],
        [-86, -23],
        [-9, -32],
        [-95, -58],
        [-73, -66],
        [-75, -92],
        [-11, -44],
        [-28, -17],
        [-3, -80],
        [-60, -12],
        [-49, -35],
        [-18, -38],
        [21, -56],
        [-32, 29],
        [-54, 13],
        [-28, 54],
        [-18, 60],
        [-18, -4],
        [-103, 63],
        [120, -116],
        [-289, 30],
        [-335, -57],
        [-209, -8],
        [-50, 1],
        [-116, 354],
        [-35, 14],
        [-72, -3],
        [-331, 80],
      ],
      [
        [52289, 55004],
        [127, 31],
        [4, 43],
        [-15, 29],
        [18, 73],
        [-115, 85],
        [-6, -22],
        [-42, -18],
        [-47, -76],
        [-40, 4],
        [-66, 29],
        [-31, -6],
        [-28, 17],
        [-8, 54],
        [-45, 15],
        [-27, 22],
        [-3, 69],
        [20, 36],
        [-20, 38],
        [25, 52],
        [-622, 464],
        [-45, 23],
        [-11, 29],
        [-29, -4],
        [-83, 48],
        [-27, 36],
        [-46, 2],
        [22, 64],
        [-247, 161],
        [41, 144],
        [31, 17],
        [-8, 25],
        [8, 49],
        [-11, 15],
        [3, 82],
        [26, 50],
        [-139, 230],
        [8, 136],
        [-102, 73],
        [-90, 92],
        [-320, 156],
        [-73, -15],
        [5, 23],
        [-87, -25],
        [-60, -6],
        [-30, -37],
        [-61, -39],
        [-12, -28],
        [-37, -24],
        [-58, 26],
        [-64, -57],
        [-37, 84],
        [8, 32],
        [-43, 23],
        [-35, 68],
        [-50, 27],
        [-7, 39],
        [-42, 24],
        [-57, 1],
        [-19, 29],
        [-37, -3],
        [-40, -23],
        [-106, -13],
        [-65, -39],
        [-49, 17],
        [-32, 28],
        [-74, 3],
        [-55, -7],
        [-70, 12],
        [-65, 45],
        [-33, -48],
        [-34, -8],
        [-41, 21],
        [-29, -25],
        [9, -29],
        [-44, -13],
        [-8, -66],
        [-27, -30],
        [-116, 12],
        [-41, 158],
        [-69, 30],
        [-26, 44],
        [-63, 5],
        [-65, -12],
        [-74, 70],
        [-10, 146],
        [-79, 120],
        [-121, 180],
        [-342, 502],
        [5, 20],
        [-127, 147],
        [-56, 84],
        [62, 46],
        [137, 107],
        [-74, 10],
        [60, 75],
        [57, 23],
        [22, 69],
        [-17, 20],
        [-21, 85],
        [-64, 44],
        [-9, 35],
        [-39, 14],
        [-20, 82],
        [-38, 46],
        [-55, 37],
        [1, 59],
        [-41, 30],
        [-27, 5],
        [-38, 54],
        [14, 22],
        [-17, 26],
        [-41, 3],
        [3, 26],
        [-33, 24],
        [-43, -14],
        [-40, 20],
        [-52, 49],
        [5, 22],
        [70, 10],
        [39, 23],
        [14, 29],
        [30, 10],
        [17, 33],
        [46, 5],
        [34, 53],
        [62, 54],
        [24, 80],
        [-9, 88],
        [-46, 33],
        [15, 35],
        [8, 65],
        [37, 54],
        [-40, 60],
        [-107, -17],
        [49, 142],
        [-45, 57],
        [-220, 253],
        [-44, 45],
        [-230, -14],
        [21, 138],
        [-10, 55],
        [-30, 5],
        [-35, -62],
        [-52, 3],
        [-21, -17],
        [2, -42],
        [-33, 4],
        [-11, 59],
        [-42, -3],
        [-36, 34],
        [-47, 9],
        [23, -69],
        [-16, -25],
        [-27, 2],
        [-39, 58],
        [-44, 40],
        [23, 80],
        [-17, 84],
        [-28, 96],
        [41, 26],
        [35, 5],
        [18, 62],
        [62, 28],
        [30, 3],
        [57, 47],
        [5, 50],
        [-27, 34],
        [-29, 60],
        [-4, 48],
        [-71, 2],
        [-75, -25],
        [-78, 74],
        [-36, -6],
        [-55, -58],
        [-48, -34],
        [-39, -46],
        [-44, 9],
        [-9, 51],
        [-46, 57],
        [-66, -13],
        [-38, -67],
        [18, -58],
        [-60, -18],
        [-28, 41],
        [-42, 44],
        [-98, 3],
        [-175, -48],
        [-25, 37],
        [-28, 2],
        [-19, 14],
        [-82, 27],
        [-54, -12],
        [-44, 65],
        [-27, -27],
        [-24, 26],
        [-47, -12],
        [-9, -25],
        [16, -75],
        [-61, -20],
        [-34, -44],
        [13, -39],
        [-3, -45],
      ],
      [
        [45353, 61553],
        [-23, 9],
        [-203, 39],
        [-95, 77],
        [45, 166],
        [-182, -46],
        [-18, 131],
        [43, 66],
        [-18, 209],
        [-50, 173],
        [-50, 14],
        [-45, 60],
        [-55, 49],
        [-41, 80],
        [-42, 114],
        [19, 46],
        [-6, 36],
        [-23, 23],
        [79, 86],
        [99, 160],
        [159, 142],
        [-128, 238],
        [-47, 82],
        [7, 137],
        [-27, 88],
        [-129, 180],
        [39, 21],
        [-12, 41],
        [15, 296],
        [-13, 33],
        [-161, 75],
        [-103, 35],
        [-47, 109],
        [-78, 59],
        [-66, 181],
        [1, 44],
        [21, 95],
        [-61, 56],
        [-9, 85],
        [-37, 15],
        [30, 46],
        [-83, 45],
        [-1, 78],
        [-65, -38],
        [-44, 75],
        [-41, -29],
        [-74, 59],
        [-287, 3],
        [-89, 153],
        [-25, 41],
        [45, 124],
        [27, -8],
        [85, 30],
        [15, 31],
        [47, 58],
        [17, 38],
        [-210, 73],
        [-23, 84],
        [-2, 98],
        [-20, 50],
        [-9, 196],
        [-110, 66],
        [-61, 92],
        [-68, 31],
        [-61, 6],
        [-114, 137],
        [-71, 52],
        [-21, 73],
        [-24, 152],
        [-37, 97],
        [-8, 77],
        [-75, 147],
        [1, 74],
        [-24, 24],
        [32, 169],
        [18, 81],
        [-33, 251],
        [-26, 112],
        [21, 8],
        [54, -34],
        [-24, 80],
        [34, -21],
        [48, 10],
        [4, -53],
        [21, -12],
        [54, 43],
        [27, 3],
        [47, -55],
        [44, -20],
        [20, -33],
        [46, 32],
        [-4, 45],
        [10, 34],
        [-37, 42],
        [-7, 44],
        [31, 11],
        [5, -30],
        [28, -19],
        [-5, -46],
        [47, -26],
        [22, -35],
        [35, -20],
        [37, 1],
        [51, -13],
        [62, -1],
        [35, -39],
        [39, 42],
        [41, 9],
        [36, -7],
        [76, 20],
        [47, -37],
        [36, -1],
        [24, -26],
        [20, 38],
        [51, -24],
        [22, 41],
        [26, 12],
        [179, -57],
        [-24, 68],
        [210, 21],
        [171, 82],
        [116, 72],
        [55, 0],
        [68, -36],
        [28, 31],
        [16, -16],
        [37, -1],
        [13, -32],
        [27, 71],
        [-4, 144],
        [115, 0],
        [36, 61],
        [242, -146],
        [69, 28],
        [75, 55],
        [-9, 149],
        [73, -21],
        [20, -24],
        [99, 67],
        [-43, 27],
        [-121, 253],
        [9, 66],
        [42, 74],
        [-60, 6],
        [-14, 20],
        [33, 66],
        [-1, 56],
        [39, 44],
        [-12, 32],
        [0, 41],
        [-72, -11],
        [-39, 164],
        [2, 86],
        [-93, 105],
        [-19, 47],
        [-30, 26],
        [-11, 100],
        [-71, 97],
        [5, 124],
        [-23, 42],
        [1, 250],
        [0, 117],
        [-105, 21],
        [-65, 29],
        [-21, 45],
        [-82, 28],
        [-11, 146],
        [42, -14],
        [55, 41],
        [3, 30],
        [-28, 27],
        [-129, -12],
        [-36, 94],
        [-71, 131],
        [14, 42],
        [-42, 61],
        [-93, 46],
        [7, 11],
        [-2, 82],
        [24, 118],
        [13, 43],
        [-44, 243],
        [-29, 79],
        [14, 10],
        [-60, 328],
        [51, 3],
        [17, 63],
        [-9, 21],
        [-74, -8],
        [-10, 53],
        [98, 88],
        [45, 66],
        [-7, 37],
        [-43, 69],
        [-89, 112],
        [-76, -47],
        [0, 48],
        [-18, 43],
        [-21, 96],
        [64, 4],
        [21, 83],
        [-34, 40],
        [6, 72],
        [-45, 52],
        [5, 29],
        [90, 32],
        [1, 29],
        [221, -8],
        [58, 197],
        [-156, 500],
        [-18, 152],
        [-53, 102],
        [6, 30],
        [107, 6],
        [22, 83],
        [116, 6],
        [94, 18],
        [86, 60],
        [-26, 16],
        [-85, 28],
        [-59, 171],
        [109, 68],
        [-96, 128],
        [83, 24],
        [-23, 106],
        [8, 84],
        [-47, 109],
        [168, 53],
        [-123, 157],
        [-64, 119],
        [305, 8],
        [-1, 52],
        [207, 45],
        [33, -6],
        [10, 57],
        [16, 18],
        [-29, 222],
        [-277, 4],
        [-79, 16],
        [-50, 29],
        [-28, 117],
        [4, 11],
        [91, 59],
        [36, 15],
        [-67, 154],
        [28, 27],
        [3, 57],
        [-19, 69],
        [1, 109],
        [-19, 95],
        [-25, 15],
        [59, 62],
        [9, 80],
        [31, 229],
        [-17, 68],
        [-19, 76],
        [1, 157],
        [13, 64],
        [-27, 660],
        [-12, 307],
        [158, -60],
        [13, -23],
        [45, -22],
        [37, -35],
        [67, -15],
        [39, 83],
        [-109, 122],
        [-26, 96],
        [-15, -1],
        [-24, 49],
        [-194, 14],
        [11, 171],
        [-132, 208],
        [161, 93],
        [44, 145],
        [-262, 8],
        [-18, 7],
        [35, 10],
        [-21, 256],
        [-52, 44],
        [-7, 21],
        [-14, 109],
        [-45, -11],
        [-183, 127],
        [3, 68],
        [-138, 8],
        [-25, -43],
        [-316, 71],
        [-40, 21],
        [-40, 41],
        [-121, 47],
        [-11, 10],
        [-4, 60],
        [50, 255],
        [-92, 147],
        [-147, 100],
        [-135, -13],
        [59, 181],
        [26, 433],
        [-6, 27],
        [-38, 202],
        [442, -10],
        [187, -7],
        [-3, 499],
        [548, 6],
        [-2, 137],
        [-313, 0],
        [56, 64],
        [45, 25],
        [-45, 31],
        [-47, 58],
        [-62, 13],
        [-25, 73],
        [-3, 75],
        [-291, 114],
        [-56, 50],
        [48, 167],
        [138, 116],
        [-199, 11],
        [-56, 118],
        [-183, -81],
        [-24, 12],
        [-3, 40],
        [35, 58],
        [78, 53],
        [9, 16],
        [287, 1],
        [282, 461],
      ],
      [
        [44188, 83026],
        [408, 5],
        [277, 0],
        [819, 0],
        [383, -2],
        [187, 4],
        [443, -2],
        [5, 1277],
        [-5, 277],
        [1, 671],
        [322, 0],
        [442, 4],
        [190, -6],
        [231, 1],
        [212, -1],
        [394, 1],
        [437, -1],
        [290, 2],
        [685, 1],
        [940, 0],
        [224, -1],
        [996, 1],
        [802, 0],
        [921, 1],
        [639, -1],
        [43, -56],
        [32, -20],
        [26, -37],
        [78, -61],
        [75, 9],
        [39, 50],
        [64, 19],
        [67, -42],
        [73, -15],
        [32, -14],
        [148, -87],
        [15, -19],
        [18, -64],
        [21, -26],
        [93, -68],
        [70, -167],
        [142, -200],
        [5, -61],
        [56, -100],
        [50, -140],
        [136, -81],
        [22, -33],
        [35, -119],
        [61, -72],
        [20, -90],
        [53, -68],
        [30, -24],
        [83, -23],
        [40, -15],
        [74, -82],
        [120, -66],
        [90, -7],
        [28, -10],
        [101, -101],
        [32, -16],
        [265, -22],
        [78, -8],
        [146, -125],
        [75, -8],
        [46, -64],
        [-10, -62],
        [44, -105],
        [29, -27],
        [106, 0],
        [26, -33],
        [29, -66],
        [23, -13],
        [66, 8],
        [32, -11],
        [52, -66],
        [26, -21],
        [10, -31],
        [69, -91],
        [85, -85],
        [43, -56],
        [62, -77],
        [50, -21],
        [20, -39],
        [-4, -34],
        [30, -82],
        [49, -16],
        [84, 5],
        [20, -6],
        [94, -72],
        [20, -46],
        [30, -19],
        [195, -68],
        [86, -36],
        [25, -79],
        [73, -7],
        [106, -73],
        [24, -39],
        [14, -53],
        [49, -43],
        [23, -100],
        [-5, -45],
        [19, -35],
        [38, -24],
        [-6, -32],
        [58, -89],
        [66, -26],
        [47, -1],
        [63, -61],
        [13, -34],
        [57, 12],
        [43, -51],
        [-1, -39],
        [29, -32],
        [81, -46],
        [27, -40],
        [60, -7],
        [22, -25],
        [26, -54],
        [51, -14],
        [18, -21],
        [59, -14],
        [10, -48],
        [34, 17],
        [19, -14],
        [-1, -63],
        [32, -1],
        [-13, -128],
        [40, 15],
        [52, -26],
        [32, -5],
        [29, 15],
        [43, -40],
        [62, -9],
        [11, -31],
        [63, -27],
        [19, 2],
        [14, -43],
        [-11, -35],
        [60, -18],
        [23, 44],
        [5, 32],
        [33, 7],
        [17, -36],
        [45, -17],
        [17, -43],
        [45, -1],
        [12, -36],
        [32, -25],
        [37, 28],
        [49, 17],
        [37, 0],
        [10, -21],
        [44, 32],
        [32, -32],
        [-43, -53],
        [15, -25],
        [43, -1],
        [56, 44],
        [43, -38],
        [4, -37],
        [48, -47],
        [43, 56],
        [8, -39],
        [33, -7],
        [-20, -87],
        [92, 1],
        [53, -10],
        [39, -30],
        [49, -21],
        [-8, -35],
        [39, -20],
        [20, -58],
        [34, 0],
        [17, -31],
        [34, -13],
        [-1, -39],
        [57, 11],
        [32, -39],
        [38, -63],
        [62, 33],
        [57, -47],
        [39, 29],
        [24, -13],
        [27, 19],
        [23, -22],
        [15, -54],
        [21, -2],
        [38, -37],
        [11, -136],
        [23, -38],
        [-5, -30],
        [39, -57],
        [22, -10],
        [37, 12],
        [35, -30],
        [33, -6],
        [42, 10],
        [21, -33],
        [25, 33],
        [29, -38],
        [-5, -52],
        [46, -10],
        [11, -32],
        [38, -39],
        [18, -58],
        [-12, -23],
        [47, -37],
        [-15, -34],
        [7, -24],
        [35, -13],
        [5, -38],
        [-23, -31],
        [64, -39],
        [-10, -74],
        [34, -6],
        [-24, -70],
        [14, -36],
        [13, -25],
        [-18, -49],
        [22, -29],
        [-3, -52],
        [28, -9],
        [7, -34],
        [-16, -31],
        [58, -40],
        [-35, -42],
        [10, -47],
        [-21, -48],
        [47, -34],
        [16, -23],
        [61, -30],
        [67, 14],
        [-9, -39],
        [36, -6],
        [-15, -67],
        [-25, -29],
        [47, -31],
        [-8, -37],
        [65, -15],
        [27, -23],
        [24, -45],
        [43, -32],
        [-9, -35],
        [48, 6],
        [33, -17],
        [14, -96],
        [-10, -45],
        [55, -5],
        [-7, -48],
        [45, -11],
        [26, 11],
        [45, -39],
        [57, -81],
        [29, -17],
        [-22, -53],
        [39, -51],
        [26, -106],
        [46, -62],
        [-2, -94],
        [-9, -49],
        [14, -22],
        [-42, -65],
        [-1, -36],
        [23, -37],
        [-18, -79],
        [37, -98],
        [-31, -59],
        [-42, -47],
        [-20, -48],
        [53, -64],
        [-26, -10],
        [-15, -53],
        [48, -28],
        [19, -40],
        [-19, -17],
        [28, -47],
        [8, -37],
        [-12, -49],
        [-21, -28],
        [59, -3],
        [-22, -88],
        [49, 2],
        [-29, -55],
        [9, -37],
        [-6, -85],
        [25, -52],
        [41, -8],
        [-3, -31],
        [33, -23],
        [5, -38],
        [54, -34],
        [3, -26],
        [35, -21],
        [28, -30],
        [14, -80],
        [61, -28],
        [28, -34],
        [-42, -47],
        [30, -13],
        [7, -33],
        [38, -18],
        [39, -58],
        [33, -9],
        [33, -65],
        [4, -38],
        [36, -20],
        [25, -41],
        [-18, -92],
        [54, -29],
        [-9, -38],
        [14, -30],
        [31, -5],
        [-13, -39],
        [34, -35],
        [-6, -35],
        [10, -60],
        [58, -27],
        [-6, -22],
        [-50, -19],
        [39, -54],
        [48, -32],
        [0, -30],
        [59, -63],
        [-3, -46],
        [20, -23],
        [34, 31],
        [28, -25],
        [34, -1],
        [7, -25],
        [44, -2],
        [11, -48],
        [39, -2],
        [-9, -36],
        [51, -12],
        [18, -19],
        [246, -156],
        [30, -98],
        [32, 7],
        [2, -58],
        [48, 6],
        [66, -41],
        [36, 0],
        [-4, -35],
        [43, 0],
        [50, -41],
        [32, 16],
        [42, 44],
        [27, -19],
        [0, -25],
        [73, 1],
        [14, -20],
        [132, -28],
        [15, -37],
        [61, -20],
        [62, -48],
        [8, -65],
        [79, 29],
        [26, -25],
        [-21, -94],
        [-18, -26],
        [51, -45],
        [50, -28],
        [9, -31],
        [55, -47],
        [6, -64],
        [28, -14],
        [29, -35],
        [-1, -36],
        [26, -19],
        [41, 8],
        [13, -31],
        [27, 3],
        [15, -37],
        [79, 5],
        [22, -52],
        [44, 16],
        [52, -39],
        [1, -22],
        [33, -10],
        [-1, -30],
        [38, -34],
        [47, -2],
        [25, -22],
        [53, -24],
        [8, -34],
        [75, -50],
        [84, -40],
        [83, -32],
        [32, -2],
        [85, -41],
        [27, 0],
        [11, 15],
        [135, -33],
        [59, 6],
        [56, -48],
        [65, 15],
        [46, -40],
        [46, 30],
        [45, -23],
        [63, 6],
        [83, -18],
        [8, -21],
        [43, -22],
        [58, 24],
        [21, -6],
        [15, -59],
        [39, -11],
        [42, 31],
        [25, 1],
        [29, -48],
        [1, -61],
        [-22, -16],
        [-2, -61],
        [26, -36],
        [31, 3],
        [7, 30],
        [45, 27],
        [18, -26],
        [-12, -34],
        [65, 8],
        [1, -56],
        [27, -44],
        [31, -21],
        [50, -80],
        [23, 14],
        [48, 1],
        [37, -37],
        [50, -6],
        [130, -34],
        [23, -53],
        [17, -8],
        [42, 21],
        [32, -10],
        [19, 18],
        [71, 13],
        [53, -35],
        [33, -39],
        [40, -3],
        [56, 20],
        [101, 8],
        [-10, -30],
        [16, -29],
        [47, 6],
        [67, -37],
        [2, -82],
        [103, -14],
        [-16, -35],
        [20, -18],
        [31, 6],
        [38, -61],
        [72, -58],
        [-17, -66],
        [10, -20],
        [42, -2],
        [8, 30],
        [51, 1],
        [0, -36],
        [40, -32],
        [29, -6],
        [31, -78],
        [38, 6],
        [24, -25],
        [44, 7],
        [10, -36],
        [68, 0],
        [1, -39],
        [50, -2],
        [81, -25],
        [38, 46],
        [11, 72],
        [12, 20],
        [71, -18],
        [13, -52],
        [-23, -18],
        [-44, -4],
        [16, -39],
        [44, -20],
        [24, 5],
        [47, 45],
        [33, -13],
        [-9, -29],
        [-34, -34],
        [42, -35],
      ],
      [
        [67443, 60257],
        [-747, 143],
        [0, -19],
        [-92, 23],
        [-88, 0],
        [-125, -11],
        [-23, 6],
        [-281, -2],
        [-6, 119],
        [-176, -16],
        [-38, -123],
        [-18, -32],
        [-53, 27],
        [-583, 124],
        [-203, 18],
        [1, 11],
        [-106, 145],
        [-2, 14],
        [-46, 93],
        [-54, 59],
        [-41, -33],
        [5, -23],
        [-37, -52],
        [-20, -44],
        [-73, -31],
        [-28, -32],
        [55, -74],
        [7, -59],
        [-71, -55],
        [26, -22],
        [32, -5],
        [42, -44],
        [41, -104],
        [-49, -36],
        [-46, -57],
        [9, -24],
        [-24, -36],
        [-92, -187],
        [-119, -50],
        [-87, -29],
        [-47, -41],
        [-45, -17],
        [-183, -120],
        [-23, -39],
        [-21, -66],
        [-28, -58],
        [-21, -110],
        [-61, -143],
        [-49, -99],
        [-23, -28],
        [-28, -82],
        [-27, -55],
        [-32, -10],
        [7, -76],
        [21, -30],
        [4, -84],
        [-23, -59],
        [-338, -366],
        [-88, 197],
        [-121, -56],
        [-27, 13],
        [-10, 32],
        [-30, 13],
        [-54, 55],
        [-35, -4],
        [-46, 97],
        [-28, 8],
        [3, 34],
        [-39, 43],
        [-33, 21],
        [-90, 103],
        [-24, 14],
        [-17, 54],
        [-25, 3],
        [-47, 60],
        [-33, -2],
        [-53, 66],
        [-60, -33],
        [-73, 34],
        [-65, 58],
        [-16, -3],
        [-67, 23],
        [-197, -14],
        [-32, -6],
      ],
      [
        [88785, 24061],
        [175, -84],
        [130, -80],
        [-12, -46],
        [72, -74],
        [21, -31],
        [65, -57],
        [-19, -87],
        [-13, -9],
        [-20, -137],
        [-23, -124],
        [49, -16],
        [-12, -88],
        [104, -36],
        [25, -8],
        [-10, -38],
        [-40, 13],
        [-12, -18],
        [-40, -3],
        [-27, -17],
        [7, -8],
        [-4, -95],
        [60, -78],
        [11, -26],
        [-69, -21],
        [59, -74],
        [-55, -28],
        [42, -106],
        [-8, -89],
        [-30, -92],
        [-62, -56],
      ],
      [
        [89149, 22448],
        [-20, 22],
        [-209, 33],
        [-66, -48],
        [-76, -137],
        [-11, 3],
        [-291, 65],
        [-46, 135],
        [-4, 1],
        [-417, 33],
        [-239, 177],
      ],
      [
        [87770, 22732],
        [-41, 72],
        [-36, 131],
        [-33, 89],
        [-19, 99],
        [-30, 39],
        [-10, 43],
        [-31, 25],
        [-9, 0],
        [-30, 26],
        [-53, 16],
        [14, 131],
        [-42, 31],
        [-76, 19],
        [69, 95],
        [-30, 32],
        [-2, 17],
        [105, 117],
        [35, 114],
        [51, 61],
        [35, 28],
        [56, -12],
        [50, 52],
        [105, 80],
        [28, 38],
        [75, 43],
        [77, 75],
        [-32, 49],
        [41, 31],
        [3, 45],
        [21, 17],
        [15, 54],
        [25, 20],
        [-66, 19],
        [33, 110],
        [17, 69],
        [26, 19],
        [127, -43],
        [18, 11],
        [74, -28],
        [-27, 74],
        [-53, 30],
        [14, 16],
        [57, -2],
        [4, 42],
        [33, 47],
        [-46, 22],
        [23, 54],
        [23, 2],
        [35, 59],
        [18, 14],
        [27, 53],
        [46, 32],
        [27, -10],
        [-3, -30],
        [26, -55],
        [22, -42],
        [-35, -53],
        [-69, -89],
        [22, -74],
        [53, -50],
        [41, -3],
        [37, 11],
        [33, -15],
        [121, -54],
        [-19, -48],
        [79, -192],
        [20, -38],
        [-42, -100],
        [-12, -106],
      ],
      [
        [61445, 41734],
        [-48, 3],
        [-286, -88],
        [-403, -29],
        [-416, 12],
        [-201, -10],
        [-118, -64],
        [-23, 8],
        [1, 46],
        [-25, 19],
        [-12, 35],
        [1, 162],
        [-33, 81],
        [-49, 39],
        [14, 74],
        [-25, 45],
        [27, 78],
        [-35, 15],
        [2, 40],
        [-30, 20],
        [-30, -2],
        [-65, 48],
        [-34, -2],
      ],
      [
        [59657, 42264],
        [-32, 25],
        [-10, 70],
        [-31, -2],
        [-36, 68],
        [-39, 17],
        [-45, 1],
        [-29, -19],
        [-33, 15],
        [-36, -11],
        [-214, 53],
        [-27, -15],
        [-53, -3],
        [-53, -32],
        [-28, -67],
        [-57, -8],
        [-26, -18],
        [-49, 45],
        [-37, -10],
        [-48, 33],
        [-61, -19],
        [-50, 36],
        [6, 27],
        [-75, 2],
        [-35, 47],
        [-66, 59],
        [-4, 26],
        [42, 35],
        [-8, 56],
        [23, 17],
        [-1, 28],
        [-31, 45],
        [30, 21],
        [-5, 35],
        [25, 27],
        [-27, 58],
        [28, 30],
        [-8, 17],
        [5, 59],
        [-48, 9],
        [7, 38],
        [-32, 33],
        [-7, 38],
        [21, 85],
        [-93, 52],
        [-11, -24],
        [-43, 0],
        [-44, 17],
        [-43, 76],
        [13, 20],
        [-16, 82],
        [-35, 50],
        [-13, 83],
        [-41, 4],
        [11, 59],
        [-29, 35],
        [-54, 27],
        [8, 21],
        [42, -3],
        [-18, 36],
        [22, 35],
        [29, 8],
        [14, 51],
        [38, 77],
        [-20, 27],
        [-75, 7],
        [-38, 20],
        [0, 49],
        [-41, 21],
        [36, 40],
        [24, 47],
        [-13, 24],
        [20, 40],
        [-28, 36],
        [-47, 18],
        [-39, 38],
        [-12, 33],
        [-41, 10],
        [16, 65],
        [-12, 81],
        [-40, 42],
        [-4, 73],
        [-98, 115],
        [-23, 7],
        [-57, 53],
        [-20, 100],
        [-156, -38],
        [2, -96],
        [-39, 66],
        [-141, -33],
        [-38, -187],
        [-75, 177],
        [-54, 333],
        [-28, 140],
        [47, 155],
        [2, 53],
        [46, 65],
        [-79, 41],
        [16, 50],
        [-32, 19],
        [-12, 25],
        [20, 36],
        [-21, 34],
        [5, 23],
        [-16, 45],
        [-35, -16],
        [-57, 139],
        [-44, 105],
        [35, 335],
        [316, -143],
        [83, -22],
        [19, 15],
        [0, 58],
        [19, 15],
        [1, 43],
        [-22, 13],
        [-1, 42],
        [-21, 29],
        [-49, 36],
        [-12, 34],
        [-85, 54],
        [-210, 21],
        [171, 174],
        [-28, 80],
        [-44, -7],
        [-63, 34],
        [-29, 45],
        [-76, 19],
        [-28, 69],
        [-32, 13],
        [-37, 35],
        [-19, -13],
        [-66, 38],
        [8, 31],
        [-13, 51],
        [-31, 42],
        [34, 33],
        [-10, 23],
        [31, 74],
        [31, 49],
        [-3, 32],
        [-31, 0],
        [-34, 30],
        [9, 92],
        [-5, 39],
        [-40, 71],
        [-29, 22],
        [-48, 72],
        [7, 28],
        [-32, 30],
        [-18, 69],
        [-31, 37],
        [3, 36],
        [-119, -4],
        [-6, 147],
        [-8, 55],
        [-19, 58],
        [-34, 14],
        [-37, 59],
        [-276, 253],
        [-80, -24],
        [-113, 89],
        [-342, 114],
        [-272, -68],
        [-39, -26],
        [-44, -54],
        [-30, -140],
        [-48, -61],
        [-53, -22],
        [-132, -33],
        [-120, -40],
        [-131, -22],
        [-55, -14],
        [-177, 65],
        [-40, -20],
        [-51, 41],
        [-24, 37],
        [-4, 35],
        [-238, 343],
        [11, 56],
        [-55, 94],
        [-28, 25],
        [148, 112],
        [5, 80],
        [26, 28],
        [12, 68],
        [-60, 25],
        [-26, 22],
        [-23, 42],
        [-56, 15],
        [-20, -52],
        [-44, 72],
        [-68, 12],
        [-25, 31],
        [34, 90],
        [-44, 25],
        [-61, -4],
        [-175, 344],
        [-25, 124],
        [-78, 206],
        [-42, 33],
        [-318, 343],
        [-41, 12],
        [-14, 48],
        [-298, 320],
        [-31, 29],
        [-84, 11],
        [-77, 10],
        [-76, -71],
        [-52, 34],
        [-58, 109],
        [-15, 77],
        [89, 39],
        [-34, 70],
        [-55, 41],
        [-21, -5],
        [-102, 107],
        [-126, 92],
        [-93, -91],
        [-19, 92],
        [31, 26],
        [-180, 322],
        [-14, 17],
        [-7, 51],
        [-22, 47],
        [-3, 39],
        [-288, 115],
        [24, 660],
        [-21, 13],
        [-90, 173],
        [63, 4],
        [17, 34],
        [46, 56],
        [-124, 78],
        [-45, 18],
        [-228, 339],
        [167, -25],
        [-178, 448],
        [117, 98],
        [93, 13],
        [28, 13],
        [14, 37],
        [-6, 28],
        [26, 58],
        [0, 45],
        [23, 36],
        [26, 17],
        [3, 48],
        [-36, 42],
        [-85, -11],
        [-52, 57],
        [20, 117],
        [-16, 10],
        [13, 82],
        [17, 14],
        [144, 3],
        [2, -38],
        [62, -10],
        [25, 35],
        [43, 15],
        [349, 177],
        [280, 165],
        [-97, 160],
      ],
      [
        [72176, 52061],
        [77, -102],
        [-2, -26],
        [20, -64],
        [28, 0],
        [65, -96],
        [-31, -20],
        [9, -24],
        [-43, -103],
        [-138, 1],
        [-1, -178],
        [492, -201],
        [4, -177],
        [75, -180],
        [156, -546],
        [15, -48],
        [80, -480],
        [68, -604],
        [-33, -228],
        [64, 5],
        [-33, -85],
        [-94, -16],
        [-89, -4],
        [-63, -80],
        [-148, 5],
        [-55, 7],
        [-133, 4],
        [-21, -53],
        [-81, -35],
        [-72, -8],
        [-69, -28],
        [-13, -21],
        [-77, -8],
        [-34, -14],
        [-80, -15],
        [-48, 20],
        [-35, -14],
        [-74, 10],
        [-61, -8],
        [-52, 28],
        [-8, 27],
        [-67, 43],
        [-10, 34],
        [-36, 18],
        [-108, -82],
        [-88, -24],
        [-11, 27],
        [-55, 40],
        [-37, 129],
        [-21, -7],
        [-10, 57],
        [-66, 82],
        [-7, -10],
        [-68, 58],
        [-13, -10],
        [-3, -83],
        [-32, -31],
        [2, -35],
        [-304, 144],
        [-74, -121],
        [-154, 88],
        [-120, 76],
        [-147, -216],
        [-56, 66],
        [-52, -170],
        [-133, 103],
        [-55, 30],
        [-83, -4],
        [-38, 37],
        [-51, -18],
        [-23, -37],
        [-24, -5],
        [-69, 6],
        [-1, -15],
        [-69, -3],
        [-25, -19],
        [-50, 32],
        [-1, 61],
        [-32, 11],
        [-22, 36],
        [-36, 10],
        [-38, -33],
        [-15, -30],
        [-79, -26],
        [-71, 4],
        [-37, 19],
        [-84, -37],
        [-28, 9],
        [-258, -26],
        [-36, 45],
        [-34, -19],
        [-84, 10],
        [-15, -71],
        [-27, -21],
        [4, -124],
        [12, -35],
        [-36, -104],
        [-16, -55],
        [-22, -30],
        [-35, -14],
        [0, -31],
        [-24, -9],
        [-51, -51],
        [-30, 8],
        [-57, -17],
        [-9, -89],
        [-82, -21],
        [-18, -41],
        [-30, -5],
        [-49, 15],
        [-26, 20],
        [-32, -17],
        [-46, 6],
        [-52, -20],
        [-43, -5],
        [-1, -76],
        [25, -68],
        [24, -81],
        [-21, -48],
        [4, -32],
        [-17, -65],
        [26, -86],
        [-29, -44],
        [-63, -33],
        [-120, -135],
        [-74, -167],
        [-65, -35],
        [-111, 193],
        [-162, -94],
        [-232, -204],
        [-66, -58],
        [-173, -138],
        [-10, 5],
        [-48, -51],
        [-14, -89],
        [-86, 10],
        [-51, 15],
        [-21, -118],
        [-114, 19],
        [102, -90],
        [59, -122],
        [16, 26],
        [71, -22],
        [-23, -67],
        [-33, -217],
        [-103, -163],
        [25, -67],
        [70, -60],
        [6, -119],
        [69, -85],
        [-29, -34],
        [10, -44],
        [-59, -35],
        [-83, -89],
        [-52, -69],
        [36, -123],
        [63, -132],
        [-16, -78],
        [-30, -28],
        [302, -15],
        [-39, -226],
        [-81, -86],
        [-37, 15],
        [-137, 117],
        [-131, -56],
        [19, -42],
        [-20, -8],
        [-6, -36],
        [-15, -95],
        [-76, 58],
        [-36, -11],
        [43, -53],
        [31, -55],
        [-98, -19],
        [-1, 60],
        [-45, 1],
        [10, -62],
        [17, -50],
        [-68, -65],
        [-53, -27],
        [-36, -43],
        [-30, -1],
        [-28, -41],
        [-44, -13],
        [-144, -96],
        [-94, -66],
        [-188, -153],
        [1, -14],
        [-74, -195],
        [-25, -112],
        [-60, -99],
        [-8, -59],
        [-25, -57],
        [-20, -20],
        [-19, -112],
        [4, -56],
        [3, -46],
        [-12, -62],
        [-18, -42],
        [-9, -156],
        [-18, -148],
        [-14, -212],
        [-197, -267],
        [-1, -125],
        [-6, -596],
        [48, -36],
        [-24, -56],
        [18, -75],
        [-5, -34],
        [32, -3],
        [21, -22],
        [-7, -41],
        [19, -32],
        [43, 0],
        [33, -31],
        [6, -50],
        [49, -9],
        [50, -75],
        [19, -15],
        [-8, -35],
        [12, -32],
        [3, -75],
        [-44, -8],
        [2, -35],
        [35, -38],
        [16, -39],
        [-27, -47],
        [18, -47],
        [52, -65],
        [-25, -28],
        [36, -27],
        [8, -68],
        [24, 1],
        [26, -27],
        [-10, -28],
        [-61, -26],
        [-54, 47],
        [-56, -32],
        [-50, 8],
        [-34, 21],
        [-91, -42],
        [-117, -7],
        [-79, 91],
        [-45, 16],
        [-18, -13],
        [-56, 6],
        [5, -32],
        [-8, -47],
        [-49, -63],
        [-63, -8],
        [-35, -45],
        [-37, -12],
        [-13, -66],
        [26, -31],
        [-65, -71],
        [-8, -33],
        [23, -54],
        [-19, -66],
        [-36, -18],
        [-9, -21],
        [36, -46],
        [-40, -25],
        [76, -48],
        [16, -19],
        [-19, -41],
        [-41, -24],
        [29, -35],
        [11, -45],
        [29, -15],
        [33, -40],
        [-5, -45],
        [-43, 14],
        [-35, -29],
        [-3, -33],
        [-46, -77],
        [0, -40],
        [-75, 26],
        [-27, -20],
        [-20, -63],
        [-33, -40],
        [14, -76],
        [24, -53],
        [53, -75],
        [30, -94],
        [-13, -55],
        [-76, -72],
        [-21, -84],
        [-34, -5],
        [-43, -25],
        [-34, -32],
        [-21, -39],
      ],
      [
        [64454, 38931],
        [-104, 58],
        [-338, -140],
        [-65, -31],
        [-161, -53],
        [29, -36],
        [-32, -31],
        [34, -46],
        [-40, -15],
        [-17, -20],
        [-35, -1],
        [-52, 72],
        [-77, 19],
        [-20, 36],
        [-37, 23],
        [-23, 59],
        [-27, 26],
        [-73, 6],
        [-34, 28],
        [-50, 90],
        [-19, 89],
        [-39, 45],
        [13, 73],
        [-164, 15],
        [-78, -7],
        [9, 181],
        [-5, 122],
        [-9, 89],
        [-29, 29],
        [-33, 88],
        [-73, -36],
        [-106, -16],
        [-28, 6],
        [-20, 63],
        [-44, -49],
        [-37, -4],
        [-113, 60],
        [-26, 54],
        [-39, 18],
        [8, 41],
        [-26, 51],
        [11, 24],
        [4, 111],
        [-14, 61],
        [-44, 26],
        [-71, 4],
        [0, -45],
        [-31, -10],
        [-97, 18],
        [-37, 48],
        [-84, -13],
        [-19, -206],
        [-451, -502],
        [-125, -32],
        [-91, 429],
        [-298, 351],
        [19, 108],
        [51, 48],
        [756, 243],
        [-93, 41],
        [-12, 14],
        [18, 106],
        [-8, 27],
        [17, 48],
        [-17, 19],
        [36, 54],
        [-12, 36],
        [-51, 67],
        [-47, 28],
        [-29, 1],
        [-21, -52],
        [-44, 28],
        [-41, -40],
        [-89, 62],
        [-15, 31],
        [-37, 32],
        [10, 36],
        [-14, 29],
        [9, 36],
        [5, 95],
        [-6, 61],
        [-29, 10],
        [-46, 53],
        [23, 26],
        [-44, 62],
        [-1, 25],
        [27, 27],
        [-4, 27],
        [37, 72],
        [-53, 81],
        [23, 42],
      ],
      [
        [77739, 28620],
        [-13, 23],
        [-42, 16],
        [-41, -8],
        [-56, -77],
        [-40, -9],
        [-23, 61],
        [-17, -28],
        [-31, -5],
        [-30, 33],
        [4, 38],
        [-29, 2],
        [-39, -41],
        [-15, 22],
        [-44, 18],
        [-60, -60],
        [-33, -21],
        [-33, 51],
        [-29, -3],
        [-1, -44],
        [-34, -35],
        [-33, -12],
        [-56, 27],
        [-62, 9],
        [-11, -55],
        [-6, -37],
        [-27, -28],
        [9, -32],
        [38, -38],
        [-6, -45],
        [-85, -7],
        [-33, -62],
        [32, -46],
        [-16, -26],
        [-30, 24],
        [-42, -28],
        [-27, -90],
        [-18, -34],
        [-24, 31],
        [-33, -2],
        [-32, -54],
        [11, -33],
        [-18, -43],
        [-46, -8],
        [-10, 50],
        [-21, 22],
        [-73, 4],
        [-28, 23],
        [-128, -44],
        [-34, 14],
        [-48, 35],
        [-22, -1],
        [-16, 40],
        [-47, -33],
        [-32, 7],
        [-24, -48],
        [-55, -14],
        [8, 29],
        [-39, 32],
        [-13, 41],
        [-20, 12],
        [-68, -35],
        [-40, -31],
        [-61, -2],
        [-2, -32],
        [-43, -23],
        [14, -41],
        [-27, -7],
        [-30, 62],
        [-32, 7],
        [-47, -20],
        [-33, -28],
        [-14, 42],
        [40, 2],
        [11, 50],
        [-55, 27],
        [-35, -33],
        [-28, 69],
        [-32, 5],
        [16, 51],
        [8, 59],
        [-48, 28],
        [6, 59],
        [-30, 28],
        [40, 34],
        [-25, 35],
        [57, 55],
        [-38, 15],
        [-35, -10],
        [-44, 31],
        [46, 32],
        [4, 18],
        [-64, 23],
        [68, 51],
        [19, 39],
        [-10, 26],
        [-76, 10],
        [-24, 69],
        [-59, -3],
        [-43, 11],
        [-29, -6],
        [-14, -24],
        [-42, -7],
        [-24, -27],
        [41, -77],
        [-12, -29],
        [-29, 7],
        [-20, 73],
        [-33, 26],
        [16, 74],
        [49, 77],
        [5, 33],
        [-39, 36],
        [-16, -56],
        [-67, -13],
        [-74, 0],
        [-57, -18],
        [-38, 21],
        [-35, 5],
        [-25, 21],
        [-45, -2],
      ],
      [
        [74814, 28920],
        [42, 49],
        [12, 54],
        [62, 20],
        [-35, 69],
        [104, 125],
        [-2, 19],
        [45, 10],
        [19, 71],
        [-16, 66],
        [33, 48],
        [40, 22],
        [21, 50],
        [23, 10],
        [1, 33],
        [47, 56],
        [7, 32],
        [-23, 38],
        [20, 24],
        [49, 0],
        [63, -49],
        [30, 40],
        [42, 79],
        [2, 16],
        [-5, 31],
        [33, 7],
        [-20, 45],
        [31, 30],
        [16, 74],
        [26, 32],
        [-34, 10],
        [3, 88],
        [11, 11],
        [-57, 77],
        [-10, 57],
        [9, 38],
        [-64, -2],
        [-39, -11],
        [-31, 19],
        [-23, -22],
        [-53, 20],
        [-1, 34],
        [-23, 24],
        [2, 51],
        [29, 120],
        [-10, 31],
        [-76, 13],
        [-30, -12],
        [-13, 29],
        [28, 61],
        [-1, 33],
        [-42, -23],
        [-82, -2],
        [1, 50],
        [-55, 11],
        [5, 49],
        [29, 36],
        [-8, 25],
        [-22, 16],
        [-39, -17],
        [-31, 36],
        [-38, 20],
        [40, 93],
        [48, 49],
        [3, 39],
        [-18, 44],
        [29, 48],
        [43, 1],
        [43, 40],
        [60, -1],
        [94, 81],
        [30, 34],
        [0, 65],
        [34, 18],
        [22, 59],
        [68, 72],
        [36, 19],
        [1, 41],
        [74, -6],
        [28, 57],
        [59, -24],
        [28, 2],
        [-3, 57],
        [11, 67],
        [26, 56],
        [33, 19],
        [-2, 61],
        [18, 6],
        [55, 69],
        [15, 66],
        [-5, 84],
        [19, 17],
        [15, 52],
        [29, 65],
        [30, 25],
        [53, 44],
        [-13, 76],
        [30, 50],
        [155, 6],
        [44, 17],
        [47, 35],
        [-11, 57],
        [-31, 16],
        [-19, -12],
        [-12, 87],
        [72, 1],
        [34, 25],
        [-15, 54],
        [38, 22],
        [7, 42],
        [76, -48],
        [28, 19],
        [-11, 54],
        [18, 63],
        [-4, 36],
        [29, 25],
        [2, 117],
        [13, 73],
        [23, 36],
        [53, 8],
        [-63, 69],
        [41, 14],
        [-1, 35],
        [46, 22],
        [59, -10],
        [4, 36],
        [122, 17],
        [10, -21],
        [38, 6],
        [6, 31],
        [51, 50],
        [68, -34],
        [41, -3],
        [32, 40],
        [58, 22],
        [9, 27],
        [-2, 67],
        [-19, 50],
        [13, 132],
        [-41, 53],
        [-17, 36],
        [-60, 39],
        [-46, 61],
        [63, 55],
        [122, 28],
        [34, -14],
        [57, 40],
        [56, -2],
        [41, 30],
        [38, -29],
        [48, 16],
        [39, 1],
        [-46, 48],
        [-7, 97],
        [-28, -28],
        [-10, 39],
        [5, 73],
        [-174, 222],
        [-26, 45],
        [-32, -9],
        [-8, 47],
        [22, 23],
        [48, 16],
        [28, 33],
        [-13, 18],
        [30, 65],
        [27, 3],
        [19, 29],
        [-1, 52],
        [-26, 1],
        [42, 90],
        [36, 50],
        [7, 40],
        [34, -18],
        [10, 64],
        [18, 22],
        [-19, 28],
        [-32, 3],
        [-9, 38],
        [12, 45],
        [34, 46],
        [-7, 56],
        [70, 105],
        [-3, 29],
        [-59, 49],
        [18, 28],
        [36, -27],
        [63, 143],
        [-40, -9],
        [-62, 15],
        [-12, 178],
        [-16, 31],
        [118, 6],
        [99, -13],
        [129, 108],
      ],
      [
        [77507, 35914],
        [66, 52],
      ],
      [
        [77573, 35966],
        [103, 87],
        [37, -2],
        [8, -33],
        [48, 32],
        [142, -9],
        [73, 32],
        [192, 39],
        [210, -19],
        [63, -42],
        [60, -65],
        [24, -10],
        [19, 44],
        [80, 4],
        [25, 10],
        [201, -37],
        [-13, -68],
        [137, -122],
        [132, -100],
        [83, -9],
        [33, -11],
        [237, 35],
        [116, 25],
        [357, -60],
        [48, -42],
        [27, -49],
        [101, -10],
        [25, -60],
        [116, -35],
        [-38, -66],
        [17, -23],
        [41, -23],
        [5, -47],
        [22, 2],
        [149, -46],
        [23, 72],
        [56, -63],
        [85, -48],
        [-72, -146],
        [-35, -80],
        [189, -81],
        [33, -52],
        [79, 14],
        [86, -34],
        [34, 20],
        [18, -35],
        [50, -21],
        [24, 5],
        [51, -14],
        [28, -21],
        [6, -33],
        [32, -32],
        [15, -55],
        [68, -8],
        [8, 19],
        [40, -30],
        [46, 7],
        [23, -31],
        [53, -31],
        [0, -37],
        [38, -16],
        [86, 18],
        [18, 44],
        [-4, 30],
        [98, -50],
        [-35, -70],
        [7, -43],
        [74, -8],
        [64, 38],
        [28, 29],
        [60, 39],
        [53, -7],
        [60, 18],
        [59, 49],
        [320, 5],
        [41, 64],
        [-35, 96],
        [-39, 59],
        [-66, 34],
        [34, 39],
        [28, 10],
        [13, 34],
        [42, 62],
        [-5, 67],
        [23, 25],
        [-2, 32],
        [19, 31],
        [7, 55],
        [39, 60],
        [32, 11],
        [77, -28],
        [53, 11],
        [45, -11],
        [38, 31],
        [64, -8],
        [111, 59],
        [135, -48],
        [206, 23],
        [23, 4],
        [84, -70],
        [35, -40],
        [106, 3],
        [82, -42],
        [48, -46],
        [67, 12],
        [14, -8],
        [47, -72],
        [-24, -24],
        [5, -29],
        [-14, -63],
        [33, -45],
        [27, 18],
        [31, 60],
        [34, 2],
        [103, -120],
        [57, -30],
        [167, -145],
        [63, -171],
        [84, 11],
        [209, -8],
        [116, 15],
        [76, -4],
        [3, -34],
        [-41, -70],
        [67, -53],
        [12, -19],
        [-45, -28],
        [34, -93],
        [5, -50],
        [30, -31],
        [2, 59],
        [167, -68],
        [74, 57],
        [105, 69],
        [149, 24],
        [-11, -69],
        [54, 10],
        [41, -22],
        [45, 46],
        [48, 9],
        [36, 20],
        [-19, 51],
        [7, 16],
        [63, 21],
      ],
      [
        [85478, 34410],
        [20, -38],
        [-1, -54],
        [-16, -26],
        [20, -18],
        [-21, -36],
        [11, -17],
        [-24, -86],
        [1, -48],
        [16, -12],
        [-21, -61],
        [34, -66],
        [-27, -32],
        [-4, -39],
        [17, -18],
        [3, -42],
        [-25, -32],
        [-62, -55],
        [10, -66],
        [68, -3],
        [-32, -53],
        [2, -62],
        [19, -35],
        [36, -19],
        [64, -84],
        [26, -1],
        [84, 48],
        [-14, 55],
        [137, 8],
        [29, -19],
        [71, -11],
        [66, -35],
        [-11, -21],
        [-19, -40],
        [-90, -99],
        [-5, -138],
        [24, -25],
        [-11, -38],
        [-197, 38],
        [-37, -52],
        [-53, -44],
        [-18, -5],
        [-61, -52],
        [-8, -44],
        [-106, -79],
        [-22, -10],
        [-47, -54],
        [-65, -45],
        [-57, 5],
        [-35, 26],
        [-45, 2],
        [-58, 25],
        [-36, -8],
        [-40, 8],
        [-52, 70],
        [-21, 7],
        [-83, 25],
        [-87, 16],
        [-17, 31],
        [-1, 44],
        [-14, 18],
        [-141, 18],
        [-36, 11],
        [-113, -143],
        [45, -4],
        [22, -30],
        [-35, -43],
        [7, -24],
        [-16, -38],
        [-11, -64],
        [-23, -56],
        [-16, -69],
        [-14, -20],
        [-35, -92],
        [26, -1],
        [0, -35],
        [-20, -94],
        [27, -50],
        [3, -43],
        [23, -21],
        [30, -16],
        [-14, -34],
        [1, -61],
        [-53, -69],
        [-31, 2],
        [-52, 36],
        [-95, 31],
        [-35, -28],
        [38, -85],
        [-61, -78],
        [19, -29],
        [-31, -29],
        [-7, -27],
        [38, -39],
        [5, -34],
        [-56, -40],
        [64, -38],
        [13, -29],
        [-130, -21],
        [-116, -48],
        [-43, 29],
        [-8, 32],
        [-31, 13],
        [-197, 6],
        [-15, -39],
        [-29, 10],
        [-60, 22],
        [-58, 35],
        [-119, 82],
        [-28, 13],
        [-83, 38],
        [-39, -40],
        [47, -47],
        [-7, -21],
        [4, -77],
        [-14, -21],
        [-156, 11],
        [-22, -15],
        [2, -44],
        [24, -21],
        [-161, -122],
        [-134, 3],
        [-85, -4],
        [-61, 8],
        [-84, -22],
        [-189, 62],
        [4, 114],
        [-36, 0],
        [-52, 26],
        [10, -106],
        [-71, 8],
        [2, -39],
        [-30, -23],
        [-20, -49],
        [-53, -82],
        [24, -82],
        [-105, -40],
        [-32, -23],
        [-127, -52],
        [-31, -45],
        [-42, -12],
        [-12, -48],
        [90, -19],
        [-26, -148],
        [21, -60],
        [52, -65],
        [-3, -64],
        [-156, -35],
        [-25, -34],
        [-38, -26],
        [15, -11],
        [55, -110],
        [-13, -48],
        [8, -30],
        [38, -24],
        [56, -3],
        [49, -187],
        [66, 23],
        [35, 1],
        [36, -67],
        [15, 4],
        [101, -49],
        [12, -58],
        [22, -48],
        [30, -89],
        [-7, -24],
        [-5, -88],
        [-92, 7],
        [-13, -181],
        [30, -30],
        [-40, -30],
        [57, -8],
        [-13, -22],
        [12, -44],
        [25, -5],
        [-1, -45],
        [19, -39],
        [-7, -59],
        [2, -148],
        [5, -28],
        [47, -47],
        [10, -64],
        [0, -69],
        [30, -13],
        [116, 1],
        [106, -42],
        [51, -12],
        [31, -75],
        [43, -53],
        [15, -68],
        [-5, -109],
        [25, -36],
        [34, -26],
        [42, 4],
        [57, -51],
        [32, -19],
      ],
      [
        [82842, 28448],
        [30, -77],
        [84, -59],
        [11, -44],
        [-43, -46],
        [-41, -18],
        [-1, -35],
        [-26, -36],
        [-36, -28],
        [11, -87],
        [49, -32],
        [9, -26],
        [-72, -36],
        [5, -24],
        [-29, -23],
        [6, -42],
        [-46, -88],
        [-5, -52],
        [-45, -29],
        [-50, -45],
        [30, -82],
        [-55, -37],
        [34, -81],
        [96, -60],
        [49, -17],
        [-18, -58],
        [15, -28],
        [20, -98],
        [-2, -88],
        [-20, -2],
        [-8, 53],
        [-44, 4],
        [2, -27],
        [33, -128],
        [-110, -4],
        [-83, -26],
        [-27, 18],
        [-65, -16],
        [-108, -6],
        [-66, 28],
        [6, -42],
        [-36, 0],
        [-5, -25],
        [-44, -30],
        [-42, -14],
        [-43, -40],
        [-49, 6],
        [-12, -84],
        [-18, -8],
        [-28, -63],
        [8, -44],
        [-74, 20],
        [6, 66],
        [22, 15],
        [15, 130],
        [-7, 42],
        [-67, -62],
        [-44, -20],
        [-39, 10],
        [-33, 31],
        [-56, -42],
        [-59, 4],
        [2, 41],
        [56, 42],
        [62, -5],
        [47, 56],
        [-6, 32],
        [-86, 6],
        [-86, -6],
        [-30, -29],
        [-45, -69],
        [-20, -62],
        [-17, -12],
        [-98, 1],
        [-58, 12],
        [-30, 24],
        [-53, -29],
        [-41, -41],
        [-66, -14],
        [-43, -23],
        [-66, -11],
        [-64, -49],
        [-66, -87],
        [-30, 20],
        [-54, -6],
        [-31, 10],
        [-32, -14],
        [-21, 104],
        [-32, 45],
        [-7, 51],
        [-47, 14],
        [-46, 64],
        [-55, 34],
        [-40, -29],
        [12, -91],
        [-17, -35],
        [-8, -61],
        [-82, 0],
        [-17, 60],
        [-14, 11],
        [-57, -24],
        [-46, -1],
        [-87, 77],
        [-34, 13],
        [-32, -21],
        [-67, -10],
        [-78, 33],
        [-2, -142],
        [-50, -14],
        [-26, -12],
        [-35, 8],
        [-27, 42],
        [-7, 70],
        [-20, 19],
        [-88, -18],
        [2, 59],
        [25, 37],
        [45, 34],
        [49, 18],
        [-32, 68],
        [4, 30],
        [57, 12],
        [10, 33],
        [-51, 30],
        [-9, 28],
        [-39, 18],
        [-36, -8],
        [-24, 14],
        [-11, 32],
        [-35, 14],
        [-6, 40],
        [64, 71],
        [34, 24],
        [-87, 81],
        [-26, 21],
        [-83, 8],
        [-35, 20],
        [-147, -15],
        [-24, -27],
        [-65, -4],
        [-117, -42],
        [-28, -45],
        [-28, -18],
        [-5, -4],
        [-95, 117],
        [-53, 17],
        [-39, -54],
        [-14, -57],
        [-23, -17],
        [-67, -20],
        [63, -19],
        [61, -37],
        [25, 1],
        [17, -29],
        [-106, -67],
        [-83, -5],
        [-8, -91],
        [-81, 20],
        [-43, 57],
        [-2, 22],
        [-37, 24],
        [-40, -21],
        [-27, 38],
        [-128, -39],
        [-50, 42],
        [-22, 12],
        [-92, -5],
        [-53, -28],
        [-92, 1],
        [-27, 31],
        [-55, -12],
        [-42, 23],
        [-61, -50],
        [-17, 17],
        [-44, 5],
        [-4, 49],
        [38, 40],
        [-8, 62],
        [17, 88],
        [-57, -15],
        [-3, 126],
        [-15, 86],
        [27, 21],
        [53, -1],
        [8, 37],
        [-13, 45],
        [-44, -12],
        [-19, 12],
        [-14, 42],
        [-43, 52],
        [-20, 2],
        [12, 189],
        [67, 9],
        [195, -38],
        [48, 194],
        [-41, 71],
        [-155, -3],
        [-51, 74],
        [-43, 6],
        [-19, 47],
        [-70, 14],
        [-9, -66],
        [-42, 0],
        [-57, 28],
        [6, 78],
        [55, 22],
        [-21, 43],
        [43, 34],
        [-76, -4],
        [10, 67],
        [-25, 26],
      ],
      [
        [90326, 9701],
        [-23, 26],
        [-49, 78],
        [-122, 137],
        [-31, 52],
        [-84, 3],
        [-72, 16],
        [-35, -19],
        [-38, -1],
        [-92, -29],
        [-51, -53],
        [-19, -46],
        [-145, 36],
        [-73, -5],
        [-32, 7],
        [-43, 27],
        [-168, 59],
        [-133, 55],
        [-254, 88],
        [-177, 56],
        [-61, 18],
        [-114, 23],
        [-165, 59],
        [-315, 90],
        [-44, 10],
        [-201, 54],
        [-264, 67],
        [-268, 58],
        [-219, 44],
        [-116, 17],
        [-137, 14],
        [-224, 16],
        [-112, 1],
        [-63, -6],
        [-101, -20],
        [-29, 1],
        [-64, 12],
        [-148, 45],
        [-128, 49],
        [-138, 68],
        [-140, 80],
        [-80, 49],
        [-120, 106],
        [-115, 95],
        [-77, 26],
        [-29, -40],
        [-40, 13],
        [-25, 66],
        [43, -26],
        [13, 56],
        [-43, 29],
        [-19, -23],
        [-71, 7],
        [-49, 32],
        [31, 20],
        [7, 50],
        [24, 32],
        [54, 9],
        [-2, 39],
        [-52, 53],
        [-86, 22],
        [-64, -23],
        [-23, -32],
        [-30, -2],
        [-17, -25],
        [27, -33],
        [27, 22],
        [33, -16],
        [-25, -36],
        [-27, 6],
        [-36, -20],
        [-41, 36],
        [20, 47],
        [-38, 24],
        [-6, 31],
        [-93, 114],
        [-35, 12],
        [-28, 59],
        [-130, 76],
        [-68, 28],
        [-140, 53],
        [-148, 53],
        [-136, 43],
        [-118, 21],
        [-228, 102],
        [-189, 76],
        [-83, 28],
        [-92, 42],
        [-163, 64],
        [-158, 59],
        [-275, 105],
        [-185, 68],
        [-228, 81],
        [-84, 23],
        [-285, 109],
        [-229, 82],
        [-81, 26],
        [-100, 30],
        [-117, 21],
        [-55, 18],
        [-224, 94],
        [-212, 93],
        [-56, 19],
        [-149, 62],
        [-264, 94],
        [-93, 28],
        [-70, 14],
        [-107, 42],
        [-263, 113],
        [-57, 15],
        [-31, -5],
        [-97, 61],
        [-137, 49],
        [34, 82],
        [-15, 60],
        [-59, 56],
        [-17, 29],
        [-39, 33],
        [-123, 106],
        [-135, 103],
        [-126, 78],
        [-49, 26],
        [-6, 35],
        [-20, 14],
        [-5, 40],
        [-39, 35],
        [-100, 74],
        [-49, 28],
        [-202, 100],
        [-104, 47],
        [-120, 46],
        [-135, 44],
        [-71, 37],
        [-266, 115],
        [-203, 81],
        [18, 37],
        [52, -13],
        [18, 54],
        [-1, 38],
        [-33, 78],
        [-36, 45],
        [-86, 89],
        [-75, 64],
        [-88, 58],
        [-56, 4],
        [-19, -22],
        [-54, -6],
        [-60, -30],
        [-29, 12],
        [21, 30],
        [32, 20],
        [-8, 41],
        [-22, 32],
        [-34, -15],
        [-12, -43],
        [-41, 6],
        [-27, 44],
        [-39, 10],
        [-43, -23],
        [-19, 43],
        [7, 21],
        [-28, 55],
        [-43, 19],
        [-68, 5],
        [-71, 27],
        [1, 44],
        [-17, 17],
        [6, 38],
        [-10, 59],
        [-90, 162],
        [-88, 95],
        [-132, 103],
        [-79, 55],
        [-62, 32],
        [-19, 59],
        [11, 17],
        [-35, 50],
        [-74, 67],
        [7, 66],
        [-52, 68],
        [-15, 34],
        [-94, 95],
        [-113, 77],
        [-118, 51],
        [-50, 5],
        [-19, 39],
        [-136, 78],
        [-141, 75],
        [-33, 31],
        [-142, 61],
        [-80, 24],
        [-28, -1],
        [-146, 64],
        [-74, 14],
        [-118, -1],
        [-166, -33],
        [-52, -82],
        [-94, -83],
        [-17, -42],
      ],
      [
        [74628, 16841],
        [2, 79],
        [-5, 68],
        [-39, 30],
        [-43, 12],
        [-83, 57],
        [-32, 46],
        [-19, 140],
        [27, 52],
        [-13, 70],
        [-14, 37],
        [26, 70],
        [-5, 75],
        [24, 126],
        [-16, 15],
        [8, 49],
        [46, 49],
        [17, 49],
        [8, 90],
        [47, 22],
        [13, 44],
        [34, 47],
        [42, 3],
        [62, -9],
        [34, 18],
        [101, 23],
        [75, -9],
        [73, 10],
        [39, 23],
        [42, 40],
        [36, 2],
        [55, -32],
        [31, 12],
        [56, -10],
        [100, 24],
        [20, 29],
        [-18, 59],
        [28, 39],
        [90, -26],
        [70, 23],
        [43, -4],
        [38, 47],
        [38, 5],
        [30, 28],
        [-13, 64],
        [48, 79],
        [64, -71],
        [62, -13],
        [23, 34],
        [-53, 20],
        [-31, 30],
        [92, 51],
        [-20, 42],
        [-14, 63],
        [14, 15],
        [52, 14],
        [-25, 41],
        [-44, 46],
        [40, 55],
        [1, 70],
        [-59, 63],
        [14, 27],
        [-10, 49],
        [-69, 68],
        [8, 65],
        [41, 61],
        [21, 64],
        [54, 37],
        [1, 19],
        [-38, 41],
        [-76, 99],
        [-11, 108],
        [12, 51],
        [15, 106],
        [16, 42],
        [92, 67],
        [16, 33],
        [56, 74],
        [57, 30],
        [42, 10],
        [132, 53],
        [50, 34],
        [50, 17],
        [216, 44],
        [52, -12],
        [26, -44],
        [10, -52],
        [34, -13],
        [38, 6],
        [87, 38],
        [72, -1],
        [75, 28],
        [67, -16],
        [23, -67],
        [56, -38],
        [19, -43],
        [2, -35],
        [31, -80],
        [30, -22],
        [5, -67],
        [22, -34],
        [34, -11],
        [56, -44],
        [49, 1],
        [30, -13],
        [13, -35],
        [41, -16],
        [78, -6],
        [49, -46],
        [28, 2],
        [93, 17],
        [52, -18],
        [26, 10],
        [25, 41],
        [19, -1],
        [38, -38],
        [38, 11],
        [28, 50],
        [42, -23],
        [47, 25],
        [10, 45],
        [31, 4],
        [27, -26],
        [30, -2],
        [38, 22],
        [35, -10],
        [22, -41],
        [33, 1],
        [7, 25],
        [-8, 64],
        [29, 18],
        [32, -2],
        [106, 37],
        [39, -6],
        [30, 24],
        [63, 0],
        [33, 18],
        [45, 40],
        [68, -47],
        [28, 20],
        [61, -9],
        [39, -16],
        [65, -1],
        [57, 13],
        [81, -58],
        [7, -30],
        [31, -5],
        [84, 17],
        [52, -15],
        [46, -35],
        [25, -3],
        [41, 35],
        [55, -40],
        [172, -12],
        [31, 35],
        [104, 21],
        [55, 30],
        [41, 11],
        [45, -16],
        [40, 17],
        [26, -12],
        [15, -152],
        [18, -13],
        [57, 1],
        [66, -39],
        [52, -58],
        [15, -34],
        [-28, -59],
        [17, -35],
        [54, 3],
        [44, 43],
        [41, -21],
        [30, -34],
        [27, 9],
        [26, 67],
        [-11, 31],
        [30, 33],
        [42, -38],
        [29, -10],
        [35, 27],
        [36, 100],
        [49, 10],
        [28, -45],
        [47, -26],
        [66, -14],
        [65, 5],
        [71, 11],
        [46, 21],
        [40, -40],
        [47, -106],
        [19, -64],
        [73, -14],
        [20, -33],
        [27, -15],
        [58, 9],
        [43, -105],
        [33, -33],
        [29, 19],
        [13, 59],
        [17, 16],
        [44, 2],
        [33, -24],
        [15, -30],
        [-9, -53],
        [28, -51],
        [41, -16],
        [-10, -52],
        [65, -61],
        [27, -2],
        [64, -71],
        [7, 61],
        [19, 39],
        [30, 14],
        [18, 33],
        [75, 6],
        [5, 52],
        [35, 18],
        [27, 46],
        [-16, 26],
        [48, 12],
        [-6, 32],
        [-152, 92],
        [-55, 48],
        [-8, 74],
        [-49, -2],
        [-7, 22],
        [-45, 35],
        [-77, 46],
        [-55, 24],
        [-46, 37],
        [-15, -28],
        [-27, 21],
        [-12, 33],
        [-70, 99],
        [-32, 25],
        [-57, -14],
        [-96, 212],
        [7, 11],
        [-3, 92],
        [26, 136],
        [32, 119],
        [2, 40],
        [-35, 6],
        [-3, 62],
        [-29, 43],
        [20, 37],
        [-11, 56],
        [-41, 39],
        [-52, -15],
        [-6, 33],
        [20, 48],
        [4, 43],
        [32, 97],
        [-33, 36],
        [-38, 7],
        [-38, 25],
        [0, 21],
        [31, 55],
        [-23, 27],
        [-12, 97],
        [58, 48],
        [12, 25],
        [-36, 118],
        [-7, 42],
        [56, 82],
        [-11, 19],
        [71, 55],
        [76, 13],
        [24, -52],
        [37, 15],
        [8, -51],
        [39, 1],
        [78, -80],
        [-9, -44],
        [38, -3],
        [-10, -55],
        [-1, -88],
        [47, -7],
        [24, 41],
        [88, 89],
        [-8, 20],
        [33, 47],
        [30, -1],
        [32, 65],
        [43, 22],
        [-10, 44],
        [34, 34],
        [56, -8],
        [9, 29],
        [36, 41],
        [11, 35],
      ],
      [
        [81634, 21522],
        [29, -18],
        [11, -39],
        [34, 2],
        [22, -47],
        [38, -41],
        [33, -2],
        [40, -40],
        [72, -18],
        [36, -40],
        [28, 30],
        [57, -31],
        [57, -41],
        [53, 7],
        [40, -34],
        [17, -67],
        [-36, -22],
        [34, -83],
        [39, 47],
        [20, -14],
        [58, -7],
        [26, -18],
        [30, -45],
        [51, -24],
        [8, 27],
        [40, 5],
        [0, -44],
        [16, -38],
        [25, -16],
        [19, -19],
        [-88, -45],
        [-32, -136],
        [-27, -35],
        [3, -63],
        [-22, -43],
        [-88, -17],
        [-27, -36],
        [7, -53],
        [-49, -99],
        [6, -63],
        [50, -50],
        [9, -54],
        [57, -3],
        [48, 27],
        [39, -20],
        [28, -31],
        [32, -72],
        [-33, -14],
        [0, -55],
        [-19, -29],
        [-8, -65],
        [-22, -27],
        [-6, -35],
        [63, -119],
        [25, -92],
        [86, 49],
        [22, 50],
        [49, 47],
        [62, -16],
        [39, -41],
        [3, -24],
        [51, -134],
        [-25, -107],
        [-45, -59],
        [-14, -38],
        [-23, -144],
        [51, -18],
        [68, 3],
        [34, -46],
        [27, -69],
        [148, -113],
        [51, -50],
        [50, 71],
        [57, -4],
        [13, -43],
        [26, 5],
        [15, 31],
        [-9, 56],
        [11, 74],
        [25, 32],
        [-4, 27],
        [24, 53],
        [30, -10],
        [26, -35],
        [47, -4],
        [-5, 30],
        [25, 38],
        [17, -7],
        [15, 37],
        [26, 11],
        [9, 28],
        [30, 16],
        [22, -17],
        [28, 31],
        [0, 24],
        [61, -10],
        [23, 44],
        [-7, 20],
        [48, 17],
        [-12, 49],
        [35, -8],
        [16, 28],
        [85, 28],
        [12, 57],
        [69, -2],
        [33, 69],
        [72, 38],
        [65, -10],
        [22, 82],
        [39, 51],
        [18, 57],
        [19, 20],
        [-9, 91],
        [-54, 25],
        [50, 29],
        [17, -12],
        [17, -28],
        [124, 54],
        [17, 48],
        [39, 2],
        [17, -15],
        [30, -21],
        [20, -45],
        [52, -33],
        [-20, -80],
        [21, -21],
        [38, 34],
        [47, -20],
        [22, -23],
        [65, -42],
        [5, 69],
        [51, 56],
        [30, 58],
        [121, 39],
        [44, 20],
        [3, 16],
        [47, 24],
        [33, 42],
        [25, 3],
        [54, -13],
        [27, 5],
        [66, -54],
        [15, 68],
        [75, 33],
        [20, -14],
        [60, 18],
        [15, 44],
        [31, 2],
        [48, -35],
        [38, 48],
        [12, 16],
        [1, 110],
        [41, 46],
        [16, 65],
        [73, 49],
        [-17, 53],
        [5, 26],
        [44, 48],
        [26, 13],
        [15, 56],
        [9, 13],
        [141, -22],
        [27, -13],
        [33, -57],
        [31, -7],
        [29, -32],
        [38, 0],
        [-27, 65],
        [-14, 5],
        [-34, 77],
        [-18, 12],
        [-77, 116],
        [55, 30],
        [0, 55],
        [138, -60],
        [31, -22],
        [19, -59],
        [35, -47],
        [-1, -25],
        [48, -29],
        [4, -45],
        [27, -36],
        [35, 8],
        [15, 24],
        [8, 69],
        [28, -11],
        [35, 8],
        [70, -6],
        [46, -18],
        [-4, -27],
        [-4, -41],
        [61, -86],
        [54, -30],
        [56, -16],
        [53, -4],
        [49, 64],
        [82, 21],
        [47, 43],
      ],
      [
        [86779, 20698],
        [37, -84],
        [25, -93],
        [15, -55],
        [61, -147],
        [18, -27],
        [30, -141],
        [36, 24],
        [28, -18],
        [-12, -38],
        [9, -29],
        [52, -43],
        [27, 13],
        [13, -26],
        [-22, -34],
        [11, -84],
        [70, -30],
        [4, -15],
        [76, -136],
        [51, -24],
        [31, -63],
        [38, -51],
        [0, -61],
        [42, -43],
        [-10, -45],
        [64, -2],
        [-34, 59],
        [65, 24],
        [38, 24],
        [-5, -130],
        [5, -14],
        [75, -23],
        [37, 23],
        [59, -6],
        [50, -18],
        [53, -7],
        [98, -11],
        [6, 27],
        [187, 1],
        [4, -7],
        [-10, -39],
        [82, -60],
        [51, -53],
        [-20, 78],
        [4, 41],
        [97, 77],
        [52, 15],
        [62, -32],
        [-3, -52],
        [53, -69],
        [-25, -27],
        [10, -20],
        [90, -52],
        [2, -27],
        [35, -48],
        [50, -5],
        [25, -43],
        [26, -21],
        [-4, -46],
        [23, -2],
        [20, -42],
        [18, -9],
        [-2, -41],
        [-16, -42],
        [-26, -28],
        [18, -46],
        [26, -13],
      ],
      [
        [88749, 18782],
        [-18, -21],
        [12, -46],
        [24, -27],
        [10, -84],
        [38, -34],
        [-65, -47],
        [20, -43],
        [30, -1],
        [5, -43],
        [-36, -19],
        [-10, -35],
        [45, 3],
        [23, 36],
        [80, 63],
        [67, -29],
        [9, -35],
        [-29, -47],
        [10, -22],
        [38, 10],
        [20, -17],
        [33, 31],
        [48, -5],
        [-27, -59],
        [4, -122],
        [-28, -111],
        [198, -8],
        [333, -107],
        [13, -4],
        [104, -185],
        [31, -55],
        [-36, -125],
        [-48, -169],
        [4, -4],
        [165, 31],
        [100, 0],
        [-9, -35],
        [64, -17],
        [10, 39],
        [61, -8],
        [35, -16],
        [21, -36],
        [31, 10],
        [29, -28],
        [60, 7],
        [39, -33],
        [-36, -35],
        [-46, -30],
        [-41, -10],
        [-11, -25],
        [-48, 0],
        [-75, 22],
        [-33, -10],
        [-56, -53],
        [-14, -34],
        [24, -18],
        [44, 11],
        [160, -68],
        [55, 8],
        [20, -21],
        [75, -24],
        [81, -43],
        [44, -38],
        [-11, -23],
        [36, -32],
        [62, 38],
        [68, -57],
        [2, -36],
        [33, 9],
        [41, -23],
        [28, -35],
        [29, 2],
        [48, 46],
        [36, 10],
        [13, -17],
        [46, 41],
        [12, 39],
        [68, 26],
        [9, 21],
        [41, 33],
        [48, 10],
        [22, -17],
        [59, 1],
        [14, 30],
        [46, -27],
        [66, 12],
        [27, 91],
        [39, -8],
        [68, 15],
        [28, -32],
        [35, 9],
        [35, -45],
        [21, 8],
        [12, 38],
        [51, -9],
        [58, 7],
        [37, -44],
        [28, 10],
        [41, -35],
        [-35, -24],
        [5, -44],
        [28, -31],
        [13, -37],
        [-11, -67],
        [-28, -41],
        [-37, -21],
        [32, -107],
        [-14, -39],
        [28, -4],
        [27, -65],
        [-7, -67],
      ],
      [
        [91697, 16476],
        [0, -131],
        [-180, -208],
        [-33, -43],
        [-104, -78],
        [-12, -56],
        [45, -139],
        [-11, -59],
        [13, -81],
        [-15, -9],
        [14, -48],
        [2, -62],
        [70, -15],
        [19, -75],
        [1, -66],
        [25, -95],
        [48, 15],
        [80, -51],
        [96, -109],
        [65, 12],
        [98, 10],
        [57, -113],
        [44, -14],
        [17, -36],
        [-3, -31],
        [30, -18],
        [2, -57],
        [17, -45],
        [53, -44],
        [-15, -26],
        [6, -40],
        [4, -40],
        [48, -23],
        [39, -145],
        [-79, 5],
        [-16, -33],
        [-16, -76],
        [143, -307],
        [81, -323],
        [-80, -7],
        [-61, -124],
        [-25, -131],
        [3, -5],
        [95, -142],
        [64, -38],
        [51, 57],
        [56, -19],
        [41, 21],
        [63, 1],
        [35, -17],
        [56, -43],
        [37, -63],
        [51, -47],
        [14, -62],
        [-23, -23],
        [2, -39],
        [-36, -3],
        [-23, -18],
        [14, -8],
        [-28, -147],
        [-6, -93],
        [8, -51],
        [36, -39],
        [62, -5],
        [41, 10],
        [30, -10],
        [25, -15],
        [58, 1],
        [14, -21],
        [42, -1],
        [15, -40],
        [92, -32],
        [55, 0],
        [44, -36],
        [45, -22],
        [82, -86],
        [39, -11],
        [123, -36],
        [177, -84],
        [-82, -103],
        [-23, -17],
        [-24, 26],
        [-103, 13],
        [-80, -81],
        [-102, -190],
        [-65, -49],
        [23, -11],
        [-5, -73],
        [26, -1],
        [30, -91],
        [38, -46],
        [20, -71],
        [9, -73],
        [38, -47],
        [-16, -39],
        [9, -24],
        [-11, -66],
        [-35, -41],
        [13, -37],
        [-31, -63],
        [7, -22],
        [-34, -22],
        [2, -31],
        [-31, -34],
        [10, -28],
        [-31, -41],
        [0, -47],
        [-17, -70],
        [-56, -31],
        [-38, 32],
        [-31, -19],
        [7, -32],
        [28, -22],
        [10, -37],
        [-50, -35],
        [-11, -40],
        [-71, 6],
        [-25, -27],
        [-28, 11],
        [-43, -18],
        [-29, -28],
        [-13, -36],
        [-36, 6],
        [-14, -37],
        [-47, -4],
        [23, 68],
        [-79, -4],
        [-16, -12],
        [-57, 43],
        [-21, -48],
        [-24, -54],
        [-1, -82],
        [-11, -46],
        [59, -1],
        [4, -59],
        [18, -95],
        [39, -36],
        [26, -66],
        [81, 22],
        [13, -9],
        [-54, -175],
        [-8, 19],
        [-102, -45],
        [-53, -40],
        [-3, -24],
        [-39, -21],
        [-47, -3],
        [-42, -22],
        [-107, -4],
        [5, 61],
        [-115, -1],
        [-62, 14],
        [-47, -72],
        [-199, -42],
        [0, -22],
        [-53, 8],
        [12, -95],
        [41, -71],
        [-18, -76],
        [88, 15],
        [-1, -48],
        [69, 1],
        [6, -31],
        [-21, -37],
        [-8, -56],
        [40, -84],
        [0, -25],
        [-73, -102],
        [-155, -212],
        [-90, 0],
        [-76, 19],
        [-85, 7],
        [-73, -24],
        [-64, -34],
        [-7, -27],
        [-43, -1],
        [-32, -33],
        [-34, 6],
        [-54, -15],
        [-76, -60],
        [-46, -132],
        [-23, -25],
      ],
      [
        [91111, 8816],
        [-14, 16],
        [-63, 30],
        [20, 33],
        [-18, 51],
        [-33, 39],
        [-147, 146],
        [-160, 174],
        [-117, 113],
        [-91, 74],
        [-57, 54],
        [-65, 103],
        [-40, 52],
      ],
      [
        [85102, 28348],
        [109, 1035],
        [2, 17],
        [31, 304],
        [26, -8],
        [90, 22],
        [37, 28],
        [34, 7],
        [30, 31],
        [49, -6],
        [78, 27],
        [34, -18],
        [34, 6],
        [15, 21],
        [35, 51],
        [54, 7],
        [32, 20],
        [54, -31],
        [11, 33],
        [49, -7],
        [46, 44],
        [60, 36],
        [14, 29],
        [50, 0],
        [61, 19],
        [41, -21],
        [21, -48],
        [34, 17],
        [25, 55],
        [59, 15],
        [23, 55],
        [30, -10],
        [23, 13],
        [-2, 32],
        [23, 36],
        [79, 44],
        [71, -1],
        [23, 35],
        [49, 32],
        [108, 10],
        [-10, 65],
        [-31, 31],
        [22, 19],
        [-16, 37],
        [-34, 36],
        [-53, 39],
        [-70, 67],
        [-22, 93],
        [26, 45],
        [22, 13],
        [75, 26],
        [16, 27],
        [38, 29],
        [30, 6],
        [15, 67],
        [-11, 41],
        [56, 38],
        [4, 29],
        [-37, 0],
        [20, 44],
        [36, 32],
        [3, 43],
        [-21, 28],
        [30, 36],
        [74, 36],
        [49, 15],
        [-2, 34],
        [36, 6],
        [24, 61],
        [7, 53],
        [23, 27],
        [21, 73],
        [88, 20],
        [-8, 70],
        [11, 35],
        [38, 15],
        [-6, 45],
        [34, 21],
        [33, 44],
        [-8, 33],
        [20, 41],
        [-19, 18],
        [-17, 54],
        [31, 116],
        [25, 25],
        [-5, 35],
        [42, 35],
        [36, 9],
        [18, 117],
        [-35, 33],
        [26, 52],
        [-29, 34],
        [-53, -28],
        [-25, 20],
        [3, 38],
        [-46, 47],
        [6, 64],
        [35, 2],
        [83, -2],
        [55, 11],
        [64, -14],
        [21, 49],
        [-12, 18],
        [11, 45],
        [26, 30],
        [30, 5],
        [33, 45],
        [63, 36],
        [27, -40],
        [37, 9],
        [28, -27],
        [29, -68],
        [31, 7],
        [24, -27],
        [4, -30],
        [93, -49],
        [26, 10],
        [39, 42],
        [21, -24],
        [69, -7],
        [22, 15],
        [17, 45],
        [51, 17],
        [53, 4],
        [16, 19],
        [25, 59],
        [56, 7],
        [59, 39],
        [26, -12],
        [58, 39],
        [28, -32],
        [66, 8],
        [1, 37],
        [41, -11],
        [54, -2],
        [34, 33],
        [59, 39],
        [-8, -44],
        [52, -23],
        [30, 27],
        [3, 26],
        [51, 68],
        [-42, 202],
        [-18, 14],
        [-43, 1],
        [-38, 39],
        [1, 41],
        [16, 22],
        [49, 13],
        [37, 38],
        [-4, 81],
        [7, 24],
        [-21, 39],
      ],
      [
        [88799, 33361],
        [56, -15],
        [15, 22],
        [44, 0],
        [80, 57],
        [89, 19],
        [24, -10],
        [63, 1],
        [-2, 27],
        [47, 19],
        [9, -21],
        [82, 43],
        [11, -43],
        [10, -40],
        [35, 19],
        [16, -27],
        [13, -71],
        [-8, -41],
        [33, -39],
        [15, -52],
        [-22, -20],
        [22, -40],
        [36, 11],
        [33, -17],
        [-55, -56],
        [38, -19],
        [14, -53],
        [38, -11],
        [0, -32],
        [56, -56],
        [1, -64],
        [37, 7],
        [50, 36],
        [37, 1],
        [1, -41],
        [69, -55],
        [14, 7],
        [60, -46],
        [116, 18],
        [24, -23],
        [24, 30],
        [-23, 66],
        [-19, -8],
        [-47, 57],
        [23, 18],
        [121, -54],
        [18, -51],
        [19, 13],
        [29, 57],
        [73, -10],
        [23, 21],
        [31, -33],
        [70, 12],
        [67, 15],
        [26, -54],
        [-20, -37],
        [9, -39],
        [50, 33],
        [-16, 53],
        [41, 90],
        [38, 14],
        [44, -37],
        [18, -38],
        [56, -12],
        [56, 7],
        [3, 9],
        [118, 62],
        [43, 103],
        [11, 69],
        [-5, 53],
        [-21, 28],
        [-4, 39],
        [30, 16],
        [-13, 81],
        [23, 79],
        [-22, 29],
        [-40, 9],
        [-16, 26],
        [-70, 38],
        [-74, -3],
        [-59, 42],
        [-49, 21],
        [-27, 55],
        [-31, 29],
        [43, 35],
        [99, -10],
        [4, 29],
        [24, 18],
        [12, 50],
        [44, -14],
        [50, 5],
        [92, -34],
        [31, 11],
        [33, 59],
        [55, 11],
        [62, -11],
        [62, 59],
        [53, -3],
        [26, -33],
        [19, -45],
        [34, 5],
        [16, -29],
        [47, 7],
        [-35, 39],
        [49, 47],
        [4, 39],
      ],
      [
        [91332, 33889],
        [20, -21],
        [93, 56],
        [-3, -42],
        [34, 15],
        [17, -15],
        [8, -47],
        [-10, -80],
        [19, -75],
        [-44, -15],
        [-46, 30],
        [-47, -48],
        [-11, -63],
        [-37, -42],
        [-71, -104],
        [-21, -53],
        [-70, -89],
        [15, -28],
        [86, -79],
        [12, -18],
        [77, 18],
        [2, 21],
        [58, -7],
        [44, 8],
        [36, -14],
        [0, -75],
        [-56, -23],
        [12, -33],
        [38, -2],
        [55, -38],
        [24, -25],
        [-29, -24],
        [53, -18],
        [-5, -73],
        [21, -39],
        [52, -19],
        [13, -29],
        [31, -8],
        [35, -61],
        [49, -1],
        [28, 19],
        [143, 0],
        [16, 16],
        [32, -27],
        [74, 23],
        [5, 44],
        [61, 46],
        [29, 10],
        [25, 28],
        [29, -10],
        [48, -36],
        [14, 51],
        [41, 31],
        [37, -7],
        [5, -89],
        [-24, -53],
        [-56, -40],
        [-2, -36],
        [68, -35],
        [-5, -26],
        [90, 21],
        [24, -33],
        [37, -22],
        [32, 36],
        [60, 44],
        [10, 24],
        [43, 6],
        [8, -38],
        [37, -5],
        [17, -38],
        [-9, -43],
        [50, -31],
        [-33, -46],
        [9, -26],
        [59, 26],
        [59, -24],
        [18, -46],
        [56, -31],
        [45, -37],
        [-1, -58],
        [-25, -27],
        [18, -92],
        [-22, -69],
        [-57, -51],
        [-22, -12],
        [-34, 14],
        [-12, 32],
        [-38, -17],
        [9, -41],
        [-37, -8],
        [-26, -36],
        [14, -50],
        [-4, -21],
        [-67, -25],
        [9, -33],
        [-17, -46],
        [33, -15],
        [-29, -90],
        [-45, 34],
        [-21, -73],
        [-21, -18],
        [-11, -49],
        [-9, -39],
        [66, -82],
        [-34, -33],
        [-76, -5],
        [-32, -60],
        [-24, -75],
        [-20, -26],
        [42, -36],
        [-12, -20],
        [19, -30],
        [-35, -10],
        [15, -64],
        [32, -31],
        [0, -39],
        [115, -18],
        [-42, -96],
        [-31, 19],
        [-28, -21],
        [5, -34],
        [-26, 23],
        [-37, -40],
        [-105, 4],
        [-35, -7],
        [-35, -35],
        [-19, 24],
        [28, 63],
        [-46, 25],
        [-20, -16],
        [-15, -44],
        [-49, -24],
        [-41, 28],
        [-39, 41],
        [131, 59],
        [-7, 38],
        [-57, 15],
        [8, 36],
        [-51, 22],
        [-33, -3],
        [-35, 20],
        [16, 35],
        [-10, 29],
        [19, 31],
        [11, 49],
        [-53, -39],
        [-37, 32],
        [-30, -5],
        [-8, -30],
        [-41, -15],
        [-52, 4],
        [-24, 23],
        [-59, -24],
        [-4, -20],
        [-60, -2],
        [-23, -8],
        [-7, -31],
        [-55, -36],
        [-4, -31],
        [-25, -30],
        [-11, -40],
        [14, -32],
        [-31, -88],
        [-34, -22],
        [8, -28],
        [-12, -38],
        [38, -81],
        [29, -21],
        [-58, -27],
        [-39, -4],
        [-22, -29],
        [-100, -13],
        [-31, -21],
        [-18, 60],
        [-45, -15],
        [25, -39],
        [-14, -34],
        [-25, 1],
        [-43, -43],
        [-9, -23],
        [14, -47],
        [-49, -51],
        [-47, -21],
        [15, -60],
        [48, -68],
        [22, 12],
        [12, 50],
        [18, 29],
        [35, 10],
        [12, 26],
        [63, 27],
        [18, 26],
        [141, 52],
        [104, 93],
        [21, 47],
        [52, 29],
        [11, 22],
        [19, -48],
        [-15, -45],
        [-37, -55],
        [16, -13],
        [-91, -77],
        [-50, -24],
        [6, -52],
        [-8, -42],
        [-33, -54],
        [-125, -108],
        [-1, -38],
        [21, -48],
        [4, -34],
        [51, -127],
        [-7, -26],
        [-75, 3],
        [-44, 33],
        [-30, -10],
        [-40, -49],
        [-14, -42],
        [6, -81],
        [-15, -75],
        [-22, -20],
        [-18, -47],
        [-49, -48],
        [-39, -10],
        [-26, -47],
        [-53, -2],
        [-26, -23],
        [-26, 5],
        [-41, -30],
        [-17, -40],
        [73, -62],
        [2, -27],
        [32, -48],
        [83, -86],
        [-3, -37],
        [18, -30],
        [5, -56],
        [-3, -127],
        [19, -31],
        [12, -67],
        [-20, -59],
        [40, -44],
        [20, -38],
        [34, -11],
        [46, -40],
        [30, 11],
        [22, -18],
        [44, 16],
        [45, -19],
        [29, 8],
        [48, -7],
        [34, -19],
        [17, 12],
        [117, 150],
        [69, 80],
        [147, 111],
        [47, -20],
        [28, 16],
        [43, -10],
        [55, 26],
        [52, 45],
        [75, 19],
        [17, 54],
        [-4, 31],
        [19, 22],
        [-7, 30],
        [73, 64],
        [25, 9],
        [79, 60],
        [8, 42],
        [19, 4],
        [34, 47],
        [40, 45],
        [54, 6],
        [42, 21],
        [27, 74],
        [41, 10],
        [35, 28],
        [67, -10],
        [35, -17],
        [19, 21],
        [60, 13],
        [55, 62],
        [36, 53],
        [14, 47],
        [54, 62],
        [39, 75],
        [25, 8],
        [41, 39],
        [31, 61],
        [-14, 19],
        [50, -11],
        [2, 44],
        [23, 13],
        [35, -14],
        [11, 37],
        [20, 15],
        [-9, 43],
        [16, 38],
        [34, 40],
        [6, 50],
        [-23, 12],
        [17, 35],
        [23, -17],
        [59, -105],
        [64, -103],
        [56, -1],
        [32, -25],
        [15, -123],
        [-50, -59],
        [20, -73],
        [73, -209],
        [-10, -38],
        [55, 0],
        [61, -40],
      ],
      [
        [93719, 29577],
        [-29, -19],
        [-9, -53],
        [21, -34],
        [-21, -50],
        [-30, -14],
        [-39, 2],
        [1, -41],
        [-21, -39],
        [6, -27],
        [-39, -56],
        [-25, -7],
        [-31, -6],
        [-49, -33],
        [-93, -23],
        [-35, -29],
        [-38, -105],
        [8, -29],
        [-51, -33],
        [-2, -30],
        [-23, -19],
        [-28, -20],
        [-32, -70],
        [-41, -25],
        [14, -44],
        [-52, -28],
        [-11, -57],
        [-24, -3],
        [-61, -29],
        [-59, 9],
        [-25, -23],
        [-40, 28],
        [-38, 12],
        [10, -74],
        [-12, -86],
        [11, -42],
        [-56, -4],
        [-19, -16],
        [-56, 26],
        [-41, -23],
        [-75, 23],
        [-21, 41],
        [-83, -16],
        [-15, -15],
        [7, -58],
        [-19, -4],
        [-32, -66],
        [-79, -48],
        [1, -62],
        [14, -81],
        [21, -65],
        [28, -23],
        [49, -3],
        [30, 14],
        [41, -1],
        [43, 33],
        [2, 36],
        [21, 21],
        [101, 17],
        [49, 72],
        [25, 20],
        [31, 5],
        [63, -42],
        [42, -49],
        [25, -13],
        [43, -58],
        [3, -29],
        [-37, -23],
        [23, -50],
        [38, -33],
        [64, -82],
        [-9, -28],
        [-15, -53],
        [15, -21],
        [-44, -34],
        [0, -23],
        [81, -13],
        [77, -27],
        [15, -56],
        [-31, -49],
        [-37, -4],
        [-25, 23],
        [-23, -33],
        [-6, -53],
        [-89, -49],
        [-53, -22],
        [7, -44],
        [-25, -42],
        [-23, -90],
        [-59, -52],
        [34, -65],
        [-5, -22],
        [49, -33],
        [-33, -64],
        [-14, -60],
        [44, -57],
        [20, -39],
        [-30, -31],
        [-64, -60],
        [-79, 0],
        [-15, 24],
        [-28, -4],
        [-29, 24],
        [-40, -22],
        [-36, -73],
        [-90, -1],
        [32, -36],
        [-38, -35],
        [12, -71],
        [-43, -20],
        [-47, -1],
        [6, -72],
        [-12, -30],
        [-80, -41],
        [-20, -56],
        [-62, -28],
        [-47, -77],
        [37, -17],
        [28, -29],
        [64, 19],
        [14, -11],
        [22, 6],
        [53, -24],
        [10, -90],
        [42, -25],
        [24, -35],
        [-1, -88],
        [29, -15],
        [44, -73],
        [24, -15],
        [27, 26],
        [37, -6],
        [61, -52],
        [31, -66],
        [-3, -58],
        [-36, -20],
        [-49, 13],
        [-18, -21],
        [-56, -39],
        [-33, -34],
        [-78, -17],
      ],
      [
        [92477, 25633],
        [-49, 0],
        [-31, 29],
        [-82, 3],
        [-50, -11],
        [-44, 23],
        [-53, -22],
        [-42, -5],
        [-8, -67],
        [48, -46],
        [-4, -69],
        [-99, -148],
        [-100, -134],
        [-67, -94],
        [-129, 36],
        [-13, 4],
        [-80, -16],
        [-40, 1],
        [-71, 20],
        [-58, -23],
        [-78, 25],
        [-41, -25],
        [5, -32],
        [-49, -20],
        [-78, -5],
        [-43, 60],
        [13, 21],
        [-46, 78],
        [-51, -63],
        [-40, 32],
        [-37, -5],
        [10, 51],
        [-84, 0],
        [-49, -90],
        [-86, -84],
        [-134, -18],
        [-18, 33],
        [-26, 12],
        [-47, -11],
        [-36, 3],
      ],
      [
        [90590, 25076],
        [18, 20],
        [-28, 40],
        [-22, 65],
        [23, 65],
        [-14, 43],
        [27, 35],
        [30, -32],
        [24, 2],
        [41, -27],
        [24, 23],
        [77, 21],
        [1, 24],
        [-72, 32],
        [34, 46],
        [8, 52],
        [21, 40],
        [-31, 37],
        [0, 83],
        [67, 36],
        [36, -17],
        [20, 54],
        [10, 106],
        [22, 41],
        [-68, 40],
        [-5, 63],
        [-56, -7],
        [7, 43],
        [-70, 34],
        [-4, 50],
        [-18, 33],
        [-79, 85],
        [-65, -12],
        [10, -77],
        [-22, -17],
        [-92, 92],
        [117, 107],
        [-5, 47],
        [-36, -12],
        [-28, -50],
        [-56, 39],
        [-62, -23],
        [-27, 42],
        [-50, 13],
        [-43, 12],
        [-2, 26],
        [-70, 21],
        [-32, -10],
        [-89, 42],
        [-61, -56],
        [21, -17],
        [-1, -33],
        [-26, -27],
        [-50, 41],
        [-40, 16],
        [-10, -3],
        [-124, 73],
        [13, 50],
        [-67, 59],
        [-45, -54],
        [-24, 8],
        [-58, 32],
        [-39, -35],
        [-24, -1],
        [-5, -53],
        [-27, 20],
        [-28, -46],
        [-17, -5],
        [-17, -39],
        [57, -28],
        [-12, -68],
        [10, -19],
        [-49, -33],
        [-52, 21],
        [-22, -62],
        [-60, -134],
        [-22, -21],
        [-39, 12],
        [-53, 33],
        [-42, 32],
        [-133, 65],
        [38, 25],
        [-95, 170],
        [144, 68],
        [107, 50],
        [46, -32],
        [12, 16],
        [-14, 83],
        [18, 8],
        [-16, 106],
        [-46, 8],
        [-29, 30],
        [-49, 13],
        [-11, 34],
        [-66, -18],
        [19, 74],
        [67, -11],
        [73, 96],
        [44, 9],
        [49, -4],
        [13, 127],
        [-25, 40],
        [14, 41],
        [-10, 51],
        [-63, 8],
        [-3, 58],
        [-42, 25],
        [-25, 33],
        [-60, 52],
        [-12, 20],
        [-36, -64],
        [-31, -5],
        [-21, -89],
        [20, -44],
        [-34, -76],
        [-1, -65],
        [-25, -19],
        [-10, -34],
        [46, -24],
        [33, -85],
        [-108, -2],
        [-31, 36],
        [7, 91],
        [13, 15],
        [-6, 106],
        [-40, -9],
        [-43, -26],
        [-8, -39],
        [16, -22],
        [-50, -33],
        [11, -19],
        [-21, -53],
        [-32, 54],
        [18, 144],
        [-33, 19],
        [-35, 2],
        [-6, 38],
        [-44, 42],
        [-29, -19],
        [-27, 6],
        [-76, -13],
        [-36, 12],
        [-23, -17],
        [-54, -6],
        [-74, 1],
        [-13, -73],
        [-27, 2],
        [-3, -46],
        [-56, -26],
        [13, -25],
        [-90, -41],
        [-4, -33],
        [-27, -36],
        [-30, -16],
        [-25, -65],
        [-48, -24],
        [33, -111],
        [33, -14],
        [4, -49],
        [-40, -16],
        [-20, -46],
        [25, -64],
        [-50, -74],
        [-30, -2],
        [-26, 8],
        [-20, -28],
        [-10, -49],
        [-106, -5],
        [-21, -29],
        [-15, -61],
        [-83, -26],
        [-63, -101],
        [-9, -47],
        [27, -37],
        [-69, -10],
        [-10, -14],
        [-54, 24],
        [-41, -31],
        [4, -55],
        [-31, -15],
        [-32, 19],
        [-61, 3],
        [-44, -47],
        [-35, 25],
        [-12, 42],
        [11, 30],
        [33, 12],
        [-26, 50],
        [-2, 38],
        [25, 44],
        [-4, 34],
        [36, 48],
        [6, 69],
        [-85, 41],
        [-107, -46],
        [-29, 23],
        [-13, 63],
        [-27, 15],
        [-12, 21],
        [-58, 44],
        [42, 59],
        [-19, 22],
        [-46, -28],
        [-64, -12],
        [-35, 31],
        [-28, -1],
        [-29, 32],
        [41, 193],
        [7, 51],
        [-18, 32],
        [83, 27],
        [43, -7],
        [-20, 60],
        [46, 40],
        [0, 28],
        [36, 45],
        [-19, 66],
        [-35, 143],
        [-45, 64],
        [-7, 51],
        [-98, 83],
        [-11, 93],
        [-17, 20],
        [-35, 28],
        [-9, 46],
        [-71, 104],
        [-30, 35],
        [77, 24],
        [-15, 36],
        [-32, 73],
        [-60, -9],
        [-16, -48],
        [-90, -3],
        [-14, 38],
        [-81, -4],
        [-16, -28],
        [-41, 0],
        [-25, 15],
        [-59, 12],
        [-137, -118],
        [-27, 30],
        [-3, 31],
        [-23, 30],
        [-65, -6],
        [-21, 88],
        [-45, -7],
        [-22, -58],
        [-36, 15],
        [-78, 9],
        [-54, -31],
        [-46, 8],
        [-110, 78],
        [-102, 93],
        [-100, 102],
        [-9, 73],
        [-25, 20],
        [-211, 197],
        [-31, -48],
        [-48, -19],
      ],
      [
        [62494, 23263],
        [-64, -5],
        [-17, -25],
        [-49, 12],
        [-31, -4],
        [17, 88],
        [-13, 30],
        [35, 7],
        [13, 45],
        [21, 19],
        [27, 53],
        [-15, 41],
        [-30, 34],
        [-61, 29],
        [-72, 16],
        [-35, -8],
        [-29, -42],
        [23, -27],
        [-37, -15],
        [-61, 9],
        [-43, -9],
        [-52, -23],
        [-70, 38],
        [-86, 32],
        [-103, 54],
        [-63, 52],
        [-36, 20],
        [-77, 93],
        [-58, 36],
        [-36, 39],
        [-11, 26],
        [-100, 79],
        [-66, 41],
        [7, 35],
        [33, -7],
        [24, 53],
        [-8, 81],
        [-33, 27],
        [8, 39],
        [-31, 46],
        [-50, 15],
        [-8, 40],
        [-38, 0],
        [-17, 28],
        [-25, 8],
        [-52, 45],
        [72, 17],
        [-7, 32],
        [-23, 20],
        [0, 52],
        [-80, 48],
        [-12, 50],
        [11, 78],
        [-35, 146],
        [-33, 21],
        [-29, 54],
        [-30, 33],
        [-48, 24],
        [-41, 3],
        [-27, -14],
        [1, -45],
        [-46, 15],
        [-6, 24],
        [-31, 13],
        [6, 72],
        [-38, 17],
        [-6, 25],
        [-41, 31],
        [-53, 24],
        [-88, 8],
        [-11, 45],
        [-83, 70],
        [-134, 127],
        [-58, 42],
        [13, 18],
        [-19, 60],
        [-36, 48],
        [-84, 68],
        [-10, 31],
        [-79, 114],
        [-48, 51],
        [-50, 37],
        [11, 24],
        [-23, 71],
        [-50, 90],
        [-67, 93],
        [-141, 165],
        [-131, 174],
        [-145, 213],
        [-86, 115],
        [-105, 157],
        [-69, 116],
        [-75, 153],
        [-30, 75],
        [-62, 125],
        [-29, 51],
        [13, 86],
        [-9, 75],
        [-6, 136],
        [3, 76],
        [22, 57],
        [-15, 104],
        [-32, 99],
        [-27, 47],
        [-61, 35],
        [-21, -16],
        [-36, 60],
        [0, 38],
        [-25, 36],
        [-59, 59],
        [-245, 211],
        [-15, 38],
        [-50, 63],
        [-24, 66],
        [-50, 81],
        [6, 7],
        [-32, 93],
        [-13, 87],
        [35, 32],
        [71, -23],
        [-2, 51],
        [19, 47],
        [70, 10],
        [34, 73],
        [41, 6],
        [58, 57],
        [45, 72],
        [46, 20],
        [58, -9],
        [76, 48],
        [41, -4],
        [44, 25],
        [55, -6],
        [21, 16],
        [103, 19],
        [70, -4],
        [36, -15],
        [95, 32],
        [84, -6],
        [36, -30],
        [25, 16],
        [1, 46],
        [56, -9],
        [62, 22],
        [25, -5],
        [52, 29],
        [76, -20],
        [46, 7],
        [17, -10],
        [78, 21],
        [25, -8],
        [52, 24],
        [50, 2],
        [40, 39],
        [70, 47],
        [45, 17],
        [19, 59],
        [61, 17],
        [75, 47],
        [61, 121],
        [-4, 25],
        [26, 51],
        [6, 38],
        [25, 50],
        [-3, 97],
        [-37, 43],
        [-16, 47],
        [-90, 62],
        [-75, 30],
      ],
      [
        [60168, 30343],
        [12, 50],
        [26, 9],
        [38, -25],
        [20, 13],
        [-11, 38],
        [30, 31],
        [14, 47],
        [39, -7],
        [-8, 47],
        [10, 68],
        [25, -3],
        [4, 62],
        [-9, 28],
        [66, 45],
        [23, 38],
        [47, 26],
        [36, 2],
        [25, 51],
        [108, -47],
        [51, 124],
        [-40, 17],
        [15, 38],
        [-23, 11],
        [-6, 39],
        [32, 31],
        [15, 77],
        [4, 59],
        [33, 23],
        [-17, 32],
        [31, 18],
        [53, 64],
        [10, 31],
        [-12, 26],
        [53, 8],
        [78, 55],
        [4, 25],
        [38, 17],
        [-2, 20],
        [76, 54],
        [45, 39],
        [84, 12],
        [40, -8],
        [20, 12],
        [33, -20],
        [15, -27],
        [-12, -58],
        [34, -20],
        [53, 22],
        [1, 23],
        [36, 2],
        [31, 18],
        [35, -15],
        [42, 11],
        [30, -33],
        [60, -28],
        [23, 50],
        [49, 54],
        [83, 24],
        [35, 23],
        [65, 22],
        [32, -10],
        [34, 31],
        [-15, 38],
        [11, 37],
        [31, 17],
        [18, 34],
        [31, -1],
        [8, 36],
        [34, 7],
        [28, 61],
        [36, -4],
        [39, 30],
        [-13, 23],
        [58, 10],
        [27, 63],
        [113, -37],
        [52, 19],
        [19, -8],
        [74, 35],
        [20, -19],
        [9, -38],
        [59, 11],
        [87, -29],
        [44, 30],
        [15, -4],
        [14, -66],
        [-18, -72],
        [54, -8],
        [19, -41],
        [96, -58],
        [53, -5],
        [9, -35],
        [-9, -48],
        [55, -13],
        [66, -45],
        [36, 16],
        [40, -6],
        [41, -49],
        [48, -2],
        [32, -3],
        [46, 39],
        [49, 17],
        [60, -3],
        [38, -14],
        [24, -24],
        [35, -10],
        [6, -30],
        [59, -31],
        [-4, -69],
        [37, -10],
        [7, -61],
        [45, 11],
        [13, -57],
        [69, -66],
        [15, -95],
        [43, -14],
        [42, -30],
        [26, -51],
        [68, -42],
        [12, -21],
        [64, -30],
        [32, 21],
        [71, -85],
        [36, 26],
        [24, -30],
        [42, -20],
        [32, -28],
        [48, -84],
        [33, -40],
        [10, -37],
        [23, -30],
        [20, 16],
        [57, -45],
        [22, -47],
        [116, -42],
        [29, -20],
        [9, -33],
        [34, -16],
        [25, -54],
        [40, -1],
        [36, -28],
        [-5, -61],
        [15, -15],
        [-11, -62],
        [31, -62],
        [-6, -87],
        [33, -58],
        [38, -16],
        [45, -51],
        [23, 21],
        [-14, 53],
        [5, 59],
        [31, 5],
        [-61, 48],
        [21, 57],
        [82, 40],
        [0, 24],
        [-36, 20],
        [0, 21],
        [-30, 33],
        [22, 45],
        [0, 78],
        [23, 14],
        [1, 33],
        [-20, 16],
        [-6, 41],
        [-55, 43],
        [-60, 157],
        [-33, 9],
        [-13, 73],
        [-33, -12],
        [-7, -52],
        [-28, 1],
        [-141, 135],
        [-34, -41],
        [-47, 16],
        [-58, -13],
        [-76, -75],
        [-3, 43],
        [116, 136],
        [-55, 13],
        [17, 47],
        [1, 53],
        [-18, 28],
        [79, 31],
        [48, 2],
        [16, -21],
        [60, -20],
        [60, 41],
        [59, 10],
        [8, 68],
        [53, 10],
        [-30, 52],
        [-19, 64],
        [98, -4],
        [42, 33],
        [44, 52],
        [12, 27],
        [-1, 44],
        [79, 66],
        [41, 46],
        [65, -28],
        [-3, 73],
        [13, 46],
        [-63, 2],
        [-67, 42],
        [-22, 76],
        [-2, 38],
        [33, 34],
        [28, -7],
        [4, 51],
        [-24, 43],
        [-51, 26],
        [-9, 28],
        [30, 21],
        [9, 49],
        [27, 8],
        [11, 38],
        [-57, 8],
        [-4, 23],
        [19, 53],
        [27, -9],
        [30, 37],
        [26, 61],
        [-21, 60],
        [31, 47],
        [19, 114],
        [-52, 56],
        [-15, 46],
        [26, 127],
        [28, 19],
        [21, 43],
        [58, 20],
        [61, -21],
        [79, -2],
        [35, -19],
        [50, 33],
        [32, -14],
        [54, 10],
        [21, 27],
        [45, -31],
        [26, 28],
        [47, 24],
        [31, -25],
        [27, 49],
        [22, -18],
        [2, -61],
        [40, -4],
        [18, 48],
        [28, 9],
        [33, -18],
        [13, 44],
        [31, -30],
        [35, 22],
        [21, -6],
        [32, 46],
        [16, -33],
        [31, 16],
        [4, 61],
        [-6, 34],
        [50, 6],
        [2, 28],
        [78, 48],
        [15, 26],
        [50, 13],
        [12, 21],
        [59, -18],
        [57, -72],
        [43, 3],
        [58, -20],
        [-21, 74],
        [-30, 18],
        [6, 37],
        [25, -2],
        [47, -80],
        [1, -65],
        [68, 12],
        [28, -33],
        [21, 58],
        [86, 20],
        [54, 31],
        [102, -44],
        [97, 44],
        [8, 33],
        [-37, 81],
        [22, 46],
        [25, 30],
        [40, 21],
        [-2, 19],
        [34, 39],
        [48, 11],
        [49, 26],
        [9, 51],
        [85, 42],
        [0, 30],
        [37, 6],
        [6, 41],
        [18, 35],
        [-6, 53],
        [20, 55],
        [-39, 39],
        [-72, 20],
        [-9, 25],
        [48, 43],
        [-34, 41],
        [39, 15],
        [20, 32],
        [90, -9],
        [50, 48],
        [-35, 51],
        [-62, 29],
        [-11, 61],
        [-35, 60],
        [19, 25],
        [-14, 25],
        [-48, 27],
        [-33, 6],
        [-9, 29],
        [-35, 16],
        [-8, 38],
        [-51, -16],
        [-5, -32],
        [-51, -1],
        [-50, 22],
        [-54, 0],
        [-10, 54],
        [-39, 37],
        [-68, 13],
        [-37, 43],
        [20, 121],
        [-13, 15],
        [-59, -14],
        [-67, 26],
        [-35, 60],
        [12, 28],
        [-26, 17],
        [-32, -4],
        [-75, 37],
        [-19, 41],
        [72, 136],
        [-19, 60],
        [-85, 60],
        [41, 131],
        [58, 26],
        [12, 42],
        [84, 74],
        [-17, 42],
        [-44, 58],
        [-27, 4],
        [-17, 35],
        [-76, 56],
        [-30, 57],
        [12, 16],
        [55, -1],
        [14, 28],
        [-12, 46],
        [-18, 23],
        [-22, 17],
        [-79, 12],
        [-65, -23],
        [-87, -4],
        [-51, 41],
        [-40, -1],
        [-19, 17],
        [-44, -4],
        [-64, 31],
        [-42, 12],
        [-27, -5],
        [-58, 25],
        [-55, -3],
        [-18, -21],
        [-35, -1],
        [-17, -18],
        [-65, -1],
        [-21, 35],
        [-50, -27],
        [-53, 15],
        [-44, 0],
        [-24, 33],
        [-59, 50],
        [-56, 12],
        [-41, 52],
        [-31, 59],
        [-49, 28],
        [-16, 83],
        [52, 28],
        [2, 35],
        [-37, 4],
        [-25, 51],
        [-15, 3],
        [-20, 74],
        [-7, 23],
        [10, 61],
        [38, 24],
        [8, 48],
        [49, 74],
        [23, 149],
        [-27, 31],
        [-64, 41],
        [-42, -13],
        [-44, 2],
        [-105, -69],
        [-47, -12],
        [-61, 28],
        [-10, 18],
        [-65, 20],
        [-31, 97],
        [-39, -5],
        [-27, 18],
        [-32, -25],
        [-24, -44],
        [-22, 12],
        [-30, -30],
        [-23, -2],
        [-12, -44],
        [-38, 21],
        [-38, -25],
        [-63, -12],
        [-30, 9],
        [-29, 4],
        [17, 130],
        [29, 46],
        [-8, 41],
        [-34, 28],
        [14, 28],
        [2, 53],
        [-10, 23],
        [28, 36],
        [-6, 19],
        [-2, 86],
        [-24, 51],
        [-3, 61],
        [-17, 23],
        [38, 54],
        [15, 74],
        [-1, 46],
        [32, 66],
        [-7, 77],
        [33, 25],
        [-7, 26],
        [65, 54],
        [0, 29],
        [21, 39],
        [-40, 29],
        [1, 30],
        [29, 16],
        [14, 67],
        [21, 9],
        [-9, 71],
        [28, 42],
        [44, 26],
        [102, 127],
        [21, 89],
        [-29, 20],
        [-10, 37],
        [6, 29],
        [3, 119],
      ],
      [
        [64713, 38608],
        [32, 6],
        [50, -14],
        [87, 32],
        [-3, 49],
        [6, 69],
        [-18, 22],
        [21, 74],
        [63, 100],
        [45, 8],
        [25, 24],
        [77, 15],
        [33, -29],
        [12, -45],
        [99, -87],
        [46, -11],
        [6, 58],
        [-27, 54],
        [-10, 53],
        [-14, 12],
        [26, 97],
        [-35, 35],
        [-59, -19],
        [-36, 50],
        [20, 29],
        [33, 12],
        [-22, 54],
        [-19, 8],
        [-27, 44],
        [37, 56],
        [21, 49],
        [58, -10],
        [34, 10],
        [31, 35],
        [37, 5],
        [58, -53],
        [91, -12],
        [12, -26],
        [36, 31],
        [-1, 36],
        [-35, 25],
        [65, 38],
        [18, 41],
        [105, 9],
        [51, -56],
        [-25, -32],
        [23, -32],
        [-9, -33],
        [76, -65],
        [-5, -29],
        [19, -82],
        [-24, -50],
        [-25, -26],
        [17, -40],
        [-22, -8],
        [0, -45],
        [-43, -61],
        [-18, -66],
        [2, -40],
        [-21, -39],
        [24, -39],
        [-15, -31],
        [-40, -13],
        [-35, 10],
        [-11, -91],
        [12, -13],
        [52, 13],
        [38, 32],
        [36, -15],
        [32, 36],
        [54, 39],
        [32, -2],
        [60, -27],
        [26, -30],
        [51, 31],
        [-3, 39],
        [43, 56],
        [-14, 64],
        [2, 29],
        [65, 12],
        [25, 19],
        [9, 43],
        [36, 18],
        [10, 29],
        [63, 0],
        [9, 89],
        [43, 52],
        [49, 5],
        [32, 73],
        [-20, 37],
        [14, 20],
        [-40, 65],
        [-38, 3],
        [-66, 33],
        [-14, 40],
        [-44, -6],
        [-35, 14],
        [-42, 53],
        [-28, 4],
        [-26, 29],
        [30, 34],
        [87, -14],
        [32, 11],
        [-50, 55],
        [-31, 14],
        [-14, 36],
        [-32, 17],
        [49, 27],
        [1, 46],
        [27, 22],
        [-22, 28],
        [-39, -5],
        [-45, 21],
        [-51, 7],
        [-24, 32],
        [-14, 39],
        [1, 63],
        [-33, 40],
        [26, 36],
        [1, 44],
        [37, 34],
        [18, 66],
        [-67, 41],
        [-19, -33],
        [-41, 7],
        [-17, 26],
        [-6, 46],
        [-59, 8],
        [-55, 26],
        [21, 36],
        [34, -45],
        [17, 17],
        [-32, 60],
        [68, 7],
        [7, 25],
        [-35, 33],
        [-2, 20],
        [46, 21],
        [24, -2],
        [22, 29],
        [38, 25],
        [9, 21],
        [74, 21],
        [81, 3],
        [32, -26],
        [37, 21],
        [81, -8],
        [64, 3],
        [22, 20],
        [36, -23],
        [103, 22],
        [18, -18],
        [37, -89],
        [38, 35],
        [41, -5],
        [29, 13],
        [45, -8],
        [45, -27],
        [106, 19],
        [49, 1],
        [8, -27],
        [74, 8],
        [103, -2],
        [32, 20],
        [25, -31],
        [1, -34],
        [64, -5],
        [12, -35],
        [4, -86],
        [-21, -24],
        [-32, -66],
        [6, -42],
        [-7, -29],
        [20, -18],
        [-15, -44],
        [-23, -8],
        [-2, -62],
        [26, -43],
        [-53, -77],
        [-213, -78],
        [-25, -38],
        [-36, -11],
        [-48, -33],
        [-54, -20],
        [-23, -54],
        [37, -39],
        [-7, -32],
        [-60, -25],
        [-22, -32],
        [-17, -83],
        [41, -30],
        [18, -67],
        [-12, -69],
        [-22, -70],
        [-53, 6],
        [-5, -106],
        [21, -17],
        [8, -44],
        [-65, 4],
        [-21, -19],
        [34, -30],
        [65, -37],
        [-24, -30],
        [57, -15],
        [-15, -70],
        [-61, 2],
        [-17, -13],
        [13, -44],
        [-42, -10],
        [-28, -60],
        [13, -56],
        [-53, -12],
        [-15, -40],
        [-49, -30],
        [9, -48],
        [-30, -33],
        [23, -44],
        [-7, -20],
        [29, -32],
        [-8, -44],
        [20, -79],
        [-1, -88],
        [-17, -25],
        [21, -38],
        [35, -34],
        [17, -64],
        [41, -39],
        [26, -9],
        [22, -62],
        [4, -46],
        [-12, -39],
        [32, -27],
        [17, -67],
        [33, -43],
        [18, 10],
        [20, 80],
        [64, 169],
        [8, 139],
        [-14, 54],
        [26, 25],
        [36, 65],
        [12, 52],
        [-34, 70],
        [-21, 91],
        [-23, 42],
        [3, 58],
        [39, 46],
        [29, 16],
        [49, 43],
        [12, 37],
        [28, 26],
        [-8, 36],
        [19, 73],
        [-19, 22],
        [13, 42],
        [0, 77],
        [18, 72],
        [31, 46],
        [18, 68],
        [31, 44],
        [24, 69],
        [-3, 91],
        [34, 99],
        [14, 99],
        [22, 46],
        [63, -7],
        [17, 21],
        [33, 0],
        [28, 67],
        [55, 10],
        [69, -47],
        [49, -7],
        [30, -23],
        [59, -18],
        [35, 32],
        [52, -66],
        [62, 43],
        [141, 35],
        [38, -21],
        [35, -13],
        [-16, -55],
        [7, -36],
        [25, -59],
        [61, -5],
        [9, -33],
        [-22, -51],
        [-27, -15],
        [71, -46],
        [-12, -35],
        [6, -57],
        [42, -41],
        [-11, -42],
        [19, -26],
        [4, -46],
        [-15, -25],
        [57, -60],
        [-11, -35],
        [-41, -17],
        [-34, -39],
        [-72, -16],
        [6, -89],
        [-46, -141],
        [-33, 3],
        [2, -43],
        [31, -31],
        [-18, -40],
        [-96, 10],
        [-34, 16],
        [-30, -95],
        [-15, -32],
        [12, -59],
        [21, -53],
        [39, -5],
        [45, -61],
        [91, -20],
        [-15, -39],
        [-84, -111],
        [-45, -42],
        [-24, -52],
        [-23, -93],
        [-37, -37],
        [-4, -48],
        [-28, -39],
        [-23, -87],
        [-76, -101],
        [-22, -56],
        [-40, -34],
        [49, -23],
        [11, -38],
        [-29, -3],
        [1, -30],
        [57, -1],
        [54, -31],
        [28, 6],
        [27, -17],
        [55, 29],
        [35, 0],
        [36, -39],
        [73, -3],
        [52, 68],
        [60, -27],
        [14, 68],
        [-13, 28],
        [19, 26],
        [42, 26],
        [38, 1],
        [94, -74],
        [35, 27],
        [68, 10],
        [-10, -39],
        [10, -55],
        [66, -20],
        [53, 7],
        [48, 37],
        [23, -11],
        [12, -36],
        [78, 49],
        [24, -4],
        [51, 19],
        [1, 53],
        [39, 33],
        [13, 30],
        [-8, 33],
        [3, 86],
        [10, 44],
        [-21, 38],
        [8, 41],
        [53, 0],
        [19, 47],
        [19, 75],
        [108, -14],
        [12, 73],
        [57, 18],
        [40, 41],
        [55, 0],
        [55, 30],
        [52, -17],
        [67, -42],
        [60, 78],
        [10, 40],
        [-71, 8],
        [34, 52],
        [-11, 72],
        [44, 71],
        [-42, 39],
        [-97, 6],
        [-49, -97],
        [-65, -31],
        [-5, 32],
        [16, 96],
        [-62, 35],
        [20, 31],
        [39, 19],
        [19, 59],
        [-72, 0],
        [-19, 73],
        [9, 90],
        [40, 8],
        [39, 22],
        [5, 30],
        [39, 21],
        [39, -6],
        [26, 29],
        [39, 70],
        [21, -20],
        [8, -43],
        [17, -7],
        [76, 57],
        [13, 53],
        [66, -10],
        [55, 3],
        [34, -61],
        [81, -10],
        [11, -15],
        [33, 59],
        [24, 23],
        [29, -2],
        [47, -56],
        [21, -90],
        [43, 48],
        [85, -28],
        [16, -74],
        [-14, -39],
        [8, -30],
        [-72, -81],
        [-45, -36],
        [-51, 11],
        [-23, -30],
        [3, -67],
        [-26, -65],
        [-25, -25],
        [10, -37],
        [-11, -37],
        [29, -19],
        [73, 31],
        [38, 72],
        [117, -18],
        [48, 17],
        [66, -22],
        [88, 8],
        [95, -7],
        [12, -39],
        [29, 1],
        [38, -45],
        [-3, -68],
        [23, -26],
        [76, -30],
        [31, -24],
        [-9, -47],
        [-16, -33],
        [11, -39],
        [29, -12],
        [-94, -51],
        [7, -34],
        [-78, -4],
        [-34, -34],
        [-48, -23],
        [21, -62],
        [-20, -50],
        [5, -40],
        [-18, -34],
        [37, -37],
        [46, -13],
        [2, -17],
        [58, -21],
        [2, -41],
        [-34, -67],
        [-36, -20],
        [-18, 7],
        [-36, -49],
        [-104, 14],
        [-39, -32],
        [-41, -52],
        [-40, 3],
        [-6, -77],
        [44, -21],
        [169, -22],
        [7, -81],
        [-17, -76],
        [-1, -71],
        [-13, -19],
        [-34, 9],
        [-58, -62],
        [-50, 26],
        [-74, -25],
        [-9, -17],
        [-48, -14],
        [-89, 7],
        [-27, 11],
        [-25, -22],
        [23, -55],
        [30, -32],
        [-8, -43],
        [-75, -12],
        [-54, 4],
        [-16, 20],
        [-93, 26],
        [17, -32],
        [-15, -21],
        [-93, 26],
        [-40, 36],
        [-26, 49],
        [-107, -92],
        [-22, -11],
        [-13, -45],
        [-47, -23],
        [-47, -43],
        [-39, -17],
        [-11, -52],
        [-1, -53],
        [-18, -32],
        [-61, 1],
        [-108, -20],
        [-39, -33],
        [8, -26],
        [-52, 1],
        [-37, 43],
        [-50, -57],
        [-74, -100],
        [-18, -57],
        [-57, -58],
        [8, -22],
        [-40, -64],
        [-52, 19],
        [-24, -50],
        [11, -75],
        [-45, -3],
        [-2, 21],
        [-54, 27],
        [-37, 50],
        [-32, -28],
        [-74, -42],
        [-26, -7],
        [24, -61],
        [-44, 0],
        [-37, -13],
        [-77, -7],
        [-31, 18],
        [-24, -7],
        [21, -33],
        [-5, -39],
        [35, -32],
        [35, -12],
        [36, -37],
        [26, -9],
        [53, 13],
        [25, -60],
        [52, -63],
        [14, -32],
        [-8, -79],
        [13, -26],
        [-9, -37],
        [-37, -7],
        [-5, -47],
        [-22, -33],
        [-27, -114],
        [-52, -34],
        [-36, -77],
        [-31, -78],
        [23, -102],
        [-1, -75],
        [24, -50],
        [-32, -21],
        [-10, -36],
        [-53, 24],
        [-62, 13],
        [-11, 25],
        [-43, -1],
        [-9, -65],
        [-15, -51],
        [10, -31],
        [-63, -14],
        [-50, 2],
        [-10, 34],
        [-38, 47],
        [-70, 16],
        [-70, -58],
        [-18, -33],
        [-46, -16],
        [-59, 8],
        [-18, -33],
        [18, -72],
        [-37, -31],
        [56, -39],
        [13, -46],
        [33, -31],
        [-58, -20],
        [-30, -26],
        [-8, -84],
        [-33, -54],
        [79, -24],
        [65, 12],
        [48, -10],
        [-27, -44],
        [6, -42],
        [46, -52],
        [20, 14],
        [47, -7],
        [22, 9],
        [34, -23],
        [19, -52],
        [-9, -26],
        [7, -27],
        [60, -29],
        [66, -72],
        [46, 12],
        [-7, 63],
        [13, 11],
        [12, 82],
        [44, 60],
        [31, -3],
        [17, -27],
        [61, 38],
        [24, -13],
        [27, 13],
        [2, -54],
        [14, -44],
        [29, -30],
        [25, -60],
        [34, -30],
        [31, -34],
        [-1, -45],
        [20, -18],
        [-43, -62],
        [15, -33],
        [-46, -7],
        [-15, -20],
        [-56, 9],
        [-105, -28],
        [-18, 21],
        [-27, -8],
        [-2, -65],
        [-26, -25],
        [-47, 14],
        [-27, 27],
        [-59, 41],
        [-54, 7],
        [-18, -30],
        [-59, -14],
        [-22, 10],
        [-60, -8],
        [-40, -29],
        [-25, 10],
        [-38, -78],
        [-50, -19],
        [-46, 9],
        [-49, 27],
        [-37, -41],
        [-4, -26],
        [-41, -22],
        [3, -86],
        [-9, -30],
        [27, -82],
        [63, 57],
        [57, 30],
        [55, -12],
        [58, 37],
        [41, -42],
        [74, 12],
        [27, -6],
        [-13, -81],
        [-16, -36],
        [7, -79],
        [14, -17],
        [-16, -89],
        [-76, 0],
        [-33, -20],
        [48, -47],
        [76, -46],
        [19, -30],
        [37, 0],
        [38, -35],
        [23, -36],
        [-14, -102],
        [47, -22],
        [26, -43],
        [5, -37],
        [27, -44],
        [53, -9],
        [46, -45],
        [62, 4],
        [29, 32],
        [75, 27],
        [12, 56],
        [59, -1],
        [18, 15],
        [50, -84],
        [50, 23],
        [80, 25],
        [30, 30],
        [50, -8],
        [22, 11],
        [85, -11],
        [34, 21],
        [9, -35],
        [42, -14],
        [-32, -60],
        [25, -42],
        [102, -88],
        [-9, -63],
        [135, -139],
        [3, -27],
        [32, 0],
        [27, -26],
        [36, -8],
        [37, -13],
        [30, 16],
        [-4, 28],
        [22, 23],
        [55, -6],
        [53, 15],
        [17, -11],
        [22, 49],
        [77, -40],
        [14, -27],
        [33, 42],
        [37, 17],
        [11, 41],
        [-12, 15],
        [16, 42],
        [58, -4],
        [61, -16],
        [23, 29],
        [83, 45],
        [46, -36],
        [42, -4],
        [5, -40],
        [26, -30],
        [66, 1],
        [73, -12],
        [7, -17],
        [119, -55],
        [19, 37],
        [34, 27],
        [39, -27],
        [81, 16],
        [22, 29],
        [40, 14],
        [47, 81],
        [28, 38],
        [-66, -1],
        [-20, 19],
        [9, 38],
        [-39, 7],
        [-40, 28],
        [-29, 70],
        [35, 22],
        [47, 14],
        [23, 22],
        [20, 53],
        [-28, 46],
        [-28, 95],
        [-3, 59],
        [24, 41],
        [31, 13],
        [-16, 33],
        [27, 101],
        [59, 80],
        [-25, 15],
        [17, 41],
        [43, 18],
        [20, -70],
        [66, 10],
        [20, -44],
        [43, -5],
        [27, 27],
        [1, 39],
        [47, 24],
        [52, -13],
        [12, -37],
        [34, -14],
        [6, -29],
        [58, 2],
        [9, -28],
        [63, -3],
        [9, -100],
        [122, -22],
        [49, -23],
        [5, 61],
        [32, 57],
        [-2, 30],
        [118, 8],
        [28, 51],
        [-5, 40],
        [41, -12],
        [3, 45],
        [16, 42],
        [67, 34],
        [-27, 20],
        [9, 59],
        [54, 50],
        [99, -44],
        [-11, 62],
        [2, 56],
        [24, 25],
        [30, -16],
        [33, -66],
        [33, 104],
        [35, 8],
        [45, -63],
        [70, 18],
        [17, 52],
        [-12, 40],
        [35, 34],
        [47, 6],
        [54, 49],
        [-21, 59],
        [15, 26],
        [1, 64],
        [37, -29],
        [36, -8],
        [58, -91],
        [-2, -65],
        [28, -37],
        [49, 12],
        [12, -20],
        [17, 9],
        [129, 116],
        [34, 14],
        [5, 95],
        [10, 37],
        [-35, 1],
        [-26, 58],
        [-26, 15],
        [25, 37],
        [-18, 36],
        [22, 14],
        [-14, 67],
        [15, 33],
        [42, 24],
        [27, 36],
        [-52, 18],
        [-3, 61],
        [55, 11],
        [-6, 28],
        [25, 42],
        [2, 27],
        [33, 23],
        [-22, 35],
        [-57, 51],
        [50, 45],
        [3, 30],
        [-51, 10],
        [-82, -12],
        [-26, 31],
        [-111, 25],
        [-32, -9],
        [-6, 30],
        [24, 69],
        [-12, 48],
        [-103, -6],
        [-22, 25],
        [-15, 66],
        [-30, 15],
        [-25, -31],
        [-126, 46],
        [-12, 62],
        [-36, 63],
        [5, 27],
        [-33, 116],
        [36, 40],
        [-46, 7],
        [-18, 17],
        [-36, 1],
        [-35, 21],
        [-11, 17],
        [33, -4],
        [11, 28],
        [29, -5],
        [47, 20],
        [81, 69],
        [65, 114],
        [9, 20],
      ],
      [
        [75892, 37049],
        [97, -11],
        [47, -26],
        [68, -7],
        [64, 39],
        [78, -25],
        [34, -37],
        [-2, -40],
        [84, 8],
        [39, 29],
        [97, -62],
        [-10, -36],
        [106, -74],
        [-7, -29],
        [128, -55],
        [63, -85],
        [45, -20],
        [24, -87],
        [21, -18],
        [-6, -63],
        [28, 10],
        [37, -9],
        [36, 15],
        [39, 38],
        [21, 51],
        [21, -48],
        [87, -47],
        [2, 26],
        [39, -2],
        [63, 13],
        [3, -111],
        [29, -194],
        [-13, -62],
        [19, -34],
        [61, -10],
        [51, -117],
        [69, 37],
        [19, -15],
        [34, -77],
      ],
      [
        [74814, 28920],
        [-44, -27],
        [-43, 12],
        [-28, -14],
        [-45, 15],
        [-15, -25],
        [-30, -3],
        [-44, 14],
        [-56, 6],
        [16, -64],
        [-65, 13],
        [-23, -10],
        [22, -46],
        [-30, -13],
        [-68, -23],
        [-43, 22],
        [-70, -20],
        [-9, -32],
        [-77, -14],
        [-72, -32],
        [-65, 2],
        [-42, 37],
        [-32, 12],
        [-27, -23],
        [-16, 23],
        [6, 33],
        [-27, 8],
        [-40, 22],
        [-44, -68],
        [-50, 25],
        [-45, -42],
        [-47, -31],
        [-54, 10],
        [-22, -39],
        [-25, -4],
        [-62, 9],
        [-44, 20],
        [-36, -31],
        [-44, 28],
        [-54, -4],
        [-45, 41],
        [-77, -13],
        [-52, -46],
        [-38, 8],
        [-60, -26],
        [-26, -26],
        [-13, -48],
        [-36, -10],
        [-34, 38],
        [-15, -21],
        [0, -43],
        [-21, -14],
        [-48, 1],
        [-39, -26],
        [4, -23],
        [32, -13],
        [13, -37],
        [-10, -23],
        [-33, -25],
        [-22, 31],
        [-38, 19],
        [-22, -15],
        [-23, -78],
        [-26, 8],
        [8, 39],
        [-39, 33],
        [-16, -65],
        [-59, -4],
        [-44, -28],
        [-39, 42],
        [-56, 8],
        [-15, -24],
        [4, -45],
        [-35, -10],
        [5, -37],
        [-34, -78],
        [-63, -30],
        [-91, 41],
        [-37, -2],
        [-22, -24],
        [-24, 3],
        [-30, -44],
        [4, -29],
        [8, -27],
        [3, -78],
        [16, -28],
        [-4, -68],
        [-47, -27],
        [-88, 11],
        [-75, -15],
        [-25, 6],
        [-59, -57],
        [-38, -29],
        [-26, 21],
        [-126, -77],
        [-34, 18],
        [-74, -3],
        [-14, -29],
        [30, -29],
        [13, -30],
        [-14, -37],
        [-51, -46],
        [-37, 9],
        [-49, 36],
        [-12, -8],
        [-37, 48],
        [-3, 36],
        [-31, 15],
        [-20, 44],
        [4, 41],
        [-28, 17],
        [-16, 39],
        [-44, -23],
        [-49, 6],
        [-35, 26],
        [-65, -10],
        [-103, 25],
        [-25, 19],
        [-84, 0],
        [1, -21],
        [48, -83],
        [87, -68],
        [-10, -32],
        [-64, -5],
        [-17, 11],
        [-56, 50],
        [-23, -4],
        [-14, -64],
        [-55, -8],
        [-38, 9],
        [-52, -8],
        [-41, 61],
        [-121, -8],
        [-18, -15],
        [18, -33],
        [-60, -13],
        [13, -45],
        [28, 8],
        [11, -29],
        [-17, -61],
        [-21, -43],
        [49, -60],
        [-2, -58],
        [27, -79],
        [-22, -100],
        [-31, -53],
        [-41, -39],
        [-21, -71],
        [13, -52],
        [51, -83],
        [31, -9],
        [15, -28],
        [49, -11],
        [21, 56],
        [51, 20],
        [28, 44],
        [73, 16],
        [43, 20],
        [24, -7],
        [23, 27],
        [57, -19],
        [10, -36],
        [50, 8],
        [30, -8],
        [81, -66],
        [28, -19],
        [79, 17],
        [16, 27],
        [34, -7],
        [83, -32],
        [45, 1],
        [101, -25],
        [13, 8],
        [63, -33],
        [24, -27],
        [87, -7],
        [63, -105],
        [67, -56],
        [51, -53],
        [61, -45],
        [-4, -42],
        [-34, -22],
        [-13, -34],
        [41, -44],
        [-6, -47],
        [21, -30],
        [-22, -36],
        [-37, -13],
        [-27, -49],
        [4, -28],
        [41, -55],
        [-39, -28],
        [-36, 4],
        [-15, -24],
        [-72, 24],
        [-91, -1],
        [-110, -162],
        [29, -30],
        [-6, -37],
        [19, -28],
        [-33, -43],
        [51, 5],
        [8, -31],
        [-34, -29],
        [77, -77],
        [11, -42],
        [28, -21],
        [24, -54],
        [-75, -94],
        [4, -45],
        [22, -27],
        [-8, -27],
        [3, -45],
        [23, -9],
        [37, -41],
        [9, -71],
        [78, -9],
        [22, -12],
        [11, -36],
        [26, -23],
        [47, 11],
        [51, -9],
        [46, -63],
        [-10, -37],
        [-32, -45],
        [17, -22],
        [8, -50],
        [29, -29],
        [-22, -43],
        [2, -30],
        [33, -38],
        [-28, -37],
        [-3, -68],
        [-23, -9],
        [-77, -95],
        [68, -28],
        [55, 34],
        [37, 36],
        [54, 15],
        [14, 15],
        [55, -15],
        [21, 8],
        [12, -64],
        [-3, -41],
        [62, -17],
        [106, 44],
        [26, 22],
        [38, -9],
        [50, 56],
        [77, 59],
        [42, 3],
        [7, 28],
        [33, -31],
        [-5, -30],
        [20, -23],
        [-18, -65],
        [124, -28],
        [29, -71],
        [-26, -33],
        [-30, -3],
        [-5, -28],
        [-40, -14],
        [-16, -94],
        [43, 19],
        [3, -37],
        [25, -30],
        [37, -1],
        [-30, -40],
        [-21, 31],
        [-43, 18],
        [-41, -70],
        [24, -41],
        [-64, -114],
        [-25, -5],
        [-31, -64],
        [0, -22],
        [-30, -33],
        [-2, -38],
        [-16, -28],
        [0, -63],
        [-24, -42],
        [-3, -35],
        [-41, -37],
        [-25, -1],
        [-59, -99],
        [-12, -70],
        [12, -90],
        [-34, -16],
        [-27, -81],
        [-2, -38],
        [-69, -69],
        [-14, -45],
        [-31, 28],
        [-79, 41],
        [-35, -1],
        [31, 67],
        [0, 40],
        [-18, 11],
        [-42, -37],
        [-13, -32],
        [-80, 32],
        [-45, -1],
        [-13, 30],
        [-60, 37],
        [-90, -51],
        [-78, -15],
        [-15, -36],
        [-1, -49],
        [-68, -10],
        [-28, -32],
        [-9, -33],
        [-36, -22],
        [-32, 44],
        [-57, -59],
        [-24, -14],
        [-76, 30],
        [0, 26],
        [-86, -27],
        [-69, -57],
        [-72, -72],
        [-58, -12],
        [-35, 25],
        [-33, -25],
        [-82, -16],
        [-65, -100],
        [-24, -7],
        [13, -128],
        [-31, -24],
        [-75, 69],
        [-22, 11],
        [-67, -25],
        [-6, -38],
        [38, -87],
        [-33, -18],
        [7, -30],
        [8, -91],
        [79, -89],
        [32, -42],
        [-102, -13],
        [-51, 14],
        [-24, -84],
        [-28, -36],
        [-40, 16],
        [-45, 10],
        [-54, -59],
        [21, -98],
        [-19, -30],
        [-43, -20],
        [-57, -40],
        [-56, -105],
        [-23, -7],
        [-12, -44],
        [-68, -68],
        [-12, -42],
        [-43, 4],
        [-77, -24],
        [-101, 50],
        [-71, 93],
        [-54, 37],
        [-21, 29],
        [8, 49],
        [-17, 16],
        [-14, 54],
        [2, 52],
        [-36, 3],
        [-25, 40],
        [-9, 36],
        [-33, -6],
        [-67, -28],
        [-9, 12],
        [-44, -14],
        [-8, -40],
        [-32, -1],
        [-53, -32],
        [-29, 7],
        [-13, -30],
        [-37, 10],
        [-43, -43],
        [-36, -13],
        [-91, -48],
        [-63, 25],
        [-56, 7],
        [-22, -16],
        [-46, 1],
        [-19, 16],
        [-32, -11],
        [-9, -26],
        [-44, -26],
        [-69, 3],
        [-40, 66],
        [-100, 11],
        [-89, -32],
        [-55, 39],
        [-26, -5],
        [-15, -42],
        [-33, -52],
      ],
      [
        [62884, 22953],
        [-17, -15],
        [-38, 35],
        [16, 28],
        [34, 12],
        [5, 35],
        [27, 26],
        [-10, 35],
        [-39, 47],
        [-49, 26],
        [-49, -19],
        [-44, 1],
        [-45, 31],
        [30, 25],
        [-16, 44],
        [-30, 3],
        [-26, -20],
        [-33, 6],
        [-21, -28],
        [-54, -6],
        [-31, 44],
      ],
      [
        [90590, 25076],
        [-20, -37],
        [-52, -2],
        [0, -51],
        [-51, -10],
        [6, -32],
        [-41, -69],
        [-27, -30],
        [21, -70],
        [6, -69],
        [84, -66],
        [17, -29],
        [11, -62],
        [70, -69],
        [-3, -35],
        [31, -37],
        [5, -25],
      ],
      [
        [90647, 24383],
        [-38, -39],
        [123, -133],
        [-29, -20],
        [-27, 27],
        [-61, -2],
        [18, -49],
        [-21, -40],
        [11, -23],
        [-20, -32],
        [26, -29],
        [-5, -71],
        [19, -66],
        [17, -24],
        [47, 1],
        [-19, -63],
        [-48, -13],
        [-26, 10],
        [-14, -130],
        [146, -301],
        [20, -31],
        [-22, -37],
        [-52, -57],
        [3, -90],
        [-19, -177],
        [31, -87],
        [5, -18],
        [14, -50],
        [-13, -15],
        [-8, -123],
        [63, -3],
        [-24, -130],
        [28, -32],
        [-42, -39],
        [-19, -34],
        [42, -48],
        [-5, -44],
        [20, -45],
        [-12, -31],
        [45, -42],
        [-35, -63],
        [-25, -33],
      ],
      [
        [90741, 22157],
        [-89, -47],
        [-64, -24],
        [-114, -167],
        [-25, -16],
        [-85, -106],
        [-53, 10],
        [-94, -1],
        [-74, -21],
        [-55, 16],
        [-29, -18],
        [-23, 15],
        [-27, -38],
        [-35, 24],
        [-78, 15],
        [-34, 58],
        [-28, 2],
        [-26, -25],
        [-23, 26],
        [-20, -2],
        [-69, 53],
        [13, 43],
        [-59, 79],
        [7, 47],
        [-1, 28],
        [-24, 23],
        [14, 73],
        [-37, 14],
        [-41, 44],
        [-70, 8],
        [-64, 103],
        [7, 24],
        [-133, 28],
        [-60, -47],
        [-52, 28],
        [-47, 42],
      ],
      [
        [87770, 22732],
        [-76, -45],
        [-85, -122],
        [-21, -53],
        [6, -27],
        [-9, -105],
        [14, -59],
        [35, -43],
        [-42, 0],
        [-7, -45],
        [34, -32],
        [-33, -23],
        [-4, -42],
        [39, -98],
        [8, -84],
        [-5, -88],
        [-11, -42],
        [-58, -55],
        [-57, -23],
        [-19, -49],
        [-32, -31],
        [-72, -86],
        [-194, -19],
        [-19, -83],
        [-42, 8],
        [-42, -11],
        [-13, -98],
        [10, -125],
        [16, -38],
        [-113, -259],
        [-57, -26],
        [-13, -66],
        [-129, -165],
      ],
      [
        [81634, 21522],
        [6, 34],
        [53, -5],
        [5, 36],
        [29, 31],
        [134, 84],
        [-5, 25],
        [31, 32],
        [66, -2],
        [-26, 61],
        [22, 93],
        [21, -16],
        [33, 16],
        [-19, 32],
        [14, 35],
        [-16, 24],
        [59, 79],
        [-28, 35],
        [15, 15],
        [38, 9],
        [16, -14],
        [56, 17],
        [8, 19],
        [107, 50],
        [-2, 25],
        [16, 11],
        [32, -25],
        [44, 20],
        [55, 94],
        [34, 11],
        [35, 30],
        [47, 2],
        [35, 20],
        [25, 52],
        [-2, 51],
        [20, 41],
        [3, 78],
        [24, 4],
        [16, 33],
        [8, 53],
        [27, 48],
        [-7, 27],
        [59, 44],
        [46, -11],
        [23, 25],
        [-76, 81],
        [32, 32],
        [-7, 80],
        [161, 165],
        [30, 17],
        [40, 100],
        [13, 54],
        [-2, 134],
        [33, 42],
        [-35, 47],
        [12, 56],
        [41, 16],
        [10, 27],
        [3, 54],
        [20, 25],
        [-44, 56],
        [-4, 40],
        [46, 39],
        [36, 53],
        [6, 69],
        [92, 20],
        [25, 18],
        [129, 8],
        [10, -3],
        [98, 48],
        [62, 88],
        [60, 46],
        [-55, 70],
        [-20, -1],
        [-2, 79],
        [19, 20],
        [5, 91],
        [98, -22],
        [10, 21],
        [-33, 31],
        [-78, 4],
        [0, 114],
        [24, 44],
        [-64, 51],
        [-20, 53],
        [-59, 26],
        [-46, -3],
        [-2, 47],
        [-22, 19],
        [-1, 53],
        [-17, 81],
        [-24, 97],
        [2, 49],
        [19, 35],
        [-81, 135],
        [-41, 52],
        [30, 24],
        [17, 92],
        [25, 22],
        [74, 34],
        [23, 57],
        [23, 9],
        [12, -91],
        [117, 12],
        [66, -24],
        [18, 66],
        [71, -1],
        [5, -26],
        [89, 100],
        [16, 23],
        [-3, 47],
        [17, 42],
        [-8, 34],
        [0, 123],
        [15, 30],
        [-21, 39],
        [16, 37],
        [-15, 55],
        [9, 44],
        [47, 108],
        [12, 32],
        [29, 23],
        [35, 2],
        [66, -16],
        [39, 33],
        [17, -3],
        [16, 3],
        [94, -26],
        [17, 33],
        [-35, 6],
        [-101, 53],
        [-43, 30],
        [-77, 159],
        [-50, 21],
        [-6, 325],
        [31, 73],
        [39, 46],
        [-99, 22],
        [-31, -27],
        [-50, 11],
        [-12, 52],
        [9, 33],
        [-13, 55],
        [16, 10],
        [13, 74],
        [28, -2],
        [39, -40],
      ],
      [
        [83820, 27241],
        [52, -31],
        [36, 0],
        [8, -22],
        [84, -42],
        [63, -1],
        [37, 23],
        [52, 10],
        [-3, 24],
        [41, 18],
        [61, -18],
        [54, 80],
        [55, 36],
        [29, -2],
        [38, 25],
        [25, 64],
        [101, -17],
        [-9, -67],
        [74, 0],
        [141, 20],
        [34, 0],
        [-5, 14],
        [18, 71],
        [-26, 47],
        [-25, 25],
        [-14, 41],
        [-1, 53],
        [-20, 24],
        [13, 74],
        [38, 36],
        [-30, 56],
        [8, 77],
        [-30, 62],
        [-22, 14],
        [-8, 34],
        [-22, 5],
        [-61, 74],
        [11, 42],
        [-45, 76],
        [-15, 38],
        [-16, 24],
        [1, 45],
        [-26, 17],
        [25, 73],
        [31, -9],
        [1, -33],
        [61, -41],
        [37, -69],
        [8, -121],
        [150, -21],
        [-21, 69],
        [3, 27],
        [-28, 7],
        [-25, 88],
        [25, -1],
        [-9, 72],
        [49, 81],
        [29, 23],
        [166, -72],
        [84, -15],
      ],
      [
        [74628, 16841],
        [-23, -23],
        [-96, -35],
        [-12, -27],
        [-80, -38],
        [-42, 2],
        [-110, 54],
        [-209, 122],
        [-225, 92],
        [-344, 95],
        [-179, 58],
        [-114, 40],
        [-181, 55],
        [-95, 7],
        [-198, 56],
        [-29, 2],
        [-240, 78],
        [-30, -6],
        [-23, 14],
        [-54, -1],
        [-40, 12],
        [-47, -12],
        [-23, 22],
        [-62, 21],
        [-84, 4],
        [-40, -23],
        [-96, 37],
        [-12, 33],
        [-114, 26],
        [-32, -18],
        [-47, 35],
        [-105, 22],
        [-14, 13],
        [-79, 32],
        [-89, 48],
        [-176, 77],
        [-293, 142],
        [-169, 79],
        [-29, 7],
        [-102, 55],
        [-60, 16],
        [-29, -2],
        [-25, 24],
        [-79, 36],
        [-41, -8],
        [-90, 35],
        [-40, -14],
        [-93, 6],
        [-33, -15],
        [-56, 9],
        [-17, 50],
        [-38, 14],
        [-52, -15],
        [-49, 11],
        [-49, 29],
        [-35, 6],
        [-68, 31],
        [-32, 23],
        [-52, 13],
        [-26, -5],
        [-38, 42],
        [-45, 8],
        [-75, -1],
        [-80, 13],
        [-110, 42],
        [-82, 26],
        [-7, 28],
        [-49, 27],
        [-75, 17],
        [-76, 35],
        [-91, -32],
        [-33, 21],
        [-27, 52],
        [-21, 11],
        [-40, -8],
        [-42, 42],
        [-32, -4],
        [-59, 46],
        [-175, 83],
        [-175, 77],
        [-6, 29],
        [-64, 30],
        [-27, 55],
        [-2, 48],
        [-55, 77],
        [-16, 36],
        [7, 39],
        [-7, 50],
        [-51, 107],
        [-4, 28],
        [-70, 104],
        [-22, 19],
        [0, 55],
        [-58, 90],
        [-17, 64],
        [-78, 99],
        [-145, 143],
        [-48, 39],
        [-78, 47],
        [-54, 56],
        [-110, 71],
        [-47, 16],
        [-27, -15],
        [-24, 32],
        [23, 29],
        [30, 1],
        [9, 35],
        [27, 13],
        [6, 47],
        [16, 13],
        [-17, 59],
        [-62, 93],
        [-67, 78],
        [-40, 37],
        [-53, 28],
      ],
      [
        [82842, 28448],
        [21, 48],
        [177, -63],
        [-9, -14],
        [134, -49],
        [93, -27],
        [69, -83],
        [123, -82],
        [100, -57],
        [55, -53],
        [14, -42],
        [-41, -74],
        [-6, -59],
        [-53, -22],
        [-28, -51],
        [-66, -57],
        [-55, -32],
        [176, -66],
        [-3, -78],
        [-16, -190],
        [38, -5],
        [38, 27],
        [9, -30],
        [29, -16],
        [22, 18],
        [39, 8],
        [27, -32],
        [-22, -26],
        [24, -25],
        [46, -8],
        [43, -67],
      ],
      [
        [90741, 22157],
        [-26, -39],
        [-55, -48],
        [-3, -47],
        [-19, -27],
        [-37, -102],
        [-48, -52],
        [-20, -139],
        [-38, -36],
        [-33, -9],
        [-45, -55],
        [-19, -3],
        [9, -59],
        [-40, -78],
        [4, -39],
        [73, 52],
        [-21, 21],
        [-4, 38],
        [84, 58],
        [15, 27],
        [38, 12],
        [32, -17],
        [13, -38],
        [-41, -90],
        [-32, -19],
        [-22, -65],
        [-21, -24],
        [-26, -31],
        [-3, -34],
        [-27, -17],
        [-34, -100],
        [-37, -50],
        [-16, 14],
        [-38, -42],
        [1, -26],
        [-28, -106],
        [-27, -58],
        [-36, -43],
        [-27, -77],
        [67, -29],
        [45, 41],
        [48, -43],
        [-25, -87],
        [-20, -24],
        [-47, -23],
        [-16, -32],
        [43, -145],
        [24, -20],
        [1, -26],
        [34, -42],
        [3, -93],
        [12, -58],
        [23, -46],
        [-8, -38],
        [-28, -17],
        [9, -47],
        [23, -50],
        [-19, -95],
        [9, -29],
        [40, -37],
        [-7, -26],
        [20, -38],
        [-44, -107],
        [38, -63],
        [-17, -37],
        [29, -4],
        [11, -36],
        [-21, -55],
        [-30, -53],
        [17, -64],
        [-22, -15],
        [23, -33],
        [-25, 3],
        [-69, -30],
        [-36, 21],
        [-14, 47],
        [-45, -10],
        [-33, 29],
        [-13, 27],
        [-2, 48],
        [-22, 18],
        [-77, 21],
        [-17, 37],
        [-70, 48],
        [-6, 26],
        [-32, 23],
        [-17, 58],
        [-27, -5],
        [-44, 22],
        [-39, -7],
        [-34, -69],
        [22, -43],
        [-4, -24],
        [-31, -19],
        [1, -22],
        [-34, -33],
        [-34, -9],
        [-27, 13],
        [-130, -52],
        [-30, -22],
        [-50, -13],
        [-20, -22],
        [1, -79],
        [-25, -4],
        [5, -43],
        [-92, -50],
        [-47, 3],
        [-112, -27],
        [-15, 33],
        [-28, -11],
        [-19, -108],
        [-95, -66],
        [-37, 0],
        [-20, -46],
        [-50, -60],
        [-79, -67],
        [-47, -12],
        [5, -52],
        [-39, -28],
      ],
      [
        [64454, 38931],
        [-22, -42],
        [17, -73],
        [114, -28],
        [147, -78],
        [34, -42],
        [-31, -60],
      ],
      [
        [60168, 30343],
        [-17, 4],
        [-48, 81],
        [-49, 135],
        [-40, 72],
        [-66, 77],
        [-83, 64],
        [-58, 15],
        [-48, -31],
        [-7, -26],
        [-137, -78],
        [-49, 1],
        [-97, 60],
        [-64, 9],
        [-77, 28],
        [-55, -14],
        [-106, 73],
        [-62, 24],
        [-34, -3],
        [-39, -31],
        [-18, -35],
        [-29, 23],
        [-4, 41],
        [28, 30],
        [22, 54],
        [42, 20],
        [32, -41],
        [22, -6],
        [63, 36],
        [33, 38],
        [33, 64],
        [34, 79],
        [27, 43],
        [23, 93],
        [22, 24],
        [24, 85],
        [32, -28],
        [32, 12],
        [53, 70],
        [44, 74],
        [67, 147],
        [39, 12],
        [44, 51],
        [32, 6],
        [40, 44],
        [41, 4],
        [16, 24],
        [47, 94],
        [22, -2],
        [40, 35],
        [23, 52],
        [25, 21],
        [19, 48],
        [18, 99],
        [29, 32],
        [67, -58],
        [47, 17],
        [30, -26],
        [37, 16],
        [50, 57],
        [70, 66],
        [21, 43],
        [26, 95],
        [13, 132],
        [-6, 58],
        [-36, 22],
        [-6, 53],
        [24, 16],
        [-7, 48],
        [35, 28],
        [17, 33],
        [-21, 70],
        [-22, 38],
        [9, 32],
        [62, 64],
        [6, 28],
        [-14, 194],
        [-30, 201],
        [-21, 100],
        [-32, 111],
        [-32, 83],
        [21, 41],
        [4, 45],
        [8, 56],
        [20, -7],
        [18, 57],
        [42, 22],
        [8, 28],
        [-10, 55],
        [11, 31],
        [45, 39],
        [24, 78],
        [41, 11],
        [27, 45],
        [2, 58],
        [-9, 37],
        [-53, 79],
        [18, 45],
        [-65, 88],
        [-62, 65],
        [-58, 29],
        [-40, -7],
        [-21, -65],
        [-29, 16],
        [-38, -19],
        [-43, 49],
        [-55, 38],
        [-27, -1],
        [-147, 109],
        [-68, 43],
        [-155, 90],
        [-172, 107],
        [-157, 122],
        [-5, 31],
        [-7, 38],
        [-31, 71],
        [-45, 89],
        [-94, 201],
        [-25, 61],
        [5, 29],
        [-24, 19],
        [-30, 68],
        [-112, 232],
        [-28, 67],
        [-143, 231],
        [-86, 126],
        [-105, 173],
        [-115, 210],
        [-48, 107],
        [-41, 124],
        [-20, 92],
        [-9, 98],
        [1, 76],
        [21, 237],
        [7, 98],
        [6, 216],
        [15, 44],
        [30, 16],
        [-30, 50],
        [-28, 100],
        [-20, 157],
        [-41, 239],
        [-13, 66],
        [-48, 200],
        [-49, 162],
        [-88, 241],
        [-40, 99],
        [-73, 154],
        [-73, 140],
        [-65, 117],
        [9, 34],
      ],
      [
        [57974, 39564],
        [25, 15],
        [31, -39],
        [67, -149],
        [17, -52],
        [63, -85],
        [59, -37],
        [112, 3],
        [27, 66],
        [-28, 155],
        [-92, 187],
        [-15, 37],
        [8, 50],
        [39, 0],
        [37, 19],
        [51, 20],
        [48, 50],
        [46, -35],
        [39, 18],
        [0, 55],
        [53, -8],
        [-4, -18],
        [43, -86],
        [46, -16],
        [54, -46],
        [10, -110],
        [65, -15],
        [36, 8],
        [12, 21],
        [60, -11],
        [37, 10],
        [58, -17],
        [29, -102],
        [53, 29],
        [57, -20],
        [32, 43],
        [101, -58],
        [11, -44],
        [55, 2],
        [26, 16],
        [32, 53],
        [55, 25],
        [4, 32],
        [21, 37],
        [7, 57],
        [-19, 75],
        [9, 83],
        [-10, 30],
        [-78, 53],
        [6, 28],
        [31, 28],
        [-20, 84],
        [-75, -10],
        [-24, 39],
        [42, 65],
        [21, 7],
        [-17, 58],
        [-157, -38],
        [-62, 167],
        [-53, 193],
        [35, 75],
        [6, 98],
        [-24, -2],
        [-17, 70],
        [30, 33],
        [-13, 20],
        [34, 24],
        [3, 40],
        [21, 3],
        [20, 60],
        [34, 5],
        [-4, 36],
        [38, 45],
        [3, 62],
        [27, 14],
        [31, 45],
        [-45, 35],
        [41, 109],
        [19, 13],
        [-124, 248],
        [9, 3],
        [-23, 121],
        [219, 93],
        [96, 231],
        [110, -2],
        [-14, 34],
        [9, 64],
        [-10, 26],
        [7, 56],
        [-12, 22],
        [1, 47],
        [95, 50],
      ],
      [
        [55812, 33608],
        [8, -35],
        [-6, -52],
        [8, -36],
        [-18, -41],
        [-40, -1],
        [-14, -30],
        [-47, -8],
        [-76, 46],
        [-29, 30],
        [-13, 35],
        [22, 44],
        [71, 60],
        [19, -10],
        [115, -2],
      ],
      [
        [54892, 34389],
        [135, -37],
        [91, 0],
        [33, -8],
        [14, -48],
        [42, -57],
        [-95, -59],
        [-37, -119],
        [10, -22],
        [-94, 16],
        [-52, 36],
        [-50, 25],
        [-60, 10],
        [-22, 21],
        [-64, 23],
        [-14, 16],
        [-64, 9],
        [-73, 80],
        [47, 64],
        [50, 18],
        [54, 51],
        [72, -4],
        [40, 15],
        [37, -30],
      ],
      [
        [53884, 35392],
        [96, -9],
        [24, -15],
        [62, 14],
        [44, -6],
        [10, -21],
        [101, -23],
        [37, -30],
        [89, -38],
        [52, -52],
        [-18, -63],
        [9, -57],
        [81, -86],
        [29, -46],
        [36, -14],
        [-29, -29],
        [-18, -77],
        [3, -53],
        [-25, -39],
        [-60, -61],
        [8, -28],
        [-44, -4],
        [13, 62],
        [-35, 30],
        [-53, 15],
        [-183, 75],
        [-98, 59],
        [-53, 46],
        [13, 48],
        [-63, 113],
        [-4, 31],
        [-42, 50],
        [-4, 31],
        [20, 18],
        [3, 65],
        [-14, 37],
        [-40, 54],
        [53, 3],
      ],
      [
        [53769, 35794],
        [16, -17],
        [13, -59],
        [4, -54],
        [29, -54],
        [-66, -42],
        [-28, 4],
        [-37, 77],
        [8, 52],
        [19, 12],
        [22, 77],
        [20, 4],
      ],
      [
        [88285, 57047],
        [22, -27],
        [7, -42],
        [82, -4],
        [11, -39],
        [51, 3],
        [20, 23],
        [-33, 33],
        [9, 21],
        [51, -8],
        [20, 41],
        [79, 24],
        [28, -54],
        [67, 10],
        [12, 35],
        [38, -4],
        [17, 14],
        [1, 50],
        [32, 7],
        [50, 31],
        [33, -25],
        [56, -1],
        [16, 22],
        [-11, 31],
        [461, -544],
        [106, -127],
        [252, 277],
        [105, 115],
        [398, -54],
        [695, -93],
        [12, -1028],
        [6, -514],
        [4, -339],
        [-6, -731],
        [683, 0],
        [53, 0],
        [-6, -206],
        [-346, -267],
        [-325, -256],
        [-71, -53],
        [-530, -415],
        [-470, -368],
        [-285, -225],
        [-147, -117],
        [-129, -107],
        [-47, -45],
        [-32, -9],
        [-48, 24],
        [-38, 0],
        [-17, -18],
        [-56, -16],
        [-104, 13],
        [-45, -20],
        [-49, 12],
        [-15, 19],
        [29, 60],
        [-63, 51],
        [-19, 55],
        [-12, 65],
        [-51, 0],
        [-28, 30],
        [-35, -45],
        [-55, -51],
        [-15, -45],
        [22, -7],
        [-20, -56],
        [-21, -8],
        [-8, -34],
        [-55, -9],
        [-34, -64],
        [-87, -23],
        [-49, -27],
        [-34, -5],
        [-21, 16],
        [-69, 12],
        [-21, -46],
        [-21, -3],
        [16, -10],
        [-7, -75],
        [-59, -57],
        [-15, -31],
        [5, -31],
        [97, -442],
        [-212, -255],
        [-12, -14],
        [118, -423],
        [-32, 24],
        [-111, -45],
        [-377, 161],
        [-7, -46],
        [-41, -13],
        [-26, -25],
        [-26, 14],
        [-36, -25],
        [-22, -35],
        [-37, -18],
        [-82, -13],
        [-43, 1],
        [-37, -33],
        [-34, -44],
        [-11, -35],
        [-31, -45],
        [-42, -2],
        [-31, -22],
        [-83, 7],
        [-17, -44],
        [-50, -12],
        [-61, 27],
        [-22, -27],
        [-53, -25],
        [-16, -24],
        [-54, -36],
        [-47, -57],
        [-7, -42],
        [-27, -35],
        [-2, -75],
        [12, -39],
        [-8, -82],
        [-58, -31],
        [-75, -16],
        [-36, -31],
        [-37, 7],
        [-4, -39],
        [-20, -37],
        [-44, 9],
        [-91, 45],
        [-42, 4],
        [-98, -3],
        [-438, -231],
        [-130, -109],
        [42, -259],
        [18, -88],
        [385, 114],
        [35, -72],
        [52, -140],
        [26, -54],
        [99, -280],
        [3, -225],
        [-22, -97],
        [-121, -261],
        [-104, -261],
        [-21, -37],
        [-7, -54],
        [-36, -440],
        [396, -389],
        [133, -28],
        [5, -48],
        [0, -132],
        [96, -33],
        [151, -148],
        [44, -154],
        [96, -313],
        [-50, 17],
        [-121, 45],
        [-380, -509],
        [-118, -63],
        [-80, -16],
        [-185, 56],
        [-109, 29],
        [-393, 37],
        [-168, -1],
        [-254, -48],
        [-102, -252],
        [-38, -96],
        [-113, -193],
        [-209, -534],
        [62, -295],
        [122, -583],
        [-282, 65],
        [-123, -2],
        [-174, 20],
        [-152, -1],
        [-55, -59],
        [-54, -49],
        [-78, -80],
        [-111, -89],
        [308, -167],
        [-7, -49],
        [-28, -45],
        [-75, -276],
        [-9, 1],
      ],
      [
        [83976, 42991],
        [-147, 31],
        [-425, 64],
        [101, 279],
        [-55, 15],
        [-8, -60],
        [-268, 61],
        [-129, -243],
        [-89, 10],
        [-27, -20],
        [-197, 31],
        [49, -377],
        [186, 33],
        [-38, -164],
        [-86, 16],
        [-595, 142],
        [-19, 71],
        [1, 26],
        [123, 753],
        [-263, 243],
        [-14, 27],
        [89, 360],
        [16, 170],
        [137, -80],
        [25, -3],
        [0, 106],
        [-39, 52],
        [-9, 115],
        [-102, 9],
        [14, 180],
        [9, -4],
        [43, 147],
        [64, 95],
        [42, -16],
        [21, 30],
        [-39, 20],
        [58, 85],
        [-7, 95],
        [-68, -9],
        [-56, 61],
        [-75, 161],
        [-34, -16],
        [-2, 90],
        [2, 218],
        [-143, 88],
        [1, 5],
        [14, 109],
        [-114, 13],
        [48, 229],
        [-43, 4],
        [12, 138],
        [-73, 11],
        [98, 525],
        [10, 38],
        [71, 188],
        [-69, 233],
        [88, -1],
        [13, 107],
        [-147, 30],
        [-4, 11],
        [-294, 127],
        [92, 20],
        [39, 226],
        [-221, 10],
        [85, 348],
        [67, 259],
        [-3, 120],
        [-13, 140],
        [-496, 446],
        [-143, -154],
      ],
      [
        [81040, 49065],
        [-64, 106],
        [-200, 368],
      ],
      [
        [85175, 65420],
        [21, -27],
        [26, -9],
        [47, 19],
        [16, 47],
        [35, -19],
        [30, -75],
        [17, -76],
        [38, -42],
        [42, -12],
        [42, 15],
        [25, -13],
        [39, -47],
        [14, -43],
        [92, -100],
        [45, -67],
      ],
      [
        [85704, 64971],
        [-911, -641],
        [33, -285],
        [729, -270],
        [9, -235],
        [44, -497],
        [6, -58],
        [316, -863],
        [92, -70],
        [41, -112],
        [-315, -583],
        [-72, -134],
        [-165, 39],
        [16, -191],
        [66, 51],
        [22, 42],
        [74, 0],
        [36, -15],
        [-14, -36],
        [64, -13],
        [14, 51],
        [28, -3],
        [54, 16],
        [32, -65],
        [27, 1],
        [58, -6],
        [17, 31],
        [72, -33],
        [3, -36],
        [32, -4],
        [21, 25],
        [18, -36],
        [26, -4],
        [-15, -46],
        [33, -26],
        [49, 24],
        [87, -50],
        [-6, -47],
        [37, -34],
        [18, -88],
        [-37, -45],
        [0, -26],
        [-42, 1],
        [-24, -33],
        [-6, -40],
        [-38, -52],
        [11, -21],
        [-26, -53],
        [-26, -15],
        [26, -85],
        [-12, -85],
        [4, -43],
        [-17, -25],
        [-36, -17],
        [-28, -45],
        [-71, -46],
        [-23, -25],
        [-31, -60],
        [17, -69],
        [487, -29],
        [68, 1],
        [264, -134],
        [387, -202],
        [-16, -230],
        [-24, -334],
        [-20, -197],
        [-27, -22],
        [-43, -278],
        [-26, -151],
        [96, -170],
        [40, -60],
        [29, 7],
        [37, 42],
        [46, 33],
        [19, 0],
        [41, 37],
        [138, -112],
        [339, -264],
        [287, 27],
        [62, -399],
        [61, -411],
        [19, -93],
      ],
      [
        [104813, 14907],
        [23, 13],
        [26, -25],
        [27, 47],
        [46, -7],
        [28, 30],
        [34, -23],
        [35, 32],
        [-23, 44],
        [60, 0],
        [-19, 32],
        [28, 10],
        [4, 25],
        [44, -5],
        [-7, 35],
        [40, 6],
        [66, 46],
        [23, -32],
        [5, -31],
        [57, 57],
        [-42, 28],
        [89, 27],
        [0, 62],
        [38, -10],
        [38, 50],
        [48, 22],
        [9, 56],
        [24, -17],
        [44, 28],
        [71, 10],
        [35, 57],
        [83, 29],
        [9, 22],
        [72, -9],
        [3, 32],
        [34, 27],
        [20, -49],
        [28, 8],
        [21, 51],
        [27, -5],
        [27, 33],
        [7, 32],
        [41, -5],
        [-16, 52],
        [41, 27],
        [11, 38],
        [35, -21],
        [52, -3],
        [69, 11],
        [9, 34],
        [-25, 44],
        [28, 23],
        [9, -41],
        [97, 32],
        [2, 13],
        [223, -233],
        [34, -3],
        [7, -28],
        [-30, -82],
        [0, -91],
        [-20, 21],
        [-30, -34],
        [-47, 22],
        [-11, -39],
        [-32, -27],
        [-110, -21],
        [1, 32],
        [-28, 22],
        [-24, -28],
        [3, -34],
        [-40, -44],
        [-45, 1],
        [17, -105],
        [52, 26],
        [14, -36],
        [224, -310],
        [378, -527],
        [210, -292],
        [485, -207],
        [21, 17],
        [20, -43],
        [47, -48],
        [28, -9],
        [59, 23],
        [19, 29],
        [95, -54],
        [40, 14],
        [41, -28],
        [5, -56],
        [-55, -16],
        [-35, 3],
        [-26, -22],
        [8, -32],
        [41, 17],
        [-25, -106],
        [66, -58],
        [-12, -23],
        [-39, -25],
        [-13, -30],
        [18, -19],
        [-25, -54],
        [-2, -59],
        [-18, -36],
        [-39, -17],
        [3, -47],
        [457, -24],
        [367, -21],
        [719, -40],
        [1218, -70],
        [1081, -63],
        [1012, -62],
      ],
      [
        [112044, 7269],
        [-152, 69],
        [-266, 133],
        [-346, 183],
        [-166, 79],
        [-325, 130],
        [-308, 108],
        [-201, 66],
        [-200, 57],
        [-241, 58],
        [-277, 50],
        [-113, 17],
        [-194, 18],
        [-66, 13],
        [-232, 28],
        [-130, 14],
        [-85, 2],
        [-32, -12],
        [-66, 0],
        [-78, 11],
        [-78, 9],
        [-268, 12],
        [-150, -2],
        [-110, -10],
        [-163, -22],
        [-550, -107],
        [-123, -13],
        [-200, 21],
        [-115, 6],
        [-63, -16],
        [-23, -31],
        [22, -39],
        [-7, -17],
        [-68, -16],
        [-60, 19],
        [-48, -5],
        [-28, -38],
        [-160, -7],
        [-68, -56],
        [-5, -71],
        [-82, -12],
        [-68, -55],
        [6, -18],
        [18, -37],
        [-46, -31],
        [-54, -6],
        [-33, -30],
        [-92, -15],
        [-67, -21],
        [-68, -43],
        [-43, -54],
        [-65, -112],
        [7, -39],
        [31, -87],
        [-120, -32],
        [-16, -32],
        [-87, -21],
        [-37, -27],
        [-1, -27],
        [-20, -53],
        [-21, -21],
        [-119, 4],
        [-95, -4],
        [-58, -19],
        [-6, -29],
        [-80, -13],
        [-32, -13],
        [-189, -12],
        [-51, -13],
        [-31, -22],
        [-23, -37],
        [-88, -6],
        [-45, -37],
        [-32, -38],
        [-115, -22],
        [-57, -28],
        [-16, -23],
        [-147, -13],
        [-86, -14],
        [-224, -49],
        [-43, -15],
        [-28, -24],
        [-19, -44],
        [19, -45],
        [-150, -16],
        [-8, -8],
        [-115, -20],
        [-82, -31],
        [-120, -27],
        [-25, -33],
        [-239, -49],
        [-109, -37],
        [-46, -51],
        [-152, -44],
        [-37, -30],
        [-102, -53],
        [-52, -12],
        [-38, -7],
        [-42, -41],
        [-22, 8],
        [-38, -31],
        [7, -25],
        [-46, -8],
        [-48, 30],
        [-22, -16],
        [3, -42],
        [-35, -22],
        [-24, 27],
        [-55, -21],
        [-7, -38],
        [-25, -14],
        [28, -38],
        [-36, -6],
        [-44, -24],
        [-48, -16],
        [-8, -21],
        [-42, -22],
        [-55, -42],
        [-74, -19],
        [-51, 12],
        [-60, -76],
        [-26, 4],
        [-36, -39],
        [-29, 8],
        [-34, -35],
        [-45, 4],
        [-38, -10],
        [-103, 16],
        [-13, -15],
        [-62, 12],
        [-45, -11],
        [-62, 19],
        [-49, 1],
        [-28, -15],
        [-56, 26],
        [-46, -39],
        [-67, 32],
        [-52, -4],
        [-99, 28],
        [-38, -2],
        [-42, 16],
        [-66, -23],
        [-66, -54],
        [-33, 16],
        [-23, -43],
        [-49, -9],
        [-23, -51],
        [-40, 2],
        [-39, -29],
        [-54, 20],
        [-60, 3],
        [-24, -3],
        [-59, 17],
        [-38, 0],
        [-28, -27],
        [-89, 43],
        [-182, 57],
        [-153, 88],
        [-110, 47],
        [-63, 18],
        [-56, 26],
        [-215, 48],
        [-153, 16],
        [-141, 25],
        [-116, -6],
        [-79, 22],
        [-91, 49],
        [-149, 101],
        [-136, 74],
        [-76, 31],
        [-116, 37],
        [-190, 47],
        [-46, 26],
        [-101, 84],
        [13, 30],
        [-74, 128],
        [-20, -19],
        [-40, -2],
        [-56, 36],
        [-73, 26],
        [-101, 91],
        [-97, 59],
        [-89, 42],
        [-207, 76],
        [-125, 24],
        [-134, 46],
        [-62, 9],
        [-44, -5],
        [-150, 33],
        [-104, 9],
        [-59, -9],
        [-17, -20],
        [-38, -14],
        [-160, 29],
        [-47, 4],
        [-24, -11],
        [-62, 8],
        [-209, 50],
        [-180, 65],
        [-44, 11],
        [-172, -29],
        [-211, 53],
        [-137, 18],
        [-93, -2],
        [-45, -16],
        [-41, -55],
        [-94, 11],
        [-204, 44],
        [-103, 12],
        [-98, 30],
        [-10, 16],
        [-14, 19],
        [-78, 57],
        [-77, 38],
        [-137, 91],
        [-115, 86],
        [-116, 94],
        [-187, 140],
        [-101, 67],
        [-90, 48],
        [-265, 161],
        [-267, 150],
        [-124, 63],
        [-244, 106],
        [-30, 43],
        [-57, 37],
        [-98, 40],
        [-56, 16],
        [-154, 35],
        [-55, 15],
        [-208, 40],
        [-241, 33],
        [-114, 11],
        [-119, 34],
        [-122, 37],
        [-115, 47],
        [-184, 78],
        [-122, 34],
        [-13, 12],
      ],
      [
        [91697, 16476],
        [19, -12],
        [101, -14],
        [46, 55],
        [-5, 22],
        [33, 36],
        [45, -2],
        [15, -16],
        [36, 10],
        [31, 40],
        [35, 10],
        [61, -40],
        [11, -20],
        [54, 39],
        [81, 24],
        [-4, 37],
        [25, 53],
        [36, 25],
        [-9, 18],
        [37, 71],
        [49, -58],
        [49, 23],
        [8, -19],
        [-42, -36],
        [41, -36],
        [13, -64],
        [55, -84],
        [169, 6],
        [12, 36],
        [23, 23],
        [46, 20],
        [69, 8],
        [32, 42],
        [19, 66],
        [-28, 16],
        [-4, 49],
        [17, 17],
        [-10, 31],
        [42, 101],
        [27, 2],
        [15, 24],
        [42, 13],
        [64, 37],
        [3, 46],
        [58, -24],
        [18, -20],
        [25, 22],
        [59, 12],
        [91, -23],
        [42, 24],
        [30, -18],
        [35, 1],
        [33, -14],
        [31, 17],
        [2, 26],
        [34, 19],
        [24, -32],
        [44, -23],
        [94, -29],
        [37, 19],
        [33, -70],
        [55, 30],
        [72, -19],
        [67, 6],
        [10, -34],
        [-25, -6],
        [-37, -56],
        [50, -41],
        [-10, -27],
        [16, -47],
        [0, -40],
        [71, 1],
        [31, -26],
        [51, -15],
        [24, 17],
        [61, 6],
        [25, 21],
        [42, -4],
        [73, -27],
        [100, -15],
        [7, 25],
        [53, 6],
        [38, 115],
        [-9, 35],
        [41, 62],
        [38, 22],
        [28, -2],
        [70, 45],
        [30, 28],
        [8, 91],
        [-15, 13],
        [14, 42],
        [59, -7],
        [115, 37],
        [45, -41],
        [87, -11],
        [5, 99],
        [-144, 77],
        [-57, 58],
        [1, 32],
        [-75, 41],
        [-27, 24],
        [-33, -1],
        [-124, -161],
        [8, -97],
        [36, -25],
        [-9, -35],
        [-52, -26],
        [-35, -3],
        [-53, -50],
        [-22, -76],
        [-43, 53],
        [-32, 63],
        [-1, 113],
        [27, 67],
        [10, 85],
        [25, 7],
        [72, 58],
        [13, 23],
        [-35, 27],
        [-143, 53],
        [-51, 94],
        [-31, 60],
        [-1, 147],
        [16, 17],
        [31, 36],
        [17, 61],
        [26, 24],
        [39, -7],
        [-23, 15],
        [-28, 43],
        [3, 27],
        [-43, 19],
        [46, 63],
        [24, 54],
        [98, 37],
        [-22, 65],
        [56, 126],
        [83, 104],
        [64, 15],
        [99, -26],
        [56, -25],
        [130, 0],
        [33, 18],
        [15, 28],
        [51, 15],
        [167, 17],
        [41, 7],
        [49, -68],
        [21, -132],
        [9, -102],
        [-4, -95],
        [11, -94],
        [-29, -32],
        [-43, -51],
        [64, -56],
        [103, -61],
        [31, -25],
        [19, -53],
        [-17, -32],
        [50, -22],
        [127, -115],
        [7, -55],
        [6, -51],
        [23, -44],
        [-9, -51],
        [34, -54],
        [-6, -24],
        [64, -67],
        [40, 64],
        [58, -7],
        [39, -35],
        [37, -49],
        [31, 10],
        [45, -20],
        [45, 7],
        [58, 0],
        [15, 39],
        [48, 43],
        [-7, 24],
        [33, 34],
        [29, 82],
        [73, -13],
        [11, 42],
        [35, 67],
        [19, 52],
        [41, 25],
        [35, -34],
        [26, 9],
        [41, -37],
        [52, 29],
        [39, 61],
        [23, 18],
        [12, 34],
        [21, 1],
        [40, 34],
        [33, 74],
        [64, 3],
        [45, 50],
        [51, 18],
        [49, -5],
        [26, 9],
        [31, -17],
        [75, 34],
        [12, -6],
        [59, 42],
        [47, -4],
        [35, 18],
        [48, -51],
        [43, 38],
        [82, 19],
        [-23, 85],
        [40, 33],
        [74, 9],
        [1, -34],
        [25, -37],
        [84, -92],
        [22, -5],
        [23, -46],
        [46, 23],
        [50, -54],
        [33, -15],
        [72, 23],
        [6, -19],
        [214, 36],
        [21, 80],
        [-4, 18],
        [62, 67],
        [73, 80],
        [29, 33],
        [19, 73],
        [34, 16],
        [58, 9],
        [70, -17],
        [54, -46],
        [50, -2],
        [19, -17],
        [2, 3],
        [18, 24],
        [10, 54],
        [17, 25],
        [33, -19],
        [39, 26],
        [28, -6],
        [39, 14],
        [98, 16],
        [41, -8],
        [51, -4],
        [41, 28],
        [21, 47],
        [-5, 43],
        [62, 93],
        [16, 62],
        [35, 48],
        [-18, 20],
        [3, 55],
        [50, 36],
        [44, 3],
        [26, 28],
        [52, 16],
        [5, 48],
        [-13, 27],
        [79, 97],
        [23, 10],
        [2, 38],
        [52, -12],
        [0, 50],
        [18, 18],
        [71, 21],
        [18, -12],
      ],
      [
        [99498, 19094],
        [-39, -28],
        [-20, -31],
        [57, -44],
        [55, 27],
        [78, 12],
        [19, -36],
        [-1, -53],
        [31, 80],
        [36, -27],
        [33, 29],
        [-32, 21],
        [2, 131],
        [-16, 16],
        [-99, 37],
        [-14, 13],
        [0, 48],
        [18, 44],
        [3, 41],
        [43, 30],
        [20, 43],
        [30, 34],
        [2, 53],
        [-10, 62],
        [17, 12],
        [-1, 30],
        [-26, 33],
        [-68, -11],
        [-15, 79],
        [-23, 8],
        [-36, -30],
        [-35, 39],
        [4, 26],
        [31, 8],
        [33, 56],
        [-56, 54],
        [39, 71],
        [73, -99],
        [40, 73],
        [-52, 66],
        [46, -11],
        [20, 22],
        [-26, 27],
        [26, 29],
        [17, 43],
        [54, 19],
        [2, 55],
        [-16, 32],
        [-60, 68],
        [20, 27],
        [15, 20],
        [-10, 46],
        [-1, 58],
        [62, -44],
        [50, -50],
        [16, 6],
        [45, -49],
        [66, -30],
        [15, -18],
        [60, -69],
        [27, 2],
        [38, -30],
        [25, -4],
        [52, -47],
        [24, -8],
        [83, -63],
        [92, 3],
        [18, -22],
        [46, 16],
        [48, -21],
        [28, 7],
        [7, 25],
        [45, -5],
        [33, -27],
        [66, -13],
        [20, -34],
        [39, 3],
        [36, -18],
        [24, -57],
        [-15, -43],
        [37, -66],
        [26, -6],
        [15, -34],
        [25, -17],
        [56, -85],
        [-7, -41],
        [25, -2],
        [24, -112],
        [-32, -6],
        [24, -52],
        [37, 2],
        [22, -102],
        [44, -48],
        [9, -33],
        [23, -20],
        [26, 10],
        [28, -48],
        [33, -27],
        [36, -8],
        [47, -44],
        [-8, -30],
        [5, -60],
        [36, -32],
        [20, 19],
        [26, -51],
        [38, -7],
        [8, -48],
        [24, -61],
        [-8, -40],
        [12, -48],
        [28, -39],
        [25, -10],
        [34, -28],
        [39, -16],
        [2, -37],
        [59, -8],
        [-22, -31],
        [19, -63],
        [-1, -27],
        [-60, -57],
        [97, -104],
        [-13, -87],
        [100, -110],
        [15, -30],
        [50, -28],
        [69, -146],
        [66, 64],
        [62, 31],
        [84, 26],
        [10, -15],
        [0, -56],
        [-17, -21],
        [-61, -3],
        [15, -51],
        [-24, -27],
        [39, -53],
        [68, -30],
        [69, -14],
        [29, 41],
        [28, -29],
        [62, 31],
        [1, 55],
        [31, 17],
        [13, 44],
        [77, 14],
        [62, -25],
        [21, -58],
        [48, -45],
        [13, -46],
        [48, 9],
        [21, -32],
        [46, 58],
        [61, -26],
        [66, 21],
        [15, 22],
        [46, 12],
        [45, 33],
        [52, -22],
        [54, 36],
        [22, -11],
        [35, 38],
        [81, -14],
        [23, -69],
        [48, 41],
        [40, 3],
        [0, -63],
        [48, -15],
        [236, -25],
        [84, -8],
        [41, -237],
        [112, -649],
        [-223, -503],
        [-10, -20],
        [-38, 2],
        [2, -26],
        [43, -57],
        [-19, -44],
        [-7, -57],
        [-56, -37],
        [-10, -29],
        [15, -57],
        [-6, -45],
        [-54, 2],
        [-56, -34],
        [-7, -31],
        [-30, -30],
        [6, -25],
        [-22, -64],
        [6, -38],
        [52, -19],
        [47, 16],
        [32, -4],
        [1, -39],
        [-20, -18],
        [-31, 5],
        [-34, -22],
        [-19, -38],
        [113, -15],
        [-1, -44],
        [23, -46],
        [58, -39],
        [43, -14],
        [28, -61],
        [30, -36],
        [51, -23],
        [56, -7],
        [3, -45],
        [19, -41],
        [81, 19],
        [14, -37],
        [43, -10],
        [-4, -70],
        [-69, 6],
        [-32, -25],
        [-34, 6],
        [-19, -26],
        [-6, -42],
        [63, -35],
        [22, 25],
        [-4, 59],
        [44, -2],
        [44, -15],
        [-6, -41],
        [18, -17],
        [89, -8],
        [60, -31],
        [34, -45],
        [35, -108],
        [4, -61],
        [37, -4],
        [21, -20],
        [28, -66],
        [14, 19],
        [38, 12],
        [8, 47],
        [112, 5],
        [25, 17],
        [50, 3],
        [45, 44],
        [55, -3],
        [13, -21],
        [43, -5],
        [32, 14],
        [41, -13],
        [-3, -33],
        [45, 11],
        [22, -16],
        [34, 18],
        [-3, 30],
        [26, 19],
      ],
      [
        [94875, 29256],
        [-19, -58],
        [-38, -86],
        [-10, -5],
        [-11, -36],
        [-23, -7],
        [-10, -69],
        [-21, -6],
        [1, -43],
        [-14, -41],
        [75, -12],
        [22, -46],
        [7, -86],
        [37, -20],
        [32, -35],
        [69, -58],
        [47, -17],
        [28, -28],
        [8, 75],
        [21, -7],
        [50, 81],
        [23, -14],
        [-12, -40],
        [17, -12],
        [-51, -54],
        [3, -58],
        [24, 0],
        [7, -34],
        [-20, -23],
        [-32, 6],
        [-32, -15],
        [-46, 11],
        [-15, -87],
        [-65, -6],
        [-38, -15],
        [-46, -32],
        [-37, 21],
        [-39, 2],
        [28, -95],
        [27, -5],
        [30, -28],
        [11, -46],
        [9, -45],
        [-13, -33],
        [21, -43],
        [9, -73],
        [-35, -13],
        [-4, -33],
        [36, -69],
        [29, 9],
        [22, 30],
        [61, -35],
        [38, 1],
        [27, -64],
        [57, -22],
        [48, 20],
        [52, -2],
        [19, -23],
        [41, 23],
        [3, 41],
        [30, -1],
        [15, 29],
        [26, -2],
        [35, -39],
        [4, -11],
        [23, -15],
        [54, -11],
        [-2, -45],
        [-13, -29],
        [7, -40],
        [24, -16],
        [-18, -44],
        [10, -60],
        [22, -21],
        [47, -14],
        [40, -45],
        [-25, -42],
        [-53, 10],
        [11, -60],
        [35, -27],
        [73, 14],
        [31, 39],
        [30, 87],
        [25, -35],
        [32, 17],
        [24, 61],
        [53, -7],
        [44, 46],
        [30, 4],
        [15, 29],
        [34, 7],
        [29, 27],
        [-41, 54],
        [6, 46],
        [69, 37],
        [4, 33],
        [44, 27],
        [36, 3],
        [30, 35],
        [-10, 103],
        [-1, 74],
        [23, 59],
        [36, 26],
        [31, 40],
        [42, -29],
        [50, 17],
        [87, -56],
        [66, 64],
        [57, 21],
        [22, -29],
        [2, -42],
        [-18, -46],
        [66, -49],
        [222, -78],
        [132, -45],
        [17, -26],
        [34, -14],
        [23, 21],
        [42, -49],
        [31, -2],
        [51, 17],
        [7, -31],
        [63, -8],
        [295, -103],
        [16, 44],
        [50, -1],
        [-14, -40],
        [2, -67],
        [26, -14],
        [36, 19],
        [37, 0],
        [36, -24],
        [-79, -75],
        [-62, -34],
        [-66, -87],
        [-26, -16],
        [-45, -60],
        [7, -39],
        [-16, -49],
        [-94, -29],
        [-4, -47],
        [-17, -28],
        [29, -56],
        [-12, -77],
        [-81, -24],
        [-3, -36],
        [-31, -14],
        [-36, -59],
        [-63, -20],
        [-32, -30],
        [-4, -29],
        [-34, -61],
        [0, -63],
        [24, -9],
        [23, -56],
        [12, -3],
        [-31, -48],
        [-30, -9],
        [-18, -25],
        [-36, -19],
        [-64, -98],
        [20, -29],
        [-44, -25],
        [-8, -22],
        [-12, -55],
        [-23, -56],
        [6, -98],
        [-34, -48],
        [-5, -88],
        [16, -84],
        [-30, -80],
        [4, -114],
        [-11, -15],
        [26, -92],
        [-33, -35],
        [-48, -27],
        [102, -149],
        [17, -9],
        [15, -60],
        [-55, 6],
        [-47, 26],
        [-69, -16],
        [-7, -36],
        [-83, -85],
        [-17, -10],
        [-56, -71],
        [-17, -4],
        [-21, -29],
        [-26, -4],
        [-55, -59],
        [-64, 63],
        [-16, -20],
        [-37, -40],
        [0, -71],
        [-28, -66],
        [18, -12],
        [-2, -48],
        [17, -34],
        [-4, -68],
        [13, -60],
        [59, -37],
        [31, -52],
        [-9, -17],
        [24, -32],
        [6, -42],
        [-23, -30],
        [6, -25],
        [45, -17],
        [110, 13],
        [47, -32],
        [22, 22],
        [35, -41],
        [6, -167],
        [-29, -12],
        [5, -32],
        [-23, -48],
        [-113, 0],
        [-39, -17],
        [-18, -107],
        [102, -21],
        [53, -133],
        [54, 13],
        [51, 68],
        [106, -3],
        [125, -13],
        [26, -9],
        [69, -23],
        [45, -3],
        [40, -16],
        [77, -46],
        [2, -34],
        [35, -28],
        [57, 5],
        [20, -44],
        [-16, -56],
        [25, -33],
        [-7, -21],
        [-42, -18],
        [37, -41],
        [30, 7],
        [8, -35],
        [40, 33],
        [8, 29],
        [60, 30],
        [41, 5],
        [58, -23],
        [26, -19],
        [3, -1],
        [54, 11],
        [21, -17],
        [9, -48],
        [65, -22],
        [43, 8],
        [37, -12],
        [44, 40],
        [26, -8],
        [68, 54],
        [25, -28],
        [34, -17],
        [53, 33],
        [7, -32],
        [34, -28],
        [16, -47],
        [27, -13],
        [27, 11],
        [73, -3],
        [14, -27],
        [42, -26],
        [25, -28],
        [-18, -10],
        [-30, -70],
        [-41, -70],
        [18, -64],
        [-29, -28],
        [-26, 5],
        [-33, -46],
        [-42, -23],
        [-28, -26],
        [-73, -30],
        [-20, -43],
        [29, -45],
        [38, -76],
        [-8, -42],
        [22, -36],
        [-18, -31],
        [59, -42],
        [-41, -43],
        [-35, -31],
        [-32, 22],
        [-21, 38],
        [-48, 41],
        [16, 48],
        [-49, -1],
        [-65, 25],
        [-88, 22],
        [-67, -4],
        [-22, 8],
        [-35, -35],
        [-41, 14],
        [-71, 6],
        [-50, -6],
        [-50, 25],
        [-31, -25],
        [-29, 39],
        [-9, -26],
        [-53, -33],
        [50, -67],
        [-26, -26],
        [-55, -12],
        [-34, -51],
        [-76, -97],
        [-99, -51],
        [-10, -67],
        [-33, -104],
        [14, -167],
        [-3, -2],
        [-8, -8],
        [-36, -63],
        [-13, -44],
        [-26, -35],
        [29, -13],
        [81, -77],
        [19, -36],
        [-9, -39],
        [3, -51],
        [15, -59],
        [-1, -26],
        [20, -81],
        [17, -16],
        [18, -31],
        [6, -53],
        [-17, -43],
        [-80, -1],
        [-51, -24],
        [-106, -103],
        [-5, -33],
        [-11, -6],
        [-37, -81],
        [-54, -29],
        [-19, -33],
        [18, -48],
        [-24, -5],
        [1, -34],
        [-2, -6],
        [-29, -19],
        [-23, -43],
        [-32, 6],
        [-35, -37],
        [-12, -67],
        [11, -20],
        [56, 15],
        [14, -49],
        [30, -21],
        [-42, -25],
        [-20, -48],
        [12, -38],
        [-26, -70],
        [23, -9],
        [-31, -48],
        [31, -49],
        [-14, -38],
        [22, -24],
        [-16, -38],
        [97, -107],
        [61, 47],
        [29, 3],
        [43, -47],
        [12, -47],
        [42, -16],
        [19, -43],
        [-1, -28],
        [21, -22],
        [5, -22],
        [61, -22],
        [32, 12],
        [32, 67],
        [46, 16],
        [40, -23],
        [30, -49],
        [30, -19],
        [70, 23],
        [65, -65],
        [34, 3],
        [11, -53],
        [56, -3],
        [27, -25],
        [64, -37],
        [-16, -55],
        [7, -56],
        [95, -139],
        [46, -57],
        [5, -48],
        [107, -164],
        [27, -22],
        [11, -99],
        [43, 19],
        [48, 41],
        [43, 48],
        [25, 69],
        [90, 72],
        [28, -9],
        [26, 43],
        [39, 11],
        [37, 42],
        [12, -17],
        [51, 13],
        [51, 28],
        [-4, 35],
        [44, -10],
        [4, 26],
        [53, 34],
        [49, -48],
        [49, -19],
        [26, -27],
        [74, 24],
        [14, 35],
        [34, 10],
        [63, -76],
        [32, 19],
        [25, -70],
        [33, 13],
        [5, -49],
        [15, -24],
        [28, 0],
        [60, -46],
        [2, -41],
        [75, 21],
        [9, 67],
        [26, 2],
        [40, 30],
        [30, -30],
        [29, 2],
        [12, -51],
        [-15, -11],
        [20, -43],
        [-15, -18],
        [5, -38],
        [18, -10],
        [31, -113],
        [38, -23],
        [-38, -28],
        [32, -46],
        [-12, -30],
        [68, -57],
        [-2, -24],
        [32, -21],
        [35, 15],
        [37, -20],
        [69, 10],
        [-13, -39],
        [12, -27],
      ],
      [
        [90647, 24383],
        [59, -13],
        [29, 22],
        [22, -53],
        [93, -32],
        [82, -6],
        [97, 86],
        [57, -20],
        [75, -9],
        [29, 7],
        [55, -7],
        [32, -107],
        [37, -60],
        [46, -53],
        [51, -92],
        [1, -28],
        [1, -13],
        [75, -141],
        [71, -76],
        [59, -89],
        [4, -11],
        [66, 8],
        [29, -34],
        [59, -20],
        [-11, -120],
        [38, -19],
        [2, -27],
        [97, -102],
        [11, -35],
        [9, -45],
        [26, -47],
        [27, -14],
        [-20, -35],
        [78, -36],
        [36, -67],
        [42, -5],
        [20, -20],
        [-34, -40],
        [-9, -30],
        [-12, -40],
        [86, -45],
        [54, 107],
        [26, -9],
        [85, -72],
        [75, -53],
        [43, -13],
        [36, 0],
        [82, -17],
        [29, -3],
        [2, -38],
        [25, -54],
        [76, -26],
        [34, 23],
        [45, 13],
        [11, -22],
        [-40, -40],
        [24, -24],
        [-15, -30],
        [50, -7],
        [83, -50],
        [20, 10],
        [33, 46],
        [35, 27],
        [12, -25],
        [56, 59],
        [58, 32],
        [51, 49],
        [24, 36],
        [14, 54],
        [31, 14],
        [63, 49],
        [46, 45],
        [4, 22],
        [44, 57],
        [43, 30],
        [39, 14],
        [32, 43],
        [13, 60],
        [139, -135],
        [13, -26],
        [30, -12],
        [61, -17],
        [56, -25],
        [177, -115],
        [61, 46],
        [32, 36],
        [25, -6],
        [59, 37],
        [-24, 56],
        [20, 18],
        [131, 58],
        [51, 45],
        [-13, 16],
        [-31, 89],
        [-45, -19],
        [24, 68],
        [51, 17],
        [-74, 64],
        [47, 83],
        [99, 0],
        [-1, 71],
        [82, 15],
        [94, -15],
        [60, -57],
        [73, -31],
        [29, 15],
        [37, 64],
        [55, 27],
        [38, -42],
        [-7, -48],
        [41, 30],
        [45, 58],
        [18, -35],
        [51, -3],
        [63, -56],
        [55, 31],
        [58, 13],
        [38, 79],
        [55, -21],
        [33, 62],
        [58, 25],
        [3, 35],
        [-60, 35],
        [33, 85],
        [-40, 27],
        [-62, -35],
        [0, 27],
        [-49, 29],
        [-43, 12],
        [-24, 86],
        [-68, 20],
        [-20, 32],
        [-27, -13],
        [-36, 67],
        [-43, 60],
        [-16, 65],
        [-43, 16],
        [-37, -13],
        [-23, 20],
        [11, 35],
        [-10, 34],
        [-32, 0],
        [-4, 36],
        [-87, 5],
        [-2, 52],
        [-18, 19],
        [-40, -12],
        [-47, 9],
        [0, 63],
        [10, 65],
        [-92, -77],
        [-144, -69],
        [-36, -51],
        [-39, -12],
        [22, 42],
        [47, 47],
        [-7, 43],
        [-43, 52],
        [-75, 50],
        [-31, -17],
        [-39, 22],
        [11, 65],
        [44, 32],
        [28, 40],
        [11, 51],
        [4, 57],
        [-17, 40],
        [-49, 51],
        [-44, 2],
        [-38, 26],
        [-34, 7],
        [-28, 62],
        [-79, -22],
        [-11, 7],
        [-60, -16],
        [-17, 27],
        [-4, 63],
        [-20, -4],
        [-34, 49],
        [-34, 24],
        [-13, 32],
        [-35, 21],
        [-39, 3],
        [-243, 54],
        [20, 41],
        [8, 82],
        [-1, 102],
        [-17, 19],
        [0, 49],
        [-46, 64],
        [-11, 2],
        [-16, 64],
        [-47, 12],
        [-10, -60],
        [17, -31],
        [-20, -32],
        [-63, -12],
        [-7, -36],
        [-28, -20],
        [-1, -51],
        [-38, -47],
        [-54, 80],
        [-38, 12],
        [-27, -15],
        [-87, -8],
        [-74, -70],
        [-46, 16],
        [-54, 5],
        [-28, 30],
        [-32, -25],
        [-57, 0],
        [-12, 12],
        [-49, -17],
        [-58, 15],
        [-37, -4],
        [-17, 48],
        [-37, 37],
        [-12, 74],
        [-1, 53],
      ],
      [
        [93719, 29577],
        [27, -10],
        [31, 40],
        [-41, 14],
        [3, 74],
        [114, 79],
        [60, 29],
        [72, 45],
        [28, 38],
        [47, 33],
        [3, 39],
        [21, 35],
        [3, 41],
        [46, 66],
        [-30, 89],
        [-23, 15],
        [-24, 47],
        [19, 55],
        [-26, 37],
        [-20, -2],
        [16, 77],
        [36, 17],
        [41, 62],
        [-114, 67],
        [86, 288],
        [13, 23],
        [27, 90],
        [51, 136],
        [22, 44],
        [39, -14],
        [41, 19],
        [27, -10],
        [48, 32],
        [8, -80],
        [-29, -22],
        [91, -54],
        [28, 9],
        [35, 39],
        [43, 21],
        [76, -26],
        [80, 49],
        [48, -40],
        [58, -20],
        [9, -27],
        [43, -37],
        [200, -8],
        [-44, -12],
        [-42, 10],
        [-35, -24],
        [-30, -48],
        [33, -72],
        [-28, -134],
        [-101, -51],
        [-11, -155],
        [-23, -22],
        [-2, -40],
        [42, -13],
        [39, 3],
        [10, -36],
        [-16, -31],
        [10, -34],
        [-10, -33],
        [-44, -35],
        [9, -37],
        [50, 5],
        [9, -26],
        [42, -22],
        [50, 1],
        [48, -37],
        [-36, -45],
        [10, -58],
        [26, -34],
        [37, -25],
        [-20, -111],
        [32, -18],
        [40, 11],
        [23, -26],
        [-15, -63],
        [39, 2],
        [87, -48],
        [-7, 50],
        [34, 46],
        [59, -30],
        [5, -25],
        [44, 23],
        [9, 25],
        [69, 2],
        [35, -22],
        [57, -15],
        [36, -45],
        [24, -11],
        [-9, -33],
        [29, -31],
        [142, -215],
        [-65, -19],
        [-18, 23],
        [-75, 8],
        [-27, -41],
        [-19, -49],
        [-68, -58],
        [-29, 5],
        [-42, -33],
        [-34, 11],
        [-18, -37],
        [-39, 7],
        [-21, -47],
        [25, -48],
        [-11, -71],
        [-42, -46],
        [-66, 22],
        [-21, -25],
        [-37, 15],
        [5, 34],
        [-34, 37],
        [-37, 10],
        [-51, 36],
        [-5, 48],
        [-34, 17],
        [-5, 34],
        [-57, -6],
        [-35, 18],
        [-23, -26],
      ],
      [
        [85478, 34410],
        [35, 63],
        [61, 35],
        [6, 30],
        [26, 12],
        [-16, 103],
        [8, 66],
        [21, 103],
        [189, -37],
        [27, 10],
        [63, -4],
        [118, -24],
        [60, -99],
        [17, -62],
        [61, -73],
        [20, -62],
        [74, -67],
        [82, -36],
        [8, -42],
        [79, -58],
        [41, -61],
        [17, 1],
        [48, -33],
        [-31, -54],
        [26, -40],
        [64, 15],
        [59, -12],
        [106, -51],
        [61, 20],
        [19, 50],
        [56, 15],
        [-9, 26],
        [21, 28],
        [102, -16],
        [55, 30],
        [89, -100],
        [50, -1],
        [28, 67],
        [13, 49],
        [-13, 53],
        [38, 2],
        [37, 88],
        [-23, 61],
        [70, 65],
        [-3, 37],
        [13, 29],
        [-40, 46],
        [10, 24],
        [2, 66],
        [57, 26],
        [82, -12],
        [58, -63],
        [61, -22],
        [57, -7],
        [83, 91],
        [-5, 37],
        [50, 10],
        [26, 38],
        [-34, 80],
        [-5, 35],
        [14, 86],
        [25, -11],
        [46, 24],
        [40, -5],
        [55, 24],
        [13, 44],
        [31, 24],
        [40, 22],
        [10, 68],
        [28, 33],
        [-2, 66],
        [75, -8],
        [59, 23],
        [30, -42],
        [38, -115],
        [20, -36],
        [-13, -20],
        [153, -114],
        [37, -35],
        [12, -66],
        [-58, -195],
        [-8, -41],
        [25, -106],
        [35, -68],
        [1, -66],
        [1, -77],
        [30, -89],
        [79, -162],
        [-2, -45],
        [35, -15],
        [24, -133],
        [-22, -19],
        [23, -71],
        [-169, -6],
        [-39, -160],
        [161, -43],
        [1, -16],
        [-115, 2],
        [28, -40],
        [73, -39],
        [6, -62],
        [52, 10],
        [46, 23],
        [35, -37],
        [69, -45],
        [24, 14],
      ],
      [
        [141888, 23890],
        [47, -27],
        [25, -49],
        [-81, 26],
        [-25, 39],
        [34, 11],
      ],
      [
        [141971, 25069],
        [64, -12],
        [-14, -24],
        [-50, 36],
      ],
      [
        [141936, 26070],
        [-68, -41],
        [-30, 10],
        [-20, -21],
        [-34, -6],
        [-33, 21],
        [-27, -19],
        [-30, 24],
        [1, 32],
        [-45, -13],
        [-28, -43],
        [-48, -28],
        [-40, -91],
        [-33, -39],
        [-39, -72],
        [-15, -50],
        [-58, -95],
        [-49, -54],
        [-25, -55],
        [-44, -72],
        [-25, -115],
        [-35, -120],
        [-40, -92],
        [-59, -13],
        [-20, 24],
        [8, 28],
        [43, 3],
        [45, 37],
        [17, 25],
        [-5, 59],
        [43, 126],
        [-23, 30],
        [-89, 2],
        [-105, -11],
        [-45, -27],
        [-38, -5],
        [-47, -24],
        [-66, -12],
        [-11, -26],
        [0, -58],
        [15, -57],
        [-18, -113],
        [-21, -56],
        [21, -66],
        [57, -28],
        [13, -40],
        [39, 6],
        [56, -21],
        [-31, -39],
        [9, -37],
        [48, -39],
        [57, 15],
        [61, 53],
        [16, -17],
        [16, -51],
        [-21, -32],
        [17, -75],
        [29, -36],
        [-22, -25],
        [-13, -42],
        [58, -36],
        [39, 24],
        [15, 39],
        [49, 64],
        [20, 65],
        [35, 38],
        [47, 29],
        [147, 18],
        [35, 17],
        [96, 22],
        [94, -35],
        [-5, -46],
        [23, -23],
        [38, 40],
        [30, 59],
        [38, 25],
        [62, 16],
        [-77, 24],
        [13, 50],
        [27, 20],
        [20, -24],
        [29, 22],
        [39, -11],
        [53, 11],
        [55, 23],
        [13, 31],
        [-12, 36],
        [9, 37],
        [28, 2],
        [24, 32],
        [-34, 61],
        [79, -64],
        [43, -27],
        [32, -68],
        [39, -23],
        [-15, -99],
        [-3, -69],
        [-26, -30],
        [-22, -54],
        [10, -39],
        [-26, -56],
        [-16, -86],
        [14, -48],
        [-19, -73],
        [-20, -26],
        [-14, -59],
        [-19, 0],
        [-67, -67],
        [-26, -14],
        [-26, -34],
        [-87, -35],
        [-73, -79],
        [-67, -106],
        [-25, -28],
        [-85, -18],
        [27, 107],
        [-29, 75],
        [-46, -8],
        [-54, -49],
        [-48, -16],
        [-58, -50],
        [-36, -5],
        [-49, -39],
        [-54, -64],
        [-30, -8],
        [-48, -33],
        [-65, -169],
        [-22, -97],
        [-6, -84],
        [-52, -26],
        [-4, -30],
        [39, -20],
        [9, -26],
        [-15, -105],
        [-24, -16],
        [-48, -65],
        [-46, -49],
        [2, -18],
        [46, -6],
        [-35, -54],
        [9, -52],
        [52, -91],
        [43, -6],
        [29, -37],
        [70, 7],
        [27, 27],
        [44, 18],
        [30, 78],
        [43, 72],
        [7, 39],
        [69, 60],
        [44, 79],
        [-22, 32],
        [85, 67],
        [29, 61],
        [114, 82],
        [53, -6],
        [49, 13],
        [19, 45],
        [49, 34],
        [54, 8],
        [76, -13],
        [39, 11],
        [13, -28],
        [39, -36],
        [30, -5],
        [-93, -111],
        [-42, -41],
        [-60, -91],
        [-74, -71],
        [-46, -64],
        [-52, -24],
        [-14, -43],
        [-30, -44],
        [-19, -63],
        [8, -75],
        [-20, -83],
        [2, -78],
        [-31, -39],
        [5, -39],
        [-12, -88],
        [1, -78],
        [-11, -45],
        [10, -22],
        [-16, -75],
        [-14, -27],
        [-27, 0],
        [-39, -78],
        [-12, -50],
        [-22, -26],
        [-47, -119],
        [-7, -30],
        [-49, -79],
        [-21, -19],
        [-17, -71],
        [-24, -54],
        [-13, -59],
        [-46, -48],
        [-24, -91],
        [3, -96],
        [-29, -40],
        [-19, -50],
        [2, -114],
        [-57, -77],
        [2, -29],
        [-45, -76],
        [3, -43],
        [-17, -27],
        [-13, -60],
        [9, -49],
        [-19, -63],
        [13, -21],
        [-4, -40],
        [-21, -54],
        [-50, -73],
        [-65, -48],
        [-58, -90],
        [-17, -77],
        [-45, -128],
        [-14, -115],
        [-7, -92],
        [-36, -165],
        [-12, -115],
        [1, -120],
        [-17, -38],
        [-6, -45],
        [-56, -67],
        [-24, -103],
        [4, -44],
        [-13, -130],
        [12, -40],
        [-1, -53],
        [-14, -39],
        [3, -72],
        [-31, -67],
        [-80, -101],
        [-47, -98],
        [-24, -73],
        [-43, -46],
        [-30, -43],
        [-38, -104],
        [-29, -128],
        [-5, -108],
        [-10, -79],
        [-20, -86],
        [0, -79],
        [-11, -109],
        [-27, -34],
        [-33, -8],
        [-29, 55],
        [28, 16],
        [15, 63],
        [-31, 16],
        [-12, 33],
        [-29, -35],
        [-8, 51],
        [-62, -16],
        [-17, 36],
        [-23, 3],
        [-16, 61],
        [20, 24],
        [36, -10],
        [4, 26],
        [44, 64],
        [-10, 44],
        [3, 64],
        [-31, 80],
        [-60, -62],
        [-16, 75],
        [37, 13],
        [52, 118],
        [-16, 67],
        [20, 28],
        [-110, 56],
        [33, 57],
        [-43, 71],
        [-47, 21],
        [-70, -18],
        [-5, 35],
        [-25, 2],
        [7, 44],
        [-5, 60],
        [21, 11],
        [-14, 39],
        [20, 44],
        [-24, 33],
        [-102, 8],
        [-102, 31],
        [-132, 63],
        [-39, -12],
        [-66, 30],
        [-33, 27],
        [-41, 5],
        [-27, 33],
        [-97, 15],
        [29, 27],
        [10, 41],
        [-30, 5],
        [-24, 79],
        [80, 33],
        [11, 42],
        [52, 13],
        [31, 76],
        [-7, 50],
        [22, 5],
        [17, 60],
        [-43, 15],
        [-5, 53],
        [19, 22],
        [9, 46],
        [23, 34],
        [57, 59],
        [11, 65],
        [23, 30],
        [17, 73],
        [28, 33],
        [-9, 50],
        [36, 30],
        [-31, 42],
        [-37, 21],
        [-18, 40],
        [26, 79],
        [22, 109],
        [17, 44],
        [-34, 52],
        [8, 78],
        [33, 33],
        [-51, 16],
        [-40, 26],
        [12, 54],
        [-47, 62],
        [-36, 9],
        [-14, 39],
        [-38, -6],
        [33, 107],
        [14, 64],
        [-5, 30],
        [-36, 14],
        [-7, 69],
        [-25, -5],
        [-4, -47],
        [-72, 14],
        [-11, -39],
        [-49, -52],
        [3, -29],
        [-57, -60],
        [-62, -38],
        [7, -42],
        [-34, -62],
        [-56, -61],
        [-17, -95],
        [-30, -27],
        [-34, -52],
        [-15, -39],
        [0, -48],
        [-43, -26],
        [-16, 33],
        [12, 68],
        [19, 23],
        [9, 84],
        [-41, -70],
        [-19, -61],
        [-19, -15],
        [-17, -47],
        [0, -31],
        [-57, -14],
        [-88, -44],
        [6, -52],
        [-16, -51],
        [24, -16],
        [10, 69],
        [19, 25],
        [86, 17],
        [21, 33],
        [33, 11],
        [12, -66],
        [-55, -79],
        [-57, -5],
        [-30, -36],
        [-19, -59],
        [-2, -39],
        [-23, -27],
        [-19, -85],
        [-22, -21],
        [-18, -48],
        [-55, -64],
        [-2, -52],
        [-23, -68],
        [-38, -42],
        [-34, -77],
        [-23, -29],
        [-92, -210],
        [-14, -1],
        [-38, -60],
        [-11, -40],
        [-53, -10],
        [-91, 15],
        [10, -32],
        [-56, 9],
        [-53, -15],
        [-76, -12],
        [-57, 7],
        [-44, -34],
        [-46, 12],
        [-13, 23],
        [-58, 52],
        [-70, -21],
        [-26, -26],
        [-89, -29],
        [-17, -28],
        [-55, 68],
        [-28, -12],
        [-64, 34],
        [-84, -84],
        [-97, -67],
        [-47, -138],
        [-7, -86],
        [-12, -49],
        [-43, -70],
        [-17, -14],
        [-32, -79],
        [36, -62],
        [-14, -35],
        [-110, -135],
        [-19, -39],
        [-21, -11],
        [-119, -131],
        [39, -14],
        [-28, -109],
        [-14, -12],
        [8, -115],
        [-36, -44],
        [-14, -44],
        [-62, -22],
        [-16, -30],
        [-40, 19],
        [-33, -34],
        [-47, -30],
        [-37, -4],
        [-32, -42],
        [-60, 2],
        [-50, -61],
        [12, -17],
        [46, -3],
        [21, -93],
        [-41, -19],
        [-66, -103],
        [-27, -53],
        [0, -28],
        [-43, -47],
        [30, -24],
        [9, -35],
        [-26, -14],
        [-17, -50],
        [25, -53],
        [-23, -6],
        [12, -57],
        [-17, -5],
        [-51, -49],
        [-83, -43],
        [-36, -24],
        [-39, -7],
        [-23, -27],
        [18, -62],
        [-28, -22],
        [-1, -34],
        [-46, -25],
        [-21, -52],
        [21, -26],
        [-17, -26],
        [-43, -27],
        [-64, -94],
        [-28, -26],
        [-81, -20],
        [-48, -25],
        [-39, -35],
        [-22, -43],
        [16, -72],
        [-26, -77],
        [-82, 0],
        [-27, 12],
        [-8, 53],
        [-51, -8],
        [-63, 30],
        [-29, 24],
        [-20, -6],
        [-28, 70],
        [-25, 3],
        [9, 54],
        [-70, 57],
        [-1, 33],
        [-65, -39],
        [-43, 5],
        [-25, 18],
        [-47, 4],
        [-30, -27],
        [-7, 40],
        [-30, 37],
        [-7, 87],
        [-96, 39],
        [-34, 40],
        [-38, 21],
        [-69, -25],
        [-29, -48],
        [-81, 18],
        [-65, -32],
        [-97, -88],
        [-24, -4],
        [-35, 32],
        [-43, -21],
        [1, -52],
        [-12, -25],
        [-40, -21],
        [-14, -44],
        [-18, -10],
      ],
      [
        [133674, 24805],
        [354, 280],
        [-15, 142],
        [150, -16],
        [4, 52],
        [205, -32],
        [-21, -278],
        [185, 5],
        [3, 149],
        [-115, 11],
        [46, 439],
        [227, -45],
        [-8, -43],
        [182, -38],
        [27, 152],
        [152, -20],
        [12, 113],
        [-94, -23],
        [-8, 17],
        [-146, -24],
        [108, 273],
        [98, -24],
        [21, 130],
        [69, 0],
        [-1, 35],
        [39, 27],
        [7, 37],
        [83, -7],
        [-7, -31],
        [65, 14],
        [-7, -105],
        [73, -6],
        [42, 65],
        [43, -15],
        [13, 98],
        [22, 51],
        [27, 28],
        [-13, 121],
        [98, 5],
        [-5, 78],
        [216, 1],
        [33, 9],
        [26, 51],
        [-44, 39],
        [13, 60],
        [49, -30],
        [2, 55],
        [29, 52],
        [-8, 45],
        [6, 48],
        [21, 44],
        [33, -6],
        [2, 110],
        [34, -14],
        [1, 100],
        [27, 15],
        [4, 63],
        [57, -3],
        [-1, 30],
        [133, 8],
        [29, -27],
        [18, 21],
        [147, -17],
        [26, 97],
        [13, -5],
        [32, 238],
        [-27, -1],
        [1, 63],
        [232, 151],
        [96, -16],
        [3, 53],
        [27, 26],
        [114, -8],
        [2, 45],
        [42, -7],
        [7, 44],
        [318, -23],
        [24, 231],
        [-80, 11],
        [351, 226],
        [131, -25],
        [27, 34],
        [28, -2],
        [-28, 63],
        [176, 27],
        [87, 7],
        [198, -28],
        [165, 81],
        [29, -4],
        [9, 105],
        [147, -1],
        [0, -16],
        [302, -7],
        [141, -20],
        [329, 337],
        [81, 83],
        [-1, 61],
        [61, 1],
        [190, 193],
        [0, 30],
        [-10, 114],
        [148, -2],
        [115, 116],
        [891, 907],
        [3, 5],
        [312, 551],
        [448, 789],
        [208, 364],
        [-8, 2426],
      ],
      [
        [141776, 34388],
        [214, -26],
        [10, -7],
        [-5, -77],
        [8, -23],
        [35, -25],
        [70, -4],
        [26, 26],
        [56, 11],
        [34, 19],
        [39, -4],
        [55, -30],
        [65, -25],
        [111, -12],
        [44, -29],
        [66, -12],
        [35, -55],
        [22, -13],
        [47, 0],
        [48, 15],
        [28, 28],
        [73, -30],
        [42, 19],
        [28, -18],
        [57, -15],
        [63, 27],
        [38, -19],
        [63, -69],
        [28, 8],
        [10, 43],
        [26, 4],
        [3, 36],
        [35, 27],
        [45, 5],
        [74, -26],
        [11, 14],
        [51, 12],
        [39, 24],
        [36, 66],
        [32, 3],
        [45, -17],
        [46, -2],
        [71, 35],
        [27, 51],
        [-13, 34],
        [30, 113],
        [-19, 36],
        [1, 29],
        [23, 25],
        [26, 15],
        [-14, 87],
        [-12, 7],
        [-44, 18],
        [-45, 1],
        [-16, 16],
        [45, 37],
        [58, 62],
        [2, 18],
        [20, 34],
        [71, 22],
        [34, -55],
        [46, -33],
        [70, -22],
        [36, -21],
        [102, -29],
        [26, 10],
        [41, -23],
        [35, -53],
        [8, -39],
        [49, -48],
        [57, -11],
        [28, 37],
        [-51, 40],
        [-40, 19],
        [-31, -5],
        [-3, 32],
        [64, 23],
        [37, -33],
        [16, -41],
        [21, -20],
        [55, -87],
        [14, -10],
        [20, -76],
        [-3, -38],
        [-17, -15],
        [72, -91],
        [33, -68],
        [17, -1],
        [24, -47],
        [10, -41],
        [47, -31],
        [6, -32],
        [68, -70],
        [27, -51],
        [2, -65],
        [26, -92],
        [4, -47],
        [22, -75],
        [59, -107],
        [-13, -88],
        [27, -56],
        [-12, -33],
        [37, -54],
        [-12, -22],
        [8, -45],
        [26, -55],
        [53, -21],
        [25, 31],
        [5, 115],
        [50, 30],
        [-23, 32],
        [-12, 39],
        [22, 39],
        [1, 43],
        [40, 35],
        [21, 1],
        [56, 46],
        [21, 57],
        [-15, 41],
        [2, 75],
        [-25, 41],
        [-25, 6],
        [5, 39],
        [-38, 51],
        [-33, 78],
        [-35, 19],
        [35, 29],
        [23, -23],
        [46, -26],
        [6, -44],
        [21, -55],
        [26, 43],
        [18, -44],
        [-7, -61],
        [7, -101],
        [-9, -71],
        [-31, -76],
        [-60, -114],
        [-20, -98],
        [18, -87],
        [23, -76],
        [26, -59],
        [-3, -131],
        [-11, -35],
        [-12, -124],
        [21, -103],
        [66, -64],
        [51, -3],
        [69, -43],
        [58, 15],
        [15, -32],
        [-22, -29],
        [-47, -92],
        [-36, -92],
        [-49, -148],
        [-13, -67],
        [21, -54],
        [-9, -20],
        [-42, 3],
        [-55, 17],
        [-42, -31],
        [-56, -139],
        [-34, -126],
        [-2, -43],
        [-23, -62],
        [-13, -94],
        [0, -33],
        [-32, -51],
        [-6, -64],
        [-63, -64],
        [-20, -53],
        [-4, -41],
        [-39, -116],
        [-79, -97],
        [-21, -20],
        [-43, -69],
        [-26, 0],
        [-49, -25],
        [-59, -91],
        [-43, -52],
        [-16, -49],
        [-53, -55],
        [-27, -47],
        [-5, -47],
        [12, -38],
        [-72, -39],
        [-44, -37],
        [-94, -54],
        [-47, -68],
        [-16, -79],
        [-54, -68],
        [-30, -18],
        [-34, -46],
        [-27, -4],
        [-27, -50],
        [-58, -58],
        [-33, -54],
        [-87, -96],
        [-111, -96],
        [-31, -32],
        [-49, -22],
        [-67, -79],
        [-84, -73],
        [-63, -20],
        [-17, -39],
        [-84, -56],
        [-70, -62],
        [-37, -2],
        [-21, -43],
        [-49, -19],
        [7, -25],
        [-37, -12],
        [-66, -101],
        [-42, -28],
        [-40, -46],
        [5, -19],
        [-67, -113],
        [-23, -23],
        [-43, -73],
        [-45, -45],
        [0, -49],
        [-40, -49],
        [-9, -48],
        [-22, -6],
        [-14, -62],
        [-28, -21],
        [-31, -47],
        [7, -34],
        [-17, -55],
        [-39, -86],
        [-20, 9],
        [-55, -86],
        [11, -21],
        [-18, -33],
        [-32, -2],
        [-108, -133],
        [-43, -62],
        [-39, -91],
        [-1, -21],
        [-39, -64],
        [-41, -104],
        [-20, -36],
        [-50, -153],
        [-8, -48],
        [-37, -111],
        [-22, -110],
        [4, -102],
        [-10, -81],
        [17, -106],
        [-11, -64],
        [10, -40],
        [21, -33],
        [30, 9],
        [4, -41],
        [-18, -19],
        [20, -137],
        [53, -108],
        [19, -17],
        [49, 3],
        [20, -90],
        [12, -132],
        [-30, -69],
        [7, -28],
        [-44, -63],
        [-6, -41],
        [-21, -41],
        [-35, -11],
        [-51, -37],
        [-27, -59],
        [-6, -56],
        [37, -98],
        [-38, -29],
        [-8, 42],
        [-36, 6],
        [-3, 71],
        [25, 25],
        [36, 81],
        [-11, 37],
        [27, 33],
        [73, -3],
        [15, 9],
        [12, 66],
        [48, 75],
        [-16, 44],
        [36, 53],
        [12, 4],
        [-8, 110],
        [-39, 15],
        [-39, 46],
        [-22, 3],
        [-14, 33],
        [1, 47],
        [-45, 32],
        [-27, -36],
        [33, -55],
        [17, -53],
        [-10, -65],
        [2, -39],
        [31, -37],
        [10, -63],
        [-16, -18],
        [-6, -49],
        [-54, -15],
        [-28, -43],
        [-6, -38],
        [-39, -42],
        [-29, -109],
        [-28, -18],
      ],
      [
        [143749, 34937],
        [0, -10],
        [0, -8],
        [-26, 4],
        [-21, -43],
        [-21, -4],
        [-26, -88],
        [-59, -44],
        [-22, 7],
        [-53, -7],
        [-51, -31],
        [-17, -29],
        [-48, -19],
        [-63, -61],
        [-58, -39],
        [-54, 15],
        [-114, -19],
        [-119, 4],
        [-35, -18],
        [-34, -45],
        [-26, -12],
        [11, 73],
        [-36, 16],
        [-51, -2],
        [-43, -14],
        [-15, 72],
        [-35, 4],
        [5, 36],
        [-45, -9],
        [-6, -27],
        [-95, -32],
        [-17, -61],
        [-51, -7],
        [-9, -34],
        [-30, -9],
        [-26, -40],
        [-25, 1],
        [-17, 51],
        [82, 63],
        [41, 22],
        [39, 41],
        [69, 99],
        [48, 29],
        [65, -53],
        [59, -36],
        [47, -16],
        [126, -23],
        [94, 0],
        [99, 12],
        [89, 21],
        [95, 41],
        [107, 41],
        [82, 39],
        [60, 39],
        [35, 34],
        [21, 36],
        [74, 57],
        [41, -2],
        [65, -38],
        [60, -5],
        [-2, -21],
        [-52, 2],
        [-33, -8],
        [-79, 55],
      ],
      [
        [144496, 29607],
        [24, 66],
        [49, 71],
        [130, 57],
        [8, 16],
        [41, -13],
        [31, -25],
        [-9, -21],
        [14, -43],
        [50, -37],
        [23, -1],
        [36, 33],
        [54, -7],
        [37, -18],
        [27, 23],
        [83, 8],
        [-46, 47],
        [69, -3],
        [37, 14],
        [47, -3],
        [225, 129],
        [44, 43],
        [35, -3],
        [-5, -40],
        [-23, -60],
        [-46, -98],
        [-45, -78],
        [-37, -44],
        [-25, -92],
        [-38, -60],
        [-43, -53],
        [-68, -107],
        [-51, -31],
        [-56, -86],
        [-53, -4],
        [-108, -146],
        [-15, -31],
        [-41, -37],
        [-50, -68],
        [-97, -173],
        [-25, 2],
        [-48, -46],
        [-70, -104],
        [-61, -51],
        [-23, -6],
        [-48, -60],
        [-27, -6],
        [-45, -51],
        [-28, -9],
        [-36, -35],
        [-32, 13],
        [-10, 55],
        [-28, 57],
        [-66, 16],
        [32, 49],
        [-17, 91],
        [-34, 49],
        [1, 45],
        [-19, 42],
        [-1, 50],
        [17, 126],
        [20, 64],
        [0, 33],
        [29, 42],
        [16, 49],
        [77, 86],
        [30, 80],
        [41, 59],
        [67, 129],
        [60, 61],
        [20, 45],
      ],
      [
        [145443, 33094],
        [-26, 40],
        [13, 13],
        [47, -23],
        [39, -71],
        [-17, -29],
        [-36, 35],
        [-20, 35],
      ],
      [
        [144917, 34118],
        [-18, -16],
        [-66, -18],
        [-30, -21],
        [-51, 33],
        [35, 18],
        [34, -20],
        [96, 24],
      ],
      [
        [144080, 34859],
        [39, -9],
        [73, -44],
        [-20, -28],
        [-42, 52],
        [-36, -17],
        [-14, 46],
      ],
      [
        [142216, 19255],
        [-12, 7],
        [-8, 101],
        [17, 31],
        [13, -128],
        [-10, -11],
      ],
      [
        [142191, 19487],
        [-12, 4],
        [10, 121],
        [16, -24],
        [4, -84],
        [-18, -17],
      ],
      [
        [142571, 19041],
        [-46, -34],
        [-48, -19],
        [-8, 29],
        [61, 29],
        [29, 37],
        [16, 63],
        [28, 25],
        [19, 40],
        [61, 75],
        [25, 45],
        [19, 139],
        [-5, 81],
        [-17, 85],
        [-21, 50],
        [1, 36],
        [48, 110],
        [35, 47],
        [35, -16],
        [-45, -50],
        [-44, -74],
        [16, -70],
        [34, -97],
        [-13, -177],
        [-31, -88],
        [-39, -49],
        [-6, -29],
        [-33, -63],
        [-49, -58],
        [-5, -41],
        [-17, -26],
      ],
      [
        [142813, 20120],
        [19, -25],
        [-39, -80],
        [-43, -42],
        [-34, -9],
        [-27, 36],
        [62, 30],
        [-5, 34],
        [21, 37],
        [46, 19],
      ],
      [
        [142229, 20220],
        [-7, 5],
        [35, 96],
        [42, 53],
        [-34, -108],
        [-36, -46],
      ],
      [
        [142976, 20792],
        [32, -36],
        [31, -97],
        [29, -59],
        [8, -50],
        [29, -26],
        [-6, -37],
        [-1, -160],
        [-13, -37],
        [-57, -93],
        [-10, 36],
        [35, 82],
        [3, 51],
        [16, 54],
        [-3, 44],
        [-27, 46],
        [4, 21],
        [-36, 69],
        [-57, 184],
        [23, 8],
      ],
      [
        [91407, 36103],
        [10, -20],
        [-33, -55],
        [1, -45],
        [50, 8],
        [32, -13],
        [-6, -39],
        [10, -23],
        [44, -28],
        [14, -22],
        [-6, -48],
        [36, -70],
        [-23, -15],
        [-22, 37],
        [-26, -33],
        [-47, -21],
        [-13, -35],
        [30, -34],
        [-56, -45],
        [-28, -3],
        [-24, 18],
        [-34, -52],
        [-26, -12],
        [2, -28],
        [-25, -22],
        [-29, 23],
        [-36, 8],
        [-19, -42],
        [44, 7],
        [22, -11],
        [4, -33],
        [-32, -39],
        [-20, -5],
        [-22, 78],
        [-25, 47],
        [-75, -26],
        [-35, 1],
        [-19, -19],
        [6, -34],
        [31, -1],
        [24, -29],
        [-2, -66],
        [-16, -23],
        [-36, -3],
        [-47, -51],
        [-80, -15],
        [-62, 42],
        [-20, 27],
        [-26, 1],
        [-24, -37],
        [31, -20],
        [35, 2],
        [-26, -80],
        [-25, -16],
        [-48, 7],
        [-3, -56],
        [-16, -36],
        [-29, -20],
        [36, -24],
        [44, 19],
        [24, -13],
        [7, -124],
        [-11, -56],
        [16, -60],
        [40, -21],
        [17, -47],
        [18, -108],
        [33, -27],
        [125, -77],
        [47, -2],
        [17, -29],
        [48, -11],
        [3, -20],
        [47, -43],
        [-17, -37],
        [13, -34],
        [30, -42],
        [45, -87],
        [-17, -16],
        [3, -54],
        [-11, -48],
        [14, -105],
        [-8, -57],
        [47, -16],
        [25, -29],
        [5, -27],
      ],
      [
        [77573, 35966],
        [-33, 100],
        [80, 59],
        [-10, 57],
        [36, 29],
        [-13, 41],
        [66, 17],
        [11, 45],
        [62, 24],
        [56, 38],
        [-26, 67],
        [29, 20],
        [26, -66],
        [33, 24],
        [79, 35],
        [-7, 48],
        [-87, 67],
        [37, 35],
        [81, 45],
        [25, 76],
        [52, 50],
        [17, 42],
        [36, -5],
        [16, 44],
        [44, 4],
        [15, 20],
        [153, 9],
        [-9, 50],
        [-74, -6],
        [3, 41],
        [-36, -5],
        [18, 74],
        [43, -18],
        [1, -47],
        [52, 8],
        [-22, 40],
        [7, 53],
        [-95, 42],
        [-13, -67],
        [-36, 16],
        [-15, -75],
        [-80, 12],
        [10, 39],
        [22, 26],
        [7, 37],
        [61, -2],
        [33, 19],
        [13, 112],
        [-16, 7],
        [18, 93],
        [99, 236],
        [8, 42],
        [-47, -3],
        [-16, 43],
        [-46, 121],
        [125, 164],
        [-38, 12],
        [-30, 40],
        [-65, 44],
        [-40, 45],
        [-8, 54],
        [-31, 20],
        [-29, 39],
        [-41, 19],
        [-143, 11],
        [29, 39],
        [56, 36],
        [-12, 23],
        [9, 34],
        [30, 21],
        [-33, 27],
        [-29, -2],
        [-24, 40],
        [-29, 9],
        [-40, 55],
        [-44, 85],
        [10, 107],
        [236, -28],
        [15, 183],
        [23, 223],
        [-6, 83],
        [281, -15],
        [-8, 81],
        [137, 188],
        [-5, 38],
        [-33, 57],
        [0, 65],
        [11, 23],
        [15, 85],
        [-24, 111],
        [-47, 86],
        [-9, 39],
        [-48, 38],
        [-44, 99],
        [-37, 23],
        [-14, 82],
        [-104, -26],
        [-95, 110],
        [66, 80],
        [76, 98],
        [-50, 13],
        [-150, 116],
        [-85, 48],
        [-368, -24],
        [-1, -4],
        [-27, -200],
        [-324, -221],
        [-22, -97],
        [-7, -121],
        [-62, 42],
        [-36, 14],
        [23, -173],
        [-303, -372],
        [-23, -43],
        [-63, 7],
        [-47, 24],
        [-51, 45],
        [-230, -58],
        [49, -140],
        [-166, 38],
        [-32, -16],
        [-23, -98],
        [-66, 25],
        [-6, 3],
        [-175, 144],
        [31, 61],
        [22, 108],
        [27, 85],
        [-244, 59],
        [90, 459],
        [-65, -6],
        [-332, -44],
        [-29, 23],
        [-10, 7],
        [-813, 647],
        [-72, 87],
        [-163, 210],
        [-74, 108],
        [-23, 88],
        [-143, 563],
        [-24, 140],
        [-21, 112],
        [-101, -8],
        [40, 127],
        [45, 73],
        [19, 44],
        [63, 119],
        [44, 59],
        [-72, 102],
        [-51, 86],
        [6, 199],
        [-229, 108],
        [17, 207],
        [151, -11],
        [38, 28],
        [59, 189],
        [-43, 0],
        [-28, -113],
        [-35, -56],
        [-68, -5],
        [23, 50],
        [-145, 151],
        [128, 108],
        [67, 111],
        [16, 74],
        [37, 235],
        [19, 96],
        [204, 4],
        [-12, -112],
        [23, -116],
        [104, -12],
        [0, -188],
        [212, -36],
        [101, 22],
        [408, 72],
        [1089, 370],
        [242, 208],
        [836, 720],
        [340, 288],
        [135, 116],
        [447, 395],
        [61, 77],
        [272, 237],
        [139, 119],
        [208, 167],
        [-78, 832],
        [-33, 360],
        [199, 22],
        [496, 213],
        [242, 907],
        [117, 206],
        [12, -28],
        [-14, -45],
        [-102, -161],
        [24, -38],
        [7, -48],
        [-14, -45],
        [-20, -9],
        [18, -56],
        [0, -47],
        [282, -271],
        [52, 38],
        [382, 267],
        [359, 415],
        [140, 166],
      ],
      [
        [83976, 42991],
        [-26, -156],
        [-40, 5],
        [-3, -239],
        [41, -6],
        [-26, -125],
        [216, -23],
        [-3, -120],
        [1, -5],
        [265, -150],
        [-32, -24],
        [-37, -10],
        [-11, -19],
        [-73, -14],
        [-43, -50],
        [-36, -9],
        [-23, -43],
        [24, -95],
        [-26, -20],
        [5, -31],
        [-37, -25],
        [-28, 26],
        [-27, 44],
        [-52, 10],
        [-9, -25],
        [46, -193],
        [-97, 35],
        [2, -293],
        [303, 6],
        [19, -110],
        [50, -351],
        [-314, -290],
        [-20, -15],
        [36, -57],
        [330, -125],
        [290, 118],
        [11, 9],
        [108, -10],
        [231, -7],
        [48, -14],
        [138, -74],
        [-24, -257],
        [156, -87],
        [39, -14],
        [35, 43],
        [60, 8],
        [76, -32],
        [19, 1],
        [43, -27],
        [142, 15],
        [26, 24],
        [77, 43],
        [88, 39],
        [71, -27],
        [489, -170],
        [119, -141],
        [97, 12],
        [88, 28],
        [-95, 217],
        [-7, -1],
        [-42, 144],
        [-10, 10],
        [-52, 165],
        [-23, 74],
        [219, 22],
        [19, -32],
        [71, -7],
        [132, -333],
        [30, -47],
        [101, -8],
        [108, 42],
        [50, -3],
        [11, -59],
        [26, -59],
        [20, -84],
        [200, 29],
        [38, -90],
        [-40, -9],
        [7, -31],
        [67, 5],
        [40, -104],
        [26, -71],
        [51, -91],
        [49, -159],
        [25, -52],
        [9, -63],
        [34, -151],
        [14, -10],
        [40, -118],
        [37, -52],
        [30, -102],
        [21, -1],
        [515, -29],
        [27, 0],
        [248, 43],
        [274, -54],
        [317, -58],
        [10, -51],
        [20, -53],
        [32, -2],
        [39, 2],
        [53, -36],
        [8, -27],
        [32, -19],
        [43, 15],
        [38, 45],
        [60, -13],
        [26, 17],
        [44, -10],
        [44, -26],
        [82, -17],
        [25, 20],
        [88, 2],
        [26, 21],
        [61, -9],
        [19, 13],
        [58, 0],
        [22, 11],
        [15, 49],
        [25, 14],
        [54, 1],
        [9, 31],
        [50, 13],
        [30, 28],
        [83, 38],
        [105, 7],
      ],
      [
        [90566, 38911],
        [-48, -169],
        [24, 8],
        [429, -1],
        [19, -35],
        [-16, -26],
        [14, -59],
        [68, -5],
        [0, -25],
        [44, 0],
        [0, -22],
        [90, -1],
        [-1, -49],
        [46, 0],
        [0, -46],
        [44, 0],
        [45, -14],
        [1, -27],
        [46, -34],
        [37, -1],
        [46, -35],
        [9, -37],
        [52, 38],
        [14, 42],
        [68, 3],
        [32, -56],
        [54, -51],
        [-24, -36],
        [39, -11],
        [77, 49],
        [53, -40],
        [-43, -66],
        [3, -34],
        [104, -1],
        [3, -12],
        [63, 10],
        [-6, -86],
        [81, 3],
        [119, 22],
        [-85, -103],
        [7, -31],
        [35, -29],
        [5, -64],
        [-11, -46],
        [-35, -7],
        [-50, -30],
        [-256, -182],
        [-27, -11],
        [-67, -78],
        [-5, -38],
        [-27, -15],
        [86, -68],
        [-30, -41],
        [-33, -20],
        [8, -49],
        [-38, -19],
        [-7, -55],
        [32, -34],
        [-4, -28],
        [-34, -9],
        [-18, -35],
        [13, -45],
        [-22, -29],
        [1, -31],
        [-50, -73],
        [-21, -76],
        [-46, -10],
        [-38, -28],
        [64, -87],
        [-28, -19],
        [-60, -11],
        [-36, 8],
        [-81, 55],
        [-36, 33],
        [-52, -21],
        [-66, -55],
        [-26, -14],
        [-48, 34],
        [-58, 8],
        [-19, -46],
        [8, -51],
        [17, -33],
        [34, -26],
        [59, -22],
        [65, 29],
        [46, 57],
        [55, 4],
        [22, -10],
        [43, -64],
        [20, -45],
        [-17, -17],
        [-29, 16],
        [-103, 36],
        [-57, -9],
        [-14, -65],
        [53, -1],
        [46, -22],
        [55, 9],
        [10, -46],
        [-38, -50],
        [-15, 2],
        [-57, 44],
        [-14, -38],
        [-32, -44],
        [20, -82],
        [-34, -62],
        [15, -9],
        [62, 24],
        [16, -12],
        [27, -79],
        [15, -69],
        [19, -37],
        [23, 2],
        [69, 70],
        [29, -5],
      ],
      [
        [48478, 49371],
        [-25, -4],
        [-10, 93],
        [-63, 74],
        [-129, 73],
        [-41, 43],
        [-92, 39],
        [-95, 58],
        [-130, 85],
        [-167, 128],
        [-57, 56],
        [-46, 62],
        [-42, 80],
        [-5, 86],
        [13, 65],
        [-5, 67],
        [-26, 52],
        [-54, 71],
        [-59, 60],
        [-111, 87],
        [10, 24],
        [-93, 146],
        [-76, 27],
        [-70, 46],
        [-24, 110],
        [-42, 99],
        [-82, 139],
        [-160, 292],
        [-58, 88],
        [-64, 122],
        [-81, 123],
        [-77, 90],
        [-87, 87],
        [-86, 74],
        [-89, 64],
        [-97, 56],
        [-56, 70],
        [5, 36],
        [20, 8],
        [-107, 220],
        [-120, 88],
        [-56, 30],
        [-37, 69],
        [-144, 182],
        [-69, 65],
        [-105, 70],
        [-101, 48],
        [-4, 9],
        [-179, 82],
        [-159, 77],
        [-164, 67],
        [-216, 79],
        [-174, 51],
        [-171, 36],
        [-85, 14],
        [-26, 19],
        [-216, 5],
        [-181, 99],
        [-141, 75],
        [-72, 31],
        [-126, 48],
        [-118, 30],
        [-119, 25],
        [-104, 16],
        [-161, 13],
        [-29, 33],
        [-37, 74],
        [-57, 33],
        [-81, 91],
        [-67, 41],
        [-23, 78],
        [-95, 102],
        [-65, 78],
        [-201, 78],
        [-40, 100],
        [-60, 82],
        [-92, 80],
        [-96, 61],
        [-118, 46],
        [-118, 33],
        [-65, 13],
        [-175, 13],
        [-56, -7],
        [-134, -39],
        [-111, -4],
        [11, 27],
        [7, 132],
        [-8, 38],
        [-34, 41],
        [0, 74],
        [-15, 83],
        [-17, 132],
        [-14, 54],
        [-39, 97],
        [-24, 40],
        [-47, 133],
        [24, 54],
        [29, 148],
        [14, 117],
        [-19, 59],
        [9, 39],
        [-62, 90],
        [-26, 57],
        [-34, 125],
        [61, 250],
        [120, 292],
        [39, 54],
        [56, 93],
        [17, 11],
        [113, 167],
        [70, 110],
        [123, 214],
        [32, 62],
        [53, 119],
        [15, 49],
        [27, 186],
        [14, 26],
        [120, 118],
        [41, 45],
        [-29, 37],
      ],
      [
        [41879, 58254],
        [47, -18],
        [149, 90],
        [26, 43],
        [80, -14],
        [19, -39],
        [29, -26],
        [47, -76],
        [30, -23],
        [60, 0],
        [80, -29],
        [17, -19],
        [47, 8],
        [6, 21],
        [89, 48],
        [60, 65],
        [8, 52],
        [19, 5],
        [25, 67],
        [27, 31],
        [293, 222],
        [12, -11],
        [247, -40],
        [62, -9],
        [125, 130],
        [-4, 25],
        [132, -75],
        [98, 131],
        [-73, 72],
        [125, 97],
        [51, 27],
        [0, 21],
        [-59, 47],
        [-28, -29],
        [-266, -5],
        [106, 52],
        [84, 302],
        [222, 67],
        [85, 29],
        [87, -27],
        [51, 41],
        [-1, 33],
        [195, 67],
        [108, 0],
        [1, -32],
        [146, -1],
        [-1, 277],
        [54, 47],
        [17, 27],
        [28, 56],
        [124, 36],
        [-6, 53],
        [-20, 16],
        [23, 54],
        [13, 84],
        [48, 17],
        [13, 25],
        [65, 2],
        [17, 78],
        [-8, 35],
        [22, 44],
        [57, -1],
        [13, 11],
        [5, 76],
        [-14, 65],
        [27, 18],
        [47, -73],
        [60, 12],
        [15, 38],
        [53, 48],
        [1, 24],
        [-61, 18],
        [-25, 23],
        [-12, 37],
        [15, 36],
        [36, 11],
        [64, 78],
        [51, 174],
        [20, 10],
        [233, 440],
        [195, 28],
        [-345, 50],
        [-14, 5],
      ],
      [
        [57974, 39564],
        [3, 19],
        [-23, 44],
        [-53, 136],
        [-57, 113],
        [-44, 80],
        [-117, 183],
        [-103, 130],
        [-123, 138],
        [-156, 157],
        [-153, 146],
        [-121, 103],
        [-157, 111],
        [-137, 92],
        [-31, -9],
        [-129, 184],
        [-210, 258],
        [-180, 215],
        [-126, 142],
        [-126, 135],
        [-94, 96],
        [-104, 99],
        [-58, 50],
        [-157, 120],
        [-98, 113],
        [-93, 91],
        [-228, 202],
        [-49, 38],
        [-45, 19],
        [-37, 0],
        [-11, -42],
        [-46, 8],
        [-19, 49],
        [-4, 94],
        [26, 1],
        [9, 36],
        [-22, 40],
        [-45, 44],
        [-77, 42],
        [-21, 53],
        [-42, 42],
        [1, 54],
        [-27, 59],
        [-66, 79],
        [-34, 32],
        [50, 16],
        [15, 38],
        [-5, 44],
        [-63, 101],
        [-82, 109],
        [-53, 83],
        [-61, 76],
        [-149, 152],
        [-110, 91],
        [-20, 29],
        [-94, 89],
        [-51, 40],
        [9, 76],
        [-85, 85],
        [-34, 20],
        [-108, 102],
        [-22, 8],
        [-19, 48],
        [4, 32],
        [-48, 63],
        [-42, 40],
        [-114, 87],
        [-111, 69],
        [-49, 21],
        [-21, 40],
        [-58, 49],
        [-58, 59],
        [-75, 42],
        [-7, 31],
        [29, 6],
        [15, 33],
        [33, 28],
        [-8, 62],
        [-32, 53],
        [-85, 115],
        [-115, 109],
        [18, 53],
        [-21, 41],
        [-65, 75],
        [-52, 65],
        [-40, 40],
        [-18, 137],
        [-23, 77],
        [-58, 62],
        [-86, 86],
        [-119, 127],
        [-123, 118],
        [-170, 170],
        [-64, 56],
        [-139, 125],
        [-277, 236],
        [-142, 121],
        [-95, 75],
        [-103, 72],
        [-22, 24],
        [4, 27],
        [-227, 153],
        [-277, 197],
        [-122, 82],
        [-356, 219],
        [-15, 40],
        [-134, 118],
        [-140, 111],
        [-21, 21],
        [-176, 129],
        [-487, 342],
        [-139, 96],
        [-290, 193],
        [-160, 96],
        [-127, 63],
        [-95, 36],
        [-49, 36],
        [-31, 52],
        [11, 34],
        [-58, 60],
      ],
      [
        [45977, 52513],
        [30, -25],
        [-34, -22],
        [-46, 47],
        [5, 45],
        [45, -45],
      ],
      [
        [45922, 52569],
        [-33, 38],
        [24, 22],
        [9, -60],
      ],
      [
        [41879, 58254],
        [-14, 52],
        [28, 141],
        [8, 79],
        [6, 185],
        [-9, 144],
        [-14, 90],
        [-33, 158],
        [-16, 50],
        [-41, 93],
        [-61, 101],
        [-100, 129],
        [-92, 83],
        [-125, 80],
        [-104, 161],
        [-75, 81],
        [-83, 63],
        [-122, 52],
        [-144, 19],
        [-55, 39],
        [-35, -26],
        [-10, -42],
        [-136, 56],
        [-157, 36],
        [-160, 24],
        [-120, 8],
        [-63, -2],
        [-83, -11],
        [-35, -14],
        [-17, -32],
        [5, -24],
        [-31, -26],
        [-86, 14],
        [-191, 81],
        [-71, 34],
        [-105, 38],
        [-39, 29],
        [-32, 44],
        [-62, 47],
        [-101, 91],
        [-76, 86],
        [-83, 137],
        [-18, 57],
        [-23, 127],
        [-30, 96],
        [-22, 132],
        [-20, 59],
        [-35, 76],
        [-24, 83],
        [-21, 41],
        [-91, 135],
        [-73, 80],
        [-58, 75],
        [-19, 42],
        [4, 32],
        [29, 25],
        [-8, 42],
        [-18, 20],
        [-46, 104],
        [-54, 56],
        [-82, 48],
        [-155, 66],
        [-64, 8],
        [-59, 26],
        [-66, -13],
        [-96, 80],
        [-38, 23],
        [-35, 18],
        [-87, 28],
        [-147, 30],
        [-162, 42],
        [-157, 37],
        [-81, 12],
        [-233, 57],
        [-99, 37],
        [-116, 84],
        [-61, 77],
        [-85, 77],
        [-101, 103],
        [-82, 96],
        [-84, 81],
        [-83, 55],
        [-67, 35],
        [-81, 30],
        [-107, 24],
        [-95, 3],
        [-33, 9],
        [-58, -29],
        [-118, 58],
        [-101, 30],
        [-39, 17],
        [-48, 55],
        [-18, 141],
        [11, 82],
        [28, 126],
        [8, 61],
        [-4, 63],
        [15, 11],
        [12, 116],
        [2, 97],
        [12, 151],
        [0, 131],
        [-11, 52],
        [-22, 41],
        [-63, 172],
        [-61, 156],
        [-21, 92],
        [5, 86],
        [12, 59],
        [28, 80],
        [38, -16],
        [18, 66],
        [16, 122],
        [-14, 57],
        [4, 47],
        [-22, 55],
        [-7, 93],
        [-30, 131],
        [-2, 80],
        [28, 44],
        [51, 48],
        [35, 54],
        [24, 69],
        [22, -18],
        [69, 34],
        [33, -34],
        [30, 5],
        [39, 37],
        [39, -21],
        [69, 21],
        [-25, 41],
        [-44, 11],
        [-55, 38],
        [-50, 61],
        [-89, 46],
        [-61, 12],
        [-70, 17],
        [-32, 0],
        [-80, -30],
        [-54, 29],
        [8, 58],
        [-64, 26],
        [-18, -62],
        [43, -3],
        [17, -39],
        [41, -9],
        [43, -60],
        [-124, 93],
        [-83, 18],
        [-31, -13],
        [-94, 51],
        [-120, 39],
        [-146, 33],
        [-109, 16],
        [-127, 4],
        [-25, 84],
        [-60, 91],
        [-83, -9],
        [-38, -26],
        [-32, -39],
        [9, -23],
        [-20, -45],
        [-24, 2],
        [9, -50],
        [-52, 43],
        [-40, -8],
        [-35, -76],
        [-21, 3],
        [-37, -76],
        [93, 30],
        [10, -12],
        [51, 13],
        [36, 21],
        [39, -9],
        [-12, -30],
        [-37, -29],
        [18, -28],
        [-3, -29],
        [-38, -60],
        [-16, -58],
        [-36, -32],
        [-45, 41],
        [-43, 0],
        [-17, 59],
        [-93, 6],
        [5, 42],
        [-40, 20],
        [-29, -53],
        [-44, -7],
        [-1, 53],
        [-18, 46],
        [-39, 33],
        [-2, 23],
        [36, 41],
        [38, 13],
        [6, 41],
        [-26, 37],
        [-52, -13],
        [-30, 14],
        [-45, 98],
        [-5, 42],
        [-85, 33],
        [-103, 3],
        [-87, -32],
        [-1, -16],
        [-46, -20],
        [-48, -90],
        [-28, 46],
        [-53, -22],
        [-62, 23],
        [-19, -25],
        [-41, 4],
        [26, 45],
        [25, 21],
        [-17, 47],
        [-80, 53],
        [-21, 34],
        [-65, 23],
        [-37, 22],
        [-110, 18],
        [-46, 23],
        [-31, 57],
        [-7, 37],
        [-33, 47],
        [-24, -4],
        [-48, 48],
        [-21, 47],
        [-50, 27],
        [-80, 17],
        [-14, 39],
        [-59, -11],
        [18, 33],
        [-38, 49],
        [-33, 26],
        [-47, 15],
        [21, 33],
        [-37, 11],
        [-19, 118],
        [-75, 87],
        [-27, 40],
        [-41, 13],
        [9, 33],
        [-31, 32],
        [-37, 18],
        [-25, 70],
        [11, 70],
        [-22, 63],
        [-34, 50],
        [-112, 52],
        [-40, -2],
        [-5, 41],
        [24, 28],
        [-14, 33],
        [-36, 21],
        [-24, 27],
        [15, 32],
        [-22, 70],
        [-107, 48],
        [-11, 34],
        [-43, -3],
        [3, 25],
        [-37, 11],
        [-12, 28],
        [-48, 35],
        [-13, -9],
        [-40, 59],
        [22, 36],
        [-38, 83],
        [17, 30],
        [-7, 65],
        [-29, 41],
        [-37, 34],
        [-86, 57],
        [-61, 27],
        [-151, 59],
        [-100, 21],
        [-102, 32],
        [-96, 48],
        [-98, 42],
        [-73, 40],
        [-53, 19],
        [-226, 48],
        [-53, 20],
        [4, 94],
        [-10, 56],
        [-19, 44],
        [-55, 83],
        [-34, 31],
        [-19, 68],
        [-31, 65],
        [-25, 86],
        [-35, 62],
        [-18, 71],
        [-44, 71],
        [-65, 64],
        [-61, 46],
        [-203, 127],
        [-106, 81],
        [-47, 46],
        [-24, 40],
        [-108, 70],
        [-1, 32],
        [-80, 48],
        [1, 58],
        [-38, 37],
        [2, 20],
        [-59, 49],
        [-14, 30],
        [19, 25],
        [66, -10],
        [56, 36],
        [80, 90],
        [-63, 16],
        [-87, 119],
        [-36, 32],
        [-43, 16],
        [-51, 62],
        [-95, 58],
        [-69, 23],
        [-156, 34],
        [2, 50],
        [-16, 52],
        [-67, 27],
        [-12, 27],
        [18, 39],
        [-64, 57],
        [-39, 13],
        [-23, 34],
        [-22, 6],
        [-54, 74],
        [-24, 75],
        [-57, 41],
        [-98, 14],
        [-92, -5],
        [-79, 18],
        [-25, 29],
        [92, 64],
        [12, 49],
        [-14, 39],
        [-47, 73],
        [-18, 39],
        [5, 75],
        [-25, 42],
        [16, 65],
        [-9, 54],
        [-24, 16],
        [-37, -4],
        [7, 42],
        [55, 93],
        [24, 62],
        [-31, 80],
        [-57, 107],
        [-70, 21],
        [24, 61],
        [-39, 47],
        [-44, 4],
        [-65, -11],
        [-17, 13],
        [18, 55],
        [34, 60],
        [11, 54],
        [33, 119],
        [-6, 104],
        [-25, 73],
        [-41, 70],
        [-37, 96],
        [-36, 46],
        [-70, 49],
        [-92, 25],
        [-47, 1],
        [-101, -16],
        [-150, -53],
        [-24, -22],
        [-27, 32],
        [-43, 21],
        [-62, 9],
        [-91, 32],
        [-38, 24],
        [-45, 61],
        [-8, 69],
        [-31, 54],
        [15, 47],
        [51, 79],
        [62, 116],
        [59, 153],
        [11, 61],
        [0, 68],
        [-40, 79],
        [-38, 30],
        [-32, -2],
        [-48, 18],
        [-76, 68],
        [4, 44],
        [-14, 25],
        [13, 62],
        [-33, 64],
        [-44, 49],
        [-31, 15],
        [-41, 48],
        [-77, 47],
        [-27, 55],
        [-41, 30],
        [-11, 30],
        [-56, 32],
        [-7, 47],
        [-67, 95],
        [-1, 48],
        [-18, 38],
        [-37, 33],
        [-16, 47],
        [-62, 67],
        [-34, -5],
        [-97, 78],
        [-25, 86],
        [-2, 43],
        [-29, 53],
        [-31, 28],
        [-2, 39],
        [-23, 26],
        [-5, 57],
        [-88, 111],
        [-18, 42],
        [-58, 46],
        [-11, 32],
        [-35, 44],
        [9, 69],
        [-2, 57],
        [-28, 85],
        [-60, 91],
        [-48, 35],
        [-129, 39],
        [-43, -8],
        [-41, -26],
        [-34, 0],
        [-42, 24],
        [-25, 39],
        [2, 27],
        [29, 59],
        [12, 46],
        [-15, 37],
        [-2, 48],
        [36, 120],
        [6, 77],
        [-24, 27],
        [0, 49],
        [-39, 117],
        [-47, 61],
        [-19, 42],
        [-5, 41],
        [8, 65],
        [19, 73],
        [12, 88],
        [-4, 50],
        [9, 131],
        [0, 84],
        [-15, 93],
        [-28, 79],
        [-64, 113],
        [-87, 99],
        [-57, 55],
        [-94, 57],
        [-92, 14],
        [-43, -29],
        [-21, 20],
        [38, 46],
        [24, 88],
        [6, 48],
        [4, 119],
        [-3, 91],
        [-13, 103],
        [-33, 129],
        [-37, 90],
        [-54, 94],
        [-75, 91],
        [-30, 49],
        [-209, 217],
        [-140, 119],
        [-57, 34],
        [-146, 219],
        [-95, 132],
        [-56, 101],
        [-118, 197],
        [-48, 102],
        [-28, 96],
        [-49, 249],
        [-64, 183],
        [-38, 85],
        [3, 25],
        [41, 52],
        [27, 79],
        [49, 238],
        [13, 116],
        [6, 179],
        [2, 92],
        [-20, 97],
        [-59, 162],
        [-50, 115],
        [-18, 65],
        [36, 28],
        [13, -22],
        [-16, -66],
        [18, -55],
        [46, -91],
        [36, -38],
        [8, -40],
        [34, 18],
        [25, 37],
        [35, 14],
        [42, 44],
        [28, 45],
        [7, 45],
        [7, 148],
        [-45, 109],
        [-42, 197],
        [-14, 22],
        [1, 44],
        [15, 19],
        [-56, 19],
        [-39, 95],
        [-16, 73],
        [-40, 51],
        [-46, -40],
        [-167, 77],
        [-149, 76],
        [-61, 43],
        [-22, 45],
        [-63, 4],
        [-23, -10],
        [-134, 6],
        [-96, 29],
        [-187, 46],
        [-29, 12],
        [-142, 34],
        [-159, 32],
        [-123, 17],
        [-68, 21],
        [-11, 24],
        [-59, -16],
        [-424, 76],
        [-39, 2],
        [-28, 26],
        [14, 50],
        [-27, 21],
        [-54, 21],
        [-163, 28],
        [-94, 4],
        [-58, 43],
        [-31, 41],
        [21, 12],
        [26, -26],
        [56, -5],
        [33, 26],
        [13, 55],
        [0, 40],
        [-13, 67],
        [-27, 56],
        [6, 12],
        [-23, 65],
        [-66, 123],
        [-1, 46],
        [23, 29],
        [9, 36],
        [-17, 41],
        [-3, 37],
        [-21, 45],
        [-48, 60],
        [-72, 73],
        [-51, 40],
        [-62, 35],
        [-250, 118],
        [-100, 45],
        [-15, 31],
        [-48, 9],
        [9, 21],
        [-53, 9],
        [-35, -9],
        [-65, 12],
        [-145, 84],
        [-51, 56],
        [-17, -2],
        [-60, -37],
        [-35, 22],
        [-3, 30],
        [-92, 44],
        [-77, -12],
        [-9, -27],
        [-83, 20],
        [-70, 35],
        [-48, 34],
        [-24, 56],
        [-66, 15],
        [-5, -29],
        [19, -90],
        [19, -29],
        [-11, -62],
        [5, -53],
        [57, -7],
        [7, -45],
        [-15, -38],
        [-70, -52],
        [1, -41],
        [-42, -58],
        [-86, -28],
        [-49, 43],
        [-24, -25],
        [15, -30],
        [-32, -97],
        [0, -44],
        [-37, -9],
        [-77, 1],
        [-105, 16],
        [-211, -6],
        [-132, 5],
        [-70, 16],
        [-128, 47],
        [-72, 33],
        [-59, 47],
        [-71, 40],
        [-168, 61],
        [-35, 19],
        [-98, 70],
        [-45, 54],
        [-78, 52],
        [8, 40],
        [-58, 46],
        [-82, 34],
        [-52, 35],
        [-98, 52],
        [-28, 20],
        [-64, 19],
        [-50, 35],
        [-60, 29],
        [-74, 16],
        [-7, 50],
        [-68, 53],
        [-125, 29],
        [-14, 24],
        [-64, 35],
        [14, 22],
        [-30, 26],
        [-69, 23],
        [-2, 26],
        [-64, 54],
        [-57, 86],
        [-43, 28],
        [-69, 32],
        [-64, 43],
        [-112, 29],
        [-61, 5],
        [-241, -13],
        [-48, 11],
        [-138, 70],
        [-32, 33],
        [-34, 72],
        [-25, 34],
        [-81, 65],
        [-38, 13],
        [-86, 10],
        [-81, -15],
        [-10, -16],
      ],
      [
        [16333, 88767],
        [150, -47],
        [523, -169],
        [716, -232],
        [1026, -337],
        [113, -34],
        [233, -79],
        [384, -127],
        [90, -25],
        [60, -25],
        [480, -160],
        [195, -62],
        [189, -64],
        [1111, -370],
        [417, -140],
        [642, -218],
        [1043, -352],
        [922, -304],
        [916, -300],
        [833, -274],
        [355, -116],
        [728, -242],
        [222, -74],
        [1039, -347],
        [547, -185],
        [712, -241],
        [821, -279],
        [49, -18],
        [346, -118],
        [505, -172],
        [632, -219],
        [553, -190],
        [639, -220],
        [566, 1],
        [479, 5],
        [676, -3],
        [528, -4],
        [451, -1],
        [407, 2],
        [277, 4],
        [881, 4],
        [922, 0],
        [923, 0],
        [786, -1],
        [1209, 1],
        [732, -4],
        [903, -6],
        [720, 0],
        [204, 1],
      ],
      [
        [34651, 66400],
        [-13, 21],
        [-68, 56],
        [-16, -29],
        [-42, 0],
        [-8, -34],
        [17, -52],
        [30, 1],
        [42, -31],
        [71, 5],
        [-13, 63],
      ],
      [
        [16948, 85125],
        [60, 6],
        [130, 1],
        [119, -14],
        [61, -26],
        [16, -16],
        [-26, -59],
        [-60, -35],
        [-78, 18],
        [-148, 63],
        [-88, 49],
        [14, 13],
      ],
      [
        [32128, 66430],
        [20, -15],
        [36, -80],
        [-40, 7],
        [-31, 20],
        [-29, 50],
        [-8, 46],
        [10, 31],
        [42, -59],
      ],
      [
        [27925, 70159],
        [27, -31],
        [13, -36],
        [-22, -22],
        [-18, 89],
      ],
      [
        [26726, 70169],
        [23, -7],
        [8, -58],
        [20, -23],
        [-20, -56],
        [1, -73],
        [-28, -62],
        [-91, -29],
        [-133, 31],
        [-18, 65],
        [-20, 25],
        [-15, 158],
        [83, 35],
        [112, -14],
        [60, 27],
        [18, -19],
      ],
      [
        [27928, 72618],
        [11, -36],
        [38, -32],
        [8, -30],
        [33, -8],
        [8, -42],
        [38, -13],
        [-40, -41],
        [7, -53],
        [-24, -48],
        [15, -52],
        [-15, -57],
        [2, -30],
        [27, -38],
        [47, -35],
        [68, -90],
        [8, -26],
        [30, -12],
        [3, -44],
        [23, -28],
        [27, -55],
        [-3, -29],
        [24, -52],
        [38, -38],
        [23, -53],
        [7, -51],
        [43, -23],
        [-34, -29],
        [-11, -63],
        [-29, -35],
        [-25, -145],
        [2, -107],
        [-25, -79],
        [-33, -68],
        [-8, -53],
        [-41, -42],
        [-13, -31],
        [20, -40],
        [-7, -44],
        [-81, -68],
        [-5, -74],
        [-64, -90],
        [-15, -40],
        [6, -26],
        [-15, -36],
        [18, -26],
        [6, -41],
        [-9, -28],
        [90, -59],
        [-60, -39],
        [-47, 21],
        [-83, -40],
        [-64, -70],
        [-21, 35],
        [-25, 9],
        [-38, 37],
        [-72, 17],
        [-82, -27],
        [-15, 60],
        [-43, 1],
        [-63, 23],
        [-17, 34],
        [-29, 16],
        [-43, 53],
        [-42, 5],
        [-44, -13],
        [-50, 25],
        [-96, -4],
        [-44, 27],
        [-5, 52],
        [-19, 19],
        [-62, 7],
        [-40, 18],
        [-19, 40],
        [-42, 29],
        [-46, 12],
        [-89, 49],
        [-31, 8],
        [-51, 66],
        [-43, 14],
        [-39, -12],
        [-43, 44],
        [56, 12],
        [28, 41],
        [61, 22],
        [153, 111],
        [47, 46],
        [27, 72],
        [53, 50],
        [13, 61],
        [-29, 44],
        [16, 29],
        [-15, 57],
        [-36, 36],
        [-5, 64],
        [-18, 30],
        [18, 48],
        [-12, 90],
        [20, 32],
        [-4, 39],
        [-22, 33],
        [50, 41],
        [15, 65],
        [-9, 58],
        [14, 29],
        [12, 64],
        [1, 76],
        [40, 39],
        [21, 152],
        [30, 31],
        [30, 64],
        [44, 48],
        [45, -7],
        [24, 17],
        [50, -53],
        [65, -18],
        [54, 19],
        [59, 46],
        [71, 66],
        [49, 38],
        [77, 3],
        [21, 10],
        [34, -17],
        [39, 10],
        [37, -3],
        [23, 16],
        [47, -2],
        [40, 15],
      ],
      [
        [113849, 13752],
        [-50, 34],
        [-26, 4],
        [-14, -48],
        [-66, 25],
        [-12, 67],
        [39, 35],
        [-143, 107],
        [-86, 60],
        [-10, 32],
        [-33, 46],
        [52, 38],
        [22, 75],
        [26, 6],
        [19, 39],
        [69, -3],
        [22, 65],
        [51, 17],
        [-33, 29],
        [24, 40],
        [-1, 44],
        [15, 73],
        [27, 65],
        [32, 31],
        [-47, 70],
        [44, 37],
        [-10, 84],
        [26, 64],
        [-45, 26],
        [1, 34],
        [-49, 4],
        [-32, -12],
        [-49, 51],
        [-55, 19],
        [-8, 37],
        [-57, 51],
        [-8, 32],
        [-59, 16],
        [-3, 67],
        [-42, 6],
        [6, 58],
        [-32, -13],
        [-65, 45],
        [-38, 10],
        [3, 27],
        [33, 23],
        [-13, 35],
        [-37, 2],
        [-18, 37],
        [-10, 56],
        [27, 48],
        [-74, 1],
        [-16, 26],
        [-32, -15],
        [-2, 36],
        [-51, 5],
        [-39, 27],
        [-82, -22],
        [-7, 40],
        [9, 27],
        [-34, 18],
        [-32, -37],
        [-20, 45],
        [-48, 40],
        [-43, -26],
        [-10, 27],
        [-79, 22],
        [-33, -38],
        [-26, 50],
        [-23, 14],
        [32, 39],
        [15, 47],
        [-4, 45],
        [-28, 17],
        [-32, -14],
        [-70, 0],
        [-22, -18],
        [-26, 22],
        [-47, -24],
        [-41, 18],
        [-42, -4],
        [-12, 64],
        [-69, 80],
        [14, 27],
        [-11, 57],
        [-19, 21],
        [11, 40],
        [-50, 31],
        [24, 32],
        [-5, 34],
        [36, 17],
        [-57, 55],
        [-47, 31],
        [-24, 1],
        [-21, -48],
        [-36, 12],
        [-46, -22],
        [-44, 21],
        [-25, -16],
        [-29, 21],
        [-46, 86],
        [-67, 40],
        [-11, -17],
        [-49, -13],
        [-84, 25],
        [9, 37],
        [-8, 31],
        [15, 43],
        [-8, 38],
        [-27, 25],
        [13, 52],
        [-24, 57],
        [-7, 47],
        [18, 73],
        [2, 35],
        [-20, 11],
        [6, 38],
        [46, 11],
        [-9, 39],
        [50, 37],
        [12, -32],
        [29, 33],
        [-20, 50],
        [11, 31],
        [-13, 37],
        [-20, 3],
        [-42, -29],
        [-15, 13],
        [18, 74],
        [-15, 43],
        [24, 59],
        [17, 79],
        [-47, 52],
        [-31, 11],
        [-27, 35],
        [5, 24],
        [60, 35],
        [-2, 58],
        [-57, 44],
        [-21, 72],
        [-2, 36],
        [12, 75],
        [19, 49],
        [-13, 42],
        [-28, 33],
        [-30, -1],
        [-36, -35],
        [-39, 3],
        [-16, 42],
        [-3, 116],
        [-1, 69],
      ],
      [
        [111447, 18189],
        [14, 14],
        [120, 34],
        [294, 96],
        [313, 108],
        [140, 51],
        [375, 122],
        [36, -5],
        [44, 43],
        [93, 29],
        [203, 76],
        [157, 56],
        [89, 36],
        [64, 20],
        [302, 116],
        [178, 61],
        [69, 10],
        [13, 20],
        [64, 15],
        [207, 61],
        [141, 39],
        [111, 27],
        [210, 43],
        [140, 20],
        [116, 3],
        [180, 14],
        [197, 9],
        [247, 2],
        [82, 9],
        [30, -11],
        [73, -1],
        [2, -29],
        [48, 2],
        [-6, 39],
        [61, 4],
        [345, 4],
        [29, -2],
        [128, -43],
        [72, -9],
        [144, -4],
        [181, 10],
        [240, 23],
        [94, 18],
        [94, 27],
        [149, 56],
        [79, 35],
        [107, 60],
        [72, 50],
        [78, 63],
        [76, 71],
        [68, 74],
        [113, 151],
        [13, 29],
        [74, 117],
        [14, 42],
        [-10, 27],
        [66, 77],
        [49, -33],
        [51, -12],
        [95, 6],
        [239, 39],
        [119, 25],
        [296, 79],
        [90, 33],
        [67, 20],
      ],
      [
        [125897, 16226],
        [-2, -1555],
        [1, -384],
        [2, -851],
        [-302, 1],
        [-715, 0],
        [-321, 3],
        [-305, -4],
        [-435, 0],
      ],
      [
        [94712, 43194],
        [0, -98],
        [10, -236],
        [5, -180],
        [5, -60],
        [-1, -98],
        [9, -131],
        [8, -194],
        [-2, -87],
        [5, -233],
        [-7, -204],
        [-11, -75],
        [-5, -143],
        [-1, -127],
        [-17, -111],
        [-16, -60],
        [-11, -78],
        [-40, -182],
        [-19, -73],
        [-82, -211],
        [-68, -155],
        [-26, -94],
        [-31, -56],
        [-20, -68],
        [-33, -62],
        [-39, -188],
        [-25, -221],
        [-4, -150],
        [3, -155],
        [24, -116],
        [-20, -1],
        [0, -81],
        [15, -118],
        [46, -224],
        [33, -138],
        [31, -111],
        [53, -159],
        [23, -64],
        [48, -95],
        [85, -133],
        [5, -21],
      ],
      [
        [94642, 38203],
        [-37, -10],
        [-87, -43],
        [-61, -38],
        [-34, -30],
        [-20, -38],
        [-6, -88],
        [-33, -27],
        [-30, 3],
        [-200, 73],
        [-13, 37],
        [-30, 23],
        [-56, 19],
        [-4, 48],
        [-78, 30],
        [14, 77],
        [-104, 86],
        [-12, 34],
        [-68, 11],
        [-35, 26],
        [-37, 0],
        [-27, -43],
        [-35, 22],
        [12, 27],
        [-2, 47],
        [66, -38],
        [61, 116],
        [1, 25],
        [-29, 27],
        [-39, 14],
        [-17, 42],
        [-55, -8],
        [-48, 23],
        [-37, -3],
        [-42, 29],
        [-47, -11],
        [-70, -2],
        [-20, -41],
        [-58, -1],
        [-28, 23],
        [-35, 84],
        [-50, 20],
        [-44, -33],
        [-32, 60],
        [-1, 78],
        [-121, 67],
        [-59, 27],
        [-67, -9],
        [-25, 29],
        [-66, 28],
        [-22, 44],
        [7, 41],
        [-51, 45],
        [31, 71],
        [-8, 31],
        [-62, -24],
        [-25, 25],
        [-34, 7],
        [-38, -45],
        [-23, 5],
        [-26, 33],
        [-35, 9],
        [-19, -12],
        [-16, -69],
        [-30, -24],
        [-50, -15],
        [-21, 7],
        [-28, 73],
        [-37, 21],
        [-43, -33],
        [-36, 37],
        [-48, -17],
        [26, -44],
        [8, -44],
        [-42, -37],
        [-26, -54],
        [4, -25],
        [41, -17],
        [17, -46],
        [-17, -43],
        [2, -45],
        [-17, -11],
        [-35, 37],
        [-69, -44],
        [-51, -1],
        [-11, 38],
        [25, 15],
        [-20, 36],
        [-22, -12],
        [-56, -69],
        [-33, -15],
        [-39, 6],
        [-11, 41],
        [26, 28],
        [5, 84],
        [-24, 20],
        [-23, -14],
        [-14, -44],
        [-60, -62],
        [-42, 63],
        [-63, 0],
        [3, 92],
        [-49, 5],
        [-27, -62],
        [-57, -37],
        [-27, 10],
        [12, 45],
        [-22, 27],
        [-75, -17],
        [-25, 10],
        [-15, -11],
        [-48, 20],
        [-36, -40],
        [-6, -41],
        [-34, -7],
        [-20, -24],
        [-69, -3],
        [-26, -29],
        [-69, -3],
        [-29, 9],
        [-35, -37],
        [-36, 11],
        [-32, -7],
        [-77, 38],
        [-10, 24],
        [-37, 2],
        [-21, -26],
        [-24, -2],
        [-44, 58],
        [-134, -49],
        [-27, 9],
      ],
      [
        [85704, 64971],
        [25, -57],
        [57, -48],
        [52, -11],
        [8, 30],
        [27, 36],
        [15, -33],
        [38, -17],
        [50, 6],
        [29, -17],
        [20, -31],
        [-37, -69],
        [50, -35],
        [35, 5],
        [48, -17],
        [65, 32],
        [-19, 34],
        [10, 18],
        [54, -31],
        [47, 22],
        [34, -11],
        [17, -55],
        [70, -56],
        [-5, -75],
        [77, 25],
        [29, 36],
        [63, -44],
        [27, -73],
        [34, -62],
        [56, -32],
        [20, -28],
        [-8, -41],
        [-25, -23],
        [-15, -44],
        [-2, -55],
        [-14, -56],
        [2, -45],
        [-16, -62],
        [15, -18],
        [50, 13],
        [59, 5],
        [55, -22],
        [37, -33],
        [12, -46],
        [-17, -21],
        [-3, -40],
        [-47, -69],
        [-11, -64],
        [37, -135],
        [-8, -69],
        [-16, -36],
        [5, -49],
        [-50, -76],
        [-23, -69],
        [16, -62],
        [-10, -20],
        [-69, -56],
        [-44, -3],
        [-29, -31],
        [3, -26],
        [33, -33],
        [36, -10],
        [77, 11],
        [48, -11],
        [30, -44],
        [-8, -51],
        [-30, -66],
        [20, -38],
        [50, -19],
        [76, 42],
        [54, -18],
        [51, -69],
        [1, -69],
        [-17, -67],
        [13, -25],
        [43, -36],
        [0, -44],
        [31, -118],
        [-19, -97],
        [-44, -36],
        [11, -36],
        [29, -30],
        [0, -73],
        [-46, -64],
        [-1, -27],
        [59, -64],
        [-32, -62],
        [-44, -33],
        [-35, -41],
        [4, -31],
        [30, -66],
        [8, -51],
        [-4, -74],
        [39, -33],
        [45, -5],
        [31, 31],
        [19, -2],
        [46, -60],
        [11, -27],
        [73, -87],
        [49, -26],
        [-21, -32],
        [-51, -30],
        [-8, -20],
        [28, -83],
        [43, -47],
        [60, -24],
        [65, -6],
        [65, -22],
        [59, -37],
        [14, -46],
        [-35, -134],
        [54, -69],
        [33, -6],
        [71, 3],
        [63, -33],
        [58, -77],
        [29, -138],
        [89, -136],
        [14, -207],
        [142, -103],
        [-5, -153],
        [44, -187],
        [101, -171],
        [50, -303],
        [-18, -46],
        [-1, -37],
        [16, -30],
        [66, -31],
        [117, -24],
        [48, -49],
        [54, -69],
        [67, -128],
        [-5, -29],
        [-28, -40],
        [-6, -45],
        [-23, -68],
        [-39, -21],
        [12, -42],
        [52, -44],
        [15, -26],
        [30, -18],
        [21, -51],
        [16, -9],
        [91, 5],
        [36, 21],
        [46, 45],
        [32, 13],
        [32, -6],
        [43, -29],
        [37, -66],
        [52, 5],
        [67, -11],
        [38, 41],
        [20, 5],
        [87, -29],
        [11, -25],
        [-13, -66],
        [36, -30],
        [48, -3],
        [16, 28],
        [-8, 37],
        [31, 51],
        [26, -9],
        [-3, -48],
        [34, -40],
        [62, -9],
        [19, -34],
        [-8, -30],
        [22, -31],
        [31, 20],
        [131, 46],
        [44, -9],
        [19, -28],
        [24, 0],
        [97, 61],
        [26, -24],
        [44, 8],
        [34, -44],
        [10, -57],
        [36, -49],
        [1, -37],
        [54, -25],
        [60, 6],
        [55, 26],
        [14, -56],
        [42, -30],
        [13, -34],
        [-39, -20],
        [-27, 23],
        [-26, -21],
        [25, -37],
        [46, -9],
        [34, 23],
        [54, -20],
        [27, -44],
        [31, 15],
        [30, -10],
        [4, -47],
        [-51, 7],
        [-29, -35],
        [85, -30],
        [60, -3],
        [29, -11],
        [16, -37],
        [-9, -34],
        [17, -39],
        [31, -22],
        [75, 1],
        [23, 17],
        [69, 21],
        [7, 45],
        [40, 32],
        [17, -31],
        [27, -8],
        [71, 30],
        [49, -1],
        [36, -31],
        [-27, -29],
        [23, -50],
        [32, 20],
        [36, 5],
        [2, -63],
        [26, -11],
        [18, 34],
        [36, 10],
        [11, 52],
        [39, -88],
        [37, 7],
        [25, -40],
        [33, 30],
        [25, 1],
        [45, -22],
        [-28, -49],
        [24, -16],
        [59, 20],
        [23, -5],
        [19, 40],
        [35, 1],
        [61, 26],
        [16, -44],
        [46, 37],
        [26, -31],
        [3, -39],
        [-24, -27],
        [13, -33],
        [53, -19],
        [68, -53],
        [58, -12],
        [-3, -32],
        [53, -43],
        [32, -45],
        [84, 5],
        [-5, 53],
        [30, 20],
        [17, -19],
        [-5, -49],
        [23, -36],
        [21, 11],
        [5, 50],
        [18, 16],
        [36, -6],
        [9, -40],
        [-22, -29],
        [20, -31],
        [-8, -32],
        [67, -103],
        [44, -13],
        [21, -50],
        [35, 61],
        [43, 14],
        [61, -22],
        [32, -3],
        [-10, -47],
        [-66, 4],
        [11, -30],
        [35, -10],
        [46, -38],
        [12, -31],
        [48, -24],
        [18, -39],
        [89, 25],
        [52, -7],
        [34, -35],
        [34, -14],
        [31, -56],
        [23, -6],
        [15, 43],
        [39, 21],
        [9, 41],
        [30, -15],
        [14, -34],
        [50, -3],
        [12, -38],
        [30, -26],
        [28, -2],
        [24, 48],
        [4, 44],
        [45, -35],
        [106, 26],
        [49, -43],
        [80, 44],
        [26, -99],
        [-44, -28],
        [13, -28],
        [31, 5],
        [29, 41],
        [84, -6],
        [33, -15],
        [20, 47],
        [4, 49],
        [37, 27],
        [15, -32],
        [64, 9],
        [33, 18],
        [56, -23],
        [7, 28],
        [36, 2],
        [1, -33],
        [66, -41],
        [44, 48],
        [39, 0],
        [46, -41],
        [72, 22],
        [60, 0],
        [28, 17],
        [59, 0],
        [10, 28],
        [48, -10],
        [33, -38],
        [24, 56],
        [14, -73],
        [44, -7],
        [63, 3],
        [22, -35],
        [33, 51],
        [52, -10],
        [31, 21],
        [36, 6],
        [31, -29],
        [-21, -63],
        [16, -25],
        [58, -10],
        [17, -22],
        [38, 39],
        [-27, 12],
        [-2, 28],
        [37, 10],
        [26, -34],
        [-8, -60],
        [25, -10],
        [27, 25],
        [23, -25],
        [61, 29],
        [69, -5],
        [2, -38],
        [46, 15],
        [29, 25],
        [28, -4],
        [-3, -33],
        [23, -25],
        [23, 41],
        [55, -7],
        [19, 41],
        [16, -74],
        [40, 6],
        [38, -21],
        [4, 40],
        [22, 18],
        [28, -24],
        [11, -39],
        [-54, -30],
        [78, -62],
        [5, -43],
        [35, 9],
        [29, -52],
        [36, -8],
        [-8, -57],
        [54, -46],
        [18, 23],
        [57, 7],
        [-3, -35],
        [15, -56],
        [-14, -30],
        [74, -22],
        [-4, -31],
        [35, -7],
        [20, 56],
        [44, -15],
        [14, -70],
        [48, 3],
        [-5, -44],
        [24, -25],
        [26, -55],
        [11, -48],
        [44, 8],
        [54, 55],
        [12, -11],
        [-5, -79],
        [56, -9],
        [49, 5],
        [22, -20],
        [23, 29],
        [47, 1],
        [-10, -56],
        [17, -13],
        [28, 19],
        [-4, -76],
        [23, -40],
        [34, 8],
        [47, -45],
        [56, 0],
        [-6, 34],
        [21, 18],
        [52, -1],
        [-8, -47],
        [32, -21],
        [31, 33],
        [22, -22],
        [40, 2],
        [21, 92],
        [42, 70],
        [4, 26],
        [-70, 4],
        [45, 35],
        [-16, 41],
        [7, 41],
        [-18, 32],
        [4, 31],
        [31, 2],
        [51, 40],
        [10, 31],
        [59, -7],
        [-7, -40],
        [60, -11],
        [0, 34],
        [34, 32],
        [40, -26],
        [17, 9],
        [5, 41],
        [32, -15],
        [24, 15],
        [64, -6],
        [4, 21],
        [-57, 72],
        [33, 24],
        [26, -33],
        [71, -6],
        [62, -14],
        [25, 29],
        [71, 26],
        [27, -11],
        [56, 33],
        [14, -27],
        [40, -2],
        [38, -20],
        [11, 26],
        [59, 28],
        [16, -18],
        [55, -6],
        [-10, -40],
        [14, -16],
        [49, 31],
        [10, -209],
        [-7, -180],
        [-28, -257],
        [-51, -334],
        [-27, -146],
        [-28, -114],
        [-32, -103],
        [-95, -262],
        [-24, -32],
        [-149, -295],
        [-114, -210],
        [-97, -164],
        [-250, -451],
        [-202, -381],
        [-136, -279],
        [-35, -84],
        [-10, -39],
        [-45, -56],
        [-77, -153],
        [-104, -252],
        [-51, -114],
        [-110, -277],
        [-44, -119],
        [-82, -231],
        [-134, -409],
        [-53, -173],
        [-204, -752],
        [-70, -277],
        [-22, -77],
        [-59, -239],
        [-50, -215],
        [-49, -237],
        [-28, -173],
        [-25, -111],
        [-46, -296],
        [-46, -357],
        [-19, -218],
        [-10, -70],
        [-9, -135],
        [-22, -215],
        [-21, -270],
        [-25, -335],
        [-30, -449],
        [-7, -139],
        [0, -276],
        [3, -74],
        [2, -349],
        [4, -132],
        [7, -59],
        [-21, -76],
        [-5, -232],
        [-12, -210],
        [-32, -367],
        [-12, -100],
        [-29, -300],
        [-8, -111],
        [-25, -304],
        [-18, -254],
        [-7, -246],
        [6, -277],
      ],
      [
        [94638, 37729],
        [41, -166],
        [49, -165],
        [52, -153],
        [44, -115],
        [64, -149],
        [108, -216],
        [59, -99],
        [181, -285],
        [74, -125],
        [75, -113],
        [31, -53],
        [92, -130],
        [146, -187],
        [94, -102],
        [101, -102],
        [158, -135],
        [97, -90],
        [66, -80],
        [108, -97],
        [132, -108],
        [211, -162],
        [48, -29],
        [16, -41],
        [59, -67],
        [-12, -36],
        [-13, -35],
        [0, -62],
        [15, -88],
        [-10, -54],
        [-45, -114],
        [-18, -74],
        [-40, -120],
        [-113, -269],
        [-78, -127],
        [-40, -78],
        [-31, -78],
        [-32, -131],
        [-11, -77],
        [-3, -115],
        [9, -51],
        [-15, -56],
        [10, -89],
        [37, -150],
        [37, -113],
        [57, -146],
        [51, -110],
        [72, -140],
        [57, -144],
        [44, -121],
        [68, -139],
        [4, -36],
        [59, -124],
        [39, -57],
        [7, -46],
        [34, -81],
        [95, -201],
        [94, -181],
        [65, -106],
        [64, -90],
        [15, -90],
        [30, -75],
        [60, -98],
        [3, -78],
        [49, -110],
        [-33, -67],
        [23, -21],
        [5, -82],
        [22, -69],
        [30, -51],
        [13, -43],
        [15, -42],
        [57, -103],
        [94, -134],
        [61, -71],
        [124, -145],
        [216, -232],
        [156, -151],
        [114, -101],
        [59, -44],
        [163, -259],
        [121, -145],
        [69, -78],
        [229, -243],
        [46, -53],
        [164, -165],
        [136, -145],
        [59, -93],
        [249, -254],
        [54, -81],
        [20, -35],
        [256, -314],
        [172, -216],
        [27, -39],
        [108, -133],
        [22, -19],
        [-1, -59],
        [60, -126],
        [96, -127],
        [65, -79],
        [33, -41],
        [81, -83],
        [49, -72],
        [65, -67],
        [62, -52],
        [13, 1],
        [51, -61],
        [9, -23],
        [1, -70],
        [36, -71],
        [20, -67],
        [60, -84],
        [-14, -26],
        [46, -117],
        [36, -45],
        [-7, -38],
        [34, -79],
        [-26, -91],
        [2, -27],
        [53, -101],
        [-17, -86],
        [15, -90],
        [95, -174],
        [12, -32],
        [-33, -48],
        [5, -64],
        [15, -83],
        [64, -125],
        [69, -101],
        [73, -94],
        [43, -55],
        [29, -23],
        [23, -100],
        [-34, -20],
        [-14, -34],
        [-8, -94],
        [-1, -86],
        [26, -104],
        [43, -107],
        [-20, -59],
        [18, -75],
        [22, -54],
        [49, -75],
        [108, -119],
        [52, -43],
        [141, -91],
        [21, -10],
        [65, -29],
        [47, -9],
        [38, -33],
        [34, -2],
        [35, -66],
        [-3, -39],
        [25, -36],
        [46, -25],
        [85, -2],
        [37, 8],
        [45, -25],
        [-34, -26],
        [-23, 31],
        [-23, -20],
        [23, -41],
        [62, -67],
        [-8, -42],
        [24, -39],
        [61, -31],
        [47, -53],
        [6, -32],
        [-28, -18],
        [-9, -54],
        [-17, -38],
        [31, -117],
        [7, -44],
        [31, -42],
        [77, -68],
        [71, -38],
        [86, -29],
        [107, -9],
        [50, 8],
        [61, 27],
        [44, 3],
        [39, -28],
        [18, -45],
        [26, -292],
        [16, -114],
        [16, -64],
        [28, -66],
        [44, -67],
        [-8, -64],
        [12, -42],
        [64, -99],
        [120, -128],
        [73, -61],
        [104, -72],
        [82, -42],
        [152, -68],
        [142, -56],
        [130, -35],
        [71, -42],
        [74, -70],
        [44, -27],
        [127, -68],
        [88, -39],
        [84, -30],
        [152, -44],
        [184, -38],
        [220, -23],
        [153, -11],
        [253, -9],
        [210, -2],
        [135, 1],
        [98, 9],
        [207, 5],
        [38, 10],
        [75, -39],
        [118, -17],
        [165, -3],
        [22, 14],
        [47, -7],
        [13, 24],
        [42, -13],
        [3, -45],
        [74, -56],
        [96, -36],
        [22, -33],
        [42, -16],
        [18, -60],
        [25, -24],
        [87, -37],
        [52, 3],
        [54, -18],
        [-7, -50],
        [23, -32],
        [65, -36],
        [7, -54],
        [29, -37],
        [21, 0],
        [-8, -68],
        [34, -39],
        [47, -27],
        [103, -43],
        [102, -34],
        [74, 5],
        [24, -20],
        [112, -23],
        [170, -11],
        [35, 9],
        [53, -6],
        [60, 6],
        [34, -16],
        [147, -12],
        [84, -23],
        [34, -45],
        [43, -21],
        [23, -52],
        [27, -34],
        [28, -78],
        [4, -43],
        [37, -102],
        [2, -66],
        [50, -56],
        [87, -80],
        [-4, -36],
        [34, -95],
        [38, -48],
        [87, -77],
        [86, -52],
        [41, -47],
        [56, -53],
        [20, -30],
        [17, -63],
        [31, -51],
        [70, -60],
        [80, -52],
        [-16, -28],
        [-1, -37],
        [12, -102],
        [29, -102],
        [31, -70],
        [17, -68],
        [47, -57],
        [43, -39],
        [113, -72],
        [108, -49],
        [149, -39],
        [147, -12],
        [85, 4],
        [149, 21],
        [79, 19],
        [48, -1],
        [111, 9],
        [86, 13],
        [293, 60],
        [231, 59],
        [155, 36],
        [41, 16],
        [129, 28],
        [113, 33],
        [68, 9],
      ],
      [
        [94642, 38203],
        [-38, -24],
        [-5, -39],
        [5, -186],
        [18, -149],
        [16, -76],
      ],
      [
        [132796, 33534],
        [158, 23],
        [176, 23],
        [73, 18],
        [196, 20],
        [154, 20],
        [76, 19],
        [81, -2],
        [131, 11],
        [159, 19],
        [72, 6],
        [113, 21],
        [126, 7],
        [71, 8],
        [94, 2],
        [96, 11],
        [152, 41],
        [114, 22],
        [133, 11],
        [181, 31],
        [17, 6],
        [98, 17],
        [135, 10],
        [168, 42],
        [132, 3],
        [111, 27],
        [80, 42],
        [70, 11],
        [10, 37],
        [105, 23],
        [82, 8],
        [85, 23],
        [197, 99],
        [4, 22],
        [48, 49],
        [129, 97],
        [58, 53],
        [46, 56],
        [17, 38],
        [59, 36],
        [68, 19],
        [59, 5],
        [204, 44],
        [49, -10],
        [59, 10],
        [93, 34],
        [137, 36],
        [56, 19],
        [165, 22],
        [89, 29],
        [111, 9],
        [16, 9],
        [99, -28],
        [18, -23],
        [37, -1],
        [14, -17],
        [56, -6],
        [119, -1],
        [35, 5],
        [73, 37],
        [41, -24],
        [64, 39],
        [48, -5],
        [27, 22],
        [-4, 52],
        [179, 109],
        [53, 23],
        [57, 19],
        [-6, 25],
        [86, 33],
        [64, 18],
        [60, 6],
        [127, -19],
        [101, -28],
        [157, -19],
        [86, -6],
        [306, -1],
        [136, -45],
        [104, -47],
        [90, -32],
        [137, -65],
        [198, -86],
        [101, -35],
        [268, -85],
        [189, -49],
        [51, 4],
        [117, -30],
        [117, -22],
        [143, -39],
        [264, -59],
        [55, -2],
      ],
      [
        [128579, 31207],
        [10, 63],
        [35, 71],
        [45, 162],
        [42, 126],
        [29, 106],
        [29, 67],
        [100, 173],
        [87, 91],
        [78, 55],
        [215, 132],
        [173, 104],
        [98, 65],
        [170, 125],
        [102, 65],
        [174, 91],
        [39, 30],
        [100, 22],
        [110, 12],
        [158, 42],
        [133, 50],
        [149, 90],
        [117, 85],
        [177, 89],
        [113, 40],
        [66, 14],
        [87, 36],
        [118, 20],
        [169, 47],
        [297, 66],
        [137, 20],
        [45, 24],
        [89, 6],
        [353, 62],
        [65, 25],
        [220, 39],
        [88, 12],
      ],
      [
        [131594, 39204],
        [-1, -11],
        [49, -69],
        [0, -43],
        [-31, 7],
        [-1, 63],
        [-32, 23],
        [-3, 26],
        [-28, 30],
        [-7, 28],
        [29, 39],
        [31, -41],
        [-6, -52],
      ],
      [
        [131493, 39380],
        [-63, 24],
        [49, 33],
        [22, -33],
        [-8, -24],
      ],
      [
        [131978, 39634],
        [53, -75],
        [64, -69],
        [97, -136],
        [42, -116],
        [5, -172],
        [-20, -71],
        [-22, -40],
        [-59, -146],
        [-44, -56],
        [-37, -31],
        [-36, -1],
        [-8, 37],
        [-25, 29],
        [22, 18],
        [-52, 38],
        [-25, -2],
        [-35, -57],
        [-36, 16],
        [15, 28],
        [-67, 97],
        [-50, 36],
        [-75, 24],
        [47, 15],
        [41, -28],
        [59, -5],
        [-19, 76],
        [-79, 3],
        [-14, 34],
        [-3, 86],
        [-44, 58],
        [38, 62],
        [3, 51],
        [50, 30],
        [-4, 47],
        [-21, 54],
        [11, 29],
        [-8, 32],
        [-38, 10],
        [-9, -56],
        [-40, 42],
        [-3, 25],
        [-34, 67],
        [-16, -27],
        [14, -32],
        [-13, -28],
        [-32, 7],
        [-30, -60],
        [-43, 2],
        [-4, -35],
        [-48, -18],
        [-33, -28],
        [-33, 54],
        [11, 44],
        [-5, 53],
        [46, 55],
        [6, 35],
        [25, 26],
        [40, 18],
        [44, -6],
        [49, 34],
        [22, 49],
        [-9, 41],
        [58, -28],
        [76, -17],
        [87, -26],
        [124, -69],
        [24, -27],
      ],
      [
        [120212, 31510],
        [-73, -48],
        [3, 40],
        [49, 21],
        [21, -13],
      ],
      [
        [120304, 31594],
        [4, -16],
        [-45, -41],
        [-19, 29],
        [65, 73],
        [21, -20],
        [-26, -25],
      ],
      [
        [119852, 31913],
        [-18, -61],
        [-56, -30],
        [-19, 9],
        [-10, 54],
        [55, 3],
        [19, 25],
        [29, 0],
      ],
    ],
    transform: {
      scale: [0.00021745820558372676, 0.00020234937971476652],
      translate: [-118.36511435228296, 14.532098369765604],
    },
    objects: {
      estados: {
        type: "GeometryCollection",
        geometries: [
          {
            arcs: [[0, 1, 2]],
            type: "Polygon",
            properties: {
              CVE_ENT: "01",
              NOM_ENT: "Aguascalientes",
              poblacion: 1549118,
            },
          },
          {
            arcs: [
              [[3, 4, 5, 6, 7]],
              [[8]],
              [[9]],
              [[10]],
              [[11]],
              [[12]],
              [[13]],
              [[14]],
              [[15]],
              [[16]],
              [[17]],
              [[18]],
              [[19]],
              [[20]],
              [[21]],
              [[22]],
              [[23]],
              [[24]],
              [[25]],
              [[26]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "02",
              NOM_ENT: "Baja California",
              poblacion: 4131619,
            },
          },
          {
            arcs: [
              [[27]],
              [[28, -7, 29]],
              [[30]],
              [[31]],
              [[32]],
              [[33]],
              [[34]],
              [[35]],
              [[36]],
              [[37]],
              [[38]],
              [[39]],
              [[40]],
              [[41]],
              [[42]],
              [[43]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "03",
              NOM_ENT: "Baja California Sur",
              poblacion: 904052,
            },
          },
          {
            arcs: [[[44, 45, 46, 47, 48, 49]], [[50]], [[51]]],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "04",
              NOM_ENT: "Campeche",
              poblacion: 958567,
            },
          },
          {
            arcs: [[52, 53, 54, 55, 56, 57]],
            type: "Polygon",
            properties: {
              CVE_ENT: "05",
              NOM_ENT: "Coahuila",
              poblacion: 3400257,
            },
          },
          {
            arcs: [[[58, 59, 60, 61]], [[62]], [[63]], [[64]]],
            type: "MultiPolygon",
            properties: { CVE_ENT: "06", NOM_ENT: "Colima", poblacion: 767105 },
          },
          {
            arcs: [[65, 66, 67, 68, 69]],
            type: "Polygon",
            properties: {
              CVE_ENT: "07",
              NOM_ENT: "Chiapas",
              poblacion: 6107903,
            },
          },
          {
            arcs: [[70, 71, 72, 73, -55, 74]],
            type: "Polygon",
            properties: {
              CVE_ENT: "08",
              NOM_ENT: "Chihuahua",
              poblacion: 4043130,
            },
          },
          {
            arcs: [[75, 76, 77]],
            type: "Polygon",
            properties: {
              CVE_ENT: "09",
              NOM_ENT: "Ciudad de México",
              poblacion: 9183658,
            },
          },
          {
            arcs: [[78, 79, -71, -75, -54, 80, 81]],
            type: "Polygon",
            properties: {
              CVE_ENT: "10",
              NOM_ENT: "Durango",
              poblacion: 1927128,
            },
          },
          {
            arcs: [[82, 83, 84, 85, 86, 87]],
            type: "Polygon",
            properties: {
              CVE_ENT: "11",
              NOM_ENT: "Guanajuato",
              poblacion: 6537669,
            },
          },
          {
            arcs: [[88, 89, 90, 91, 92, 93, 94]],
            type: "Polygon",
            properties: {
              CVE_ENT: "12",
              NOM_ENT: "Guerrero",
              poblacion: 3571649,
            },
          },
          {
            arcs: [[95, 96, 97, 98, 99, 100]],
            type: "Polygon",
            properties: {
              CVE_ENT: "13",
              NOM_ENT: "Hidalgo",
              poblacion: 3299857,
            },
          },
          {
            arcs: [[101, 102, 103, -2, 104, -84, 105, -60, 106]],
            type: "Polygon",
            properties: {
              CVE_ENT: "14",
              NOM_ENT: "Jalisco",
              poblacion: 8903326,
            },
          },
          {
            arcs: [[-101, 107, 108, 109, -76, -78, 110, -91, 111, 112]],
            type: "Polygon",
            properties: {
              CVE_ENT: "15",
              NOM_ENT: "México",
              poblacion: 17723173,
            },
          },
          {
            arcs: [[-112, -90, 113, -61, -106, -83, -88, 114]],
            type: "Polygon",
            properties: {
              CVE_ENT: "16",
              NOM_ENT: "Michoacán",
              poblacion: 5045030,
            },
          },
          {
            arcs: [[-111, -77, -110, 115, -92]],
            type: "Polygon",
            properties: {
              CVE_ENT: "17",
              NOM_ENT: "Morelos",
              poblacion: 2056103,
            },
          },
          {
            arcs: [
              [[-82, 116, -103, 117, 118, -79]],
              [[119]],
              [[120]],
              [[121]],
              [[122]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "18",
              NOM_ENT: "Nayarit",
              poblacion: 1324282,
            },
          },
          {
            arcs: [[123, 124, 125, -57, 126, 127]],
            type: "Polygon",
            properties: {
              CVE_ENT: "19",
              NOM_ENT: "Nuevo León",
              poblacion: 6413123,
            },
          },
          {
            arcs: [[128, -67, 129, -94, 130, 131]],
            type: "Polygon",
            properties: {
              CVE_ENT: "20",
              NOM_ENT: "Oaxaca",
              poblacion: 4339377,
            },
          },
          {
            arcs: [[132, -131, -93, -116, -109, 133, -99, 134]],
            type: "Polygon",
            properties: {
              CVE_ENT: "21",
              NOM_ENT: "Puebla",
              poblacion: 7070124,
            },
          },
          {
            arcs: [[-87, 135, -96, -113, -115]],
            type: "Polygon",
            properties: {
              CVE_ENT: "22",
              NOM_ENT: "Querétaro",
              poblacion: 2654421,
            },
          },
          {
            arcs: [
              [[136]],
              [[137]],
              [[138, -48, 139, 140]],
              [[141]],
              [[142]],
              [[143]],
              [[144]],
              [[145]],
              [[146]],
              [[147]],
              [[148]],
              [[149]],
              [[150]],
              [[151]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "23",
              NOM_ENT: "Quintana Roo",
              poblacion: 2101638,
            },
          },
          {
            arcs: [[152, -97, -136, -86, 153, -125, 154, 155]],
            type: "Polygon",
            properties: {
              CVE_ENT: "24",
              NOM_ENT: "San Luis Potosí",
              poblacion: 2979775,
            },
          },
          {
            arcs: [[[156, 157, -72, -80, -119, 158]], [[159]], [[160]]],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "25",
              NOM_ENT: "Sinaloa",
              poblacion: 3187466,
            },
          },
          {
            arcs: [
              [[-73, -158, 161, -5, 162], [163]],
              [[164]],
              [[165]],
              [[166]],
              [[167]],
              [[168]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "26",
              NOM_ENT: "Sonora",
              poblacion: 3140762,
            },
          },
          {
            arcs: [[-69, 169, 170, -45, -50, 171]],
            type: "Polygon",
            properties: {
              CVE_ENT: "27",
              NOM_ENT: "Tabasco",
              poblacion: 2467519,
            },
          },
          {
            arcs: [[172, 173, -155, -124, -128, 174]],
            type: "Polygon",
            properties: {
              CVE_ENT: "28",
              NOM_ENT: "Tamaulipas",
              poblacion: 3748419,
            },
          },
          {
            arcs: [[-134, -108, -100]],
            type: "Polygon",
            properties: {
              CVE_ENT: "29",
              NOM_ENT: "Tlaxcala",
              poblacion: 1447721,
            },
          },
          {
            arcs: [
              [
                175, -170, -68, -129, -132, -133, -135, -98, -153, -156, -174,
                176,
              ],
            ],
            type: "Polygon",
            properties: {
              CVE_ENT: "30",
              NOM_ENT: "Veracruz",
              poblacion: 8121275,
            },
          },
          {
            arcs: [
              [[177, -140, -47, 178]],
              [[179]],
              [[180]],
              [[181]],
              [[182]],
              [[183]],
              [[184]],
            ],
            type: "MultiPolygon",
            properties: {
              CVE_ENT: "31",
              NOM_ENT: "Yucatán",
              poblacion: 2513461,
            },
          },
          {
            arcs: [[-104, -117, -81, -53, -58, -126, -154, -85, -105, -1, -3]],
            type: "Polygon",
            properties: {
              CVE_ENT: "32",
              NOM_ENT: "Zacatecas",
              poblacion: 1712936,
            },
          },
        ],
      },
    },
  };
})();
